
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gXOst", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $aPdNQ = parcelRequire("aPdNQ");





var $5aU9U = parcelRequire("5aU9U");

class $002ebcda48d3a1ac$export$7ee2d944cdf187e1 extends (0, $5aU9U.Step) {
    invert(doc) {
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            inverted: true,
            from: this.from,
            to: this.to,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedFrom = mapping.mapResult(this.from, 1);
        const mappedTo = mapping.mapResult(this.to, 1);
        if (mappedFrom.deleted || mappedTo.deleted) return null;
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            inverted: this.inverted,
            from: mappedFrom.pos,
            to: mappedTo.pos
        });
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    static from(step) {
        const { mark: mark, from: from, to: to } = step;
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            mark: mark,
            from: from,
            to: to
        });
    }
    constructor({ inverted: inverted, from: from, to: to, mark: mark }){
        super();
        this.inverted = void 0;
        this.from = void 0;
        this.to = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
class $002ebcda48d3a1ac$export$2a0a7f94dceaed30 extends (0, $5aU9U.Step) {
    invert(doc) {
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            inverted: true,
            pos: this.pos,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedPos = mapping.mapResult(this.pos, 1);
        if (mappedPos.deleted) return null;
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            inverted: this.inverted,
            pos: mappedPos.pos
        });
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    static from(step) {
        const { mark: mark, pos: pos } = step;
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            mark: mark,
            pos: pos
        });
    }
    constructor({ inverted: inverted, pos: pos, mark: mark }){
        super();
        this.inverted = void 0;
        this.pos = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.pos = pos;
        this.mark = mark;
    }
}


const $ac8be7093d42d0e1$var$createFilterStepsPlugin = (api)=>()=>new (0, $kpCD8.SafePlugin)({
            filterTransaction: (tr)=>{
                const mode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (mode !== 'view') return true;
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('allowViewModeTransaction')) return true;
                const viewModeSteps = tr.steps.reduce((acc, s)=>{
                    if (s instanceof (0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30) || s instanceof (0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1)) acc.push(s);
                    return acc;
                }, []);
                if (viewModeSteps.length === 0 || !api) {
                    if (tr.docChanged && // Check if the transaction contains any steps that modify the document (view mode steps do not)
                    tr.steps.filter((s)=>s instanceof (0, $eOaGc.ReplaceAroundStep) || s instanceof (0, $eOaGc.ReplaceStep) || s instanceof (0, $eOaGc.AddMarkStep) || s instanceof (0, $eOaGc.AddNodeMarkStep) || s instanceof (0, $eOaGc.RemoveMarkStep) || s instanceof (0, $eOaGc.RemoveNodeMarkStep)).length) return false;
                    return true;
                }
                viewModeSteps.forEach((step)=>{
                    if (step.inverted || !step.mark) return;
                    if (step.mark.type.name === 'annotation') {
                        if (step instanceof (0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30)) api.collabEdit?.actions.addInlineCommentNodeMark({
                            mark: step.mark,
                            pos: step.pos
                        });
                        else if (step instanceof (0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1)) api.collabEdit?.actions.addInlineCommentMark({
                            mark: step.mark,
                            from: step.from,
                            to: step.to
                        });
                    }
                });
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Follow-up and improve annotation logic so we can filter out transactions here
                return true;
            }
        });
const $ac8be7093d42d0e1$var$createReplaceDocumentTransactionPlugin = (api)=>()=>new (0, $kpCD8.SafePlugin)({
            // Shouldn't need explicit types but sometimes TS can't infer them so 🤷
            appendTransaction: (transactions, _oldState, newState)=>{
                if (!api) return;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode) return;
                const remoteReplaceDocumentTransaction = transactions.find((tr)=>api.collabEdit?.actions?.isRemoteReplaceDocumentTransaction(tr));
                if (!remoteReplaceDocumentTransaction || !remoteReplaceDocumentTransaction.selectionSet) return;
                const doc = newState.doc;
                const nextTr = newState.tr;
                const emptySelection = new (0, $kCECX.TextSelection)(doc.resolve(0));
                nextTr.setSelection(emptySelection);
                return nextTr;
            }
        });
const $ac8be7093d42d0e1$export$d510e4d48c393847 = ({ api: api })=>({
        name: 'editorViewModeEffects',
        actions: {
            allowViewModeTransaction: (tr)=>{
                tr.setMeta('allowViewModeTransaction', true);
                return tr;
            },
            applyViewModeStepAt: (tr)=>{
                const marksSteps = tr.steps.reduce((acc, s)=>{
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: We probably want to check the RemoveMarkStep flow too.
                    if (s instanceof (0, $eOaGc.AddMarkStep) || s instanceof (0, $eOaGc.AddNodeMarkStep)) acc.push(s);
                    return acc;
                }, []);
                if (marksSteps.length === 0) return false;
                marksSteps.reverse().map((s)=>s instanceof (0, $eOaGc.AddNodeMarkStep) ? tr.step((0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30).from(s)) : tr.step((0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1).from(s)));
                return true;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewModeEffectsFilterSteps',
                    plugin: $ac8be7093d42d0e1$var$createFilterStepsPlugin(api)
                },
                {
                    name: 'editorViewModeEffectsReplaceDocumentTransaction',
                    plugin: $ac8be7093d42d0e1$var$createReplaceDocumentTransactionPlugin(api)
                }
            ];
        }
    });
module.exports["editorViewModeEffectsPlugin"] = $ac8be7093d42d0e1$export$d510e4d48c393847;

});

parcelRegister("e1OCV", function(module, exports) {

var $4RpM6 = parcelRequire("4RpM6");


var $1KOhB = parcelRequire("1KOhB");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");

/** Fixed document thresholds for limited (performance) mode (previously Statsig-driven). */ const $72fea854eca60317$export$8817b3b4a899ccd1 = 5000;
const $72fea854eca60317$export$9a6294e90d121a22 = 30000;
const $72fea854eca60317$export$833c4477f3965ea = 2438;
const $72fea854eca60317$export$abf63b5b2766c340 = 750000;
const $72fea854eca60317$export$b7df129026e38137 = ()=>({
        docSizeThreshold: $72fea854eca60317$export$abf63b5b2766c340,
        nodeCountThreshold: $72fea854eca60317$export$833c4477f3965ea
    });


const $4218f4c6d794cff3$var$LEGACY_CONTENT_EXTENSION_KEY = 'legacy-content';
const $4218f4c6d794cff3$export$6d77f83241297715 = (doc, thresholds = (0, $72fea854eca60317$export$b7df129026e38137)())=>{
    const { docSizeThreshold: docSizeThreshold, nodeCountThreshold: nodeCountThreshold } = thresholds;
    if (doc.nodeSize > docSizeThreshold) return true;
    // Single traversal for node count and LCM detection.
    let nodeCount = 0;
    let hasLcm = false;
    doc.descendants((node)=>{
        nodeCount += 1;
        if (node.attrs?.extensionKey === $4218f4c6d794cff3$var$LEGACY_CONTENT_EXTENSION_KEY) {
            hasLcm = true;
            // Early exit: LCM found — limited mode will be enabled
            return false;
        }
        return true;
    });
    return hasLcm || nodeCount > nodeCountThreshold;
};



var $cha5E = parcelRequire("cha5E");





var $kCECX = parcelRequire("kCECX");

const $275245620839e5f9$export$4d696a2f56515a41 = new (0, $kCECX.PluginKey)('limitedModePlugin');



var $gMweA = parcelRequire("gMweA");

const $b4ae4caf75b00d26$export$4b4648e48515d3 = ({ onLatchCriteriaMet: onLatchCriteriaMet, policy: policy })=>{
    // One clock for the whole subsystem, so measured durations and the policy's windows agree.
    const now = policy.now;
    let observer;
    let destroyed = false;
    const handleEvaluation = (evaluation)=>{
        if (evaluation !== 'latched') return;
        // One-way latch: the policy will never evaluate again, so stop paying for the observers.
        teardownObservers();
        const details = policy.getLatchDetails();
        if (details) onLatchCriteriaMet(details);
    };
    function teardownObservers() {
        observer?.disconnect();
        observer = undefined;
    }
    if ((0, $gMweA.isPerformanceObserverLongTaskAvailable)()) try {
        observer = new PerformanceObserver((list)=>{
            for (const entry of list.getEntries()){
                if (policy.isLatched()) return;
                handleEvaluation(policy.recordLongTask(entry.duration));
            }
        });
        observer.observe({
            entryTypes: [
                'longtask'
            ]
        });
    } catch  {
        // `longtask` is unsupported in some browsers even when PerformanceObserver exists. The
        // latency criterion alone is still a valid trigger, so carry on without freeze detection.
        observer = undefined;
    }
    return {
        noteDocumentChange: ({ nodeSizeDelta: nodeSizeDelta, isDocumentReplaced: isDocumentReplaced })=>{
            if (destroyed || policy.isLatched()) return;
            if (isDocumentReplaced || policy.isBulkChange(nodeSizeDelta)) policy.suppress();
        },
        measureInput: ()=>{
            if (destroyed || policy.isLatched() || !(0, $gMweA.isPerformanceAPIAvailable)()) return;
            const start = now();
            // Runs after every handleTextInput and all resulting plugin work, but before paint — the
            // same measurement point frozen-editor uses, so the numbers are comparable to existing
            // SLOW_INPUT telemetry.
            requestAnimationFrame(()=>{
                if (destroyed || policy.isLatched()) return;
                handleEvaluation(policy.recordInputLatency(now() - start));
            });
        },
        destroy: ()=>{
            destroyed = true;
            teardownObservers();
        }
    };
};


function $1cd43be554c8be23$export$9c490b34b2f16a34(array) {
    const middle = Math.floor(array.length / 2);
    const sortedArray = [
        ...array
    ].sort((a, b)=>a - b);
    return array.length % 2 !== 0 ? sortedArray[middle] : (sortedArray[middle - 1] + sortedArray[middle]) / 2;
}



const $b07bae5e8193ad06$export$99f816f5d068516b = {
    warmUpMs: 10000,
    slowInputMs: 100,
    latencyWindowSize: 12,
    latencySlowSamplesRequired: 6,
    freezeTaskMs: 600,
    freezeTasksRequired: 3,
    freezeWindowMs: 30000,
    requiredConfirmations: 2,
    confirmationGapMs: 30000,
    bulkChangeNodeSize: 100,
    bulkChangeSuppressionMs: 2000,
    docSizeThreshold: 750000,
    nodeCountThreshold: 5000
};
class $b07bae5e8193ad06$export$288fa2e391880242 {
    /**
   * Whether limited mode should be on, for either reason. This is the verdict consumers act on.
   */ isBreached() {
        return this.documentBreached || this.latched;
    }
    /**
   * What the latch was based on, or `undefined` while un-latched. Intended for telemetry — nothing in
   * the decision reads it back.
   */ getLatchDetails() {
        return this.latchDetails;
    }
    /** Whether the runtime (device) criteria have latched. One-way, and never cleared. */ isLatched() {
        return this.latched;
    }
    /**
   * Latch the runtime reason directly, without accumulating evidence for it.
   *
   * The policy latches itself when its own criteria are met, so this exists for callers that have
   * already decided: the plugin replaying the detector's latch transaction, and dev tooling forcing
   * the state by hand. Idempotent, and one-way like every other route to `latched`.
   */ latch() {
        if (this.latched) return;
        this.latched = true;
        this.latchDetails = this.buildDetails('forced', undefined);
    }
    /** Whether the document currently breaches the thresholds. Can go back to false. */ isDocumentBreached() {
        return this.documentBreached;
    }
    /**
   * Evaluate the document reason against the size / node-count / legacy-content-macro thresholds.
   *
   * Walks the whole document, so the caller decides when it is worth paying for: `pm-plugins/main.ts`
   * calls this on load and on `replaceDocument` (e.g. live-to-live page navigation) only, never per
   * transaction. Editing therefore cannot turn the document reason on — a page that grows past the
   * thresholds mid-session is only re-judged the next time it loads — but replacement can still turn
   * it back off.
   */ evaluateDocument(doc) {
        this.documentBreached = (0, $4218f4c6d794cff3$export$6d77f83241297715)(doc, {
            docSizeThreshold: this.config.docSizeThreshold,
            nodeCountThreshold: this.config.nodeCountThreshold
        });
    }
    /**
   * Whether a `doc.nodeSize` delta is large enough to be bulk work rather than typing. A keystroke
   * moves this by 1; a paste, a bulk replace or a document load moves it far more.
   */ isBulkChange(nodeSizeDelta) {
        return Math.abs(nodeSizeDelta) >= this.config.bulkChangeNodeSize;
    }
    /**
   * Discard signals for a window. Called for bulk work, which is expensive but transient and
   * self-limiting, so its cost must not be attributed to the device struggling.
   */ suppress() {
        if (this.latched) return;
        this.suppressedUntil = this.now() + this.config.bulkChangeSuppressionMs;
    }
    /**
   * Feed one keystroke's input latency (dispatch through to the next animation frame).
   */ recordInputLatency(durationMs) {
        if (!this.canRecord()) return 'ignored';
        const { slowInputMs: slowInputMs, latencyWindowSize: latencyWindowSize, latencySlowSamplesRequired: latencySlowSamplesRequired } = this.config;
        this.totalInputSamples += 1;
        if (durationMs > slowInputMs) {
            this.totalSlowInputs += 1;
            // Remembered even once the window rolls over, so the freeze criterion below can check that
            // the jank actually coincided with editing.
            this.lastSlowInputAt = this.now();
        }
        this.latencySamples.push(durationMs);
        if (this.latencySamples.length > latencyWindowSize) this.latencySamples.shift();
        if (this.latencySamples.length < latencyWindowSize) return 'recorded';
        const slowSamples = this.latencySamples.filter((sample)=>sample > slowInputMs).length;
        if (slowSamples < latencySlowSamplesRequired) return 'recorded';
        // Median rather than mean: a mean is dragged over the threshold by one or two outliers, which
        // is exactly the transient jank this policy is meant to ignore.
        const windowMedian = (0, $1cd43be554c8be23$export$9c490b34b2f16a34)(this.latencySamples);
        if (windowMedian <= slowInputMs) return 'recorded';
        return this.qualify('inputLatency', windowMedian);
    }
    /**
   * Feed one `longtask` PerformanceObserver entry.
   */ recordLongTask(durationMs) {
        if (!this.canRecord()) return 'ignored';
        const { freezeTaskMs: freezeTaskMs, freezeWindowMs: freezeWindowMs, freezeTasksRequired: freezeTasksRequired } = this.config;
        if (durationMs <= freezeTaskMs) return 'recorded';
        const now = this.now();
        this.totalFreezes += 1;
        this.freezeTimes.push(now);
        this.freezeTimes = this.freezeTimes.filter((time)=>now - time <= freezeWindowMs);
        if (this.freezeTimes.length < freezeTasksRequired) return 'recorded';
        // Corroboration. `longtask` is process-wide, so without this a busy background tab or an
        // unrelated app could latch an editor the user is typing in perfectly happily.
        if (this.lastSlowInputAt === undefined || now - this.lastSlowInputAt > freezeWindowMs) return 'recorded';
        return this.qualify('freeze');
    }
    canRecord() {
        if (this.latched) return false;
        const now = this.now();
        if (now - this.startedAt < this.config.warmUpMs) return false;
        return now >= this.suppressedUntil;
    }
    /** Snapshot of what the latch was based on. Called before the evidence buffers are cleared. */ buildDetails(reason, latencyMedianMs) {
        const now = this.now();
        return {
            reason: reason,
            firstWindowReason: this.firstWindowReason ?? reason,
            requiredConfirmations: this.config.requiredConfirmations,
            documentAlreadyBreached: this.documentBreached,
            msFromFirstWindow: this.firstQualifiedAt === undefined ? undefined : Math.round(now - this.firstQualifiedAt),
            latencyMedianMs: latencyMedianMs === undefined ? undefined : Math.round(latencyMedianMs),
            timeToLatchMs: Math.round(now - this.startedAt),
            totalInputSamples: this.totalInputSamples,
            totalSlowInputs: this.totalSlowInputs,
            totalFreezes: this.totalFreezes
        };
    }
    qualify(reason, latencyMedianMs) {
        const now = this.now();
        // Each qualifying window must be independent evidence, so the buffers are cleared rather than
        // left to re-trigger off the same samples on the very next keystroke.
        this.latencySamples = [];
        this.freezeTimes = [];
        // Too soon after the last counted window to be independent of it, so it earns no credit. The
        // buffers above are still cleared, which is what makes the run rebuild from scratch.
        if (this.lastQualifiedAt !== undefined && now - this.lastQualifiedAt < this.config.confirmationGapMs) return 'qualified';
        this.qualifiedWindows += 1;
        this.lastQualifiedAt = now;
        if (this.firstQualifiedAt === undefined) {
            this.firstQualifiedAt = now;
            this.firstWindowReason = reason;
        }
        if (this.qualifiedWindows < this.config.requiredConfirmations) return 'qualified';
        this.latched = true;
        this.latchDetails = this.buildDetails(reason, latencyMedianMs);
        return 'latched';
    }
    constructor({ now: now, config: config }){
        /** Public so the detector can read the tunables it needs rather than duplicating them. */ this.config = void 0;
        /** Public so the detector shares one clock with the policy. */ this.now = void 0;
        this.startedAt = void 0;
        this.latencySamples = [];
        this.freezeTimes = [];
        this.lastSlowInputAt = void 0;
        this.firstQualifiedAt = void 0;
        this.lastQualifiedAt = void 0;
        this.qualifiedWindows = 0;
        this.suppressedUntil = 0;
        this.latched = false;
        this.documentBreached = false;
        this.firstWindowReason = void 0;
        this.latchDetails = void 0;
        /** Cumulative for the session and never cleared, unlike the evidence buffers. */ this.totalInputSamples = 0;
        this.totalSlowInputs = 0;
        this.totalFreezes = 0;
        this.now = now;
        this.config = {
            ...$b07bae5e8193ad06$export$99f816f5d068516b,
            ...config
        };
        this.startedAt = now();
    }
}


/**
 * Hardware hints, reported with a latch so it can be correlated with device class.
 *
 * Telemetry only — the policy no longer takes the hardware into account when deciding, so this
 * exists to answer "which devices are latching" from the data rather than by assumption. Both hints
 * are optional (`deviceMemory` is Chromium-only) and are simply absent where unsupported.
 */ const $500762a81161d637$var$getDeviceHints = ()=>{
    if (typeof navigator === 'undefined') return {};
    const { hardwareConcurrency: hardwareConcurrency, deviceMemory: deviceMemory } = navigator;
    return {
        hardwareConcurrency: hardwareConcurrency,
        deviceMemoryGb: deviceMemory
    };
};
/** Control-arm state: the document decision alone, exactly as before the experiment. */ const $500762a81161d637$var$documentOnlyState = (doc)=>{
    const documentSizeBreachesThreshold = (0, $4218f4c6d794cff3$export$6d77f83241297715)(doc);
    return {
        documentSizeBreachesThreshold: documentSizeBreachesThreshold,
        latchPolicyBreached: false,
        enabled: documentSizeBreachesThreshold
    };
};
/** Treatment-arm state: whatever the policy says, for both of its reasons. */ const $500762a81161d637$var$policyState = (policy)=>({
        documentSizeBreachesThreshold: policy.isDocumentBreached(),
        latchPolicyBreached: policy.isBreached(),
        enabled: policy.isBreached()
    });
const $500762a81161d637$export$ae829ec7b2625219 = (api, injectedPolicy)=>{
    let detector;
    let policy;
    if (injectedPolicy) policy = injectedPolicy;
    else if ((0, $4o0zT.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
        const config = (0, $cha5E.expVal)('platform_editor_dynamic_limited_mode', 'policyConfig', {
            warmUpMs: 10000,
            slowInputMs: 100,
            latencyWindowSize: 12,
            latencySlowSamplesRequired: 6,
            freezeTaskMs: 600,
            freezeTasksRequired: 3,
            freezeWindowMs: 30000,
            requiredConfirmations: 2,
            confirmationGapMs: 30000,
            bulkChangeNodeSize: 100,
            bulkChangeSuppressionMs: 2000,
            docSizeThreshold: 750000,
            nodeCountThreshold: 5000
        });
        // Resolved once per editor rather than per transaction. When off, no policy is built and the
        // document decision runs inline exactly as it did before this experiment.
        policy = new (0, $b07bae5e8193ad06$export$288fa2e391880242)({
            now: ()=>performance.now(),
            config: config
        });
    }
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $275245620839e5f9$export$4d696a2f56515a41),
        props: {
            handleTextInput () {
                detector?.measureInput();
                // Never handle the input — this is measurement only.
                return false;
            }
        },
        view: (editorView)=>{
            // No policy means the experiment is off: no observers, no per-keystroke measurement.
            if (!policy) return {};
            const startedAt = performance.now();
            detector = (0, $b4ae4caf75b00d26$export$4b4648e48515d3)({
                policy: policy,
                onLatchCriteriaMet: (details)=>{
                    // Treatment arm only — the detector does not exist in control. See LimitedModeLatchedAEP.
                    //
                    // `details` is the policy's own snapshot of what it latched on, taken before it cleared
                    // its evidence buffers, so it reports the closing window rather than an empty one.
                    api?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).LIMITED_MODE_LATCHED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        attributes: {
                            latched: true,
                            reason: details.reason,
                            firstWindowReason: details.firstWindowReason,
                            requiredConfirmations: details.requiredConfirmations,
                            documentAlreadyBreached: details.documentAlreadyBreached,
                            msFromFirstWindow: details.msFromFirstWindow,
                            latencyMedianMs: details.latencyMedianMs,
                            totalInputSamples: details.totalInputSamples,
                            totalSlowInputs: details.totalSlowInputs,
                            totalFreezes: details.totalFreezes,
                            nodeSize: editorView.state.doc.nodeSize,
                            // Read at latch time rather than at construction: the hints are static, and this
                            // keeps every device fact in one place next to the decision it is compared against.
                            ...$500762a81161d637$var$getDeviceHints(),
                            // Measured from the plugin view starting, which is a little later than the policy's
                            // own `timeToLatchMs` (it starts at plugin construction).
                            timeToLatch: performance.now() - startedAt
                        }
                    });
                    // The policy already holds the latch; this transaction only prompts the plugin to
                    // re-read it, which is what notifies every consumer through shared state.
                    editorView.dispatch(editorView.state.tr.setMeta((0, $275245620839e5f9$export$4d696a2f56515a41), {
                        latchPolicyBreached: true
                    }));
                }
            });
            return {
                destroy: ()=>{
                    detector?.destroy();
                    detector = undefined;
                }
            };
        },
        state: {
            init (_config, editorState) {
                if (!policy) return $500762a81161d637$var$documentOnlyState(editorState.doc);
                policy.evaluateDocument(editorState.doc);
                return $500762a81161d637$var$policyState(policy);
            },
            apply: (tr, currentPluginState, oldState, _newState)=>{
                const documentReplaced = Boolean(tr.getMeta('replaceDocument'));
                if (!policy) {
                    // Control arm, unchanged: skip the traversal once already breached, but always re-check
                    // when the document is replaced (e.g. live-to-live page navigation).
                    if (currentPluginState.documentSizeBreachesThreshold && !documentReplaced) return currentPluginState;
                    return $500762a81161d637$var$documentOnlyState(tr.doc);
                }
                // The detector's latch arrives as a transaction so that plugin state stays a function of
                // the transaction stream rather than of when `apply` happens to read the policy. Dev
                // tooling dispatches the same meta to force limited mode by hand.
                if (tr.getMeta((0, $275245620839e5f9$export$4d696a2f56515a41))?.latchPolicyBreached) policy.latch();
                // Only on replacement, never on an ordinary edit: the check walks the whole document, so
                // running it per transaction is a full-document scan on every keystroke. The trade-off is
                // that a document editing its way past the thresholds is not noticed until it next loads.
                //
                // Deliberately not skipped when limited mode is already on. Replacement is the one moment
                // the document verdict can go *down* — live-to-live navigation onto a smaller page — so
                // skipping it there is what would strand limited mode on forever. It costs one walk per
                // page navigation, which is nothing next to the navigation itself.
                if (documentReplaced) policy.evaluateDocument(tr.doc);
                // Report bulk work so the policy can discount it. The policy decides what counts as bulk;
                // this only supplies the facts.
                //
                // Known gap: operations that are expensive but barely change document size — table
                // resize, drag-and-drop moves (delete + insert nets to ~0), type-ahead — are not
                // suppressed. `@atlaskit/insm` already tracks exactly these via `startHeavyTask`, but its
                // public facade does not expose `runningHeavyTasks`, so there is no way to read them from
                // here today. Closing that gap needs an accessor on the insm package.
                if (tr.docChanged) detector?.noteDocumentChange({
                    nodeSizeDelta: tr.doc.nodeSize - oldState.doc.nodeSize,
                    isDocumentReplaced: documentReplaced
                });
                const next = $500762a81161d637$var$policyState(policy);
                // Keep the previous object when nothing changed, so shared-state diffing stays cheap and
                // consumers are not notified for no reason.
                return next.enabled === currentPluginState.enabled && next.documentSizeBreachesThreshold === currentPluginState.documentSizeBreachesThreshold ? currentPluginState : next;
            }
        }
    });
};



const $637489692354cf19$export$9f825df6a9c9b35b = ({ api: api })=>{
    return {
        name: 'limitedMode',
        pmPlugins () {
            return [
                {
                    name: 'limitedModePlugin',
                    plugin: ()=>(0, $500762a81161d637$export$ae829ec7b2625219)(api)
                }
            ];
        },
        getSharedState (editorState) {
            if (editorState) return {
                get enabled () {
                    return (0, $275245620839e5f9$export$4d696a2f56515a41).getState(editorState)?.enabled ?? false;
                },
                limitedModePluginKey: $275245620839e5f9$export$4d696a2f56515a41
            };
            return {
                enabled: false,
                limitedModePluginKey: $275245620839e5f9$export$4d696a2f56515a41
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $1KOhB.usePluginStateEffect)(api, [
                'limitedMode'
            ], ({ limitedModeState: limitedModeState })=>{
                if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                    const isEnabled = limitedModeState?.enabled ?? false;
                    const nodeIdProvider = (0, $4RpM6.getNodeIdProvider)(editorView);
                    // When limited mode is enabled first time,
                    // We need to remove all existing data-node-anchor attributes
                    // And nodeIdProvider to limited mode to prevent adding data-node-anchor on new nodes
                    if (isEnabled && nodeIdProvider && !nodeIdProvider.isLimitedMode()) nodeIdProvider.setLimitedMode();
                }
            });
        }
    };
};
module.exports["limitedModePlugin"] = $637489692354cf19$export$9f825df6a9c9b35b;

});

parcelRegister("93ZX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kpCD8 = parcelRequire("kpCD8");


var $hjuSl = parcelRequire("hjuSl");


var $kCECX = parcelRequire("kCECX");

const $e608c7972031ca0a$export$ef2bd08fc1b88107 = new (0, $kCECX.PluginKey)('aiSpeechToText');






var $3k5Tv = parcelRequire("3k5Tv");

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Deprecated legacy public API.
/**
 * @deprecated
 */ var $4382e40fbdeb0b2c$export$1684d4fa8efc3301 = /*#__PURE__*/ function(VoiceDictationState) {
    VoiceDictationState["Initializing"] = "Initializing";
    VoiceDictationState["Uninitialized"] = "Uninitialized";
    VoiceDictationState["Unsupported"] = "Unsupported";
    VoiceDictationState["Recording"] = "Recording";
    VoiceDictationState["Stopped"] = "Stopped";
    VoiceDictationState["Error"] = "Error";
    return VoiceDictationState;
}({});
var $4382e40fbdeb0b2c$export$1ba6d610c872ae71 = /*#__PURE__*/ function(VoiceDictationStopReason) {
    VoiceDictationStopReason["StoppedAccepted"] = "STOPPED_ACCEPTED";
    VoiceDictationStopReason["StoppedRejected"] = "STOPPED_REJECTED";
    VoiceDictationStopReason["TimeoutAccepted"] = "TIMEOUT_ACCEPTED";
    return VoiceDictationStopReason;
}({});








class $258c7589868d87a6$export$9090fb60710493e4 {
    insertText(transcript, tr) {
        if (!transcript) return tr;
        const { selection: selection } = tr;
        let pos = selection.$head.pos;
        // set the initial position of the interim text and cache it
        if (this.interimTextFrom === null) this.interimTextFrom = pos;
        else pos = this.interimTextFrom;
        // Replace previous interim text atomically (or insert if none exists).
        // Using insertText(text, from, to) ensures ProseMirror places the cursor
        // at the end of the new text, avoiding dangling cursor positions.
        const replaceTo = this.interimTextFrom !== null && this.interimTextTo !== null ? this.interimTextTo : pos;
        tr.insertText(transcript, pos, replaceTo);
        this.interimTextTo = pos + transcript.length;
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, this.interimTextTo));
        return tr;
    }
    rejectTranscriptedText(tr) {
        const from = this.interimTextFrom;
        const to = this.interimTextTo;
        if (from === null || to === null) return tr;
        tr.delete(from, to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from));
        this.disposeTranscriptedText();
        return tr;
    }
    disposeTranscriptedText() {
        this.interimTextFrom = null;
        this.interimTextTo = null;
    }
    constructor(interimTextFrom = null, interimTextTo = null){
        this.interimTextFrom = interimTextFrom;
        this.interimTextTo = interimTextTo;
    }
}


const $a991831695a51a72$export$5bd0207bc8bc9737 = ()=>{
    const prosemirrorInsertTextManager = (0, $cozmU.useRef)(new (0, $258c7589868d87a6$export$9090fb60710493e4)());
    const handleTranscriptUpdate = (0, $cozmU.useCallback)((transcript, tr)=>{
        return prosemirrorInsertTextManager.current.insertText(transcript, tr);
    }, []);
    const rejectTranscriptedText = (0, $cozmU.useCallback)((tr)=>{
        return prosemirrorInsertTextManager.current.rejectTranscriptedText(tr);
    }, []);
    const disposeTranscriptedText = (0, $cozmU.useCallback)(()=>{
        prosemirrorInsertTextManager.current.disposeTranscriptedText();
    }, []);
    return {
        handleTranscriptUpdate: handleTranscriptUpdate,
        rejectTranscriptedText: rejectTranscriptedText,
        disposeTranscriptedText: disposeTranscriptedText
    };
};






var $3U8XR = parcelRequire("3U8XR");


var $cFVPs = parcelRequire("cFVPs");


var $89QZA = parcelRequire("89QZA");


var $04429 = parcelRequire("04429");


const $734cc50e90d9d65a$export$35a6f2c29539ef8f = (result, action)=>{
    switch(action.type){
        case 'SET_INITIALIZING':
            return {
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Initializing,
                transcription: null
            };
        case 'SET_RECORDING':
            return {
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording,
                transcription: action.payload.transcription,
                chunkIndex: action.payload.chunkIndex
            };
        case 'SET_STOPPED':
            return {
                ...result,
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
                stopReason: action.payload.stopReason
            };
        case 'SET_ERROR':
            return {
                ...result,
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Error,
                error: action.payload.error
            };
        default:
            return result;
    }
};



var $bLDEV = parcelRequire("bLDEV");

var $ba53528647b1cd0c$export$b1a2c42ac49f689c = /*#__PURE__*/ function(ConvoAIWebSocketServerMessageType) {
    ConvoAIWebSocketServerMessageType["TranscriptionResponseDelta"] = "transcription.response.delta";
    ConvoAIWebSocketServerMessageType["TranscriptionResponseCompleted"] = "transcription.response.completed";
    ConvoAIWebSocketServerMessageType["TranscriptionItemCreated"] = "transcription.item.created";
    ConvoAIWebSocketServerMessageType["TranscriptionSessionCreated"] = "transcription.session.created";
    return ConvoAIWebSocketServerMessageType;
}({});
var $ba53528647b1cd0c$export$533906f021c29dcb = /*#__PURE__*/ function(ConvoAIWebSocketClientMessageType) {
    ConvoAIWebSocketClientMessageType["AudioBufferAppend"] = "audio.buffer.append";
    ConvoAIWebSocketClientMessageType["AudioBufferCommit"] = "audio.buffer.commit";
    ConvoAIWebSocketClientMessageType["AudioSessionUpdate"] = "audio.session.update";
    return ConvoAIWebSocketClientMessageType;
}({});
class $ba53528647b1cd0c$export$843496a58dc19cce {
    updateTranscriptionConfig(instructions = `Transcribe speech to text. You may get wake words like 'Hey Rovo!' or 'Hey Atlassian!' or 'Rovo, '. Do not include the waking phrase at the beginning of transcription`, noise_detection = 'near_field', vad_type = 'semantic_vad', eagerness = 'medium', model = 'gpt-4o-transcribe', include = [
        'item.input_audio_transcription.logprobs'
    ]) {
        // `gpt-realtime-whisper` runs in OpenAI's GA Realtime API as a streaming
        // transcription-only session. Per the OpenAI Realtime VAD guide
        // (https://developers.openai.com/api/docs/guides/realtime-vad), whisper
        // requires `turn_detection` to be omitted or `null` — server VAD is
        // incompatible. Additionally, the `prompt` / `instructions` field is
        // not supported for whisper in GA Realtime, and the BE's gateway has
        // been verified to reject session updates that include those fields.
        //
        // `noise_detection` is also dropped because it implicitly relies on a
        // VAD pipeline. `include` is preserved so future consumers can opt in
        // to logprobs without re-plumbing.
        if (model === 'gpt-realtime-whisper') {
            this.socket.send(JSON.stringify({
                type: 'audio.session.update',
                model: model,
                include: include
            }));
            return;
        }
        this.socket.send(JSON.stringify({
            type: 'audio.session.update',
            model: model,
            include: include,
            vad_type: vad_type,
            eagerness: eagerness,
            instructions: instructions,
            noise_detection: noise_detection
        }));
    }
    sendAudio(audio) {
        this.socket.send(JSON.stringify({
            audio: audio,
            type: "audio.buffer.append"
        }));
    }
    commitAudio() {
        this.socket.send(JSON.stringify({
            type: "audio.buffer.commit"
        }));
    }
    connect() {
        return new Promise((resolve, reject)=>{
            this.socket.onopen = ()=>resolve(this);
            this.socket.onerror = (event)=>reject(event);
        });
    }
    disconnect() {
        this.socket?.close();
    }
    static create(cloudID, product, experience, onMessage) {
        const api = new $ba53528647b1cd0c$export$843496a58dc19cce(cloudID, product, experience, onMessage);
        return api.connect();
    }
    constructor(cloudID, product, experience, onMessage, websocketURI = (0, $bLDEV.getWebsocketURI)()){
        this.onMessage = onMessage;
        this.websocketURI = websocketURI;
        this.socket = void 0;
        this.onServerMessage = (event)=>{
            const data = JSON.parse(event.data);
            this.onMessage(data);
        };
        this.socket = new WebSocket(`${this.websocketURI}/wss/${cloudID}/ai-feature/audio/realtime-transcriptions?product=${product}&experience=${experience}`);
        this.socket.addEventListener('message', this.onServerMessage);
    }
}



var $78ai4 = parcelRequire("78ai4");


const $d562e193a34f1a02$var$getSupportedMimeType = ()=>{
    // Order of preference: webm (best for streaming), then mp4/aac (Safari)
    const mimeTypes = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/mp4',
        'audio/aac',
        'audio/ogg;codecs=opus'
    ];
    // Access MediaRecorder via window to avoid lint errors for unsupported browsers
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const MediaRecorderAPI = window.MediaRecorder;
    // Check if MediaRecorder.isTypeSupported exists (not available in older browsers)
    if (!MediaRecorderAPI || typeof MediaRecorderAPI.isTypeSupported !== 'function') return undefined;
    return mimeTypes.find((mimeType)=>MediaRecorderAPI.isTypeSupported(mimeType)) ?? undefined;
};
class $d562e193a34f1a02$export$b5efe1d364105d67 {
    async startRecording() {
        this.resetInMemoryState();
        this.onTranscription({
            type: 'SET_INITIALIZING'
        });
        await this.connectWebSocketConvoAIAPI();
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
            audio: {
                sampleRate: this.sampleRate,
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });
        const mimeType = $d562e193a34f1a02$var$getSupportedMimeType();
        const mediaRecorderOptions = {
            audioBitsPerSecond: this.audioBitsPerSecond
        };
        if (mimeType) mediaRecorderOptions.mimeType = mimeType;
        // eslint-disable-next-line compat/compat
        this.mediaRecorder = new MediaRecorder(this.mediaStream, mediaRecorderOptions);
        this.mediaRecorder.start(this.timeSlice);
        this.mediaRecorder.addEventListener('dataavailable', this.onMediaRecorderDataAvailable);
        this.mediaRecorder.addEventListener('stop', this.onMediaRecorderStop);
        this.mediaRecorder.addEventListener('error', this.onMediaRecorderError);
        this.recordingTimeout = setTimeout(()=>{
            this.stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted);
        }, this.maxRecordingDurationMs);
    }
    stopRecording(stopReason = (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted) {
        this.insertEmptySpaceIntoTranscription();
        this.clearRecordingTimeout();
        this.onTrace?.({
            type: 'STOP_RECORDING',
            payload: {
                stopReason: stopReason
            }
        });
        this.isStopped = true;
        this.onTranscription({
            type: 'SET_STOPPED',
            payload: {
                stopReason: stopReason
            }
        });
        this.mediaRecorder?.stop();
    }
    async connectWebSocketConvoAIAPI() {
        try {
            this.onTrace?.({
                type: 'START_WEBSOCKET_CONNECTION'
            });
            this.convoAIWebSocketAPI = await (0, $ba53528647b1cd0c$export$843496a58dc19cce).create(this.cloudID, this.product, this.experience, this.onMessage);
            this.onTrace?.({
                type: 'WEBSOCKET_CONNECTION_SUCCESS'
            });
            if (!this.skipSessionUpdate) this.convoAIWebSocketAPI.updateTranscriptionConfig(undefined, undefined, this.vadType, this.eagerness, this.model);
        } catch (error) {
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
        }
    }
    insertEmptySpaceIntoTranscription() {
        if (this.transcription) {
            this.transcription = this.transcription + ' ';
            this.onTranscription({
                type: 'SET_RECORDING',
                payload: {
                    transcription: this.transcription,
                    chunkIndex: this.chunkIndex
                }
            });
        }
    }
    clearRecordingTimeout() {
        if (this.recordingTimeout) {
            clearTimeout(this.recordingTimeout);
            this.recordingTimeout = null;
        }
    }
    resetInMemoryState() {
        this.isStopped = false;
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.sessionReadyDispatched = false;
        this.finalResponseListener = null;
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.lastAudioChunkWasProcessed = false;
        this.transcription = null;
        this.audioChunks = [];
        this.clearRecordingTimeout();
    }
    constructor(options){
        this.audioChunks = [];
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.convoAIWebSocketAPI = null;
        this.mediaStream = null;
        this.mediaRecorder = null;
        this.lastAudioChunkWasProcessed = false;
        this.recordingTimeout = null;
        this.transcription = null;
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.sessionReadyDispatched = false;
        this.finalResponseListener = null;
        this.isStopped = false;
        this.cloudID = void 0;
        this.sampleRate = void 0;
        this.audioBitsPerSecond = void 0;
        this.timeSlice = void 0;
        this.maxRecordingDurationMs = void 0;
        this.product = void 0;
        this.experience = void 0;
        this.vadType = void 0;
        this.eagerness = void 0;
        this.model = void 0;
        this.skipSessionUpdate = void 0;
        this.onTrace = void 0;
        this.onTranscription = void 0;
        this.onMessage = (event)=>{
            switch(event.type){
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionSessionCreated:
                    // Server has set up the transcription session and is ready to receive
                    // audio. Flip out of `Initializing` immediately so the loading state
                    // clears in ~hundreds of ms (vs waiting for the first delta which may
                    // not arrive for several seconds depending on server VAD silence
                    // thresholds and whether the user has started speaking yet).
                    if (!this.sessionReadyDispatched) {
                        this.sessionReadyDispatched = true;
                        this.onTranscription({
                            type: 'SET_RECORDING',
                            payload: {
                                transcription: '',
                                chunkIndex: 0
                            }
                        });
                    }
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionResponseDelta:
                    this.transcription = this.transcription !== null ? this.transcription + event.delta : event.delta;
                    this.chunkIndex++;
                    this.onTranscription({
                        type: 'SET_RECORDING',
                        payload: {
                            transcription: this.transcription,
                            chunkIndex: this.chunkIndex
                        }
                    });
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionResponseCompleted:
                    // Server has finalized an utterance. Insert a separator (single
                    // space) before the next utterance starts so that consecutive
                    // utterances don't visually fuse together in the rendered
                    // transcript (e.g. "EnglishOh." → "English Oh."). This is the
                    // only signal the gateway emits between utterances for
                    // gpt-realtime-whisper, where TranscriptionItemCreated does not
                    // fire.
                    // Only insert space if the session has not been stopped.
                    // If isStopped is true, stopRecording() has already been called and
                    // dispatching SET_RECORDING here would flip the UI back to listening
                    // after the user has explicitly stopped — causing the auto-resume bug.
                    if (!this.isStopped) this.insertEmptySpaceIntoTranscription();
                    // If we are in the middle of a graceful shutdown (`stopRecording`
                    // flushed remaining audio and is waiting for the server to
                    // finalize before closing), this signals "the server is done."
                    if (this.finalResponseListener) {
                        const listener = this.finalResponseListener;
                        this.finalResponseListener = null;
                        listener();
                    }
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionItemCreated:
                    this.createdItemChunkIndex++;
                    this.onTrace?.({
                        type: 'TRANSCRIPTION_ITEM_CREATED',
                        payload: {
                            createdItemChunkIndex: this.createdItemChunkIndex
                        }
                    });
                    this.insertEmptySpaceIntoTranscription();
                    break;
            }
        };
        this.onMediaRecorderStop = ()=>{
            this.mediaStream?.getTracks().forEach((track)=>track.stop());
            // Flush any in-flight audio bytes the data-available pipeline hadn't
            // yet committed, then give the server a brief window to finalize the
            // current utterance (emit response.completed) before tearing down the
            // WebSocket. Without this, the trailing N hundred milliseconds of
            // audio reach the server but get dropped because we close before the
            // final transcription.response.delta / response.completed are emitted.
            const api = this.convoAIWebSocketAPI;
            if (!api) return;
            try {
                api.commitAudio();
            } catch  {
                // commitAudio may throw if the socket has already closed; in that
                // case there is nothing more to wait for.
                api.disconnect();
                return;
            }
            const FINAL_RESPONSE_WAIT_MS = 2000;
            let settled = false;
            const finish = ()=>{
                if (settled) return;
                settled = true;
                this.finalResponseListener = null;
                api.disconnect();
            };
            this.finalResponseListener = finish;
            setTimeout(finish, FINAL_RESPONSE_WAIT_MS);
        };
        this.onMediaRecorderError = (event)=>{
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: event.message
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: event.message
                }
            });
        };
        this.onMediaRecorderDataAvailable = async (event)=>{
            this.audioChunks.push(event.data);
            try {
                const { audioString: audioString, newAudioEndPosition: newAudioEndPosition } = await (0, $78ai4.processAudioToTextWithPCM16)(this.audioChunks, this.lastProcessedPosition, this.sampleRate);
                this.lastProcessedPosition = newAudioEndPosition;
                if (audioString) {
                    this.lastAudioChunkWasProcessed = true;
                    this.processedChunksCountAfterLastCommit++;
                    this.convoAIWebSocketAPI?.sendAudio(audioString);
                } else if (audioString === null && this.lastAudioChunkWasProcessed) {
                    this.convoAIWebSocketAPI?.commitAudio();
                    this.processedChunksCountAfterLastCommit = 0;
                    this.lastAudioChunkWasProcessed = false;
                }
            } catch (error) {
                this.onTranscription({
                    type: 'SET_ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
                this.onTrace?.({
                    type: 'ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
            }
        };
        const { onTranscription: onTranscription, cloudID: cloudID, sampleRate: sampleRate = 24000, audioBitsPerSecond: audioBitsPerSecond = 16000, timeSlice: timeSlice = 1000, maxRecordingDurationMs: maxRecordingDurationMs = 60000, onTrace: onTrace, product: product = 'confluence', experience: experience = 'confluence-ai-first-creation', vadType: vadType, eagerness: eagerness, model: model, skipSessionUpdate: skipSessionUpdate = false } = options;
        this.onTranscription = onTranscription;
        this.cloudID = cloudID;
        this.sampleRate = sampleRate;
        this.audioBitsPerSecond = audioBitsPerSecond;
        this.timeSlice = timeSlice;
        this.maxRecordingDurationMs = maxRecordingDurationMs;
        this.onTrace = onTrace;
        this.product = product;
        this.experience = experience;
        this.vadType = vadType;
        this.eagerness = eagerness;
        this.model = model;
        this.skipSessionUpdate = skipSessionUpdate;
    }
}



const $d5990454569ae605$export$ba4cb2752281b87f = (onVoiceDictationUpdate, cloudID, { audioBitsPerSecond: audioBitsPerSecond = 16000, sampleRate: sampleRate = 24000, timeSlice: timeSlice = 1000, maxRecordingDurationMs: maxRecordingDurationMs = 60000, enableGhostText: enableGhostTextOption, product: product, experience: experience, vadType: vadType, eagerness: eagerness, model: model, skipSessionUpdate: skipSessionUpdate } = {})=>{
    const { sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, isInSmartCreateFlow: isInSmartCreateFlow } = (0, $cozmU.useContext)((0, $89QZA.SharedFeaturesInstrumentationIdContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultDiscarded: trackAIResultDiscarded } = (0, $cFVPs.useAIEventsInstrumentation)({
        product: 'platform',
        subproduct: 'platform',
        aiFeatureName: 'aiVoiceDictation',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        additionalAttributes: {
            isLegacyVersion: true,
            productAttributionOverride: product ?? 'confluence',
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    });
    const { start: start, success: success, startConnectionAttempt: startConnectionAttempt, successConnectionEstablished: successConnectionEstablished, reportTTFB: reportTTFB, reportRTT: reportRTT, failure: failure } = (0, $04429.useUFOStreamingExperience)('streaming-stt', 'ai-speech-to-text');
    const [result, dispatch] = (0, $cozmU.useReducer)((0, $734cc50e90d9d65a$export$35a6f2c29539ef8f), {
        state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Uninitialized,
        transcription: null
    });
    const trace = (0, $cozmU.useCallback)((action)=>{
        (0, $3U8XR.match)(action).with({
            type: 'START_WEBSOCKET_CONNECTION'
        }, ()=>{
            start();
            startConnectionAttempt();
        }).with({
            type: 'WEBSOCKET_CONNECTION_SUCCESS'
        }, ()=>{
            successConnectionEstablished();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: 1
            }
        }, ()=>{
            // Time to First Byte for first chunk
            reportTTFB();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: (0, $3U8XR.P).number
            }
        }, ({ payload: { createdItemChunkIndex: createdItemChunkIndex } })=>{
            // Round-trip time between received server messages
            reportRTT(createdItemChunkIndex);
        }).with({
            type: 'STOP_RECORDING'
        }, (stopAction)=>{
            success({
                metadata: {
                    stopReason: stopAction.payload.stopReason
                }
            });
        }).with({
            type: 'ERROR'
        }, (errorAction)=>{
            failure({
                metadata: {
                    error: errorAction.payload.error
                }
            });
        }).exhaustive();
    }, [
        reportRTT,
        reportTTFB,
        start,
        startConnectionAttempt,
        successConnectionEstablished,
        failure,
        success
    ]);
    const speechToTextManager = (0, $cozmU.useRef)(new (0, $d562e193a34f1a02$export$b5efe1d364105d67)({
        onTranscription: (action)=>dispatch(action),
        onTrace: (action)=>trace(action),
        cloudID: cloudID,
        sampleRate: sampleRate,
        audioBitsPerSecond: audioBitsPerSecond,
        timeSlice: timeSlice,
        maxRecordingDurationMs: maxRecordingDurationMs,
        product: product,
        experience: experience,
        vadType: vadType,
        eagerness: eagerness,
        model: model,
        skipSessionUpdate: skipSessionUpdate
    }));
    (0, $cozmU.useEffect)(()=>{
        onVoiceDictationUpdate(result);
    }, [
        result,
        onVoiceDictationUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $3U8XR.match)(result).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Initializing
        }, ()=>trackAIInteractionInit()).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording,
            chunkIndex: 1
        }, ()=>trackAIResultView()).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted
        }, ()=>trackAIResultAction('STTAcceptedByUser')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedRejected
        }, ()=>trackAIResultDiscarded('STTRejectedByUser')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted
        }, ()=>trackAIResultAction('STTAcceptedDueToTimeout')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Error
        }, (errorResult)=>trackAIResultError({
                aiErrorMessage: errorResult.error
            })).with((0, $3U8XR.P)._, ()=>{}).exhaustive();
    }, [
        result,
        trackAIInteractionInit,
        trackAIInteractionDismiss,
        trackAIResultView,
        trackAIResultError,
        trackAIResultAction,
        trackAIResultDiscarded
    ]);
    const startRecording = (0, $cozmU.useCallback)(()=>{
        speechToTextManager.current.startRecording();
    }, []);
    const stopRecording = (0, $cozmU.useCallback)((stopReason = (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted)=>{
        speechToTextManager.current.stopRecording(stopReason);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>stopRecording();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        result,
        {
            startRecording: startRecording,
            stopRecording: stopRecording
        }
    ];
};






var $1sCHt = parcelRequire("1sCHt");


var $eh6Ml = parcelRequire("eh6Ml");

const $47e91d0d524ca808$export$7abe5c0eca305a26 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                label: ''
            }),
        appearance: "primary",
        label: "Accept",
        onClick: onClick
    });
};









var $l3wuH = parcelRequire("l3wuH");

const $aec5babce2cfe750$export$a27af6ac3487f513 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                label: ''
            }),
        appearance: "subtle",
        onClick: onClick,
        label: "Reject"
    });
};



const $c9d69eeb89d1ca61$export$27e3d771cf5f0905 = ({ api: api, cloudId: cloudId })=>{
    const { isListening: isListening } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSpeechToText'
    ], (states)=>({
            isListening: states.aiSpeechToTextState?.isListening ?? false
        }));
    const { handleTranscriptUpdate: handleTranscriptUpdate, rejectTranscriptedText: rejectTranscriptedText, disposeTranscriptedText: disposeTranscriptedText } = (0, $a991831695a51a72$export$5bd0207bc8bc9737)();
    const onVoiceDictationUpdate = (0, $cozmU.useCallback)((result)=>{
        switch(result.state){
            case (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording:
                if (!api?.core?.actions?.execute) return;
                api.core.actions.execute(({ tr: tr })=>handleTranscriptUpdate(result.transcription, tr));
                break;
            case (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped:
                if (result.stopReason === (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted) {
                    disposeTranscriptedText();
                    api?.core.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                            isListening: false
                        });
                        return tr;
                    });
                }
                break;
            default:
                break;
        }
    }, [
        handleTranscriptUpdate,
        api,
        disposeTranscriptedText
    ]);
    const [, { startRecording: startRecording, stopRecording: stopRecording }] = (0, $d5990454569ae605$export$ba4cb2752281b87f)(onVoiceDictationUpdate, cloudId);
    const handleAccept = (0, $cozmU.useCallback)(()=>{
        disposeTranscriptedText();
        stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return tr;
        });
    }, [
        stopRecording,
        disposeTranscriptedText,
        api
    ]);
    const handleReject = (0, $cozmU.useCallback)(()=>{
        stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedRejected);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return rejectTranscriptedText(tr);
        });
    }, [
        stopRecording,
        rejectTranscriptedText,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isListening) startRecording();
        else stopRecording();
    }, [
        isListening,
        startRecording,
        stopRecording
    ]);
    if (!isListening) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47e91d0d524ca808$export$7abe5c0eca305a26), {
        onClick: handleAccept
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aec5babce2cfe750$export$a27af6ac3487f513), {
        onClick: handleReject
    }));
};


// This CLOUD_ID works only for internal usage and POC purposes. Do not use it in production or share it externally.
// TODO: We need to implement here a logic to get the current user's cloudId.
const $e314379a347b848a$var$CLOUD_ID_INTERNAL_USE_ONLY = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $e314379a347b848a$var$EMPTY_STATE = {
    isListening: false,
    error: null
};
const $e314379a347b848a$export$8fc6b5430a555c3d = ({ api: api })=>{
    return {
        name: 'aiSpeechToText',
        getSharedState (editorState) {
            if (!editorState) return $e314379a347b848a$var$EMPTY_STATE;
            return (0, $e608c7972031ca0a$export$ef2bd08fc1b88107).getState(editorState) ?? $e314379a347b848a$var$EMPTY_STATE;
        },
        pmPlugins () {
            return [
                {
                    name: 'speechToText',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            key: (0, $e608c7972031ca0a$export$ef2bd08fc1b88107),
                            state: {
                                init () {
                                    return $e314379a347b848a$var$EMPTY_STATE;
                                },
                                apply (tr, oldPluginState) {
                                    const meta = tr.getMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107));
                                    if (meta) return {
                                        ...oldPluginState,
                                        ...meta
                                    };
                                    return oldPluginState;
                                }
                            }
                        })
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ()=>[
                    {
                        id: 'aiSpeechToText',
                        title: 'Speech to text',
                        description: 'Dictate text using your voice',
                        priority: 600,
                        keywords: [
                            'speech',
                            'voice',
                            'dictation',
                            'microphone',
                            'audio',
                            'speak',
                            'stt'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjuSl))), {
                                label: "AI Speech to Text"
                            }),
                        action: (insert)=>{
                            const tr = insert('');
                            return tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                                isListening: true
                            });
                        }
                    }
                ]
        },
        contentComponent () {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9d69eeb89d1ca61$export$27e3d771cf5f0905), {
                cloudId: $e314379a347b848a$var$CLOUD_ID_INTERNAL_USE_ONLY,
                api: api
            });
        }
    };
};
module.exports["aiSpeechToTextPlugin"] = $e314379a347b848a$export$8fc6b5430a555c3d;

});

parcelRegister("1sOYw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $kRWx3 = parcelRequire("kRWx3");


var $4OhxS = parcelRequire("4OhxS");

var $gx3UZ = parcelRequire("gx3UZ");


var $4w5V7 = parcelRequire("4w5V7");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $kCECX = parcelRequire("kCECX");

const $7442d50be4fdd143$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('aiImageGenerationPlugin');


const $cb5f0a8f70a8cd87$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $cb5f0a8f70a8cd87$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $cb5f0a8f70a8cd87$var$setPopupMeta = ({ type: type, tr: tr })=>tr.setMeta((0, $7442d50be4fdd143$export$18d4026d1ea86bb1), {
        type: type
    });
const $cb5f0a8f70a8cd87$export$32885d2e40b7f4e1 = (tr)=>{
    return $cb5f0a8f70a8cd87$var$setPopupMeta({
        type: $cb5f0a8f70a8cd87$export$f766031ad28e12e3,
        tr: tr
    });
};
const $cb5f0a8f70a8cd87$export$ce1e1e9445fb8c72 = (tr)=>{
    return $cb5f0a8f70a8cd87$var$setPopupMeta({
        type: $cb5f0a8f70a8cd87$export$1be3e111c71a5c61,
        tr: tr
    });
};



var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");



const $f7fd7856568eef65$export$330c1774242547b5 = 'data-ai-image-generation-anchor';
const $f7fd7856568eef65$var$ANCHOR_DECORATION_KEY = 'ai-image-generation-anchor';
const $f7fd7856568eef65$var$createAnchorWidget = (pos)=>(0, $8nvEM.Decoration).widget(pos, ()=>{
        const el = document.createElement('span');
        el.setAttribute($f7fd7856568eef65$export$330c1774242547b5, 'true');
        el.contentEditable = 'false';
        el.style.cssText = 'display: inline-block; width: 0; height: 0; vertical-align: baseline; pointer-events: none;';
        return el;
    }, {
        side: -1,
        key: $f7fd7856568eef65$var$ANCHOR_DECORATION_KEY
    });
const $f7fd7856568eef65$export$f99f3880a7ce1ed9 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    decorations: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $7442d50be4fdd143$export$18d4026d1ea86bb1));
                const mappedDecorations = pluginState.decorations.map(tr.mapping, tr.doc);
                switch(meta?.type){
                    case 0, $cb5f0a8f70a8cd87$export$f766031ad28e12e3:
                        return {
                            isOpen: true,
                            decorations: (0, $8nvEM.DecorationSet).create(tr.doc, [
                                $f7fd7856568eef65$var$createAnchorWidget(tr.selection.from)
                            ])
                        };
                    case 0, $cb5f0a8f70a8cd87$export$1be3e111c71a5c61:
                        return {
                            isOpen: false,
                            decorations: (0, $8nvEM.DecorationSet).empty
                        };
                    default:
                        // If a doc edit destroyed the anchor position, auto-close so the
                        // popup can't render against a missing target.
                        if (pluginState.isOpen && mappedDecorations.find().length === 0) return {
                            isOpen: false,
                            decorations: (0, $8nvEM.DecorationSet).empty
                        };
                        return {
                            isOpen: pluginState.isOpen,
                            decorations: mappedDecorations
                        };
                }
            }
        },
        key: (0, $7442d50be4fdd143$export$18d4026d1ea86bb1),
        props: {
            decorations (state) {
                return (0, $7442d50be4fdd143$export$18d4026d1ea86bb1).getState(state)?.decorations;
            }
        }
    });
};



/* AIImageGenerationPopup.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");





var $dfEnC = parcelRequire("dfEnC");

var $7XIuB = parcelRequire("7XIuB");

var $1nt6a = parcelRequire("1nt6a");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iMnC5 = parcelRequire("iMnC5");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $ifkCZ = parcelRequire("ifkCZ");


var $e6Dq9 = parcelRequire("e6Dq9");


var $4Kyof = parcelRequire("4Kyof");


var $hYOOW = parcelRequire("hYOOW");


var $f3DNZ = parcelRequire("f3DNZ");


var $jNalm = parcelRequire("jNalm");


var $d1HsG = parcelRequire("d1HsG");


var $aqPDM = parcelRequire("aqPDM");


var $BQuz7 = parcelRequire("BQuz7");


var $9OqiZ = parcelRequire("9OqiZ");


var $hGZx0 = parcelRequire("hGZx0");


var $4P0HA = parcelRequire("4P0HA");


var $21wWN = parcelRequire("21wWN");


var $f6cdQ = parcelRequire("f6cdQ");


var $a1ZzW = parcelRequire("a1ZzW");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");







var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $at1wf = parcelRequire("at1wf");


var $gH7sg = parcelRequire("gH7sg");

const $cfd34b07a7919a27$var$i18n = (0, $kSwu1.defineMessages)({
    createImageLabel: {
        id: "ai-image-generation.image-from-ai-generation.create-image-label",
        defaultMessage: "Create an image with Rovo"
    },
    rovoIconAlt: {
        id: "ai-image-generation.image-from-ai-generation.rovo-icon-alt",
        defaultMessage: "Rovo icon"
    },
    describeImagePrompt: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-prompt",
        defaultMessage: "Describe an image to create"
    },
    describeImagePlaceholder: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-placeholder",
        defaultMessage: "Describe what you'd like to see..."
    },
    generateImage: {
        id: "ai-image-generation.image-from-ai-generation.generate-image",
        defaultMessage: "Generate image"
    },
    pickStyleLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-style-label",
        defaultMessage: "Pick a style"
    },
    styleButtonLabel: {
        id: "ai-image-generation.image-from-ai-generation.styleButtonLabel",
        defaultMessage: "Style"
    },
    pickRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-ratio-label",
        defaultMessage: "Ratio"
    },
    styleWatercolors: {
        id: "ai-image-generation.image-from-ai-generation.style-watercolors",
        defaultMessage: "Watercolors"
    },
    stylePhotoAuto: {
        id: "ai-image-generation.image-from-ai-generation.stylePhotoAuto",
        defaultMessage: "Photo (Auto)"
    },
    stylePhotoButton: {
        id: "ai-image-generation.image-from-ai-generation.stylePhotoButton",
        defaultMessage: "Photo"
    },
    styleSketch: {
        id: "ai-image-generation.image-from-ai-generation.style-sketch",
        defaultMessage: "Sketch"
    },
    styleThreeD: {
        id: "ai-image-generation.image-from-ai-generation.style-3d",
        defaultMessage: "3D"
    },
    aspectRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-label",
        defaultMessage: "Select a ratio"
    },
    aspectRatioAuto: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-auto-16-9",
        defaultMessage: "Auto 16:9"
    },
    aspectRatioLandscape: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-landscape",
        defaultMessage: "Landscape 3:2"
    },
    aspectRatioSquare: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-square",
        defaultMessage: "Square 1:1"
    },
    aspectRatioPortrait: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-portrait",
        defaultMessage: "Portrait 2:3"
    },
    aspectRatioNarrow: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-narrow",
        defaultMessage: "Narrow 9:16"
    },
    footerMessage: {
        id: "ai-image-generation.image-from-ai-generation.footer-message",
        defaultMessage: "Uses AI. Verify results."
    }
});
const $cfd34b07a7919a27$var$styles = {
    rovoIcon: "_39xV02ey7F _0jFU0Vey7F _2XsHFMFQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    imagePromptContainer: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _2Y7lL45zaO _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _37wbyuDIqT _0KLXrulfZc _46hvQm5zaO _0xmtko8HPE _43nrzT8HPE _2OUyjtETSP",
    stack: "_39xV02N91d _0aFT5vbt8w",
    actionsRow: "_39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _17lj8pFQfX",
    styleButtonContainer: "_0GTcwR4F84",
    submitButtonContainer: "_0GTcwRIZbP",
    footer: "_1UtDYzKGUX _46hvQm2ADO _3iDTPbQ4SZ _37wbyuDIqT _43nrzTTUhv _0rIjykB0rP"
};
function $cfd34b07a7919a27$export$1d338a5d45615a0b({ mediaUploadCollection: mediaUploadCollection, closePopup: closePopup, onSubmit: onSubmit, insertMedia: insertMedia }) {
    const intl = (0, $kSwu1.useIntl)();
    const [selectedTheme, setSelectedTheme] = (0, $cozmU.useState)(null);
    const [selectedAspectRatio, setSelectedAspectRatio] = (0, $cozmU.useState)(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $cozmU.useState)(true);
    const themeOptions = [
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.stylePhotoButton),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.stylePhotoAuto),
            value: null
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleThreeD),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleThreeD),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).threeD
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleSketch),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleSketch),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).sketch
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleWatercolors),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleWatercolors),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).watercolors
        }
    ];
    const aspectRatioOptions = [
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioAuto),
            value: '16:9',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($BQuz7)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioLandscape),
            value: '3:2',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aqPDM)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioSquare),
            value: '1:1',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($21wWN)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioPortrait),
            value: '2:3',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hGZx0)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioNarrow),
            value: '9:16',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9OqiZ)))
        }
    ];
    const selectedAspectRatioOption = aspectRatioOptions.find((option)=>option.value === selectedAspectRatio?.value);
    const SelectedAspectRatioIcon = selectedAspectRatioOption?.icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($BQuz7)));
    const aspectRatioButtonLabel = selectedAspectRatio?.value ?? intl.formatMessage($cfd34b07a7919a27$var$i18n.pickRatioLabel);
    const styleButtonLabel = selectedTheme?.buttonLabel ?? intl.formatMessage($cfd34b07a7919a27$var$i18n.styleButtonLabel);
    const textRef = (0, $cozmU.useRef)('');
    const textSerializerRef = (0, $cozmU.useRef)(null);
    const handleSubmit = (0, $cozmU.useCallback)((prompt)=>{
        if (!prompt.trim()) return;
        const aspectRatioToSend = selectedAspectRatio?.value ?? null;
        const imageStyleToSend = selectedTheme?.value ?? null;
        onSubmit(prompt, aspectRatioToSend, imageStyleToSend);
    }, [
        onSubmit,
        selectedAspectRatio,
        selectedTheme
    ]);
    const handleSubmitRef = (0, $cozmU.useRef)(handleSubmit);
    (0, $cozmU.useEffect)(()=>{
        handleSubmitRef.current = handleSubmit;
    }, [
        handleSubmit
    ]);
    const getTextSerializer = (0, $cozmU.useCallback)((editorView)=>{
        if (!textSerializerRef.current) textSerializerRef.current = (0, $at1wf.default).fromSchema(editorView.state.schema);
        return textSerializerRef.current;
    }, []);
    const onSave = (0, $cozmU.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        handleSubmitRef.current(text);
    }, [
        getTextSerializer
    ]);
    const handleEditorChange = (0, $cozmU.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        textRef.current = text;
        setIsSubmitDisabled(!text.trim());
    }, [
        getTextSerializer
    ]);
    const handleSubmitClick = (0, $cozmU.useCallback)(()=>{
        handleSubmit(textRef.current);
    }, [
        handleSubmit
    ]);
    const { preset: preset } = (0, $dVPAB.usePreset)((builder)=>builder.add([
            (0, $7Upsh.default),
            {}
        ]).add((0, $e6Dq9.compositionPlugin)).add((0, $4Kyof.focusPlugin)).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
            (0, $hYOOW.pastePlugin),
            {}
        ]).add((0, $ifkCZ.default)).add((0, $d1HsG.typeAheadPlugin)).add([
            (0, $f3DNZ.placeholderPlugin),
            {
                placeholder: intl.formatMessage($cfd34b07a7919a27$var$i18n.describeImagePlaceholder)
            }
        ]).add([
            (0, $fKdaf.blockTypePlugin),
            {
                allowBlockType: {
                    exclude: [
                        'heading',
                        'blockquote'
                    ]
                }
            }
        ]).add([
            (0, $jNalm.saveOnEnterPlugin),
            onSave
        ]), [
        onSave,
        intl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.rovoIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "xsmall",
        label: intl.formatMessage($cfd34b07a7919a27$var$i18n.rovoIconAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "bold"
    }, intl.formatMessage($cfd34b07a7919a27$var$i18n.createImageLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.imagePromptContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        appearance: "chromeless",
        preset: preset,
        shouldFocus: true,
        onChange: handleEditorChange,
        assistiveLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.describeImagePlaceholder)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.actionsRow
    }, (0, $4o0zT.isExperimentEnabled)('editor-image-generation-styles-and-aspect-ratios') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.styleButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        strategy: "absolute",
        zIndex: 9999,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                "aria-label": intl.formatMessage($cfd34b07a7919a27$var$i18n.pickStyleLabel),
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4P0HA))),
                testId: "image-generation-style-trigger"
            }, styleButtonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, themeOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: option.value,
            isSelected: selectedTheme?.value === option.value,
            onClick: ()=>setSelectedTheme((currentTheme)=>currentTheme?.value === option.value ? null : option)
        }, option.label))))), (0, $4o0zT.isExperimentEnabled)('editor-image-generation-styles-and-aspect-ratios') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        strategy: "absolute",
        zIndex: 9999,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                "aria-label": intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioLabel),
                iconBefore: SelectedAspectRatioIcon,
                testId: "image-generation-aspect-ratio-trigger"
            }, aspectRatioButtonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, aspectRatioOptions.map((option)=>{
        const OptionIcon = option.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: option.value,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OptionIcon, {
                label: "",
                size: "small"
            }),
            isSelected: selectedAspectRatio?.value === option.value,
            onClick: ()=>setSelectedAspectRatio((currentAspectRatio)=>currentAspectRatio?.value === option.value ? null : {
                        label: option.label,
                        value: option.value
                    })
        }, option.label);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.submitButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "image-generation-submit",
        appearance: "primary",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: intl.formatMessage($cfd34b07a7919a27$var$i18n.generateImage),
        isDisabled: isSubmitDisabled,
        onClick: handleSubmitClick
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($cfd34b07a7919a27$var$i18n.footerMessage)))))));
}




const $7bdf65bfe463f129$var$PopupWithListeners = (0, $1nt6a.default)((0, $7XIuB.default));
const $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT = 'GenerateImageEntrypoint'; // Reuse the existing image-generation Remix upload/insert route; `aiFeatureName`
// and `remixSource` below distinguish this quick-insert entrypoint in analytics.
const $7bdf65bfe463f129$var$IMAGE_GENERATION_INTERACTION_SOURCE = 'remixModalFromMediaInserts';
const $7bdf65bfe463f129$var$styles = {
    wrapper: "_0bjKvDKxmn _1ANEUSzUZr _2fwxA5yL8i _2OUyjtFYNq _39xV02e9dk _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruoI2d"
};
function $7bdf65bfe463f129$export$63fb1df4e3d7b0a7({ api: api, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mediaProvider: mediaProvider, isOpen: isOpen } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media',
        'aiImageGeneration'
    ], (states)=>({
            mediaProvider: states.mediaState?.mediaProvider,
            isOpen: states.aiImageGenerationState?.isOpen
        }));
    const closePopup = (0, $cozmU.useCallback)(()=>{
        editorView.dispatch((0, $cb5f0a8f70a8cd87$export$ce1e1e9445fb8c72)(editorView.state.tr));
        editorView.focus();
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        // When clicking a Select option, react-select removes the clicked
        // element from the DOM before this handler fires. The detached node
        // is no longer contained in the popup wrapper, so withOuterListeners
        // incorrectly treats it as an outside click. Skip closing when the
        // target has been disconnected from the document.
        const target = event.target;
        if (target && !target.isConnected) return;
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleEscapeKeydown = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleSubmit = (0, $cozmU.useCallback)((prompt, aspectRatio, imageStyle)=>{
        closePopup();
        const cmd = api?.malleableUi?.commands.startRemixThinking({
            remixModalMetadata: {
                interactionSource: $7bdf65bfe463f129$var$IMAGE_GENERATION_INTERACTION_SOURCE,
                aiFeatureName: $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT,
                userPrompt: prompt,
                aspectRatio: aspectRatio,
                imageStyle: imageStyle,
                dynamicUiType: 'image',
                remixSource: $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT
            }
        });
        if (!cmd) return;
        api?.core.actions.execute(cmd);
    }, [
        api,
        closePopup
    ]);
    if (!isOpen || !mediaProvider) return null;
     // Anchor to the decoration widget that the PM plugin mounts at the caret
    // when the popup opens. The widget is an inline zero-width DOM node, so its
    // bounding rect is aligned with the caret even in center/right-aligned
    // paragraphs, layout columns, table cells, etc.
    const targetRef = editorView.dom.querySelector(`[${(0, $f7fd7856568eef65$export$330c1774242547b5)}]`); // Without a real anchor element Popper would position against the viewport
    // origin. Bail out instead of rendering a mis-placed popup — the next
    // transaction that mounts the widget (or closes the plugin) will re-render.
    if (!targetRef) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($7bdf65bfe463f129$var$PopupWithListeners, {
        ariaLabel: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationPopupAriaLabel),
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        focusTrap: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dfEnC.PlainOutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    ref: setOutsideClickTargetRef,
                    xcss: $7bdf65bfe463f129$var$styles.wrapper,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfd34b07a7919a27$export$1d338a5d45615a0b), {
                        mediaUploadCollection: mediaProvider.uploadParams?.collection,
                        closePopup: closePopup,
                        onSubmit: handleSubmit
                    })
                })
        })
    });
}












const $05f8ceed867ab768$var$DEFAULT_ASPECT_RATIO = '16:9';
const $05f8ceed867ab768$var$PHOTO_AUTO_IMAGE_STYLE = 'Photo (Auto)';
function $05f8ceed867ab768$export$e25ea543915fb1a5({ closeMediaInsertPicker: closeMediaInsertPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent, mediaProvider: mediaProvider, api: api }) {
    const handleSubmit = (0, $cozmU.useCallback)((prompt, aspectRatio, imageStyle)=>{
        closeMediaInsertPicker();
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).SUBMITTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    aiFeatureName: 'imageGenerationMediaInsert',
                    aspectRatio: aspectRatio?.trim() || $05f8ceed867ab768$var$DEFAULT_ASPECT_RATIO,
                    imageStyle: imageStyle ?? $05f8ceed867ab768$var$PHOTO_AUTO_IMAGE_STYLE
                }
            };
            dispatchAnalyticsEvent(payload);
        }
        const remixModalMetadata = {
            interactionSource: 'remixModalFromMediaInserts',
            aiFeatureName: 'imageGenerationMediaInsert',
            userPrompt: prompt,
            aspectRatio: aspectRatio,
            imageStyle: imageStyle,
            dynamicUiType: 'image',
            remixSource: 'mediaInsert',
            onCancel: ()=>{
                const cmd = api?.mediaInsert?.commands.showMediaInsertPopup();
                if (cmd) api?.core.actions.execute(cmd);
            }
        };
        const cmd = api?.malleableUi?.commands.startRemixThinking({
            remixModalMetadata: remixModalMetadata
        });
        if (!cmd) return;
        api?.core.actions.execute(cmd);
    }, [
        api,
        closeMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfd34b07a7919a27$export$1d338a5d45615a0b), {
        mediaUploadCollection: mediaProvider.uploadParams?.collection,
        closePopup: closeMediaInsertPicker,
        onSubmit: handleSubmit
    });
}





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");














var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");




const $e0a2848c152b66e4$export$1e00734580dbc90 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const title = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration);
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert('');
        api?.aiImageGeneration.commands.showAIImageGenerationPopup()({
            tr: tr
        });
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
            label: title,
            color: "currentColor"
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        title: title
    });
};


const $9ca4b0f3933bc21c$export$a46fb6731991a73b = ({ api: api, isImageGenerationEnabled: isImageGenerationEnabled })=>[
        {
            key: (0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).key,
            type: (0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationDescription),
                    keywords: [
                        'ai',
                        'generate',
                        'image',
                        'create',
                        'picture'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e0a2848c152b66e4$export$1e00734580dbc90), {
                    api: api
                }),
            isHidden: ()=>!isImageGenerationEnabled || !api?.malleableUi || !api?.media?.sharedState.currentState()?.mediaProvider
        }
    ];


/**
 * Renders the "Create" tab label using the same
 * `intl.formatMessage(...)` pattern that `MediaInsertPicker` uses for its
 * built-in `fileTabTitle` and `linkTabTitle` tabs. Defined at module scope so
 * the component reference is stable across renders.
 */ const $aab8c39652c434bb$var$GenerateTabLabel = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: intl.formatMessage((0, $4OhxS.mediaInsertMessages).generateTabTitle)
    });
};
const $aab8c39652c434bb$export$961e3fbb53954d8c = ({ api: api, config: config })=>{
    // Register a "Create" tab on the media insert picker. This keeps
    // the public `editor-plugin-media-insert` package free of `@atlassian/*`
    // dependencies — it only knows about the registry interface, not about
    // AI image generation.
    const { isRemixHidden: isRemixHidden, isRovoLLMEnabled: isRovoLLMEnabled } = config ?? {
        isRemixHidden: true,
        isRovoLLMEnabled: false
    };
    const isRemixEnabled = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $9ca4b0f3933bc21c$export$a46fb6731991a73b)({
        api: api,
        isImageGenerationEnabled: (0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && (0, $iDrrr.fg)('m0_editor_image_generation_exclusion')
    }));
    if ((0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && api && !isRemixHidden && isRemixEnabled) api?.mediaInsert?.actions.registerInsertTab({
        key: 'ai-image-generation',
        label: /*#__PURE__*/ (0, $8aG6j.jsx)($aab8c39652c434bb$var$GenerateTabLabel, {}),
        ...(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_image_generation_improvement_ex') && {
            rank: (0, $kRWx3.MEDIA_INSERT_TAB_RANK)[(0, $krYZG.MEDIA_INSERT_TAB).CREATE]
        },
        component: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $05f8ceed867ab768$export$e25ea543915fb1a5), {
                closeMediaInsertPicker: props.closeMediaInsertPicker,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                insertMediaSingle: props.insertMediaSingle,
                mediaProvider: props.mediaProvider,
                api: api
            })
    });
    return {
        name: 'aiImageGeneration',
        pmPlugins () {
            return [
                {
                    name: 'aiImageGeneration',
                    plugin: ()=>(0, $f7fd7856568eef65$export$f99f3880a7ce1ed9)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const state = (0, $7442d50be4fdd143$export$18d4026d1ea86bb1).getState(editorState);
            if (!state) return {
                isOpen: false
            };
            return {
                isOpen: state.isOpen
            };
        },
        commands: {
            showAIImageGenerationPopup: ()=>({ tr: tr })=>(0, $cb5f0a8f70a8cd87$export$32885d2e40b7f4e1)(tr)
        },
        contentComponent: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7bdf65bfe463f129$export$63fb1df4e3d7b0a7), {
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            quickInsert: ({ formatMessage: formatMessage })=>{
                /**
         * expValEquals('cc_page_experiences_editor_image_generation', 'isEnabled', true) is for overall experiment
         *
         * fg('m0_editor_image_generation_exclusion') for features that's been hidden in M0. If this is not on
         * it should not show up in the quick insert.
         */ if (!(0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) return [];
                if (!(0, $iDrrr.fg)('m0_editor_image_generation_exclusion')) return [];
                const title = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration);
                return [
                    {
                        id: 'aiImageGeneration',
                        title: title,
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationDescription),
                        priority: 500,
                        keywords: [
                            'ai',
                            'generate',
                            'image',
                            'create',
                            'picture'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
                                label: title,
                                color: "currentColor"
                            }),
                        isDisabledOffline: true,
                        action (insert) {
                            const tr = insert('');
                            api?.aiImageGeneration.commands.showAIImageGenerationPopup()({
                                tr: tr
                            });
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};
module.exports["aiImageGenerationPlugin"] = $aab8c39652c434bb$export$961e3fbb53954d8c;

});

parcelRegister("axCbT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $jbxiN = parcelRequire("jbxiN");


var $eRJEr = parcelRequire("eRJEr");


var $4o0zT = parcelRequire("4o0zT");




parcelRequire("cozmU");


var $4PdTO = parcelRequire("4PdTO");


var $8Dx7s = parcelRequire("8Dx7s");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");





var $2pQiO = parcelRequire("2pQiO");

/* RemixPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iHsYL = parcelRequire("iHsYL");


var $9ivsj = parcelRequire("9ivsj");


var $IQ4Dz = parcelRequire("IQ4Dz");

var $64ff43be3a1ab908$exports = {};
$64ff43be3a1ab908$exports = new URL("remix-animation-card-purple.8816882c.png", import.meta.url).toString();


var $d1e5fcd73aeb6479$exports = {};
$d1e5fcd73aeb6479$exports = JSON.parse("{\"layers\":[{\"nm\":\"title text\",\"ddd\":0,\"ty\":5,\"ind\":0,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,81.9]},{\"t\":11.8,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,81.9]},{\"t\":42.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,114.7]},{\"t\":330,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,111.9]},{\"t\":360,\"s\":[752,111.9]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":11.8,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":42.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"t\":{\"a\":[],\"d\":{\"k\":[{\"s\":{\"f\":\"AtlassianSansBold\",\"fc\":[0.1608,0.1647,0.1804,1],\"sw\":0,\"s\":40,\"lh\":48,\"t\":\"Create an infographic\",\"j\":0},\"t\":0}]},\"m\":{\"a\":{\"k\":[0,0],\"a\":0},\"g\":1},\"p\":{}}},{\"nm\":\"title icon\",\"ddd\":0,\"ty\":4,\"ind\":1,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,47.9]},{\"t\":11.8,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,47.9]},{\"t\":42.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,80.7]},{\"t\":330,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,77.9]},{\"t\":360,\"s\":[692,77.9]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":11.8,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":42.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Icon\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Glyph\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.8884,-0.3241],[0.1517,-0.4158],[0,0],[0.946,0],[0.3241,0.8884],[0,0],[0,0],[0,0],[-0.7775,0.2836],[-0.1517,0.4158],[0,0],[-0.8263,0.0011],[-0.3365,-0.6077],[-0.4158,-0.1517],[0,0],[0,-0.9451]],\"o\":[[0,0.9457],[0,0],[0,0],[-0.3239,0.8881],[-0.9457,0],[0,0],[-0.1517,-0.4158],[-0.7779,-0.2838],[0,0],[0,0],[0,0],[0.3913,-0.7068],[0,0],[0,0],[0,0],[0.8889,0.3242],[0,0]],\"v\":[[18,9.1],[16.5,11.2],[12.3,13.3],[11.1,16.6],[9,18.1],[6.9,16.6],[5.7,13.3],[1.5,11.2],[0,9.1],[1.5,7],[5.7,4.9],[7,1.3],[9,0.0908],[11,1.3],[13.2,5.8],[16.5,7],[18,9.1]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.8787,-0.8786],[0,0],[0,0],[0,0],[0,0],[0,0],[1.8,-0.0002],[0,0],[0,0],[-0.2847,0.3501],[0,0],[-1.8,0.0002],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0.8787,0.8787],[0,0],[0,0],[0,0],[0,0],[-0.4513,0.0002],[-1.1,1.4],[0,0],[0,0],[0,0],[0,0],[1.1,-1.4],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[47.3,7.5],[47.3,10.7],[39.8,18.2],[36.7,15],[40.3,11.3],[31.8,11.3],[13.4,33.1],[8.7,35.3],[0,35.3],[0,30.8],[9.9,30.3],[27.1,9.1],[31.8,6.8],[40.3,6.8],[36.7,3.2],[39.8,0],[47.3,7.5]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,-0.5967],[0.422,-0.4219],[0,0],[0,0],[0,0],[0,0],[1.1,1.4],[0,0],[0,0],[-0.4513,-0.0002],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0.422,0.422],[0,0.5968],[0,0],[0,0],[0,0],[0,0],[-1.8,-0.0002],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[47.3,30],[48,31.6],[47.3,33.2],[39.8,40.7],[36.7,37.5],[40.3,33.8],[31.8,33.8],[27.1,31.6],[23.8,27.5],[26.7,23.9],[31.8,29.3],[40.3,29.3],[36.7,25.7],[39.8,22.5],[47.3,30]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Rectangle 1\",\"ddd\":0,\"ty\":4,\"ind\":2,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[471,53]},{\"t\":251.9,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[471,53]},{\"t\":307.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1237,53]},{\"t\":326.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177,53]},{\"t\":360,\"s\":[1177,53]}]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":309,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[155.3,100]},{\"t\":326.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[129.7,100]},{\"t\":360,\"s\":[129.7,100]}]},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Rectangle 1\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.2,0],[202,0],[183.1,89],[0,89],[22.2,0]]},\"a\":0}},{\"ty\":\"gf\",\"s\":{\"k\":[17,0],\"a\":0},\"e\":{\"k\":[190.6,20.8],\"a\":0},\"t\":1,\"h\":{\"k\":0,\"a\":0},\"a\":{\"k\":0,\"a\":0},\"g\":{\"k\":{\"k\":[0,1,1,1,0.3317,1,1,1,0.6875,1,1,1,1,1,1,1,0,0,0.3317,1,0.6875,1,1,0],\"a\":0},\"p\":4},\"o\":{\"k\":60,\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"h1 Header\",\"ddd\":0,\"ty\":4,\"ind\":3,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,159.9]},{\"t\":94.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,159.9]},{\"t\":117.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,187.8]},{\"t\":330,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,189.9]},{\"t\":360,\"s\":[100,189.9]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":94.2,\"i\":{\"x\":[0.275],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":117.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"h1 Header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.7371,0.6757],[1.4,-0.0922],[0.8292,-2.3],[-0.2457,-1.9],[-1.8,-2.4],[-4.4,-0.5528],[-3.3,0.6757],[-5.5,2.5],[-0.1229,0.0614],[-1,-0.1536],[-0.4607,-0.4606],[-0.5221,-1.2],[0,0],[-0.952,-0.5835],[-1,-0.1536],[-0.7678,0.2764],[-3.9,2.5],[-4.5,3.3],[0,0],[-0.921,-0.1843],[-2.4,-3.6],[-2.7,-2.8],[-4,-0.9213],[-1.6,0.0921],[-0.737,0.0922],[-3.3,1.4],[-1.9,0.86],[0,0.0614],[-1.3,0.0921],[-0.215,-0.0615],[-4.3,-3],[-1.3,-0.4606],[-0.184,0],[-1.8,0.2457],[-14.6,-0.6757],[-6.9,-0.1536],[-13.3,1.7],[-3,0.9521],[-5.7,2.5],[12.2,-2.6],[3.1,-0.1842],[15.8,0.3992],[18.7,0.8906],[6.1,-0.2764],[3.5,-0.5221],[0.123,0.0307],[1.5,1.3],[0.829,0.5528],[0.952,0.3071],[0.83,0],[0.645,-0.1228],[1.1,-0.3993],[4.1,-2.5],[5.3,-2],[0,0],[0.738,0.7371],[4.3,3.3],[4.9,0.5221],[2.3,-0.215],[1.5,-0.215],[0.645,-0.4914],[4.2,-2.7],[0.1843,-0.0614],[0.2457,0.5221],[0.7678,1.9],[3.2,2.2],[1.2,0.6449],[1.2,0.1535],[2,-0.1228],[0.6757,-0.215],[4.4,-1.4],[1.4,0],[0,0]],\"o\":[[-0.6757,-0.645],[-1.3,-1.4],[-1.4,0.0921],[-0.3378,1.2],[0.1536,1.8],[2.6,3.4],[4.2,0.5528],[6.4,-1.4],[2.7,-1.3],[0,0],[2.4,0],[0.3378,0.215],[0.6756,1.1],[0.3992,0.43],[0.9828,0.4914],[2.1,0],[0.6756,-0.2764],[1.9,-1.2],[0.307,-0.215],[0.615,-0.0921],[3.7,1],[1.2,1.8],[2.6,2.8],[1.8,0.3379],[0.829,0],[5.7,-0.8599],[3.4,-1.3],[2.2,-1.1],[0.737,-0.2764],[0.43,-0.1229],[0.952,0.6449],[1.1,0.6757],[1.3,0.4914],[0,0],[14.3,-1.8],[20.6,0.5528],[16.3,0.3378],[3.3,-0.4607],[6.1,-1.8],[12.7,-4.9],[-5.6,1.4],[-12.6,0.6143],[-6.2,-0.1536],[-6,-0.3378],[-3.3,0.2457],[-3.5,0.5835],[0,0],[-1.5,-1.2],[-0.891,-0.5221],[-0.952,-0.3378],[-0.798,0.0307],[-1.3,0.3071],[-0.952,0.6757],[-4.1,2.4],[-2.6,1.1],[-0.215,-0.0307],[-1.5,-1.3],[-4.2,-3.4],[-2.4,-0.215],[-1.1,0.0614],[-0.891,-0.0614],[0,0],[-6.3,4.1],[-0.3685,0.0922],[-0.1228,-0.2764],[-1.5,-3.9],[-1.2,-0.8599],[-1.2,-0.4607],[-1.1,-0.1229],[-0.9214,0.1536],[0,0],[-2.1,0.7064],[-1.3,0.1228],[0,0]],\"v\":[[12.3,28.6],[8.3,24.1],[4.1,21.9],[0.4625,25.4],[0.0939,29.9],[3,36.9],[14.3,43.1],[25.1,42.5],[42.6,36.3],[57.7,29.3],[64.6,28.7],[69,29.7],[74.5,42.4],[77.6,47],[81.7,50.2],[87.8,51.8],[96.6,50.4],[111.1,42.7],[149,16.6],[151.2,16.1],[159.2,16.6],[167.4,23.1],[177,37.6],[187.6,43.7],[193.1,44.3],[197.8,44],[211,40.3],[218.7,36.8],[244.1,19.6],[251.6,17.5],[254.1,18.1],[268.1,32.9],[275.3,36.4],[283.5,38],[306.6,33.6],[350.5,32],[432.2,35.8],[476.3,33.5],[495.3,29.7],[513,24.1],[510,13.5],[474.7,18],[432.6,18.6],[357.7,12],[339.4,12.1],[308.7,15.1],[282.8,20.3],[277,17.9],[263.2,3.3],[257.7,0.7985],[252.3,0],[245.7,0.6757],[235.6,3.8],[214.6,18],[200.4,25.2],[192.3,27.1],[188.7,25.6],[174.1,6.7],[159.4,0.7985],[152.2,0.645],[144.2,1.6],[142.1,2.6],[110.4,25.4],[91.9,35.3],[89.3,34.3],[86.5,25.8],[79,15.9],[75.3,13.8],[68,11.9],[58.8,12.1],[52.7,13.3],[21.4,28.7],[15.7,29.8],[12.3,28.6]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"h1 description\",\"ddd\":0,\"ty\":4,\"ind\":4,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,277.7]},{\"t\":105.3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,277.7]},{\"t\":129,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,255.6]},{\"t\":330,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,257.7]},{\"t\":360,\"s\":[100,257.7]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":105.3,\"i\":{\"x\":[0.275],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":129,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"h1 description\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector_2\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.727,-0.0474],[0.427,-1.2],[-0.127,-0.9966],[-0.95,-1.2],[-2.3,-0.2847],[-1.7,0.348],[-0.064,0.0317],[-0.237,-0.2373],[0,0],[-0.522,-0.0791],[-0.396,0.1423],[-2,1.3],[0,0],[-0.475,-0.0949],[-1.2,-1.9],[-1.4,-1.4],[-2,-0.4746],[-0.823,0.0474],[-0.965,0.4429],[0,0.0316],[-0.68,0.0474],[-0.111,-0.0316],[-2.2,-1.6],[-0.095,0],[-0.917,0.1265],[-7.5,-0.348],[-3.6,-0.0791],[-6.8,0.8859],[-2.9,1.3],[6.3,-1.3],[1.6,-0.095],[8.1,0.2057],[9.6,0.4588],[3.1,-0.1424],[1.8,-0.269],[0.064,0.0158],[0.76,0.6802],[0.427,0.2848],[0.427,0],[0.554,-0.2056],[2.1,-1.3],[2.7,-1],[0,0],[0.38,0.3796],[2.2,1.7],[2.5,0.2689],[1.2,-0.1107],[0.332,-0.2531],[2.2,-1.4],[0.094,-0.0317],[0.126,0.269],[0.396,0.9808],[1.7,1.1],[0.601,0.0791],[0.348,-0.1107],[2.2,-0.7435],[0.712,0],[0,0]],\"o\":[[-0.348,-0.3322],[-0.728,0.0475],[-0.174,0.6169],[0.079,0.9492],[1.4,1.8],[2.2,0.2848],[3.3,-0.7277],[0,0],[0.174,0.1107],[0.206,0.2215],[1.1,0],[0.348,-0.1424],[0.981,-0.617],[0.317,-0.0475],[1.9,0.5221],[0.617,0.9333],[1.4,1.4],[0.949,0.174],[0.427,0],[1.1,-0.5537],[0.38,-0.1424],[0.221,-0.0633],[0.491,0.3322],[0.585,0.348],[0,0],[7.4,-0.9334],[10.6,0.2847],[8.4,0.1741],[1.7,-0.2373],[6.5,-2.5],[-2.9,0.7277],[-6.5,0.3163],[-3.2,-0.0791],[-3.1,-0.174],[-1.7,0.1265],[-1.8,0.3005],[0,0],[-0.79,-0.6328],[-0.459,-0.2689],[-0.411,0.0158],[-0.49,0.348],[-2.1,1.2],[-1.3,0.5536],[-0.11,-0.0158],[-0.759,-0.6644],[-2.2,-1.8],[-1.2,-0.1107],[-0.585,0.0316],[0,0],[-3.2,2.1],[-0.19,0.0474],[-0.064,-0.1423],[-0.775,-2],[-0.601,-0.4429],[-0.585,-0.0633],[0,0],[-1.1,0.3639],[-0.664,0.0633],[0,0]],\"v\":[[400.4,23.6],[396.2,20.2],[394.3,21.9],[394.1,24.3],[395.7,27.9],[401.4,31.1],[407,30.8],[423.8,24],[429.6,24.2],[434.1,33.1],[439.3,35.5],[443.8,34.8],[451.3,30.8],[472,17.2],[476.1,17.4],[480.3,20.8],[485.2,28.2],[490.7,31.4],[493.5,31.7],[506.8,27.8],[519.8,19],[523.7,17.9],[525,18.2],[532.2,25.8],[540.1,28.4],[552,26.1],[574.6,25.3],[616.7,27.3],[639.4,26.1],[658.3,21.3],[656.8,15.8],[638.6,18.1],[616.9,18.4],[578.3,15],[568.9,15.1],[553.1,16.6],[539.7,19.3],[536.7,18.1],[529.7,10.6],[524,8.9],[515.4,10.8],[504.6,18.1],[497.3,21.8],[493.1,22.8],[491.3,22],[483.8,12.3],[476.2,9.3],[472.5,9.2],[467.3,10.2],[451,22],[441.4,27],[440.1,26.5],[438.6,22.1],[434.8,17],[429.1,15],[421.2,15.7],[405.1,23.6],[402.2,24.2],[400.4,23.6]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.585,0.5853],[0.332,0.6644],[1.5,-0.0632],[4.2,0],[4.5,0.5853],[11.5,2],[7.5,-1.2],[0.902,-0.3481],[3.9,-2.8],[0.016,-0.0158],[0.19,3.7],[2.5,4.3],[2.7,0.7277],[2,-0.4588],[2.9,-1.6],[2.2,-1],[0.696,0.1265],[0.38,3.5],[1.2,2.1],[2.2,0.8542],[1.9,0.0633],[0.87,-0.2373],[0,0],[4.6,-4.4],[4.3,-3.5],[0.095,-0.0316],[0.19,0.4271],[0.237,0.443],[3.3,2.4],[3.6,-0.0791],[2.6,-0.965],[0.9491,-0.6011],[0,0],[1.2,-0.174],[2.6,0.3164],[5.3,0.5379],[2.7,-0.2373],[2.5,-1],[0.9175,-0.6328],[0.4429,-0.6328],[-0.3955,-0.5062],[-1.3,0.3006],[-1.2,0.2689],[-4.6,-0.8384],[-6.2,-0.9333],[-3.5,0.3796],[0,0],[-0.8226,0.4587],[-1.9,0.1265],[-1.6,-0.9175],[-1.3,-2.2],[-0.507,-0.6169],[-3.4,-0.1582],[-1.6,0.6486],[0,0],[-3.4,3.6],[-3.8,3.5],[-4.4,1.7],[-1.1,0.0949],[-0.632,-0.5537],[-0.079,-0.9175],[0.063,-1.9],[-0.127,-0.5853],[-0.917,-0.2848],[-1.1,-0.0158],[0,0],[-3.3,1.8],[-5.8,3.7],[-2.8,0.9491],[-0.87,-0.0949],[-0.285,-0.3481],[-0.348,-1.4],[-0.997,-2.2],[-0.538,-0.4113],[-0.601,-0.0791],[-1.6,0.9808],[-0.823,0.7435],[0,0],[-4.5,0.6327],[-3.4,-0.1423],[-9.7,-0.8385],[-4.6,0.3322],[0,0]],\"o\":[[1.5,-0.4271],[1.2,-1.2],[-0.332,-0.6644],[-1.5,0.095],[-4.2,0.0158],[-9.1,-1.2],[-13.1,-2.1],[-0.933,0.1582],[-3.5,1.4],[-0.396,0.269],[0,0],[-0.284,-3.7],[-1.2,-2.1],[-2.7,-0.7277],[-4.1,0.9966],[-5.7,3.3],[-1.1,0.5379],[0,0.0316],[-0.237,-1.8],[-1.1,-2.1],[-2.1,-0.9017],[-1.8,-0.0158],[-1.7,0.3797],[-6.2,3.2],[-4.6,4.4],[-1.5,1.2],[-0.205,0.0475],[-0.38,-0.8542],[-1.8,-3.5],[-3.3,-2.5],[-3.7,-0.0158],[-1.2,0.5853],[-1.9,1.2],[-0.0474,0.0474],[-2.5,0.3164],[-5.2,-0.6485],[-2.6,-0.2689],[-2.7,0.2373],[-1.4,0.522],[-0.8701,0.7276],[-0.8859,1.3],[0.3955,0.5062],[0.6486,-0.1582],[4.1,-1.2],[4.6,0.8226],[3.1,0.443],[1.7,-0.2057],[0.3164,-0.1265],[0.8226,-0.4904],[1.9,-0.174],[1.6,0.965],[0.38,0.4904],[2,2.5],[1.7,0.0791],[0.38,-0.174],[4.8,-3.1],[3.6,-3.9],[3.8,-3.5],[1.1,-0.4904],[2.1,-0.1582],[0.348,0.2689],[0.174,1.8],[0,0.4746],[0.917,0.7751],[2,0.6327],[1.1,0],[4.3,-0.8701],[3.3,-1.9],[2.9,-1.8],[1.4,-0.4746],[0.443,0.0475],[0.553,0.696],[0.364,1.4],[0.253,0.5537],[0.522,0.443],[2.4,0.2689],[0.839,-0.4904],[0.823,-0.7593],[5,-2.9],[4.5,-0.617],[6.9,0.3797],[4.9,0.4271],[4.6,-0.3164],[0,0]],\"v\":[[370.6,29],[376.8,25.5],[378,22.7],[375.1,21.8],[356.8,24.2],[343.8,23.2],[313.4,17.7],[283.9,17],[273.2,20],[262.1,26],[251,35.8],[251.5,23.1],[248.5,11.2],[242.1,6.3],[235,6.3],[224.9,10.6],[192.2,31.2],[185.5,32.9],[186.5,11.8],[184.6,6],[179.2,1.2],[173.2,0.0011],[158.9,1.9],[149,5.4],[133.3,17.7],[120.3,30.1],[114.6,34],[112.9,33.1],[110.5,27.9],[102.9,18.7],[91.8,15.1],[82.5,17.2],[75.9,20.7],[66.8,27.8],[61.1,29.4],[53.3,29.3],[22.3,22.8],[14.3,22.7],[6.3,24.5],[2.9,26.4],[0.8416,28.4],[0.2088,31.1],[2.9,31.4],[8.2,29.9],[21.3,29.8],[52.2,37.9],[62.1,38.2],[70.9,35.8],[82.8,27.4],[90.9,24.8],[96.1,26],[100.5,30.7],[105.4,40.1],[113.9,44.4],[118.9,43.5],[122.1,41.7],[133.9,31.3],[144.8,20],[157.1,11.9],[171.6,9],[176.2,9.8],[177.6,13.3],[176.2,31.2],[176.8,38.3],[182.3,41.7],[186.5,42.3],[189.6,42],[200.7,37.5],[227.3,19.4],[235.9,14.9],[239.5,14.3],[241.3,15.4],[242.7,18.7],[244.2,38.9],[246.6,41.9],[250.2,43.3],[256.3,41.8],[264.6,33.8],[270.1,30],[284.5,25.2],[296.4,24.8],[342.9,31.5],[357.1,31.7],[370.6,29]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header white 1\",\"ddd\":0,\"ty\":4,\"ind\":5,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[142,418]},{\"t\":165.1,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[142,418]},{\"t\":194.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[142,436.4]},{\"t\":330,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[142,438]},{\"t\":360,\"s\":[142,438]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":165.1,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":194.9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.4,4.7],[-5.4,3.5],[-2.2,-0.285],[-0.915,-1.2],[-0.555,-2.4],[-0.75,-1.7],[-1.1,-0.51],[-1.2,-0.03],[-0.405,0.135],[-0.615,0.405],[-1.5,1.2],[-0.81,0.57],[-3.7,1.4],[-1.7,-0.21],[-1.3,-1.8],[-0.945,-1.1],[-2.9,-0.465],[-1.5,0.285],[-6.8,0.525],[-4,-0.285],[-3.3,-0.495],[-6.7,0.3],[-5.7,2.3],[-0.6,0.75],[0.24,0.57],[0.9,0.18],[15.4,2.3],[3.9,0.51],[4.9,-0.165],[3.1,-0.81],[3.3,-1.6],[0.345,-0.12],[0.69,1.3],[0.99,1.5],[1.5,0.99],[1.5,0.315],[2,-0.39],[0,0],[2.2,-1.4],[0.015,0.06],[0.285,0],[0.225,0.75],[0.96,2.8],[1.5,1.8],[2.1,0.555],[1.6,-0.225],[1.2,-0.405],[2.1,-1.3],[4.2,-4],[0,0]],\"o\":[[-4.8,5.5],[3.9,-3.3],[6,-4.1],[1.1,0.105],[0.885,1.2],[0.51,2],[0.18,0.405],[1.1,0.555],[0.6,0],[1.9,-0.54],[0,0],[3.1,-2.5],[1.5,-0.96],[1.8,-0.645],[1.7,0.165],[0.645,0.855],[1.8,2.2],[1.5,0.225],[1.4,-0.315],[4.8,-0.45],[4,0.3],[7.9,1.1],[6.7,-0.315],[1.6,-0.585],[0.6,-0.75],[-0.24,-0.57],[-0.915,-0.195],[-3,-0.42],[-3.9,-0.495],[-3.2,0.135],[-3.3,0.9],[-0.84,0.36],[-1.4,0.405],[-0.075,-0.18],[-1.1,-1.5],[-1.5,-0.975],[-3.1,-0.705],[-2,0.42],[0,0],[-4.4,2.8],[-1.3,0.93],[-0.255,0],[-0.885,-3.1],[-0.75,-2.1],[-1.5,-1.8],[-2.1,-0.585],[-1.6,0.225],[-4.7,1.8],[-6.1,4],[-4.2,4],[0,0]],\"v\":[[2.2,30],[6.5,34.4],[33.2,13.2],[45.6,7.9],[48.4,9.7],[50.6,15],[54.6,34.8],[59.1,39.7],[62.6,40.6],[66,40.1],[72.6,36.8],[82.4,28.3],[92,21.6],[99.9,17.4],[105.5,16.4],[109.8,19.1],[114.3,28.7],[121.7,32.9],[126.1,32.8],[149.2,25],[162.5,25],[188,28.4],[209.8,29.8],[228.4,26],[231.6,23.8],[232.1,21.8],[230.4,20.6],[189.2,20],[164.9,15.6],[151.7,14.9],[142.3,16.3],[132.2,19.9],[124.3,24.3],[120.4,22.6],[116.6,13.9],[112.7,10.1],[108.1,8.1],[100.4,8.1],[94.4,10],[86.9,14.1],[68,30.1],[62.8,32.7],[60.8,29.5],[56.8,10.2],[53.6,4.2],[47.8,0.4339],[42.1,0.1789],[38,1.2],[28.6,6.1],[13.5,18.2],[2.2,30]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Party\",\"ddd\":0,\"ty\":4,\"ind\":6,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[43.8,46.9],\"a\":0},\"p\":{\"k\":[195,750],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[60.7,60.7]},{\"t\":118.6,\"i\":{\"x\":[0.685],\"y\":[1.5]},\"o\":{\"x\":[0.422],\"y\":[0]},\"s\":[60.7,60.7]},{\"t\":147.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":30,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":118.6,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[-15]},{\"t\":118.7,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[-8]},{\"t\":147.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":118.6,\"i\":{\"x\":[0.685],\"y\":[1.5]},\"o\":{\"x\":[0.422],\"y\":[0]},\"s\":[0]},{\"t\":147.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[3.5,0],[0,3.5],[-3.5,0],[0,-3.5]],\"o\":[[0,3.5],[-3.5,0],[0,-3.5],[3.5,0],[0,0]],\"v\":[[87.5,15.6],[81.2,21.9],[75,15.6],[81.2,9.4],[87.5,15.6]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,6.9],[6.9,0],[0,-6.9],[-6.9,0]],\"o\":[[6.9,0],[0,-6.9],[-6.9,0],[0,6.9],[0,0]],\"v\":[[73.4,56.2],[85.9,43.8],[73.4,31.2],[60.9,43.8],[73.4,56.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,93.8],[73.6,72.4],[20.5,19.4],[0,93.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[54.7,23.4],[68.8,18.8],[54.7,14.1],[50,0],[45.3,14.1],[31.2,18.8],[45.3,23.4],[50,37.5],[54.7,23.4]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c1\",\"ddd\":0,\"ty\":4,\"ind\":7,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[125,824]},{\"t\":174.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[125,824]},{\"t\":204.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,824]},{\"t\":360,\"s\":[145,824]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":174.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":204.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3638,-0.1108],[0.4271,-0.5853],[-0.2531,-0.8543],[-0.6486,-0.348],[-2.1,-0.1266],[-2,0.4271],[-3.9,1.8],[-0.9649,0.1898],[-0.9491,-0.2847],[-0.791,-0.9333],[-1.9,-0.9492],[-2,0.522],[-0.8859,0.4271],[-1.4,0.2373],[-2.6,0.3638],[-3.8,-0.2215],[-4.3,-0.4113],[-4.2,0.6011],[-3.5,1.6],[3.6,-0.7118],[9.3,1.1],[1.8,0.2373],[3.7,0.2215],[0,0],[5,-2.7],[0.1424,-0.079],[0.1582,0.6961],[1.1,0.965],[2.8,0.2215],[2,-0.5695],[1.3,-0.6011],[0,0]],\"o\":[[-0.4271,-0.1265],[-0.7277,0.2373],[-0.4271,0.5853],[0.1266,0.4113],[1.9,0.8701],[2.1,0.1265],[4,-0.8226],[4.4,-2.2],[0.9966,-0.2373],[0.8543,0.2215],[0.2056,0.1898],[1.8,0.9491],[0.9966,-0.269],[3.5,-1.6],[0.5853,-0.0949],[2.6,-0.3322],[7.6,0.348],[5.1,0.5536],[4.3,-0.617],[3.9,-2],[-6.8,1.1],[-3.7,-0.3638],[-3.9,-0.4904],[-3.7,-0.2215],[-5.5,0.696],[-1.2,0.7119],[-0.6328,0.3639],[0,0],[-2,-2],[-3.4,-0.3006],[-2,0.6328],[-7.7,3.7],[0,0]],\"v\":[[4.7,10.7],[2.3,10.7],[0.4655,12],[0.1175,14.2],[2.4,16.6],[8.4,18.2],[14.6,17.8],[26.5,13.5],[38.3,7.8],[41.2,7.9],[43.7,9.5],[50,18.2],[55.9,18.9],[63.4,15],[71.5,12.4],[78.7,10.8],[88.5,10.5],[139.4,20.2],[153.4,20.1],[165,16.6],[163.2,11.2],[140.4,11.3],[113.3,4.5],[88.9,1.5],[76.1,1.8],[60.1,6.8],[54.5,10.3],[52.9,9.5],[48.8,3.7],[41,0.0702],[33.1,1.1],[22.7,5.5],[4.7,10.7]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c1\",\"ddd\":0,\"ty\":4,\"ind\":8,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,904.6]},{\"t\":185.8,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[145,904.6]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,884.6]},{\"t\":360,\"s\":[145,884.6]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":185.8,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.6,-0.2074],[-1.2,0.2535],[-0.046,0.0231],[-0.1729,-0.1728],[0,0],[-0.3802,-0.0576],[-0.2881,0.1037],[-1.5,0.9218],[0,0],[-0.3456,-0.0691],[-0.8988,-1.4],[-1,-1],[-0.5991,0.0346],[-0.7028,0.3226],[0,0.023],[-0.4955,0.0346],[-1.6,-1.1],[-0.069,0],[-0.669,0.0922],[-5.5,-0.2534],[-2.6,-0.0576],[-5,0.6453],[-2.1,0.9218],[4.6,-0.9679],[1.2,-0.0691],[5.9,0.1498],[2.3,-0.1037],[0.046,0.0115],[0.553,0.4955],[0.3111,0.2074],[0.3111,0],[0.4033,-0.1498],[1.5,-0.9448],[0,0],[0.2765,0.2765],[1.6,1.3],[1.8,0.1959],[0.8526,-0.0807],[0.242,-0.1844],[1.6,-1],[0.0691,-0.0231],[0.0922,0.1958],[0.288,0.7144],[1.2,0.8181],[0.4379,0.0576],[0.2535,-0.0807],[1.6,-0.5416],[0,0]],\"o\":[[-0.2535,-0.242],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.3],[1.6,0.2074],[2.4,-0.53],[0,0],[0.1267,0.0807],[0.1497,0.1614],[0.7835,0],[0.2535,-0.1037],[0.7144,-0.4494],[0.2304,-0.0346],[1.4,0.3802],[0.4493,0.6798],[0.9909,1],[0.3111,0],[0.8066,-0.4033],[0.2765,-0.1037],[0.1613,-0.0461],[0.426,0.2535],[0,0],[5.4,-0.6798],[7.7,0.2074],[6.1,0.1267],[1.2,-0.1728],[4.7,-1.9],[-2.1,0.53],[-4.7,0.2304],[-2.3,-0.0576],[-1.2,0.0922],[0,0],[-0.576,-0.4609],[-0.3341,-0.1959],[-0.2996,0.0115],[-0.3572,0.2535],[-1.5,0.9103],[-0.0806,-0.0115],[-0.5531,-0.4839],[-1.6,-1.3],[-0.9103,-0.0807],[-0.4263,0.023],[0,0],[-2.4,1.5],[-0.1383,0.0345],[-0.0461,-0.1037],[-0.5646,-1.5],[-0.4378,-0.3226],[-0.4263,-0.0461],[0,0],[-0.795,0.265],[0,0]],\"v\":[[4.6,10.7],[1.5,8.2],[0.1735,9.5],[0.0352,11.2],[1.1,13.8],[5.4,16.2],[9.4,16],[21.7,11],[25.9,11.2],[29.1,17.6],[32.9,19.4],[36.2,18.9],[41.7,16],[56.7,6],[59.7,6.2],[62.8,8.7],[66.4,14.1],[72.4,16.6],[82.1,13.8],[91.6,7.4],[94.4,6.6],[100.6,12.4],[106.4,14.3],[115,12.6],[131.5,12],[162.1,13.4],[178.7,12.6],[192.5,9.1],[191.3,5.1],[178.1,6.8],[162.3,7],[127.3,4.5],[106.1,7.6],[103.9,6.7],[98.7,1.2],[94.6,0],[88.4,1.4],[80.5,6.7],[72.1,10.2],[70.8,9.6],[65.3,2.5],[59.8,0.2996],[57.1,0.242],[53.3,0.9909],[41.4,9.5],[34.5,13.3],[33.5,12.9],[32.4,9.7],[29.6,6],[25.5,4.5],[19.8,5],[8,10.8],[4.6,10.7]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3111,-0.4263],[-0.1844,-0.6222],[-0.4724,-0.2535],[-1.5,-0.0922],[-1.5,0.3111],[-0.7029,0.1383],[-0.5761,-0.6798],[-1.3,-0.6914],[-1.5,0.3802],[-1,0.1728],[-2.8,-0.1613],[-3.2,-0.2995],[-3.1,0.4379],[-2.6,1.2],[2.6,-0.5185],[6.8,0.795],[1.3,0.1728],[2.7,0.1613],[0,0],[3.6,-1.9],[0.1037,-0.0576],[0.772,0.7029],[2.1,0.1613],[1.5,-0.4148],[0.9448,-0.4378],[0,0]],\"o\":[[-0.3111,-0.0922],[-0.3111,0.4263],[0.0922,0.2996],[1.4,0.6337],[1.5,0.0921],[2.9,-0.5991],[0.7259,-0.1728],[0.1498,0.1383],[1.3,0.6913],[0.7259,-0.1959],[0.4263,-0.0691],[5.6,0.2535],[3.7,0.4033],[3.1,-0.4493],[2.8,-1.4],[-4.9,0.7835],[-2.7,-0.265],[-2.9,-0.3572],[-2.7,-0.1613],[-4,0.507],[-0.8757,0.5185],[-0.4609,0.265],[-1.5,-1.4],[-2.4,-0.2189],[-1.4,0.4609],[-5.6,2.7],[0,0]],\"v\":[[3.4,7.8],[0.3391,8.8],[0.0856,10.4],[1.7,12.1],[6.1,13.3],[10.7,13],[27.9,5.7],[31.8,6.9],[36.4,13.3],[40.7,13.8],[52.1,9],[64.5,7.6],[101.5,14.7],[111.7,14.6],[120.2,12.1],[118.9,8.2],[102.2,8.3],[82.5,3.3],[64.8,1.1],[55.4,1.3],[43.8,5],[39.7,7.5],[35.6,2.7],[29.8,0.0511],[24.1,0.777],[16.5,4],[3.4,7.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[211.5,2.2],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.426,0.4264],[0.242,0.484],[1.1,-0.0461],[3,0],[3.3,0.4264],[8.4,1.5],[5.5,-0.8872],[0.657,-0.2535],[2.8,-2.1],[0.012,-0.0115],[0.139,2.7],[1.8,3.1],[2,0.53],[1.5,-0.3342],[2.1,-1.2],[1.6,-0.7604],[0.507,0.0922],[0.276,2.5],[0.864,1.5],[1.6,0.6222],[1.3,0.0461],[0.634,-0.1728],[0,0],[0.0692,-0.023],[2.4,1.8],[2.6,-0.0576],[1.9,-0.7028],[0,0],[0.9102,-0.1267],[1.9,0.2304],[3.9,0.3917],[2,-0.1728],[0.6683,-0.4608],[-0.2881,-0.3687],[-3.3,-0.6107],[-4.5,-0.6799],[-2.5,0.2766],[0,0],[-0.5992,0.3342],[-1.3,0.0922],[-1.2,-0.6683],[-0.9679,-1.6],[-0.3687,-0.4494],[-2.5,-0.1152],[0,0],[-2.8,2.5],[-3.2,1.2],[-0.784,0.0691],[-0.461,-0.4033],[-0.057,-0.6683],[0.046,-1.4],[-0.092,-0.4263],[-0.668,-0.2074],[-0.772,-0.0115],[-2.4,1.3],[-4.2,2.7],[-0.634,-0.0692],[-0.207,-0.2535],[-0.253,-1],[-0.726,-1.6],[-0.391,-0.2996],[-0.438,-0.0576],[-1.2,0.7144],[0,0],[-3.2,0.4609],[-2.5,-0.1037],[-7.1,-0.6107],[-3.4,0.242],[0,0]],\"o\":[[1.1,-0.3111],[0.853,-0.8641],[-0.242,-0.4839],[-1.1,0.0691],[-3,0.0116],[-6.6,-0.8641],[-9.5,-1.6],[-0.68,0.1153],[-2.6,1],[-0.288,0.1959],[0,0],[-0.207,-2.7],[-0.876,-1.5],[-2,-0.53],[-3,0.7259],[-4.2,2.4],[-0.807,0.3918],[0,0.0231],[-0.173,-1.3],[-0.83,-1.5],[-1.6,-0.6568],[-1.3,-0.0115],[-1.3,0.2765],[-4.5,2.4],[-0.1497,0.0346],[-2.4,-1.8],[-2.7,-0.0116],[-0.8988,0.4264],[-0.0345,0.0346],[-1.8,0.2304],[-3.8,-0.4724],[-1.9,-0.1959],[-2,0.1729],[-0.6337,0.5301],[0.2881,0.3687],[3.3,0.5992],[2.2,0.3226],[1.3,-0.1498],[0.2305,-0.0921],[0.5991,-0.3572],[1.4,-0.1267],[1.1,0.7029],[0.2765,0.3572],[1.5,1.8],[1.2,0.0576],[3.5,-2.2],[2.8,-2.5],[0.783,-0.3572],[1.5,-0.1152],[0.253,0.1959],[0.127,1.3],[0,0.3456],[0.668,0.5646],[1.5,0.4609],[0.772,0],[2.4,-1.4],[2.1,-1.3],[0.323,0.0345],[0.403,0.507],[0.265,1],[0.184,0.4033],[0.381,0.3226],[1.8,0.1959],[0.611,-0.3572],[3.7,-2.1],[3.3,-0.4494],[5,0.2765],[3.5,0.3111],[3.4,-0.2304],[0,0]],\"v\":[[269.9,21.1],[274.4,18.6],[275.3,16.5],[273.2,15.9],[259.9,17.6],[250.4,16.9],[228.3,12.9],[206.8,12.4],[199,14.6],[190.9,18.9],[182.8,26],[183.2,16.8],[181,8.2],[176.4,4.6],[171.1,4.6],[163.8,7.7],[140,22.7],[135.1,24],[135.8,8.6],[134.5,4.4],[130.5,0.888],[126.1,0.0008],[115.7,1.4],[108.5,4],[83.5,24.8],[74.9,13.6],[66.8,11],[60.1,12.5],[48.6,20.3],[44.5,21.4],[38.8,21.4],[16.2,16.6],[10.4,16.5],[2.1,19.3],[0.1521,22.6],[15.5,21.7],[38,27.6],[45.2,27.8],[51.7,26],[60.3,19.9],[66.2,18.1],[70,18.9],[73.2,22.4],[76.7,29.2],[82.9,32.3],[88.9,30.4],[105.5,14.6],[114.4,8.7],[125,6.6],[128.4,7.1],[129.4,9.7],[128.3,22.7],[128.8,27.9],[132.8,30.3],[135.9,30.8],[146.2,27.3],[165.6,14.1],[174.4,10.5],[175.8,11.2],[176.8,13.6],[177.8,28.3],[179.6,30.5],[182.2,31.5],[186.7,30.5],[196.7,21.9],[207.2,18.3],[215.9,18],[249.7,22.9],[260.1,23.1],[269.9,21.1]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,31.4],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header purple 1\",\"ddd\":0,\"ty\":4,\"ind\":9,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,410.1]},{\"t\":172.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[575,410.1]},{\"t\":202.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,428.5]},{\"t\":337.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,430.1]},{\"t\":360,\"s\":[575,430.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":172.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":202.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Header purple 1\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-6.2,4.6],[-5.2,2.9],[-2.9,1.1],[-3,0.1266],[-1.6,-1],[-0.8068,-1.6],[-0.1266,-1.9],[0.9017,-1.7],[0.2056,-0.0949],[0.6169,0.6802],[0.3481,0.9333],[-0.791,1.9],[-0.5062,0.4429],[-3.2,0.2215],[-1.5,-0.6486],[-3.1,-1.5],[-4.1,-0.8384],[-4.4,0.87],[-3.9,2.1],[-0.032,0.0158],[-0.569,-0.2373],[-0.333,-0.6169],[-0.602,-0.7752],[-1.6,-0.9017],[-0.427,-0.0949],[-3.7,-0.3638],[-3.7,-0.1423],[-7.2,1.2],[-6.1,3],[-0.284,0.4429],[0.317,0.5695],[0.633,-0.1108],[6.7,-0.5853],[8.4,0.2215],[6.6,0.9966],[0.855,0.6644],[1.5,1.9],[2.7,0.8226],[2.3,-0.5853],[0.98,-0.4429],[1.4,-0.791],[2.9,-0.3955],[2.6,0.5695],[3.1,1.9],[2.6,1.3],[4.3,0.4271],[4.1,-2.2],[0.9966,-0.617],[0.4746,-0.5695],[0.6328,-2.7],[-0.6961,-2.7],[-1.9,-1.9],[-0.5854,-0.3164],[-1.5,-0.1423],[-1.8,2.2],[-0.4587,0.9492],[-0.2056,0.8542],[1.4,3.7],[2.5,1.8],[2.1,0.4113],[1.5,-0.0633],[3.4,-1.4],[2.8,-1.8],[0,0]],\"o\":[[-5.8,5.6],[4.5,-3.2],[2.6,-1.4],[2.9,-1.1],[3.4,-0.2373],[1.6,1.1],[0.8068,1.6],[0.1265,1.8],[-0.2214,0.348],[-0.3955,0.2057],[-0.6644,-0.6961],[-0.696,-1.9],[0.3954,-0.9492],[4.1,-3.5],[3.3,-0.1424],[0.4429,0.2057],[3.1,1.5],[4.1,0.8384],[4.4,-0.8543],[0.981,-0.522],[0,0],[0.301,0.1108],[0.506,0.8226],[1.2,1.6],[0.823,0.4429],[0.428,0.0791],[7.4,0.7435],[8.8,0.2057],[7.2,-1.2],[0.839,-0.3797],[0.57,-0.8701],[-0.316,-0.5536],[-0.617,0.1265],[-6.7,0.5695],[-3.3,-0.1266],[-3.3,-0.522],[-0.364,-0.3005],[-1.4,-1.8],[-2.9,-0.9017],[-1.1,0.3322],[0,0],[-2.9,1.4],[-2.9,0.3797],[-5.3,-1.1],[-3.1,-1.9],[-2.6,-1.2],[-4.2,-0.4746],[-1.1,0.4746],[-1,0.6011],[-1.9,2.1],[-0.6327,2.7],[0.6802,2.6],[0.4746,0.4746],[1.2,0.696],[3.1,0.3797],[0.9333,-1.1],[0.4113,-0.9491],[1.3,-5.2],[-1.4,-3.7],[-2.5,-1.8],[-2.1,-0.4113],[-4.5,0.2531],[-3.4,1.4],[-5.5,3.5],[0,0]],\"v\":[[2.9,22.2],[7,27.2],[21.3,18],[29.5,14.2],[38.4,12.1],[45.7,13.6],[49.2,17.7],[50.6,22.9],[49.6,28.5],[48.6,29.6],[45.2,28.1],[43.7,25.7],[43.8,19.7],[48.2,14.6],[59.9,9.1],[67.3,10.7],[87.3,21.6],[98.1,25.4],[111.2,25.4],[123.8,20.8],[131.9,15.5],[136.5,14.9],[138.4,16.9],[142.2,24.5],[146.5,28.2],[150.3,29.7],[164,31.4],[180.5,32.5],[204.3,31.1],[224.1,25],[227.4,22.3],[227.8,20.1],[224,19.2],[203.3,23.1],[180.8,23.6],[165.8,22],[151.1,19],[146.1,9.9],[139.7,5.4],[131.7,5.4],[128.6,6.5],[116.9,14],[108,16.9],[99.6,16.5],[86.8,10.9],[73.9,3.2],[63.6,0.116],[50.4,2.8],[47.4,4.6],[39.4,11.3],[35.6,18.6],[35.7,26.8],[39.7,33.7],[42.8,36.1],[47.1,37.6],[54.9,34.3],[56.8,31.2],[57.8,28.5],[56.9,15.1],[50.6,6.7],[43.3,3.6],[38,3.3],[26.3,6.2],[17.1,11],[2.9,22.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Music\",\"ddd\":0,\"ty\":4,\"ind\":10,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[43.8,45.7],\"a\":0},\"p\":{\"k\":[625,742.1],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[60.8,60.8]},{\"t\":129.1,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[60.8,60.8]},{\"t\":157.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[87.5,87.5]},{\"t\":360,\"s\":[87.5,87.5]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":129.1,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":157.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":129.1,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":157.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[1.1,0],[0,-8.6],[-8.6,0],[0,0],[0,0],[0,0],[0,0],[1.1,0],[0,-8.6],[-8.6,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[-1,-0.205],[-8.6,0],[0,8.6],[8.3,0],[0,0],[0,0],[0,0],[-1,-0.205],[-8.6,0],[0,8.6],[8.6,0],[0,0]],\"v\":[[87.5,69.6],[87.5,0],[18.8,8.5],[18.8,60.5],[15.6,60.2],[0,75.8],[15.6,91.4],[31.2,76.8],[31.3,43.9],[75,39.1],[75,54.3],[71.9,53.9],[56.2,69.6],[71.9,85.2],[87.5,69.6]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[75,14.1],[75,26.5],[31.3,31.3],[31.3,19.6],[75,14.1]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0},\"r\":2},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c2\",\"ddd\":0,\"ty\":0,\"ind\":11,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[555,816.1]},{\"t\":190,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[555,816.1]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,816.1]},{\"t\":360,\"s\":[575,816.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":190,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"refId\":\"hdr_alt\",\"w\":240,\"h\":36},{\"nm\":\"description c2\",\"ddd\":0,\"ty\":0,\"ind\":12,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,903.1]},{\"t\":190.2,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[575,903.1]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,883.1]},{\"t\":360,\"s\":[575,883.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":190.2,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"refId\":\"desc_alt\",\"w\":350,\"h\":85},{\"nm\":\"Header purple 2\",\"ddd\":0,\"ty\":4,\"ind\":13,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,418.1]},{\"t\":107.6,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1007,418.1]},{\"t\":136.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,436.5]},{\"t\":272.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,438.1]},{\"t\":360,\"s\":[1007,438.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":107.6,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":136.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.4,4.7],[-5.4,3.5],[-2.2,-0.285],[-0.915,-1.2],[-0.555,-2.4],[-0.75,-1.7],[-1.1,-0.51],[-1.2,-0.03],[-0.405,0.135],[-0.615,0.405],[-1.5,1.2],[-0.81,0.57],[-3.7,1.4],[-1.7,-0.21],[-1.3,-1.8],[-0.945,-1.1],[-2.9,-0.465],[-1.5,0.285],[-6.8,0.525],[-4,-0.285],[-3.3,-0.495],[-6.7,0.3],[-5.7,2.3],[-0.6,0.75],[0.24,0.57],[0.9,0.18],[15.4,2.3],[3.9,0.51],[4.9,-0.165],[3.1,-0.81],[3.3,-1.6],[0.345,-0.12],[0.69,1.3],[0.99,1.5],[1.5,0.99],[1.5,0.315],[2,-0.39],[0,0],[2.2,-1.4],[0.015,0.06],[0.285,0],[0.225,0.75],[0.96,2.8],[1.5,1.8],[2.1,0.555],[1.6,-0.225],[1.2,-0.405],[2.1,-1.3],[4.2,-4],[0,0]],\"o\":[[-4.8,5.5],[3.9,-3.3],[6,-4.1],[1.1,0.105],[0.885,1.2],[0.51,2],[0.18,0.405],[1.1,0.555],[0.6,0],[1.9,-0.54],[0,0],[3.1,-2.5],[1.5,-0.96],[1.8,-0.645],[1.7,0.165],[0.645,0.855],[1.8,2.2],[1.5,0.225],[1.4,-0.315],[4.8,-0.45],[4,0.3],[7.9,1.1],[6.7,-0.315],[1.6,-0.585],[0.6,-0.75],[-0.24,-0.57],[-0.915,-0.195],[-3,-0.42],[-3.9,-0.495],[-3.2,0.135],[-3.3,0.9],[-0.84,0.36],[-1.4,0.405],[-0.075,-0.18],[-1.1,-1.5],[-1.5,-0.975],[-3.1,-0.705],[-2,0.42],[0,0],[-4.4,2.8],[-1.3,0.93],[-0.255,0],[-0.885,-3.1],[-0.75,-2.1],[-1.5,-1.8],[-2.1,-0.585],[-1.6,0.225],[-4.7,1.8],[-6.1,4],[-4.2,4],[0,0]],\"v\":[[2.2,30],[6.5,34.4],[33.2,13.2],[45.6,7.9],[48.4,9.7],[50.6,15],[54.6,34.8],[59.1,39.7],[62.6,40.6],[66,40.1],[72.6,36.8],[82.4,28.3],[92,21.6],[99.9,17.4],[105.5,16.4],[109.8,19.1],[114.3,28.7],[121.7,32.9],[126.1,32.8],[149.2,25],[162.5,25],[188,28.4],[209.8,29.8],[228.4,26],[231.6,23.8],[232.1,21.8],[230.4,20.6],[189.2,20],[164.9,15.6],[151.7,14.9],[142.3,16.3],[132.2,19.9],[124.3,24.3],[120.4,22.6],[116.6,13.9],[112.7,10.1],[108.1,8.1],[100.4,8.1],[94.4,10],[86.9,14.1],[68,30.1],[62.8,32.7],[60.8,29.5],[56.8,10.2],[53.6,4.2],[47.8,0.4339],[42.1,0.1789],[38,1.2],[28.6,6.1],[13.5,18.2],[2.2,30]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Cloud\",\"ddd\":0,\"ty\":4,\"ind\":14,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[50,33.7],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1060.8,746]},{\"t\":134.9,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[1060.8,746]},{\"t\":165.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1061.7,747.2]},{\"t\":360,\"s\":[1061.7,747.2]}]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[64.7,64.7]},{\"t\":134.9,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[64.7,64.7]},{\"t\":165.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":134.9,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":165.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":134.9,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":165.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.6,-8.3],[-1.4,0],[0,-15],[14.8,-0.2188],[0,0],[0,11.3],[-7.8,3],[0,0]],\"o\":[[10.3,0],[1.4,-0.2188],[15,0],[0,15],[0,0],[-11.3,0],[0,-8.7],[1.4,-15.4],[0,0]],\"v\":[[43.5,0.0625],[68.7,13.5],[72.9,13.1],[100,40.2],[73.3,67.3],[20.6,67.3],[0,46.8],[13.2,27.5],[43.5,0.0625]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c3\",\"ddd\":0,\"ty\":4,\"ind\":15,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[990,824.1]},{\"t\":109.5,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[990,824.1]},{\"t\":138.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,824.1]},{\"t\":360,\"s\":[1010,824.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":109.5,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":138.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3638,-0.1108],[0.4271,-0.5853],[-0.2531,-0.8543],[-0.6486,-0.348],[-2.1,-0.1266],[-2,0.4271],[-3.9,1.8],[-0.9649,0.1898],[-0.9491,-0.2847],[-0.791,-0.9333],[-1.9,-0.9492],[-2,0.522],[-0.8859,0.4271],[-1.4,0.2373],[-2.6,0.3638],[-3.8,-0.2215],[-4.3,-0.4113],[-4.2,0.6011],[-3.5,1.6],[3.6,-0.7118],[9.3,1.1],[1.8,0.2373],[3.7,0.2215],[0,0],[5,-2.7],[0.1424,-0.079],[0.1582,0.6961],[1.1,0.965],[2.8,0.2215],[2,-0.5695],[1.3,-0.6011],[0,0]],\"o\":[[-0.4271,-0.1265],[-0.7277,0.2373],[-0.4271,0.5853],[0.1266,0.4113],[1.9,0.8701],[2.1,0.1265],[4,-0.8226],[4.4,-2.2],[0.9966,-0.2373],[0.8543,0.2215],[0.2056,0.1898],[1.8,0.9491],[0.9966,-0.269],[3.5,-1.6],[0.5853,-0.0949],[2.6,-0.3322],[7.6,0.348],[5.1,0.5536],[4.3,-0.617],[3.9,-2],[-6.8,1.1],[-3.7,-0.3638],[-3.9,-0.4904],[-3.7,-0.2215],[-5.5,0.696],[-1.2,0.7119],[-0.6328,0.3639],[0,0],[-2,-2],[-3.4,-0.3006],[-2,0.6328],[-7.7,3.7],[0,0]],\"v\":[[4.7,10.7],[2.3,10.7],[0.4655,12],[0.1175,14.2],[2.4,16.6],[8.4,18.2],[14.6,17.8],[26.5,13.5],[38.3,7.8],[41.2,7.9],[43.7,9.5],[50,18.2],[55.9,18.9],[63.4,15],[71.5,12.4],[78.7,10.8],[88.5,10.5],[139.4,20.2],[153.4,20.1],[165,16.6],[163.2,11.2],[140.4,11.3],[113.3,4.5],[88.9,1.5],[76.1,1.8],[60.1,6.8],[54.5,10.3],[52.9,9.5],[48.8,3.7],[41,0.0702],[33.1,1.1],[22.7,5.5],[4.7,10.7]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c3\",\"ddd\":0,\"ty\":4,\"ind\":16,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,904.7]},{\"t\":109.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1010,904.7]},{\"t\":139.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,884.7]},{\"t\":360,\"s\":[1010,884.7]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":109.7,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":139.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.6,-0.2074],[-1.2,0.2535],[-0.046,0.0231],[-0.1729,-0.1728],[0,0],[-0.3802,-0.0576],[-0.2881,0.1037],[-1.5,0.9218],[0,0],[-0.3456,-0.0691],[-0.8988,-1.4],[-1,-1],[-0.5991,0.0346],[-0.7028,0.3226],[0,0.023],[-0.4955,0.0346],[-1.6,-1.1],[-0.069,0],[-0.669,0.0922],[-5.5,-0.2534],[-2.6,-0.0576],[-5,0.6453],[-2.1,0.9218],[4.6,-0.9679],[1.2,-0.0691],[5.9,0.1498],[2.3,-0.1037],[0.046,0.0115],[0.553,0.4955],[0.3111,0.2074],[0.3111,0],[0.4033,-0.1498],[1.5,-0.9448],[0,0],[0.2765,0.2765],[1.6,1.3],[1.8,0.1959],[0.8526,-0.0807],[0.242,-0.1844],[1.6,-1],[0.0691,-0.0231],[0.0922,0.1958],[0.288,0.7144],[1.2,0.8181],[0.4379,0.0576],[0.2535,-0.0807],[1.6,-0.5416],[0,0]],\"o\":[[-0.2535,-0.242],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.3],[1.6,0.2074],[2.4,-0.53],[0,0],[0.1267,0.0807],[0.1497,0.1614],[0.7835,0],[0.2535,-0.1037],[0.7144,-0.4494],[0.2304,-0.0346],[1.4,0.3802],[0.4493,0.6798],[0.9909,1],[0.3111,0],[0.8066,-0.4033],[0.2765,-0.1037],[0.1613,-0.0461],[0.426,0.2535],[0,0],[5.4,-0.6798],[7.7,0.2074],[6.1,0.1267],[1.2,-0.1728],[4.7,-1.9],[-2.1,0.53],[-4.7,0.2304],[-2.3,-0.0576],[-1.2,0.0922],[0,0],[-0.576,-0.4609],[-0.3341,-0.1959],[-0.2996,0.0115],[-0.3572,0.2535],[-1.5,0.9103],[-0.0806,-0.0115],[-0.5531,-0.4839],[-1.6,-1.3],[-0.9103,-0.0807],[-0.4263,0.023],[0,0],[-2.4,1.5],[-0.1383,0.0345],[-0.0461,-0.1037],[-0.5646,-1.5],[-0.4378,-0.3226],[-0.4263,-0.0461],[0,0],[-0.795,0.265],[0,0]],\"v\":[[4.6,10.7],[1.5,8.2],[0.1735,9.5],[0.0352,11.2],[1.1,13.8],[5.4,16.2],[9.4,16],[21.7,11],[25.9,11.2],[29.1,17.6],[32.9,19.4],[36.2,18.9],[41.7,16],[56.7,6],[59.7,6.2],[62.8,8.7],[66.4,14.1],[72.4,16.6],[82.1,13.8],[91.6,7.4],[94.4,6.6],[100.6,12.4],[106.4,14.3],[115,12.6],[131.5,12],[162.1,13.4],[178.7,12.6],[192.5,9.1],[191.3,5.1],[178.1,6.8],[162.3,7],[127.3,4.5],[106.1,7.6],[103.9,6.7],[98.7,1.2],[94.6,0],[88.4,1.4],[80.5,6.7],[72.1,10.2],[70.8,9.6],[65.3,2.5],[59.8,0.2996],[57.1,0.242],[53.3,0.9909],[41.4,9.5],[34.5,13.3],[33.5,12.9],[32.4,9.7],[29.6,6],[25.5,4.5],[19.8,5],[8,10.8],[4.6,10.7]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3111,-0.4263],[-0.1844,-0.6222],[-0.4724,-0.2535],[-1.5,-0.0922],[-1.5,0.3111],[-0.7029,0.1383],[-0.5761,-0.6798],[-1.3,-0.6914],[-1.5,0.3802],[-1,0.1728],[-2.8,-0.1613],[-3.2,-0.2995],[-3.1,0.4379],[-2.6,1.2],[2.6,-0.5185],[6.8,0.795],[1.3,0.1728],[2.7,0.1613],[0,0],[3.6,-1.9],[0.1037,-0.0576],[0.772,0.7029],[2.1,0.1613],[1.5,-0.4148],[0.9448,-0.4378],[0,0]],\"o\":[[-0.3111,-0.0922],[-0.3111,0.4263],[0.0922,0.2996],[1.4,0.6337],[1.5,0.0921],[2.9,-0.5991],[0.7259,-0.1728],[0.1498,0.1383],[1.3,0.6913],[0.7259,-0.1959],[0.4263,-0.0691],[5.6,0.2535],[3.7,0.4033],[3.1,-0.4493],[2.8,-1.4],[-4.9,0.7835],[-2.7,-0.265],[-2.9,-0.3572],[-2.7,-0.1613],[-4,0.507],[-0.8757,0.5185],[-0.4609,0.265],[-1.5,-1.4],[-2.4,-0.2189],[-1.4,0.4609],[-5.6,2.7],[0,0]],\"v\":[[3.4,7.8],[0.3391,8.8],[0.0856,10.4],[1.7,12.1],[6.1,13.3],[10.7,13],[27.9,5.7],[31.8,6.9],[36.4,13.3],[40.7,13.8],[52.1,9],[64.5,7.6],[101.5,14.7],[111.7,14.6],[120.2,12.1],[118.9,8.2],[102.2,8.3],[82.5,3.3],[64.8,1.1],[55.4,1.3],[43.8,5],[39.7,7.5],[35.6,2.7],[29.8,0.0511],[24.1,0.777],[16.5,4],[3.4,7.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[211.5,2.2],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.426,0.4264],[0.242,0.484],[1.1,-0.0461],[3,0],[3.3,0.4264],[8.4,1.5],[5.5,-0.8872],[0.657,-0.2535],[2.8,-2.1],[0.012,-0.0115],[0.139,2.7],[1.8,3.1],[2,0.53],[1.5,-0.3342],[2.1,-1.2],[1.6,-0.7604],[0.507,0.0922],[0.276,2.5],[0.864,1.5],[1.6,0.6222],[1.3,0.0461],[0.634,-0.1728],[0,0],[0.0692,-0.023],[2.4,1.8],[2.6,-0.0576],[1.9,-0.7028],[0,0],[0.9102,-0.1267],[1.9,0.2304],[3.9,0.3917],[2,-0.1728],[0.6683,-0.4608],[-0.2881,-0.3687],[-3.3,-0.6107],[-4.5,-0.6799],[-2.5,0.2766],[0,0],[-0.5992,0.3342],[-1.3,0.0922],[-1.2,-0.6683],[-0.9679,-1.6],[-0.3687,-0.4494],[-2.5,-0.1152],[0,0],[-2.8,2.5],[-3.2,1.2],[-0.784,0.0691],[-0.461,-0.4033],[-0.057,-0.6683],[0.046,-1.4],[-0.092,-0.4263],[-0.668,-0.2074],[-0.772,-0.0115],[-2.4,1.3],[-4.2,2.7],[-0.634,-0.0692],[-0.207,-0.2535],[-0.253,-1],[-0.726,-1.6],[-0.391,-0.2996],[-0.438,-0.0576],[-1.2,0.7144],[0,0],[-3.2,0.4609],[-2.5,-0.1037],[-7.1,-0.6107],[-3.4,0.242],[0,0]],\"o\":[[1.1,-0.3111],[0.853,-0.8641],[-0.242,-0.4839],[-1.1,0.0691],[-3,0.0116],[-6.6,-0.8641],[-9.5,-1.6],[-0.68,0.1153],[-2.6,1],[-0.288,0.1959],[0,0],[-0.207,-2.7],[-0.876,-1.5],[-2,-0.53],[-3,0.7259],[-4.2,2.4],[-0.807,0.3918],[0,0.0231],[-0.173,-1.3],[-0.83,-1.5],[-1.6,-0.6568],[-1.3,-0.0115],[-1.3,0.2765],[-4.5,2.4],[-0.1497,0.0346],[-2.4,-1.8],[-2.7,-0.0116],[-0.8988,0.4264],[-0.0345,0.0346],[-1.8,0.2304],[-3.8,-0.4724],[-1.9,-0.1959],[-2,0.1729],[-0.6337,0.5301],[0.2881,0.3687],[3.3,0.5992],[2.2,0.3226],[1.3,-0.1498],[0.2305,-0.0921],[0.5991,-0.3572],[1.4,-0.1267],[1.1,0.7029],[0.2765,0.3572],[1.5,1.8],[1.2,0.0576],[3.5,-2.2],[2.8,-2.5],[0.783,-0.3572],[1.5,-0.1152],[0.253,0.1959],[0.127,1.3],[0,0.3456],[0.668,0.5646],[1.5,0.4609],[0.772,0],[2.4,-1.4],[2.1,-1.3],[0.323,0.0345],[0.403,0.507],[0.265,1],[0.184,0.4033],[0.381,0.3226],[1.8,0.1959],[0.611,-0.3572],[3.7,-2.1],[3.3,-0.4494],[5,0.2765],[3.5,0.3111],[3.4,-0.2304],[0,0]],\"v\":[[269.9,21.1],[274.4,18.6],[275.3,16.5],[273.2,15.9],[259.9,17.6],[250.4,16.9],[228.3,12.9],[206.8,12.4],[199,14.6],[190.9,18.9],[182.8,26],[183.2,16.8],[181,8.2],[176.4,4.6],[171.1,4.6],[163.8,7.7],[140,22.7],[135.1,24],[135.8,8.6],[134.5,4.4],[130.5,0.888],[126.1,0.0008],[115.7,1.4],[108.5,4],[83.5,24.8],[74.9,13.6],[66.8,11],[60.1,12.5],[48.6,20.3],[44.5,21.4],[38.8,21.4],[16.2,16.6],[10.4,16.5],[2.1,19.3],[0.1521,22.6],[15.5,21.7],[38,27.6],[45.2,27.8],[51.7,26],[60.3,19.9],[66.2,18.1],[70,18.9],[73.2,22.4],[76.7,29.2],[82.9,32.3],[88.9,30.4],[105.5,14.6],[114.4,8.7],[125,6.6],[128.4,7.1],[129.4,9.7],[128.3,22.7],[128.8,27.9],[132.8,30.3],[135.9,30.8],[146.2,27.3],[165.6,14.1],[174.4,10.5],[175.8,11.2],[176.8,13.6],[177.8,28.3],[179.6,30.5],[182.2,31.5],[186.7,30.5],[196.7,21.9],[207.2,18.3],[215.9,18],[249.7,22.9],[260.1,23.1],[269.9,21.1]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,31.4],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header purple 3\",\"ddd\":0,\"ty\":4,\"ind\":17,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,412.1]},{\"t\":194.9,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1445,412.1]},{\"t\":226.8,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,430.5]},{\"t\":359.8,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,432.1]},{\"t\":360,\"s\":[1445,432.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":194.9,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":226.8,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Header purple 3\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-6.2,4.6],[-5.2,2.9],[-2.9,1.1],[-3,0.1266],[-1.6,-1],[-0.8068,-1.6],[-0.1266,-1.9],[0.9017,-1.7],[0.2056,-0.0949],[0.6169,0.6802],[0.3481,0.9333],[-0.791,1.9],[-0.5062,0.4429],[-3.2,0.2215],[-1.5,-0.6486],[-3.1,-1.5],[-4.1,-0.8384],[-4.4,0.87],[-3.9,2.1],[-0.032,0.0158],[-0.569,-0.2373],[-0.333,-0.6169],[-0.602,-0.7752],[-1.6,-0.9017],[-0.427,-0.0949],[-3.7,-0.3638],[-3.7,-0.1423],[-7.2,1.2],[-6.1,3],[-0.284,0.4429],[0.317,0.5695],[0.633,-0.1108],[6.7,-0.5853],[8.4,0.2215],[6.6,0.9966],[0.855,0.6644],[1.5,1.9],[2.7,0.8226],[2.3,-0.5853],[0.98,-0.4429],[1.4,-0.791],[2.9,-0.3955],[2.6,0.5695],[3.1,1.9],[2.6,1.3],[4.3,0.4271],[4.1,-2.2],[0.9966,-0.617],[0.4746,-0.5695],[0.6328,-2.7],[-0.6961,-2.7],[-1.9,-1.9],[-0.5854,-0.3164],[-1.5,-0.1423],[-1.8,2.2],[-0.4587,0.9492],[-0.2056,0.8542],[1.4,3.7],[2.5,1.8],[2.1,0.4113],[1.5,-0.0633],[3.4,-1.4],[2.8,-1.8],[0,0]],\"o\":[[-5.8,5.6],[4.5,-3.2],[2.6,-1.4],[2.9,-1.1],[3.4,-0.2373],[1.6,1.1],[0.8068,1.6],[0.1265,1.8],[-0.2214,0.348],[-0.3955,0.2057],[-0.6644,-0.6961],[-0.696,-1.9],[0.3954,-0.9492],[4.1,-3.5],[3.3,-0.1424],[0.4429,0.2057],[3.1,1.5],[4.1,0.8384],[4.4,-0.8543],[0.981,-0.522],[0,0],[0.301,0.1108],[0.506,0.8226],[1.2,1.6],[0.823,0.4429],[0.428,0.0791],[7.4,0.7435],[8.8,0.2057],[7.2,-1.2],[0.839,-0.3797],[0.57,-0.8701],[-0.316,-0.5536],[-0.617,0.1265],[-6.7,0.5695],[-3.3,-0.1266],[-3.3,-0.522],[-0.364,-0.3005],[-1.4,-1.8],[-2.9,-0.9017],[-1.1,0.3322],[0,0],[-2.9,1.4],[-2.9,0.3797],[-5.3,-1.1],[-3.1,-1.9],[-2.6,-1.2],[-4.2,-0.4746],[-1.1,0.4746],[-1,0.6011],[-1.9,2.1],[-0.6327,2.7],[0.6802,2.6],[0.4746,0.4746],[1.2,0.696],[3.1,0.3797],[0.9333,-1.1],[0.4113,-0.9491],[1.3,-5.2],[-1.4,-3.7],[-2.5,-1.8],[-2.1,-0.4113],[-4.5,0.2531],[-3.4,1.4],[-5.5,3.5],[0,0]],\"v\":[[2.9,22.2],[7,27.2],[21.3,18],[29.5,14.2],[38.4,12.1],[45.7,13.6],[49.2,17.7],[50.6,22.9],[49.6,28.5],[48.6,29.6],[45.2,28.1],[43.7,25.7],[43.8,19.7],[48.2,14.6],[59.9,9.1],[67.3,10.7],[87.3,21.6],[98.1,25.4],[111.2,25.4],[123.8,20.8],[131.9,15.5],[136.5,14.9],[138.4,16.9],[142.2,24.5],[146.5,28.2],[150.3,29.7],[164,31.4],[180.5,32.5],[204.3,31.1],[224.1,25],[227.4,22.3],[227.8,20.1],[224,19.2],[203.3,23.1],[180.8,23.6],[165.8,22],[151.1,19],[146.1,9.9],[139.7,5.4],[131.7,5.4],[128.6,6.5],[116.9,14],[108,16.9],[99.6,16.5],[86.8,10.9],[73.9,3.2],[63.6,0.116],[50.4,2.8],[47.4,4.6],[39.4,11.3],[35.6,18.6],[35.7,26.8],[39.7,33.7],[42.8,36.1],[47.1,37.6],[54.9,34.3],[56.8,31.2],[57.8,28.5],[56.9,15.1],[50.6,6.7],[43.3,3.6],[38,3.3],[26.3,6.2],[17.1,11],[2.9,22.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Blocks\",\"ddd\":0,\"ty\":4,\"ind\":18,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[50,43.8],\"a\":0},\"p\":{\"k\":[1495,744.1],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[52.3,52.3]},{\"t\":143.5,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[52.3,52.3]},{\"t\":169.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":143.5,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":169.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":143.5,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":169.6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[43.8,0],[12.5,0],[12.5,21.9],[43.8,21.9],[43.8,0]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,31.2],[100,31.2],[100,87.5],[0,87.5],[0,31.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[56.2,0],[87.5,0],[87.5,21.9],[56.2,21.9],[56.2,0]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c4\",\"ddd\":0,\"ty\":0,\"ind\":19,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1425,818.1]},{\"t\":204.4,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1425,818.1]},{\"t\":236.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,818.1]},{\"t\":360,\"s\":[1445,818.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":204.4,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":236.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"refId\":\"hdr_alt\",\"w\":240,\"h\":36},{\"nm\":\"description c4\",\"ddd\":0,\"ty\":0,\"ind\":20,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,905.1]},{\"t\":219.1,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1445,905.1]},{\"t\":245.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,885.1]},{\"t\":360,\"s\":[1445,885.1]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":219.1,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":245.4,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"refId\":\"desc_alt\",\"w\":350,\"h\":85},{\"nm\":\"card purple 1 (skeleton)\",\"ddd\":0,\"ty\":4,\"ind\":21,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[426.1,422]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[399.8,422]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[331.1,422]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.9,422]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304,422]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,422]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,432.7]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,491.2]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,642]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,691.7]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,699.6]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":360,\"s\":[307.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":30,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[100]},{\"t\":66.9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[652.3,80]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[599.7,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[462.3,80]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415.8,80]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,80]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,101.4]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,218.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.9]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,619.3]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.1]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4196,0.4314,0.4627,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card purple 1 (matte)\",\"ddd\":0,\"ty\":4,\"ind\":22,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[426.1,422]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[399.8,422]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[331.1,422]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.9,422]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304,422]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,422]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,432.7]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,491.2]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,642]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,691.7]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,699.6]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":360,\"s\":[307.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"td\":1,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[652.3,80]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[599.7,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[462.3,80]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415.8,80]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,80]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,101.4]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,218.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.9]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,619.3]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.1]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card purple 1 1\",\"ddd\":0,\"ty\":2,\"ind\":23,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[100,382],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"tt\":1,\"refId\":\"card_purple_1_1\"},{\"nm\":\"card gray 1\",\"ddd\":0,\"ty\":4,\"ind\":24,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[533.6,851]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[579.9,851]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[700.9,851]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[741.8,851]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[748.6,851]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,851]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,844.7]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,810.3]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,721.5]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692.2]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,687.5]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":360,\"s\":[742.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[832.9,80]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[740.3,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[498.3,80]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[416.4,80]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[402.7,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,80]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,101.4]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,218.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.9]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,619.3]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.1]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card gray 2\",\"ddd\":0,\"ty\":4,\"ind\":25,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[968.6,571]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1014.9,571]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1135.9,571]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1176.8,571]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1183.6,571]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,571]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,575.8]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,602]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,669.6]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,691.8]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,695.4]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":360,\"s\":[1177.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1668.6,80]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1390.8,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[664.8,80]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[419.1,80]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[378.2,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.9,80]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,101.4]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,218.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.9]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,619.3]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.1]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card gray 3\",\"ddd\":0,\"ty\":4,\"ind\":26,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[985.7,711]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1124.6,711]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1487.6,711]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1610.4,711]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1630.9,711]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.6,711]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,710.2]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,706.1]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,695.5]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,691.5]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":360,\"s\":[1612.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":5,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":10,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":20,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":25,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":35,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1668.6,80]},{\"t\":40,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1390.8,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[664.8,80]},{\"t\":50,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[419.1,80]},{\"t\":55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[378.2,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.9,80]},{\"t\":65,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,101.4]},{\"t\":70,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,218.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.9]},{\"t\":80,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,619.3]},{\"t\":85,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.1]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":95,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":100,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":110,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":115,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Background\",\"ddd\":0,\"ty\":4,\"ind\":27,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[960,540],\"a\":0},\"s\":{\"k\":[1920,1080],\"a\":0},\"r\":{\"k\":0,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]}],\"nm\":\"Remix animation - Create an infographic\",\"v\":\"5.5.2\",\"fr\":60,\"ip\":0,\"op\":360,\"w\":1920,\"h\":1080,\"ddd\":0,\"assets\":[{\"id\":\"card_purple_1_1\",\"u\":\"\",\"p\":\"https://REPLACE_ME.example.com/card-purple-1-1.png\",\"e\":0,\"h\":620,\"w\":415},{\"id\":\"desc_alt\",\"layers\":[{\"nm\":\"desc_alt_in\",\"ddd\":0,\"ty\":4,\"ind\":0,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3731,-0.4271],[-0.2211,-0.6234],[-0.5666,-0.2539],[-1.8,-0.0924],[-1.8,0.3117],[-0.8431,0.1385],[-0.6911,-0.6811],[-1.6,-0.6927],[-1.7,0.381],[-1.3,0.1732],[-3.3,-0.1616],[-3.8,-0.3001],[-3.7,0.4387],[-3.1,1.2],[3.2,-0.5195],[8.1,0.7965],[1.6,0.1732],[3.2,0.1616],[0,0],[4.3,-2],[0.1244,-0.0577],[0.926,0.7042],[2.5,0.1616],[1.8,-0.4156],[1.1,-0.4387],[0,0]],\"o\":[[-0.3731,-0.0924],[-0.3731,0.4271],[0.1106,0.3001],[1.6,0.635],[1.8,0.0923],[3.5,-0.6003],[0.8706,-0.1732],[0.1796,0.1385],[1.6,0.6926],[0.8707,-0.1962],[0.5114,-0.0693],[6.7,0.254],[4.5,0.4041],[3.7,-0.4502],[3.4,-1.4],[-5.9,0.785],[-3.2,-0.2655],[-3.4,-0.3579],[-3.2,-0.1616],[-4.8,0.5079],[-1.1,0.5195],[-0.5528,0.2655],[-1.7,-1.4],[-2.9,-0.2193],[-1.7,0.4618],[-6.7,2.7],[0,0]],\"v\":[[4.1,7.8],[0.4067,8.8],[0.1026,10.4],[2.1,12.1],[7.4,13.3],[12.8,13],[33.5,5.7],[38.1,6.9],[43.6,13.3],[48.9,13.8],[62.5,9.1],[77.3,7.6],[121.8,14.7],[134,14.7],[144.2,12.1],[142.6,8.2],[122.6,8.3],[99,3.3],[77.7,1.1],[66.5,1.3],[52.5,5],[47.6,7.5],[42.6,2.7],[35.8,0.0512],[29,0.7785],[19.8,4],[4.1,7.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,6.2],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-4.6,3.3],[-3.8,2.1],[-2.1,0.8065],[-2.2,0.0922],[-1.2,-0.7605],[-0.5876,-1.1],[-0.0922,-1.3],[0.1498,-0.0692],[0.4494,0.4955],[0.2535,0.6798],[-0.5761,1.4],[-0.3687,0.3226],[-2.4,0.1613],[-1.1,-0.4724],[-2.2,-1.1],[-3,-0.6107],[-3.2,0.6337],[-2.8,1.6],[-0.023,0.0115],[-0.4148,-0.1728],[-0.438,-0.5646],[-1.2,-0.6567],[-2.7,-0.265],[-2.7,-0.1037],[-5.2,0.8412],[-4.4,2.2],[-0.207,0.3226],[0.23,0.4148],[0.461,-0.0807],[4.9,-0.4263],[6.2,0.1613],[4.8,0.7259],[0.622,0.4839],[1.1,1.3],[2,0.5992],[0.7144,-0.3226],[1,-0.5761],[2.1,-0.2881],[1.9,0.4148],[2.3,1.3],[1.9,0.9333],[3.1,0.3111],[3,-1.6],[0.7259,-0.4494],[0.3457,-0.4148],[0.4609,-2],[-0.5069,-1.9],[-1.4,-1.3],[-1.1,-0.1037],[-1.3,1.6],[-0.3342,0.6913],[-0.1498,0.6222],[1,2.7],[1.9,1.3],[1.5,0.2996],[1.1,-0.0461],[2.5,-1],[2,-1.3],[0,0]],\"o\":[[-4.2,4.1],[3.3,-2.3],[1.9,-1],[2.1,-0.7951],[2.5,-0.1728],[1.2,0.772],[0.5877,1.2],[0.0922,1.3],[-0.2881,0.1498],[-0.4839,-0.507],[-0.507,-1.4],[0.2881,-0.6913],[3,-2.6],[2.4,-0.1037],[0.3226,0.1498],[2.2,1.1],[3,0.6107],[3.2,-0.6222],[0.7143,-0.3803],[0,0],[0.2189,0.0807],[0.875,1.1],[0.599,0.3227],[5.4,0.5416],[6.4,0.1498],[5.2,-0.8526],[0.611,-0.2765],[0.415,-0.6337],[-0.23,-0.4033],[-0.449,0.0922],[-4.9,0.4148],[-2.4,-0.0922],[-2.4,-0.3802],[-0.265,-0.2189],[-1,-1.3],[-2.1,-0.6568],[0,0],[-2.1,1],[-2.1,0.2765],[-3.8,-0.8296],[-2.3,-1.4],[-1.9,-0.9103],[-3.1,-0.3457],[-0.795,0.3457],[-0.7374,0.4379],[-1.4,1.5],[-0.4609,2],[0.4955,1.9],[0.3456,0.3457],[2.3,0.2766],[0.6798,-0.8181],[0.2995,-0.6914],[0.9218,-3.8],[-1,-2.7],[-1.9,-1.3],[-1.6,-0.2996],[-3.3,0.1844],[-2.5,1],[-4,2.6],[0,0]],\"v\":[[2.1,16.2],[5.1,19.8],[15.5,13.1],[21.5,10.3],[28,8.8],[33.3,9.9],[35.9,12.9],[36.9,16.7],[35.4,21.6],[33,20.5],[31.8,18.7],[31.9,14.3],[35.1,10.6],[43.6,6.6],[49,7.8],[63.6,15.7],[71.4,18.5],[81,18.5],[90.2,15.1],[96.1,11.3],[99.4,10.9],[103.6,17.9],[106.7,20.6],[119.4,22.9],[131.5,23.7],[148.8,22.6],[163.2,18.2],[165.6,16.3],[165.9,14.6],[163.2,14],[148.1,16.8],[131.7,17.2],[120.8,16],[110,13.8],[106.4,7.2],[101.8,3.9],[93.6,4.7],[85.1,10.2],[78.7,12.3],[72.6,12],[63.2,8],[53.8,2.4],[46.3,0.0845],[36.7,2.1],[34.5,3.3],[28.7,8.3],[25.9,13.6],[26,19.5],[28.9,24.6],[34.3,27.4],[40,24.9],[41.4,22.8],[42.1,20.8],[41.5,11],[36.8,4.9],[31.6,2.6],[27.7,2.4],[19.1,4.5],[12.5,8],[2.1,16.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[158,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.6,-0.2074],[-1.2,0.2535],[-0.046,0.0231],[-0.1729,-0.1728],[0,0],[-0.3802,-0.0576],[-0.2881,0.1037],[-1.5,0.9218],[0,0],[-0.3456,-0.0691],[-0.8988,-1.4],[-1,-1],[-0.5991,0.0346],[-0.7028,0.3226],[0,0.023],[-0.4955,0.0346],[-1.6,-1.1],[-0.069,0],[-0.669,0.0922],[-5.5,-0.2534],[-2.6,-0.0576],[-5,0.6453],[-2.1,0.9218],[4.6,-0.9679],[1.2,-0.0691],[5.9,0.1498],[2.3,-0.1037],[0.046,0.0115],[0.553,0.4955],[0.3111,0.2074],[0.3111,0],[0.4033,-0.1498],[1.5,-0.9448],[0,0],[0.2765,0.2765],[1.6,1.3],[1.8,0.1959],[0.8526,-0.0807],[0.242,-0.1844],[1.6,-1],[0.0691,-0.0231],[0.0922,0.1958],[0.288,0.7144],[1.2,0.8181],[0.4379,0.0576],[0.2535,-0.0807],[1.6,-0.5416],[0,0]],\"o\":[[-0.2535,-0.242],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.3],[1.6,0.2074],[2.4,-0.53],[0,0],[0.1267,0.0807],[0.1497,0.1614],[0.7835,0],[0.2535,-0.1037],[0.7144,-0.4494],[0.2304,-0.0346],[1.4,0.3802],[0.4493,0.6798],[0.9909,1],[0.3111,0],[0.8066,-0.4033],[0.2765,-0.1037],[0.1613,-0.0461],[0.426,0.2535],[0,0],[5.4,-0.6798],[7.7,0.2074],[6.1,0.1267],[1.2,-0.1728],[4.7,-1.9],[-2.1,0.53],[-4.7,0.2304],[-2.3,-0.0576],[-1.2,0.0922],[0,0],[-0.576,-0.4609],[-0.3341,-0.1959],[-0.2996,0.0115],[-0.3572,0.2535],[-1.5,0.9103],[-0.0806,-0.0115],[-0.5531,-0.4839],[-1.6,-1.3],[-0.9103,-0.0807],[-0.4263,0.023],[0,0],[-2.4,1.5],[-0.1383,0.0345],[-0.0461,-0.1037],[-0.5646,-1.5],[-0.4378,-0.3226],[-0.4263,-0.0461],[0,0],[-0.795,0.265],[0,0]],\"v\":[[4.6,10.7],[1.5,8.2],[0.1735,9.5],[0.0352,11.2],[1.1,13.8],[5.4,16.2],[9.4,16],[21.7,11],[25.9,11.2],[29.1,17.6],[32.9,19.4],[36.2,18.9],[41.7,16],[56.7,6],[59.7,6.2],[62.8,8.7],[66.4,14.1],[72.4,16.6],[82.1,13.8],[91.6,7.4],[94.4,6.6],[100.6,12.4],[106.4,14.3],[115,12.6],[131.5,12],[162.1,13.4],[178.7,12.6],[192.5,9.1],[191.3,5.1],[178.1,6.8],[162.3,7],[127.3,4.5],[106.1,7.6],[103.9,6.7],[98.7,1.2],[94.6,0],[88.4,1.4],[80.5,6.7],[72.1,10.2],[70.8,9.6],[65.3,2.5],[59.8,0.2996],[57.1,0.242],[53.3,0.9909],[41.4,9.5],[34.5,13.3],[33.5,12.9],[32.4,9.7],[29.6,6],[25.5,4.5],[19.8,5],[8,10.8],[4.6,10.7]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,51.4],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]}],\"fr\":60},{\"id\":\"hdr_alt\",\"layers\":[{\"nm\":\"hdr_alt_in\",\"ddd\":0,\"ty\":4,\"ind\":0,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.6047,-0.048],[0.3549,-1.2],[-0.1052,-1],[-0.7887,-1.2],[-1.9,-0.2881],[-1.4,0.3521],[-0.0526,0.032],[-0.1972,-0.2401],[0,0],[-0.4338,-0.08],[-0.3286,0.144],[-1.7,1.3],[0,0],[-0.3944,-0.096],[-1,-1.9],[-1.2,-1.4],[-1.7,-0.4802],[-0.6836,0.0481],[-0.8019,0.4481],[0,0.032],[-0.565,0.048],[-0.092,-0.032],[-1.9,-1.6],[-0.078,0],[-0.763,0.128],[-6.3,-0.3521],[-3,-0.08],[-5.7,0.8962],[-2.4,1.3],[5.2,-1.3],[1.3,-0.096],[6.8,0.2081],[8,0.4641],[2.6,-0.144],[1.5,-0.2721],[0.053,0.016],[0.631,0.6882],[0.355,0.2881],[0.354,0],[0.46,-0.2081],[1.7,-1.3],[2.2,-1.1],[0,0],[0.3155,0.3842],[1.8,1.7],[2.1,0.2721],[0.9727,-0.112],[0.2761,-0.2561],[1.8,-1.4],[0.0789,-0.0321],[0.1052,0.2721],[0.3286,0.9923],[1.4,1.1],[0.4996,0.08],[0.2892,-0.112],[1.9,-0.7522],[0.5915,0],[0,0]],\"o\":[[-0.2892,-0.3361],[-0.6047,0.048],[-0.1446,0.6242],[0.0657,0.9603],[1.1,1.8],[1.8,0.288],[2.7,-0.7363],[0,0],[0.1446,0.112],[0.1709,0.224],[0.8939,0],[0.2892,-0.1441],[0.815,-0.6242],[0.2629,-0.048],[1.6,0.5282],[0.5127,0.9443],[1.1,1.5],[0.7887,0.176],[0.3549,0],[0.9202,-0.5602],[0.315,-0.144],[0.184,-0.064],[0.408,0.3361],[0.486,0.3521],[0,0],[6.1,-0.9443],[8.8,0.2881],[7,0.1761],[1.4,-0.2401],[5.4,-2.6],[-2.4,0.7362],[-5.4,0.3201],[-2.6,-0.08],[-2.6,-0.1761],[-1.4,0.128],[-1.5,0.3041],[0,0],[-0.657,-0.6402],[-0.381,-0.2721],[-0.342,0.016],[-0.408,0.3521],[-1.7,1.3],[-1.1,0.5602],[-0.092,-0.016],[-0.631,-0.6722],[-1.8,-1.8],[-1,-0.112],[-0.4864,0.032],[0,0],[-2.7,2.1],[-0.1577,0.048],[-0.0526,-0.144],[-0.6441,-2],[-0.4995,-0.4481],[-0.4863,-0.064],[0,0],[-0.907,0.3681],[-0.5521,0.064],[0,0]],\"v\":[[5.3,14.9],[1.7,11.4],[0.1979,13.2],[0.0402,15.6],[1.3,19.2],[6.1,22.5],[10.8,22.2],[24.7,15.3],[29.5,15.5],[33.2,24.5],[37.6,27],[41.3,26.3],[47.5,22.2],[64.7,8.4],[68.1,8.7],[71.7,12.1],[75.7,19.6],[80.3,22.8],[82.6,23.1],[93.6,19.2],[104.5,10.2],[107.7,9.1],[108.8,9.4],[114.8,17.2],[121.3,19.8],[131.2,17.5],[150,16.7],[185,18.6],[203.8,17.4],[219.6,12.6],[218.3,7],[203.2,9.4],[185.1,9.7],[153.1,6.2],[145.3,6.3],[132.1,7.9],[121,10.6],[118.5,9.3],[112.7,1.7],[108,0],[100.8,2],[91.9,9.4],[85.8,13.1],[82.3,14.1],[80.8,13.3],[74.5,3.5],[68.2,0.4161],[65.2,0.3361],[60.8,1.4],[47.3,13.3],[39.3,18.4],[38.2,17.9],[37,13.4],[33.8,8.3],[29.1,6.2],[22.6,6.9],[9.2,14.9],[6.7,15.5],[5.3,14.9]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]}],\"fr\":60}],\"fonts\":{\"list\":[{\"fFamily\":\"Atlassian Sans, Arial, Helvetica, sans-serif\",\"fName\":\"AtlassianSansBold\",\"fStyle\":\"Bold\",\"fWeight\":\"700\"}]}}");



var $89bON = parcelRequire("89bON");

const $a4dc905fb76b7e55$export$1656be64ff79fed0 = {
    'title text': {
        color: ()=>(0, $89bON.getTokenValue)('color.text')
    },
    'title icon': {
        color: ()=>(0, $89bON.getTokenValue)('color.icon')
    },
    'Rectangle 1': {
        color: ()=>(0, $89bON.getTokenValue)('elevation.surface')
    },
    'h1 Header': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest')
    },
    'h1 description': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'Header white 1': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.inverse')
    },
    Party: {
        color: ()=>(0, $89bON.getTokenValue)('color.icon.inverse')
    },
    'header c1': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.inverse')
    },
    'description c1': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.inverse'),
        opacity: 0.6
    },
    Music: {
        color: ()=>(0, $89bON.getTokenValue)('color.icon.subtlest')
    },
    Cloud: {
        color: ()=>(0, $89bON.getTokenValue)('color.icon.subtlest')
    },
    Blocks: {
        color: ()=>(0, $89bON.getTokenValue)('color.icon.subtlest')
    },
    'header c2': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'description c2': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'header c3': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'description c3': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'header c4': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'description c4': {
        color: ()=>(0, $89bON.getTokenValue)('color.text.subtlest'),
        opacity: 0.6
    },
    'card purple 1 (skeleton)': {
        color: ()=>(0, $89bON.getTokenValue)('color.icon.subtlest')
    },
    'card gray 1': {
        color: ()=>(0, $89bON.getTokenValue)('color.background.accent.gray.subtlest')
    },
    'card gray 2': {
        color: ()=>(0, $89bON.getTokenValue)('color.background.accent.gray.subtlest')
    },
    'card gray 3': {
        color: ()=>(0, $89bON.getTokenValue)('color.background.accent.gray.subtlest')
    },
    Background: {
        color: ()=>(0, $89bON.getTokenValue)('elevation.surface')
    }
};


const $fc8365e3016e62d6$var$REMIX_ANIMATION_IMAGE_ASSET_ID = 'card_purple_1_1';
/** Converts a resolved hex token value into the normalized RGBA format expected by Lottie. */ const $fc8365e3016e62d6$var$hexToLottieColor = (color, opacity = 1)=>{
    const hex = color.replace('#', '');
    const red = Number.parseInt(hex.slice(0, 2), 16);
    const green = Number.parseInt(hex.slice(2, 4), 16);
    const blue = Number.parseInt(hex.slice(4, 6), 16);
    return [
        red / 255,
        green / 255,
        blue / 255,
        opacity
    ];
};
/** Recolors every RGB stop in a Lottie gradient while preserving its stop positions. */ const $fc8365e3016e62d6$var$replaceGradientColorStops = (gradient, color)=>{
    if (!gradient || typeof gradient !== 'object') return gradient;
    const { k: animatedGradient, p: colorStopCount } = gradient;
    if (!animatedGradient || !Array.isArray(animatedGradient.k) || !colorStopCount) return gradient;
    const colorStops = [
        ...animatedGradient.k
    ];
    for(let index = 0; index < colorStopCount; index++){
        const colorOffset = index * 4;
        colorStops[colorOffset + 1] = color[0];
        colorStops[colorOffset + 2] = color[1];
        colorStops[colorOffset + 3] = color[2];
    }
    return {
        ...gradient,
        k: {
            ...animatedGradient,
            k: colorStops
        }
    };
};
/** Recolors the font color in every keyframe of a Lottie text document. */ const $fc8365e3016e62d6$var$replaceTextColor = (text, color)=>{
    if (!text || typeof text !== 'object') return text;
    const { d: textDocument } = text;
    if (!textDocument?.k) return text;
    return {
        ...text,
        d: {
            ...textDocument,
            k: textDocument.k.map((keyframe)=>({
                    ...keyframe,
                    s: keyframe.s ? {
                        ...keyframe.s,
                        fc: color
                    } : keyframe.s
                }))
        }
    };
};
/** Recursively recolors fills, gradients, and text contained within a selected Lottie layer. */ const $fc8365e3016e62d6$var$replaceFillColors = (value, color)=>{
    if (Array.isArray(value)) return value.map((item)=>$fc8365e3016e62d6$var$replaceFillColors(item, color));
    if (!value || typeof value !== 'object') return value;
    const node = value;
    return Object.fromEntries(Object.entries(node).map(([key, item])=>{
        if (node.ty === 'fl' && key === 'c' && item && typeof item === 'object') return [
            key,
            {
                ...item,
                k: color
            }
        ];
        if ((node.ty === 'gf' || node.ty === 'gs') && key === 'g') return [
            key,
            $fc8365e3016e62d6$var$replaceGradientColorStops(item, color)
        ];
        if (node.ty === 5 && key === 't') return [
            key,
            $fc8365e3016e62d6$var$replaceTextColor(item, color)
        ];
        return [
            key,
            $fc8365e3016e62d6$var$replaceFillColors(item, color)
        ];
    }));
};
/** Resolves the static layer-to-token map against the currently active token theme. */ const $fc8365e3016e62d6$var$getLayerColors = ()=>{
    const layerColors = {};
    Object.entries((0, $a4dc905fb76b7e55$export$1656be64ff79fed0)).forEach(([layerName, { color: getColor, opacity: opacity }])=>{
        const color = getColor();
        if (color) layerColors[layerName] = {
            color: color,
            opacity: opacity
        };
    });
    return layerColors;
};
/** Creates a themed copy of the animation and replaces its embedded image with the local asset. */ const $fc8365e3016e62d6$var$createRemixAnimationData = (_colorMode)=>{
    const layerColors = $fc8365e3016e62d6$var$getLayerColors();
    const referencedAssetColors = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))).layers.flatMap((layer)=>{
        const layerColor = layerColors[layer.nm];
        return layer.refId && layerColor ? [
            [
                layer.refId,
                layerColor
            ]
        ] : [];
    }));
    return {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))),
        layers: (0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))).layers.map((layer)=>{
            const layerColor = layerColors[layer.nm];
            return layerColor ? $fc8365e3016e62d6$var$replaceFillColors(layer, $fc8365e3016e62d6$var$hexToLottieColor(layerColor.color, layerColor.opacity)) : layer;
        }),
        assets: (0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))).assets.map((asset)=>{
            if (asset.id === $fc8365e3016e62d6$var$REMIX_ANIMATION_IMAGE_ASSET_ID) return {
                ...asset,
                p: (0, (/*@__PURE__*/$parcel$interopDefault($64ff43be3a1ab908$exports))),
                u: ''
            };
            const assetColor = referencedAssetColors[asset.id];
            return assetColor ? $fc8365e3016e62d6$var$replaceFillColors(asset, $fc8365e3016e62d6$var$hexToLottieColor(assetColor.color, assetColor.opacity)) : asset;
        })
    };
};
const $fc8365e3016e62d6$var$placeholderStyles = null;
const $fc8365e3016e62d6$var$rendererSettings = {
    preserveAspectRatio: 'xMidYMid meet'
}; /** Marks where an accepted SUGGESTED_REMIX result will land while its card is active. */ 
function $fc8365e3016e62d6$export$ad96c1fdd46ef47e() {
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const animationData = (0, $cozmU.useMemo)(()=>$fc8365e3016e62d6$var$createRemixAnimationData(colorMode), [
        colorMode
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHsYL))), {
        animationData: animationData,
        autoplay: !isReducedMotion,
        loop: false,
        rendererSettings: $fc8365e3016e62d6$var$rendererSettings,
        "aria-hidden": "true",
        "data-testid": "ai-suggestions-remix-placeholder",
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8 _39xV02N91d _1EqgXl8yGE _3v5uP04flE _3138428HPE _0adFHsIZbP _1DCdHi8HPE _2XsHFMIZbP _1pp6NdYbGa"
        ])
    }, `${colorMode}-${isReducedMotion ? 'reduced-motion' : 'animated'}`);
}


/* SuggestionIconButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $gVCFw = parcelRequire("gVCFw");


var $3k5Tv = parcelRequire("3k5Tv");


/* SuggestionIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");




const $d7cc8c8cdc2edf4a$var$sizeStyles = {
    small: "_39xV02xpxF _0jFU0VxpxF",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $d7cc8c8cdc2edf4a$var$SPARKLE_PATH = 'M8.11719 1.00879C8.38352 1.05062 8.61063 1.23423 8.70508 1.49316L10.2549 5.74414L14.5068 7.29492C14.8027 7.40285 14.9998 7.6841 15 7.99902V8.00098C14.9998 8.3159 14.8027 8.59715 14.5068 8.70508L10.2549 10.2549L8.70508 14.5068C8.59715 14.8027 8.3159 14.9998 8.00098 15H7.99902C7.6841 14.9998 7.40285 14.8027 7.29492 14.5068L5.74414 10.2549L1.49316 8.70508C1.19728 8.59715 1.00018 8.3159 1 8.00098V7.99902C1.00018 7.6841 1.19728 7.40285 1.49316 7.29492L5.74414 5.74414L7.29492 1.49316L7.34277 1.38672C7.47321 1.15076 7.72343 1.00016 7.99902 1H8.00098L8.11719 1.00879Z'; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * The sparkle a CSS mask rather than an SVG `clipPath` + `foreignObject` as
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Safari has issues rendering the foreignObject.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `%23000` is an encoded `#000`; only the mask's alpha channel matters, so any
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * opaque fill works.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */ 
const $d7cc8c8cdc2edf4a$var$SPARKLE_MASK_IMAGE = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='${$d7cc8c8cdc2edf4a$var$SPARKLE_PATH}'/%3E%3C/svg%3E")`;
const $d7cc8c8cdc2edf4a$var$maskStyles = null;
const $d7cc8c8cdc2edf4a$export$29d3364b0f29ebd1 = ({ size: size = 'large', label: label, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1mT5xdRAKS _3X9j4qHU5A _3mXABNUZDI _4AZChJDIqT _45s7WmgIor _1pp6NdYbGa",
            $d7cc8c8cdc2edf4a$var$sizeStyles[size]
        ]),
        children: children
    });
};


const $10017670bb6714bc$var$suggestionIconScaleVar = '--suggestion-icon-scale';
const $10017670bb6714bc$var$suggestionIconRotateVar = '--suggestion-icon-rotate';
const $10017670bb6714bc$var$suggestionIconOpacityVar = '--suggestion-icon-opacity';
const $10017670bb6714bc$var$styles = {
    container: "_1mT5xdWVPG _1VJPcaKthN _1pp6NdYsOL",
    button: "_0bjKvDS5Zs _3iDTPbvLZJ _4BEwsv7dHp _102sn98g64 _2slvlC7dHp _1arFOTvLZJ _3AA1nQIO1S _2KpK8NSldA _0b5YdqdnbC",
    svgContainer: "_23rrnHZreT _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0yKXXaXWGq _1VJPcaxs8n",
    baseIconColorLayer: "_23rrnHgITp _0jFU0VN91d _39xV02N91d _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC",
    iconColor: "_0KLXru4YkS _1YKVNshOpP",
    iconColorHover: "_2uo31fN72K _1YKVNsYVbG"
};
const $10017670bb6714bc$var$AnimatedIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $10017670bb6714bc$var$styles.svgContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $d7cc8c8cdc2edf4a$export$29d3364b0f29ebd1), {
            label: "",
            size: "small",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $10017670bb6714bc$var$styles.baseIconColorLayer,
                        $10017670bb6714bc$var$styles.iconColor
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $10017670bb6714bc$var$styles.baseIconColorLayer,
                        $10017670bb6714bc$var$styles.iconColorHover
                    ])
                })
            ]
        })
    });
function $10017670bb6714bc$export$b6eb36123ab7ffdf({ leftAdjustment: leftAdjustment, localId: localId, api: api, intl: intl, topAdjustment: topAdjustment }) {
    // Derived primitives (rather than the state maps) so the hook's shallow
    // equality check can skip re-renders that don't affect this button.
    const { firstSuggestionId: firstSuggestionId, isSelected: isSelected, shortDescription: shortDescription, suggestionsCount: suggestionsCount } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, suggestionById: suggestionById, selectedSuggestion: selectedSuggestion } = state?.aiSuggestionsState ?? {};
        const suggestionIds = suggestionIdsByBaseLocalId?.get(localId);
        const firstSuggestionId = suggestionIds?.values().next().value;
        return {
            firstSuggestionId: firstSuggestionId,
            isSelected: Boolean(selectedSuggestion && suggestionIds?.has(selectedSuggestion)),
            shortDescription: firstSuggestionId ? suggestionById?.get(firstSuggestionId)?.shortDescription : undefined,
            suggestionsCount: suggestionIds?.size ?? 0
        };
    });
    const isSelectingSuggestionRef = (0, $cozmU.useRef)(false);
    const onSelectSuggestion = (0, $cozmU.useCallback)(()=>{
        if (isSelectingSuggestionRef.current) return;
        isSelectingSuggestionRef.current = true;
        const selectSuggestion = async ()=>{
            try {
                const canCloseComment = await api?.annotation?.actions.requestCloseInlineComment?.() ?? true;
                if (!canCloseComment || !firstSuggestionId) return;
                api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId, {
                    interactionPoint: 'card'
                });
            } finally{
                isSelectingSuggestionRef.current = false;
            }
        };
        selectSuggestion();
    }, [
        api,
        firstSuggestionId
    ]);
    const setHoveredSuggestion = (id)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'HOVER_SUGGESTION',
                id: id
            });
            return tr;
        });
    };
    const tooltip = (0, $cozmU.useMemo)(()=>({
            content: suggestionsCount > 1 ? intl?.formatMessage((0, $gVCFw.aiSuggestionsMessages).iconButtonSuggestionsCountLabel, {
                count: suggestionsCount
            }) || (shortDescription ?? '') : shortDescription ?? '',
            position: 'top'
        }), [
        intl,
        shortDescription,
        suggestionsCount
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        defaultLocale: intl?.defaultLocale || 'en-US',
        locale: intl?.locale || 'en-US',
        messages: intl?.messages,
        formats: intl?.formats,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                anchorName: `--button-${localId}`,
                top: topAdjustment ?? 0,
                right: `calc(${"var(--ds-space-negative-300, -24px)"} + ${"var(--ds-space-negative-300, -24px)"} - ${leftAdjustment ?? '0px'})`
            },
            className: (0, $hekY6.default)([
                $10017670bb6714bc$var$styles.container
            ]),
            children: // We keep the anchorName span rendered so that the suggestion card can reference it
            !isSelected && firstSuggestionId && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                onMouseEnter: ()=>setHoveredSuggestion(firstSuggestionId),
                onMouseLeave: ()=>setHoveredSuggestion(undefined),
                onFocus: ()=>setHoveredSuggestion(firstSuggestionId),
                onBlur: ()=>setHoveredSuggestion(undefined),
                className: (0, $hekY6.default)([
                    $10017670bb6714bc$var$styles.button
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    isTooltipDisabled: false,
                    tooltip: tooltip,
                    shape: "circle",
                    type: "button",
                    label: tooltip.content,
                    onClick: onSelectSuggestion,
                    appearance: "subtle",
                    spacing: "compact",
                    icon: $10017670bb6714bc$var$AnimatedIcon
                })
            })
        })
    });
}


/**
 * Streaming response types for ConvoAI
 */ function $9b3621d9606bf0dd$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
async function $9b3621d9606bf0dd$export$7ba546d072711b5d(body, options = {}) {
    const { onChunk: onChunk, onFinalResponse: onFinalResponse, onError: onError, signal: signal } = options;
    const reader = body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    let finalResponse = null;
    const chunks = [];
    try {
        while(!signal?.aborted){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, {
                stream: true
            });
            buffer += chunk;
            // Split by newlines and process complete lines
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const lines = buffer.split('\n');
            // Keep the last potentially incomplete line in the buffer
            buffer = lines.pop() || '';
            for (const line of lines){
                if (!line.trim()) continue;
                try {
                    const data = JSON.parse(line);
                    chunks.push(data);
                    onChunk?.(data);
                    // Check for FINAL_RESPONSE type (ConvoAI pattern)
                    if (data.type === 'FINAL_RESPONSE') {
                        finalResponse = data;
                        onFinalResponse?.(data);
                    }
                } catch (parseError) {
                    const error = new Error(`Failed to parse JSON line: ${parseError instanceof Error ? parseError.message : String(parseError)}`);
                    onError?.(error);
                }
            }
        }
        // Check if aborted
        if (signal?.aborted) reader.cancel();
        // Process any remaining buffer content
        if (buffer.trim()) try {
            const data = JSON.parse(buffer);
            chunks.push(data);
            onChunk?.(data);
            if (data.type === 'FINAL_RESPONSE') {
                finalResponse = data;
                onFinalResponse?.(data);
            }
        } catch  {
        // Ignore incomplete final chunk
        }
    } catch (error) {
        const streamError = error instanceof Error ? error : new Error(String(error));
        onError?.(streamError);
        throw streamError;
    }
    return {
        finalResponse: finalResponse,
        chunks: chunks
    };
}
async function $9b3621d9606bf0dd$export$95b9987b6ac049ec(options) {
    const { url: url, fetchOptions: fetchOptions = {}, signal: signal, onChunk: onChunk, onError: onError, onFinalResponse: onFinalResponse } = options;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        ...fetchOptions,
        signal: signal
    });
    if (!response.ok) {
        const error = new Error(`Response not OK: ${response.status}`);
        onError?.(error);
        throw error;
    }
    if (!response.body) {
        const error = new Error('No response body');
        onError?.(error);
        throw error;
    }
    return $9b3621d9606bf0dd$export$7ba546d072711b5d(response.body, {
        onChunk: onChunk,
        onError: onError,
        onFinalResponse: onFinalResponse,
        signal: signal
    });
}


const $61b8b9734ab6a330$export$eab6f356b10dc881 = 'content_reviewer_agent';
async function $61b8b9734ab6a330$export$8f943592d88201ff({ cloudId: cloudId, signal: signal }) {
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/v1/agent/provisioning/ootb/${$61b8b9734ab6a330$export$eab6f356b10dc881}`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': 'confluence',
            'X-Experience-Id': 'ai-mate',
            'Atl-CloudId': cloudId
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`Provision OOTB agent request failed: ${response.status}`);
}
async function $61b8b9734ab6a330$export$ebf2f44fe450da2b({ contentAri: contentAri, signal: signal }) {
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions?content_ari=${encodeURIComponent(contentAri)}&status=PENDING`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`Get suggestions request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}
async function $61b8b9734ab6a330$export$1d496d000386893c({ updates: updates, signal: signal }) {
    // /ai-features/content-suggested-edits/update-status
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            updates: updates
        }
    };
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/update-status`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Content suggested edits request failed: ${response.status}`);
}
async function $61b8b9734ab6a330$export$7ffa8bd2a6ad0cd0({ suggestionIds: suggestionIds, contentAri: contentAri, currentNodes: currentNodes, signal: signal }) {
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            content_ari: contentAri,
            current_nodes: currentNodes,
            suggestion_ids: suggestionIds
        }
    };
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions/regenerate`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Regenerate suggestions request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}



var $6SJ6d = parcelRequire("6SJ6d");


var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");




const $295ac436451fb879$export$ef2b3f5e81ffeef8 = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_suggested_edits_default_on');


function $c08510c480bfb65f$export$e644b4e6be3487e(suggestion) {
    if (suggestion.anchorLocalId) return suggestion.anchorLocalId;
    const firstToolCall = suggestion.toolCalls?.[0];
    return firstToolCall && 'localId' in firstToolCall.arguments ? firstToolCall.arguments.localId : undefined;
}
function $c08510c480bfb65f$export$f5640f1db7cc9e30(suggestion) {
    const localIds = suggestion.action?.localIds;
    // for suggestions that supply localIds rather than toolcalls
    if (localIds?.length) return localIds.at(-1);
    const lastToolCall = suggestion.toolCalls?.at(-1);
    if (!lastToolCall || lastToolCall === suggestion.toolCalls?.at(0)) return $c08510c480bfb65f$export$e644b4e6be3487e(suggestion);
    if ('localId' in lastToolCall.arguments) return lastToolCall.arguments.localId;
    return lastToolCall.arguments.localIds.at(-1) ?? suggestion.anchorLocalId;
}


/** `actionKind` of the suggestions whose result the remix engine generates. */ const $292ce7789767c97d$var$SUGGESTED_REMIX_ACTION_KIND = 'SUGGESTED_REMIX';
function $292ce7789767c97d$export$41c5fd813e13fc6c(suggestion) {
    return suggestion.actionKind === $292ce7789767c97d$var$SUGGESTED_REMIX_ACTION_KIND;
}
function $292ce7789767c97d$export$793e1650d3921fb5(suggestion) {
    if (suggestion.action?.localIds?.length) return suggestion.action.localIds;
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
    return anchorLocalId ? [
        anchorLocalId
    ] : [];
}



var $krYZG = parcelRequire("krYZG");

// Walks an inserted ADF subtree to collect every `localId` and node `type`. Captures localIds at
// every depth because tool-call collisions can be triggered by nested ids, not just the root.
function $2a4bc64013915ea2$var$collectFromAdf(node, localIds, nodeTypes) {
    if (!node || typeof node !== 'object') return;
    if (typeof node.type === 'string') nodeTypes.add(node.type);
    const localId = node.attrs?.localId;
    if (typeof localId === 'string') localIds.add(localId);
    if (Array.isArray(node.content)) for (const child of node.content)$2a4bc64013915ea2$var$collectFromAdf(child, localIds, nodeTypes);
}
function $2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds)localIds.add(id);
        return;
    }
    localIds.add(toolCall.arguments.localId);
    if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
        $2a4bc64013915ea2$var$collectFromAdf(JSON.parse(toolCall.arguments.value), localIds, nodeTypes);
    } catch  {
    // Ignore malformed JSON - the tool call would also fail to apply, surfaced elsewhere.
    }
}
function $2a4bc64013915ea2$var$collectToolCallAttributes(toolCall) {
    const localIds = new Set();
    const nodeTypes = new Set();
    $2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    return {
        name: toolCall.name,
        localIds: Array.from(localIds),
        nodeTypes: Array.from(nodeTypes)
    };
}
function $2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes) {
    const { errorCode: errorCode, statusCode: statusCode } = errorAttributes ?? {};
    return {
        ...typeof errorCode === 'string' ? {
            errorCode: errorCode
        } : {},
        ...typeof statusCode === 'number' ? {
            statusCode: statusCode
        } : {}
    };
}
const $2a4bc64013915ea2$export$707043ea55006b30 = (editorAnalyticsAPI)=>(transaction, suggestion)=>{
        const toolCalls = (suggestion.toolCalls ?? []).map($2a4bc64013915ea2$var$collectToolCallAttributes);
        const payload = {
            action: (0, $krYZG.ACTION).NO_DIFF_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                suggestionType: suggestion.type,
                toolCalls: toolCalls
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$d485252031168fc9 = (suggestion)=>{
    const ids = new Set();
    for (const localId of suggestion.action?.localIds ?? [])ids.add(localId);
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name === 'removeNodes') for (const id of toolCall.arguments.localIds)ids.add(id);
        else ids.add(toolCall.arguments.localId);
    }
    return ids.size;
};
const $2a4bc64013915ea2$export$9afb3e37f6af6abe = (suggestion, now = Date.now())=>{
    const createdAt = Date.parse(suggestion.createdAt);
    return Number.isFinite(createdAt) ? Math.max(0, now - createdAt) : undefined;
};
const $2a4bc64013915ea2$var$getSuggestionAgeAttribute = (suggestion, now)=>{
    const suggestionAgeMs = $2a4bc64013915ea2$export$9afb3e37f6af6abe(suggestion, now);
    return suggestionAgeMs === undefined ? {} : {
        suggestionAgeMs: suggestionAgeMs
    };
};
const $2a4bc64013915ea2$var$getSuggestionRemixAttributes = (suggestion)=>{
    if (suggestion.actionKind !== 'SUGGESTED_REMIX') return {};
    return {
        ...suggestion.action?.launchOptions?.dynamicUiType ? {
            remixType: suggestion.action.launchOptions.dynamicUiType
        } : {},
        ...suggestion.action?.launchOptions?.dynamicUiSubtype ? {
            remixSubtype: suggestion.action.launchOptions.dynamicUiSubtype
        } : {}
    };
};
const $2a4bc64013915ea2$var$getSuggestionCommonAttributes = (suggestion, now)=>{
    return {
        actionKind: suggestion.actionKind ?? 'SUGGESTED_EDIT',
        agentId: suggestion.createdByAgent?.accountId,
        ...$2a4bc64013915ea2$var$getSuggestionAgeAttribute(suggestion, now),
        ...$2a4bc64013915ea2$var$getSuggestionRemixAttributes(suggestion)
    };
};
/**
 * Returns the total plain text characters being added by a suggestion.
 * Derived from the `value` ADF JSON of inserting/replacing tool calls.
 */ function $2a4bc64013915ea2$var$getTextFromAdfNode(node) {
    if (node.type === 'text' && typeof node.text === 'string') return node.text;
    if (Array.isArray(node.content)) return node.content.map((child)=>$2a4bc64013915ea2$var$getTextFromAdfNode(child)).join('');
    return '';
}
const $2a4bc64013915ea2$export$d01a7319a5878cbe = (suggestion)=>{
    let count = 0;
    for (const toolCall of suggestion.toolCalls ?? []){
        if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
            count += $2a4bc64013915ea2$var$getTextFromAdfNode(JSON.parse(toolCall.arguments.value)).length;
        } catch  {
        // malformed JSON — skip
        }
    }
    return count;
};
const $2a4bc64013915ea2$export$1dd4e3d2c42a2395 = (suggestion, doc)=>{
    const removingCalls = [
        'removeNode',
        'removeNodes',
        'replaceNode'
    ];
    const visitedIds = new Set();
    let count = 0;
    for (const toolCall of suggestion.toolCalls ?? []){
        if (!removingCalls.includes(toolCall.name)) continue;
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            if (visitedIds.has(localId)) continue;
            visitedIds.add(localId);
            doc.descendants((node)=>{
                if (node.attrs.localId === localId) {
                    count += node.textContent.length;
                    return false;
                }
            });
        }
    }
    return count;
};
const $2a4bc64013915ea2$export$33e4f7f2497d28c1 = (editorAnalyticsAPI)=>(transaction, entryPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                entryPoint: entryPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$23faece8799b6885 = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_ERROR_RETRY,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$5a116e8d20eb61e1 = (editorAnalyticsAPI, entryPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).EXPOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            entryPoint: entryPoint
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$4ca37dd723b35752 = (editorAnalyticsAPI, error)=>{
    const errorAttributes = error?.errorAttributes;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'conversationSetup',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$c2bc44992302850a = (editorAnalyticsAPI, error)=>{
    const message = error?.message;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'streamError',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes({
                errorCode: message?.key,
                statusCode: message?.status_code
            })
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$f79b8848e86580c7 = (editorAnalyticsAPI, error)=>{
    const errorAttributes = error?.errorAttributes;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentProvisioning',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$340d751fde574e23 = (editorAnalyticsAPI)=>{
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentExternalConfigReference'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$b36e176162c1ac33 = (editorAnalyticsAPI)=>{
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentDeactivated'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$var$getRegenerationSuggestionDetails = (suggestion, now)=>({
        actionKind: suggestion.actionKind ?? 'SUGGESTED_EDIT',
        ...$2a4bc64013915ea2$var$getSuggestionAgeAttribute(suggestion, now),
        ...$2a4bc64013915ea2$var$getSuggestionRemixAttributes(suggestion),
        suggestionId: suggestion.id,
        suggestionType: suggestion.type
    });
const $2a4bc64013915ea2$export$c688d4ee3cc6e4dc = (editorAnalyticsAPI, { currentNodeCount: currentNodeCount, staleSuggestionIds: staleSuggestionIds, suggestions: suggestions, trigger: trigger })=>{
    const startedAt = Date.now();
    const staleSuggestions = suggestions.filter((suggestion)=>staleSuggestionIds.has(suggestion.id));
    const payload = {
        action: (0, $krYZG.ACTION).REGENERATION_STARTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_REGENERATION,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            staleSuggestionCount: staleSuggestions.length,
            currentNodeCount: currentNodeCount,
            suggestionDetails: staleSuggestions.map((suggestion)=>$2a4bc64013915ea2$var$getRegenerationSuggestionDetails(suggestion, startedAt)),
            trigger: trigger
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
    return {
        completed: ({ regeneratedSuggestions: regeneratedSuggestions, shouldRetainStale: shouldRetainStale })=>{
            const regeneratedById = new Map(regeneratedSuggestions.map((suggestion)=>[
                    suggestion.id,
                    suggestion
                ]));
            const outcomes = staleSuggestions.map((suggestion, index)=>{
                const regeneratedSuggestion = regeneratedById.get(suggestion.id) ?? (shouldRetainStale ? undefined : regeneratedSuggestions[index]);
                let outcome;
                if (regeneratedSuggestion?.status === 'STALE') outcome = 'stillStale';
                else if (regeneratedSuggestion) outcome = 'updated';
                else outcome = shouldRetainStale ? 'stillStale' : 'removed';
                return {
                    outcome: outcome,
                    suggestion: suggestion
                };
            });
            const suggestionDetails = outcomes.map(({ outcome: outcome, suggestion: suggestion })=>({
                    ...$2a4bc64013915ea2$var$getRegenerationSuggestionDetails(suggestion, startedAt),
                    outcome: outcome
                }));
            const completedPayload = {
                action: (0, $krYZG.ACTION).REGENERATION_COMPLETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_REGENERATION,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    staleSuggestionCount: outcomes.length,
                    currentNodeCount: currentNodeCount,
                    regenerationDurationMs: Math.max(0, Date.now() - startedAt),
                    removedSuggestionCount: outcomes.filter(({ outcome: outcome })=>outcome === 'removed').length,
                    stillStaleSuggestionCount: outcomes.filter(({ outcome: outcome })=>outcome === 'stillStale').length,
                    updatedSuggestionCount: outcomes.filter(({ outcome: outcome })=>outcome === 'updated').length,
                    suggestionDetails: suggestionDetails,
                    trigger: trigger
                }
            };
            editorAnalyticsAPI?.fireAnalyticsEvent(completedPayload);
        },
        errored: (error)=>{
            const errorAttributes = error?.errorAttributes;
            const errorPayload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_REGENERATION_ERROR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    staleSuggestionCount: staleSuggestions.length,
                    currentNodeCount: currentNodeCount,
                    regenerationDurationMs: Math.max(0, Date.now() - startedAt),
                    suggestionDetails: staleSuggestions.map((suggestion)=>$2a4bc64013915ea2$var$getRegenerationSuggestionDetails(suggestion, startedAt)),
                    trigger: trigger,
                    ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
                }
            };
            editorAnalyticsAPI?.fireAnalyticsEvent(errorPayload);
        }
    };
};
const $2a4bc64013915ea2$export$fe9dd3fdf8b03a6f = (api, trigger)=>{
    const refreshStartedAt = Date.now();
    const stateBeforeRefresh = api.aiSuggestions?.sharedState.currentState();
    const existingSuggestionIds = new Set(stateBeforeRefresh?.orderedSuggestionIds ?? []);
    const generationStartedAt = stateBeforeRefresh?.thinkingStartedAt ?? refreshStartedAt;
    return {
        completed: ({ regenerateOnly: regenerateOnly, suggestions: suggestions })=>{
            if (regenerateOnly || trigger !== 'reviewCompleted') return;
            const generatedSuggestions = suggestions.filter((suggestion)=>!existingSuggestionIds.has(suggestion.id));
            const payload = {
                action: (0, $krYZG.ACTION).GENERATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    generationDurationMs: Math.max(0, Date.now() - generationStartedAt),
                    hadExistingSuggestions: existingSuggestionIds.size > 0,
                    numberOfSuggestions: generatedSuggestions.length,
                    suggestionDetails: generatedSuggestions.map((suggestion)=>({
                            actionKind: suggestion.actionKind ?? 'SUGGESTED_EDIT',
                            affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                            agentId: suggestion.createdByAgent?.accountId,
                            hasSources: Boolean(suggestion.sources?.length),
                            ...$2a4bc64013915ea2$var$getSuggestionRemixAttributes(suggestion),
                            suggestionId: suggestion.id,
                            suggestionType: suggestion.type
                        }))
                }
            };
            api.analytics?.actions.fireAnalyticsEvent(payload);
        }
    };
};
const $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME = 'Suggested edits';
const $2a4bc64013915ea2$export$94b303e4fd9baa4e = (editorAnalyticsAPI, entryPoint, singleInstrumentationId)=>{
    const payload = {
        action: (0, $krYZG.ACTION).INITIATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_INTERACTION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            aiFeatureName: 'Editor AI',
            aiExperienceName: $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME,
            singleInstrumentationID: singleInstrumentationId,
            isAIFeature: 1,
            // TODO: EDITOR-8150 - userGeneratedAI / proactiveAIGenerated are hardcoded for
            // the current user-triggered flow; parameterise these once proactive
            // suggestions are supported.
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            invokedFrom: entryPoint
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$ec701ea77bc93a9f = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).DISCARDED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                hasSources: Boolean(suggestion.sources?.length),
                suggestionId: suggestion.id,
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$906733f59ab51f3d = (editorAnalyticsAPI)=>(transaction, suggestions)=>{
        const payload = {
            action: (0, $krYZG.ACTION).DISCARD_ALL,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                numberOfSuggestions: suggestions.length,
                suggestionDetails: suggestions.map((suggestion)=>({
                        ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
                        affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                        hasSources: Boolean(suggestion.sources?.length),
                        interactionPoint: 'sidebar',
                        suggestionId: suggestion.id,
                        suggestionType: suggestion.type
                    }))
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$6bd5a709c87f4c35 = (editorAnalyticsAPI, sentiment, singleInstrumentationId, interactionPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).SUBMITTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_FEEDBACK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            aiFeatureName: 'Editor AI',
            aiExperienceName: $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME,
            singleInstrumentationID: singleInstrumentationId,
            isAIFeature: 1,
            // TODO: EDITOR-8150 - userGeneratedAI / proactiveAIGenerated are hardcoded for
            // the current user-triggered flow; parameterise these once proactive
            // suggestions are supported.
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            invokedFrom: interactionPoint,
            aiFeedbackResult: sentiment === 'good' ? 'up' : 'down'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$5085d0c956f2f4ac = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).DISMISSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                hasSources: Boolean(suggestion.sources?.length),
                suggestionId: suggestion.id,
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$c37411486d5e33f8 = ({ currentState: currentState, editorAnalyticsAPI: editorAnalyticsAPI, interactionPoint: interactionPoint, nextSuggestionId: nextSuggestionId, transaction: transaction })=>{
    if (!interactionPoint) return transaction;
    const previousSelectedSuggestionId = currentState?.selectedSuggestion;
    const previousSelectedSuggestion = previousSelectedSuggestionId ? currentState?.suggestionById.get(previousSelectedSuggestionId) : undefined;
    const isClearingSelectedSuggestion = nextSuggestionId === null;
    const isReplacingSelectedSuggestion = nextSuggestionId !== null && currentState?.suggestionById.has(nextSuggestionId) === true;
    const shouldTrackDismissedSuggestion = previousSelectedSuggestionId !== undefined && previousSelectedSuggestionId !== nextSuggestionId && (isClearingSelectedSuggestion || isReplacingSelectedSuggestion);
    const dismissedSuggestion = shouldTrackDismissedSuggestion ? previousSelectedSuggestion : undefined;
    if (dismissedSuggestion) $2a4bc64013915ea2$export$5085d0c956f2f4ac(editorAnalyticsAPI)(transaction, dismissedSuggestion, interactionPoint);
    return transaction;
};
const $2a4bc64013915ea2$export$799e089d141dbbc0 = (suggestion, doc)=>{
    const localIds = new Set(suggestion.action?.localIds ?? []);
    const nodeTypes = new Set();
    for (const toolCall of suggestion.toolCalls ?? [])$2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    // Look up removed nodes in the doc by localId to capture their types (removeNodes has no ADF value).
    doc.descendants((node)=>{
        if (typeof node.attrs?.localId === 'string' && localIds.has(node.attrs.localId)) nodeTypes.add(node.type.name);
    });
    const schema = doc.type.schema;
    return Array.from(nodeTypes).filter((typeName)=>schema.nodes[typeName]?.isBlock === true);
};
const $2a4bc64013915ea2$export$aaae075a5bab9523 = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const isSuggestedRemix = suggestion.actionKind === 'SUGGESTED_REMIX';
        const payload = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                blockTypes: $2a4bc64013915ea2$export$799e089d141dbbc0(suggestion, transaction.doc),
                ...!isSuggestedRemix && {
                    charactersToAdd: $2a4bc64013915ea2$export$d01a7319a5878cbe(suggestion),
                    charactersToRemove: $2a4bc64013915ea2$export$1dd4e3d2c42a2395(suggestion, transaction.doc)
                },
                hasSources: Boolean(suggestion.sources?.length),
                interactionPoint: interactionPoint,
                suggestionCardCharacterCount: suggestion.shortDescription?.length ?? 0,
                suggestionId: suggestion.id,
                suggestionType: suggestion.type
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$22bc65b38809466 = (editorAnalyticsAPI, suggestion, interactionPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).REASONING_VIEWED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
            affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
            hasSources: Boolean(suggestion.sources?.length),
            interactionPoint: interactionPoint,
            reasoningCharacterCount: suggestion.reasoning?.length ?? 0,
            suggestionId: suggestion.id,
            suggestionType: suggestion.type
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$ed9c3ad08dbed35a = (editorAnalyticsAPI, interactionPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).CANCELLED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            interactionPoint: interactionPoint
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$f1a852c299619cdc = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint, isDiffHidden = false)=>{
        const isSuggestedRemix = suggestion.actionKind === 'SUGGESTED_REMIX';
        const payload = {
            action: (0, $krYZG.ACTION).ACCEPTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                ...$2a4bc64013915ea2$var$getSuggestionCommonAttributes(suggestion),
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                ...!isSuggestedRemix && {
                    charactersAdded: $2a4bc64013915ea2$export$d01a7319a5878cbe(suggestion),
                    charactersRemoved: $2a4bc64013915ea2$export$1dd4e3d2c42a2395(suggestion, transaction.doc)
                },
                hasSources: Boolean(suggestion.sources?.length),
                isDiffHidden: isDiffHidden,
                suggestionId: suggestion.id,
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };


function $c7070bf070f88a5c$export$d4c6a6d5c208b0f9(suggestion) {
    const ids = [];
    const add = (id)=>{
        if (id && !ids.includes(id)) ids.push(id);
    };
    for (const toolCall of suggestion.toolCalls ?? [])if (toolCall.name === 'removeNodes') toolCall.arguments.localIds.forEach(add);
    else add(toolCall.arguments.localId);
    suggestion.action?.localIds?.forEach(add);
    return ids;
}




var $8QOo3 = parcelRequire("8QOo3");


var $5Qi6J = parcelRequire("5Qi6J");


var $3Zd2B = parcelRequire("3Zd2B");




function $fcb2659c912a210b$export$44a924f1d868657b(suggestion) {
    return {
        agentId: suggestion.createdByAgent?.accountId || undefined,
        agentName: suggestion.createdByAgent?.name || undefined,
        agentType: suggestion.createdByAgent?.agentType || 'convo-ai'
    };
}


function $2ad4b5801d1093af$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $2ad4b5801d1093af$export$da10b2800363f225(attrs) {
    if ($2ad4b5801d1093af$var$isRecord(attrs)) return attrs;
    if (typeof attrs !== 'string') return undefined;
    try {
        const parsed = JSON.parse(attrs);
        return $2ad4b5801d1093af$var$isRecord(parsed) ? parsed : undefined;
    } catch  {
        return undefined;
    }
}



var $2w79Z = parcelRequire("2w79Z");


var $bjg0G = parcelRequire("bjg0G");

function $2c24ed7b0ddbc6f4$export$676497ef504d5696(tr, position, content, side = 'after') {
    const $insertPos = tr.doc.resolve(position);
    if ((0, $2w79Z.isEmptyParagraph)($insertPos.parent) && $insertPos.depth > 0) {
        const $beforeParagraph = tr.doc.resolve($insertPos.before());
        if ((0, $bjg0G.canInsert)($beforeParagraph, content)) {
            tr.replaceWith($insertPos.before(), $insertPos.after(), content);
            return tr;
        }
    }
    if ((0, $bjg0G.canInsert)($insertPos, content)) {
        tr.insert($insertPos.pos, content);
        return tr;
    }
    for(let depth = $insertPos.depth; depth > 0; depth--){
        const pos = side === 'before' ? $insertPos.before(depth) : $insertPos.after(depth);
        if ((0, $bjg0G.canInsert)(tr.doc.resolve(pos), content)) {
            tr.insert(pos, content);
            return tr;
        }
    }
    return tr;
}



var $lAynq = parcelRequire("lAynq");


var $aPdNQ = parcelRequire("aPdNQ");








function $e655df7f8ec1986e$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $e655df7f8ec1986e$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
const $e655df7f8ec1986e$export$5a065b4e594c5a9c = ({ toolCallArguments: toolCallArguments, tr: tr, pos: pos })=>{
    const $from = tr.doc.resolve(pos);
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    const $to = tr.doc.resolve(pos + node.nodeSize);
    const range = $from.blockRange($to);
    if (range) {
        const type = tr.doc.type.schema.nodes[toolCallArguments.wrapperType];
        try {
            // Tool-call attrs reach us in the shape the payload encoded them in, which is not
            // necessarily the shape ProseMirror can consume — see `parseToolCallAttrs`. An unusable
            // value yields `undefined`, which `findWrapping`/`createAndFill` read as "all schema
            // defaults" rather than as the junk attrs spreading a string produces.
            const wrapperAttrs = (0, $2ad4b5801d1093af$export$da10b2800363f225)(toolCallArguments.wrapperAttrs);
            // A wrapper type that supports `localId` gets one up-front, as the block menu's
            // convert-to-expand does. Without it the local-id plugin's `appendTransaction` assigns
            // one via a `BatchAttrsStep` before the view updates, which swaps the wrapper node
            // object out and drops any state keyed on its identity — including the `expandedState`
            // entry `openWrappedExpands` sets to keep a wrapped expand open. `generateShortUUID` is
            // that plugin's own generator, so the id matches the ones it assigns and is registered
            // for its collision checks.
            const needsLocalId = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') && Boolean(type.spec.attrs?.localId) && typeof wrapperAttrs?.localId !== 'string';
            const attrs = needsLocalId ? {
                ...wrapperAttrs,
                localId: (0, $lAynq.generateShortUUID)()
            } : wrapperAttrs;
            const wrapping = (0, $eOaGc.findWrapping)(range, type, attrs);
            if (wrapping !== null) tr.wrap(range, wrapping);
            else {
                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                const fragment = slice.content;
                let node = type.createAndFill(attrs, fragment);
                if (!node) node = $e655df7f8ec1986e$var$wrapChild(fragment, type, attrs);
                if (node) {
                    const insertPos = $e655df7f8ec1986e$var$findPosForNode(node, $to);
                    if (insertPos !== null) {
                        tr.insert(insertPos, node);
                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $aPdNQ.Slice).empty);
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return tr;
};


function $f40c730c85c0fd70$var$isJsonObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $f40c730c85c0fd70$var$clearMentionText(_key, value) {
    if (!$f40c730c85c0fd70$var$isJsonObject(value)) return value;
    const { attrs: attrs } = value;
    if (value.type !== 'mention' || !$f40c730c85c0fd70$var$isJsonObject(attrs) || typeof attrs.text !== 'string' || attrs.text.length === 0) return value;
    return {
        ...value,
        attrs: {
            ...attrs,
            text: ''
        }
    };
}
function $f40c730c85c0fd70$var$createNodeFromToolCallValue(schema, value) {
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value, (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') ? $f40c730c85c0fd70$var$clearMentionText : undefined) : value;
        return (0, $5Qi6J.processRawValue)(schema, parsed);
    } catch  {
        return undefined;
    }
}
function $f40c730c85c0fd70$export$3a685203b954911f(doc, localId) {
    let result;
    doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            from: pos,
            to: pos + node.nodeSize
        };
        return !result;
    });
    return result;
}
const $f40c730c85c0fd70$var$EXPAND_NODE_TYPE_NAMES = [
    'expand',
    'nestedExpand'
];
/**
 * Finds the node of `typeName` that now encloses the node with `localId`, i.e. the
 * wrapper a `wrap` tool call just created around it. Re-deriving it from the tool call's
 * own `localId` avoids having to track the wrapper's position across the steps of the
 * tool calls that follow, which can both move it and replace the node object at it.
 */ function $f40c730c85c0fd70$var$findWrapperOfNode(doc, localId, typeName) {
    const positions = $f40c730c85c0fd70$export$3a685203b954911f(doc, localId);
    if (!positions) return undefined;
    const $pos = doc.resolve(positions.from);
    for(let depth = $pos.depth; depth > 0; depth--){
        const ancestor = $pos.node(depth);
        if (ancestor.type.name === typeName) return ancestor;
    }
    return undefined;
}
/**
 * Opt every `expand` / `nestedExpand` this suggestion wrapped content in into being
 * open, so wrapping content in an expand doesn't collapse it out of sight.
 *
 * The single-player expand implementation keeps open/closed state in the
 * `expandedState` WeakMap keyed by node identity — the `__expanded` attr is only read
 * by the legacy implementation, and its schema default of `true` has no effect here.
 * A wrapper created by `wrapNode` therefore has no entry, and `ExpandNodeView` defaults
 * an unknown node to collapsed. Every other expand-creating path (`insertExpand`, the
 * block menu's convert-to-expand) opts its new node in the same way.
 *
 * Deliberately runs against the final doc of the transform, after every tool call has
 * been applied: the entry is keyed on the node object, so it has to be set against the
 * object that survives — a later tool call editing inside a wrapper replaces it.
 */ function $f40c730c85c0fd70$var$openWrappedExpands(tr, suggestion) {
    if (!(0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) return;
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name !== 'wrap' && toolCall.name !== 'wrapNode') continue;
        const { localId: localId, wrapperType: wrapperType } = toolCall.arguments;
        if (!$f40c730c85c0fd70$var$EXPAND_NODE_TYPE_NAMES.includes(wrapperType)) continue;
        // Matching on the requested `wrapperType` keeps a failed wrap from opening a
        // pre-existing expand that merely happened to already contain the target.
        const wrapper = $f40c730c85c0fd70$var$findWrapperOfNode(tr.doc, localId, wrapperType);
        if (wrapper) (0, $8QOo3.expandedState).set(wrapper, true);
    }
}
function $f40c730c85c0fd70$var$applyToolCall(tr, toolCall) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds){
            const positions = $f40c730c85c0fd70$export$3a685203b954911f(tr.doc, id);
            if (positions) tr.delete(positions.from, positions.to);
        }
        return;
    }
    const positions = $f40c730c85c0fd70$export$3a685203b954911f(tr.doc, toolCall.arguments.localId);
    if (!positions) return;
    switch(toolCall.name){
        case 'replaceNode':
        case 'insertNodeBefore':
        case 'insertNodeAfter':
            {
                const node = $f40c730c85c0fd70$var$createNodeFromToolCallValue(tr.doc.type.schema, toolCall.arguments.value);
                if (!node) return;
                // An attribute-only replaceNode (e.g. promoting a heading from H4 to H3) keeps the
                // node's type and content identical. Encoding it as a full replace yields a ReplaceStep
                // whose granular diff is empty (the text is unchanged), so the change never surfaces.
                // Apply it via setNodeMarkup instead so the diff plugin renders it as a node change.
                const existingNode = tr.doc.nodeAt(positions.from);
                if (toolCall.name === 'replaceNode' && existingNode && existingNode.type === node.type && existingNode.content.eq(node.content)) {
                    tr.setNodeMarkup(positions.from, undefined, node.attrs, node.marks);
                    return;
                }
                if (toolCall.name === 'replaceNode') {
                    /**
				 *  Only fall back to delete + safeInsertAtPos
				 * (which walks up the doc to find the nearest schema-valid ancestor) when a
				 * direct replace would produce invalid ProseMirror doc nesting.
				 *
				 * canReplaceWith takes in indices, so for replaceNode we only need to check the
				 * from index and the next index since this is for replacing a single node.
				 */ const $from = tr.doc.resolve(positions.from);
                    const canReplaceDirectly = $from.parent.canReplaceWith($from.index(), $from.index() + 1, node.type);
                    if (canReplaceDirectly) {
                        tr.replaceWith(positions.from, positions.to, node);
                        return;
                    }
                    tr.delete(positions.from, positions.to);
                    (0, $2c24ed7b0ddbc6f4$export$676497ef504d5696)(tr, positions.from, node);
                    return;
                }
                const insertPos = toolCall.name === 'insertNodeAfter' ? positions.to : positions.from;
                const side = toolCall.name === 'insertNodeBefore' ? 'before' : 'after';
                (0, $2c24ed7b0ddbc6f4$export$676497ef504d5696)(tr, insertPos, node, side);
                return;
            }
        case 'removeNode':
            tr.delete(positions.from, positions.to);
            return;
        case 'wrap':
        case 'wrapNode':
            (0, $e655df7f8ec1986e$export$5a065b4e594c5a9c)({
                toolCallArguments: toolCall.arguments,
                tr: tr,
                pos: positions.from
            });
            return;
        case 'setAttrs':
            {
                const node = tr.doc.nodeAt(positions.from);
                if (!node) return;
                // The payload may have encoded the attrs as a JSON string, which `setNodeMarkup` would
                // spread as junk keys and apply none of. See `parseToolCallAttrs`.
                const attrs = (0, $2ad4b5801d1093af$export$da10b2800363f225)(toolCall.arguments.attrs);
                // Nothing to apply: skip rather than re-set the node's current attrs, which would add
                // a step the diff then has to render as a change that changed nothing.
                if (!attrs) return;
                tr.setNodeMarkup(positions.from, undefined, {
                    ...node.attrs,
                    ...attrs
                });
                return;
            }
    }
}
function $f40c730c85c0fd70$export$e450239860b6dfe1({ tr: tr, suggestion: suggestion }) {
    for (const toolCall of suggestion.toolCalls ?? [])$f40c730c85c0fd70$var$applyToolCall(tr, toolCall);
    $f40c730c85c0fd70$var$openWrappedExpands(tr, suggestion);
    // Shared by all apply paths. Preview-only Transforms have no transaction metadata.
    if ('setMeta' in tr) tr.setMeta((0, $3Zd2B.AGENT_ATTRIBUTION_META), (0, $fcb2659c912a210b$export$44a924f1d868657b)(suggestion));
    return tr;
}


function $fca6dda0e2782a58$export$4d731d216504280(doc, suggestion) {
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
    if (anchorLocalId) {
        const anchorPositions = (0, $f40c730c85c0fd70$export$3a685203b954911f)(doc, anchorLocalId);
        if (anchorPositions) return anchorPositions.from;
    }
    for (const toolCall of suggestion.toolCalls ?? []){
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            const positions = (0, $f40c730c85c0fd70$export$3a685203b954911f)(doc, localId);
            if (positions) return positions.from;
        }
    }
    return undefined;
}
function $fca6dda0e2782a58$export$defbbc198f589f17(api, doc, pos, tr) {
    const $pos = doc.resolve(pos);
    if ($pos.depth === 0) return;
    let hasExpandAncestor = false;
    for(let depth = $pos.depth; depth > 0; depth--){
        const node = $pos.node(depth);
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            hasExpandAncestor = true;
            break;
        }
    }
    if (!hasExpandAncestor) return;
    api?.expand?.commands.toggleExpandRange($pos.before(1), pos, true)?.({
        tr: tr
    });
}
function $fca6dda0e2782a58$export$9cfe4ac318e0d7a7({ api: api, suggestion: suggestion, tr: tr, options: options }) {
    let noDiffScrollPos;
    const anchorNodePos = $fca6dda0e2782a58$export$4d731d216504280(tr.doc, suggestion);
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2')) for (const localId of (0, $c7070bf070f88a5c$export$d4c6a6d5c208b0f9)(suggestion)){
        const targetNodePos = (0, $f40c730c85c0fd70$export$3a685203b954911f)(tr.doc, localId)?.from;
        if (targetNodePos !== undefined) $fca6dda0e2782a58$export$defbbc198f589f17(api, tr.doc, targetNodePos, tr);
    }
    else if (anchorNodePos !== undefined) $fca6dda0e2782a58$export$defbbc198f589f17(api, tr.doc, anchorNodePos, tr);
    // The plugin `view` scrolls remixes itself; skip here so `scrollToPos` doesn't jump to the source.
    const noDiffTargetPos = (0, $292ce7789767c97d$export$41c5fd813e13fc6c)(suggestion) ? undefined : anchorNodePos;
    const hasToolCalls = (suggestion.toolCalls?.length ?? 0) > 0;
    if (!hasToolCalls) {
        api?.showDiff?.commands.hideDiff?.({
            tr: tr
        });
        (0, $2a4bc64013915ea2$export$707043ea55006b30)(api?.analytics?.actions)(tr, suggestion);
        noDiffScrollPos = noDiffTargetPos;
    } else {
        const isolatedTr = new (0, $eOaGc.Transform)(tr.doc);
        const appliedTr = (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
            tr: isolatedTr,
            suggestion: suggestion
        });
        const stepAttribution = suggestion.createdByAgent?.accountId ? {
            agentId: suggestion.createdByAgent.accountId,
            agentType: suggestion.createdByAgent.agentType
        } : undefined;
        if ((0, $6SJ6d.areNodesEqualIgnoreAttrs)(appliedTr.before, appliedTr.doc, [
            'localId'
        ])) {
            (0, $2a4bc64013915ea2$export$707043ea55006b30)(api?.analytics?.actions)(tr, suggestion);
            noDiffScrollPos = noDiffTargetPos;
        }
        api?.showDiff?.commands.showDiff({
            stepsWithAttribution: appliedTr.steps.map((step, i)=>({
                    step: step.invert(appliedTr.docs[i]),
                    stepAttribution: stepAttribution
                })).reverse(),
            originalDoc: appliedTr.doc,
            isInverted: true,
            diffType: (0, $iDrrr.fg)('platform_editor_ai_suggested_edits_smart_diff') && (0, $iDrrr.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'step',
            hideDeletedDiffs: options?.hideDeletedDiffs ?? (0, $295ac436451fb879$export$ef2b3f5e81ffeef8)(),
            scrollIntoView: options?.scrollIntoView ?? true,
            showIndicators: true
        })({
            tr: tr
        });
    }
    return noDiffScrollPos;
}



function $3b455e9f1a609467$export$8eb2ba4e0b5d0f47(params) {
    const suggestionById = new Map();
    const suggestionIdsByLocalId = new Map();
    const baseLocalIdBySuggestionId = new Map();
    const suggestionIdsByBaseLocalId = new Map();
    const orderedSuggestionIds = [];
    if (!params) return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
    const { suggestions: suggestions, doc: doc } = params;
    for (const suggestion of suggestions){
        suggestionById.set(suggestion.id, suggestion);
        /**
		 * Resolve the localId the suggestion anchors to — the explicit `anchorLocalId`
		 * when present, otherwise the first tool call's localId. Only this single
		 * localId is added to the suggestionIdsByLocalId map to simplify navigation,
		 * stacking, and getting logic.
		 */ const localId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
        if (localId) {
            const ids = suggestionIdsByLocalId.get(localId) ?? new Set();
            ids.add(suggestion.id);
            suggestionIdsByLocalId.set(localId, ids);
        }
    }
    // Map each top-level block position (doc depth 1) to suggestion IDs that target any localId
    // under that block — same docLevelPos as `doc.resolve(pos).before(1)` in the decorations plugin.
    doc.descendants((node, pos)=>{
        const nodeLocalId = node.attrs?.localId;
        if (!nodeLocalId) return true;
        const suggestionIdsAtLocalId = suggestionIdsByLocalId.get(nodeLocalId);
        if (suggestionIdsAtLocalId?.size) {
            const $pos = doc.resolve(pos);
            const baseLocalId = doc.nodeAt($pos.before(1))?.attrs?.localId;
            if (!baseLocalId) return true;
            suggestionIdsAtLocalId.forEach((suggestionId)=>{
                // A localId can repeat across the doc (e.g. clones produced by collab/copy-paste).
                // Keep the first-encountered mapping so each suggestion is anchored once and appears
                // exactly once in the navigation order, otherwise the card stalls on duplicates.
                if (baseLocalIdBySuggestionId.has(suggestionId)) return;
                // each suggestion maps to a base local id
                baseLocalIdBySuggestionId.set(suggestionId, baseLocalId);
                // we use doc.descendants order to determine the order of the suggestions
                orderedSuggestionIds.push(suggestionId);
            });
            const baseSet = suggestionIdsByBaseLocalId.get(baseLocalId) ?? new Set();
            const childSet = suggestionIdsByLocalId.get(nodeLocalId);
            if (childSet) // concat it into the base set
            suggestionIdsByBaseLocalId.set(baseLocalId, new Set([
                ...baseSet,
                ...childSet
            ]));
        }
        return true;
    });
    return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
}


const $56b1bb8689d88b40$export$c88671e3a419bb99 = {
    base: '--followup-card-base',
    end: '--followup-card-end',
    // Outward fallbacks, emitted only when the primary pair sits inside the target node. See
    // `findSuggestionCardAnchorRanges`.
    outerEnd: '--followup-card-outer-end',
    outerStart: '--followup-card-outer-start',
    start: '--followup-card-start'
};
/**
 * Keyed off `markerRef` (the comment's document anchor), which only inline comments carry.
 * The source `type` isn't checked because its value isn't stable — the backend has been seen
 * sending `confluence.comment` where `confluence:comment` was specified.
 */ const $56b1bb8689d88b40$var$isInlineCommentSource = (source)=>!!source.metadata && 'markerRef' in source.metadata;
const $56b1bb8689d88b40$var$isInlineCommentSuggestion = (suggestion)=>suggestion.sources?.some($56b1bb8689d88b40$var$isInlineCommentSource) ?? false;
const $56b1bb8689d88b40$export$20931deba49a7f12 = (suggestion)=>suggestion !== undefined && $56b1bb8689d88b40$var$isInlineCommentSuggestion(suggestion);






/**
 * Produces a deterministic JSON string for any JSON-compatible value.
 *
 * Guarantees:
 * - Object keys are sorted alphabetically at every nesting level.
 * - Keys whose values are `undefined` are omitted.
 * - Keys listed in `ignoreKeys` are omitted.
 * - Primitive values (string, number, boolean, null) are serialized with
 *   standard `JSON.stringify` semantics.
 * - Arrays preserve their element order.
 *
 * This ensures that two structurally equivalent values always produce
 * the same string regardless of original key insertion order.
 *
 * @param value      - The value to serialize.
 * @param ignoreKeys - Optional set of key names to strip at every level.
 * @returns A deterministic JSON string.
 *
 * @internal Not exported from the package — use `hashNode` instead.
 */ function $be28a78572d7c3d7$export$e55b76bdd351fffc(value, ignoreKeys) {
    return $be28a78572d7c3d7$var$serializeValue(value, ignoreKeys);
}
function $be28a78572d7c3d7$var$serializeValue(value, ignoreKeys) {
    // null
    if (value === null) return 'null';
    // undefined — should not normally appear in JSON, but handle gracefully
    if (value === undefined) return 'null';
    // Primitives
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'number':
            // Handle special numeric values that JSON.stringify would emit as null
            if (!Number.isFinite(value)) return 'null';
            return String(value);
        case 'boolean':
            return value ? 'true' : 'false';
    }
    // Arrays
    if (Array.isArray(value)) {
        const items = value.map((item)=>$be28a78572d7c3d7$var$serializeValue(item, ignoreKeys));
        return '[' + items.join(',') + ']';
    }
    // Objects
    if (typeof value === 'object') {
        const obj = value;
        const keys = Object.keys(obj).filter((key)=>{
            if (obj[key] === undefined) return false;
            if (ignoreKeys && ignoreKeys.has(key)) return false;
            return true;
        }).sort();
        const entries = keys.map((key)=>JSON.stringify(key) + ':' + $be28a78572d7c3d7$var$serializeValue(obj[key], ignoreKeys));
        return '{' + entries.join(',') + '}';
    }
    // Fallback for unexpected types (symbol, function, bigint, etc.)
    return 'null';
}


async function $8fd292f56cccb492$export$5ddef1f39ba79de1(node, options) {
    const ignoreKeys = options?.ignoreKeys ? new Set(options.ignoreKeys) : undefined;
    const canonical = (0, $be28a78572d7c3d7$export$e55b76bdd351fffc)(node, ignoreKeys);
    return await $8fd292f56cccb492$var$sha256Hex(canonical);
}

/**
 * Computes the SHA-256 hash of a UTF-8 string and returns it as a lowercase
 * hexadecimal string.
 *
 * Uses `globalThis.crypto.subtle` when available (all modern browsers and
 * Node.js 15+). Falls back to Node.js `crypto` module for environments
 * where the Web Crypto API is not exposed on `globalThis` (e.g. some test
 * runners).
 *
 * @internal
 */ async function $8fd292f56cccb492$var$sha256Hex(input) {
    // Prefer Web Crypto API (browsers + modern Node)
    if (typeof globalThis.crypto?.subtle?.digest === 'function') {
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data);
        const hashArray = new Uint8Array(hashBuffer);
        let hex = '';
        for(let i = 0; i < hashArray.length; i++)hex += hashArray[i].toString(16).padStart(2, '0');
        return hex;
    }
    // Fallback: Node.js crypto module
    // eslint-disable-next-line import/no-nodejs-modules, import/dynamic-import-chunkname
    const { createHash: createHash } = await Promise.resolve((parcelRequire("5rA68")));
    return createHash('sha256').update(input, 'utf8').digest('hex');
}





/** Flags the ids of suggestions currently being regenerated. */ function $1460109429ebb090$var$setRegeneratingSuggestionIds(api, ids) {
    api?.core?.actions.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_REGENERATING',
            ids: ids
        });
        return tr;
    });
}
function $1460109429ebb090$export$db2a98cd4f9c538b(suggestions) {
    const trackedLocalIds = new Set();
    for (const suggestion of suggestions)for (const localId of Object.keys(suggestion.nodeHashes ?? {}))trackedLocalIds.add(localId);
    return trackedLocalIds;
}
function $1460109429ebb090$export$118e61a2985e3c01(doc, trackedLocalIds) {
    const remaining = new Set(trackedLocalIds);
    const nodesByLocalId = new Map();
    doc.descendants((node)=>{
        if (remaining.size === 0) return false;
        const localId = node.attrs?.localId;
        if (localId && remaining.delete(localId)) nodesByLocalId.set(localId, node.toJSON());
        return true;
    });
    return nodesByLocalId;
}
async function $1460109429ebb090$export$9bae736c85d3d129(nodesByLocalId) {
    const currentHashByLocalId = new Map();
    await Promise.all(Array.from(nodesByLocalId, async ([localId, node])=>{
        currentHashByLocalId.set(localId, await (0, $8fd292f56cccb492$export$5ddef1f39ba79de1)(node));
    }));
    return currentHashByLocalId;
}
function $1460109429ebb090$export$50a77a9d00df6d98(suggestion, currentHashByLocalId) {
    for (const [localId, expectedHash] of Object.entries(suggestion.nodeHashes ?? {})){
        const currentHash = currentHashByLocalId.get(localId);
        if (currentHash === undefined || currentHash !== expectedHash) return true;
    }
    return false;
}
function $1460109429ebb090$export$88de768fc515b972(suggestions, currentHashByLocalId) {
    const staleSuggestionIds = new Set();
    const staleTrackedLocalIds = new Set();
    for (const suggestion of suggestions)if ($1460109429ebb090$export$50a77a9d00df6d98(suggestion, currentHashByLocalId)) {
        staleSuggestionIds.add(suggestion.id);
        for (const localId of Object.keys(suggestion.nodeHashes ?? {}))staleTrackedLocalIds.add(localId);
    }
    return {
        staleSuggestionIds: staleSuggestionIds,
        staleTrackedLocalIds: staleTrackedLocalIds
    };
}
function $1460109429ebb090$export$7c82f88ef397b806(localIds, nodesByLocalId) {
    const nodes = [];
    for (const localId of localIds){
        const node = nodesByLocalId.get(localId);
        if (node) nodes.push(node);
    }
    return nodes;
}
const $1460109429ebb090$export$d5477d8705cec30f = (getDoc, contentAri, api, options = {})=>async (suggestions)=>{
        const { regenerationTrigger: regenerationTrigger = 'suggestionsUpdated', signal: signal, shouldRetainStale: shouldRetainStale = false } = options;
        const trackedLocalIds = $1460109429ebb090$export$db2a98cd4f9c538b(suggestions);
        if (trackedLocalIds.size === 0) return suggestions;
        const doc = getDoc();
        if (!doc) return suggestions;
        const nodesByLocalId = $1460109429ebb090$export$118e61a2985e3c01(doc, trackedLocalIds);
        const currentHashByLocalId = await $1460109429ebb090$export$9bae736c85d3d129(nodesByLocalId);
        const { staleSuggestionIds: staleSuggestionIds, staleTrackedLocalIds: staleTrackedLocalIds } = $1460109429ebb090$export$88de768fc515b972(suggestions, currentHashByLocalId);
        if (staleSuggestionIds.size === 0) return suggestions;
        const currentNodes = $1460109429ebb090$export$7c82f88ef397b806(staleTrackedLocalIds, nodesByLocalId);
        const regenerationAnalytics = (0, $2a4bc64013915ea2$export$c688d4ee3cc6e4dc)(api?.analytics?.actions, {
            currentNodeCount: currentNodes.length,
            staleSuggestionIds: staleSuggestionIds,
            suggestions: suggestions,
            trigger: regenerationTrigger
        });
        $1460109429ebb090$var$setRegeneratingSuggestionIds(api, staleSuggestionIds);
        let regenerated;
        try {
            regenerated = await (0, $61b8b9734ab6a330$export$7ffa8bd2a6ad0cd0)({
                suggestionIds: Array.from(staleSuggestionIds),
                contentAri: contentAri,
                currentNodes: currentNodes,
                signal: signal
            });
        } catch (error) {
            // On error, keep the suggestions unchanged
            regenerationAnalytics.errored(error);
            $1460109429ebb090$var$setRegeneratingSuggestionIds(api, new Set());
            return suggestions;
        }
        const regeneratedById = new Map(regenerated.map((suggestion)=>[
                suggestion.id,
                suggestion
            ]));
        $1460109429ebb090$var$setRegeneratingSuggestionIds(api, new Set());
        regenerationAnalytics.completed({
            regeneratedSuggestions: regenerated,
            shouldRetainStale: shouldRetainStale
        });
        if (shouldRetainStale) // Swap each stale suggestion for its regenerated counterpart; keep the rest.
        return suggestions.map((suggestion)=>regeneratedById.get(suggestion.id) ?? suggestion);
        // Drop the stale originals and append the backend's replacements.
        const freshSuggestions = suggestions.filter((suggestion)=>!staleSuggestionIds.has(suggestion.id));
        return [
            ...freshSuggestions,
            ...regenerated
        ];
    };


/** The suggestions currently in plugin state, in list order. */ function $575d15e6a5835c33$var$getCurrentSuggestions(api) {
    const state = api?.aiSuggestions?.sharedState.currentState();
    if (!state) return [];
    return state.orderedSuggestionIds.map((id)=>state.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
}
const $575d15e6a5835c33$export$740daa9a9ce77ea8 = async ({ api: api, contentAri: contentAri, signal: signal, getDoc: getDoc, shouldRegenerate: shouldRegenerate = true, regenerateOnly: regenerateOnly = false, regenerationTrigger: regenerationTrigger = 'suggestionsUpdated' })=>{
    if (!api) return;
    const generationAnalytics = (0, $2a4bc64013915ea2$export$fe9dd3fdf8b03a6f)(api, regenerationTrigger);
    let suggestions;
    if (regenerateOnly) {
        // Regenerating needs a doc to hash against and an ARI to regenerate under.
        if (!getDoc || !contentAri) return;
        const current = $575d15e6a5835c33$var$getCurrentSuggestions(api);
        if (current.length === 0) return;
        const reconciled = await (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
            regenerationTrigger: regenerationTrigger,
            signal: signal,
            shouldRetainStale: true
        })(current);
        // Same reference back means nothing was stale (or regeneration failed) —
        // skip the dispatch so we don't recompute decorations for no change.
        if (reconciled === current) return;
        suggestions = reconciled;
    } else {
        const fetched = await (0, $61b8b9734ab6a330$export$ebf2f44fe450da2b)({
            contentAri: contentAri ?? '',
            signal: signal
        });
        suggestions = shouldRegenerate && getDoc && contentAri ? await (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
            regenerationTrigger: regenerationTrigger,
            signal: signal,
            shouldRetainStale: false
        })(fetched) : fetched;
    }
    generationAnalytics.completed({
        regenerateOnly: regenerateOnly,
        suggestions: suggestions
    });
    api?.core?.actions?.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: suggestions,
            contentAri: contentAri
        });
        return tr;
    });
};








const $f19306cd2f195aad$var$hoverHighlightStyle = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // Extend the highlight evenly around the node via a same-colour box-shadow
    // spread instead of padding/margin — box-shadow takes no layout space, so the
    // text doesn't shift while the background still has consistent padding.
    boxShadow: `0 0 0 ${"var(--ds-space-025, 2px)"} ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`
});
const $f19306cd2f195aad$export$fde9384a52944e6b = {
    overlay: 'ai-suggestions-hover-overlay',
    table: 'ai-suggestions-hover-table',
    extension: 'ai-suggestions-hover-extension',
    rule: 'ai-suggestions-hover-rule'
};
// Container nodes are full-bleed and/or have their own borders, so a box-shadow
// "padding" looks wrong. They get a translucent blanket overlay instead.
const $f19306cd2f195aad$var$overlayHoverNodeTypes = new Set([
    'panel',
    'codeBlock',
    'expand',
    'nestedExpand',
    'layoutSection'
]);
const $f19306cd2f195aad$var$extensionHoverNodeTypes = new Set([
    'extension',
    'bodiedExtension',
    'multiBodiedExtension'
]);
// Media is handled by the media plugin's own selection affordance — skip it.
const $f19306cd2f195aad$var$excludedHoverNodeTypes = new Set([
    'media',
    'mediaSingle',
    'mediaGroup'
]);
function $f19306cd2f195aad$export$277f5ff788d0fe35(doc, suggestion) {
    if (!suggestion) return (0, $8nvEM.DecorationSet).empty;
    const targetLocalIds = new Set();
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name === 'removeNodes') toolCall.arguments.localIds.forEach((id)=>targetLocalIds.add(id));
        else if ('localId' in toolCall.arguments) targetLocalIds.add(toolCall.arguments.localId);
    }
    for (const id of suggestion.action?.localIds ?? [])targetLocalIds.add(id);
    if (targetLocalIds.size === 0) {
        if (suggestion.anchorLocalId) targetLocalIds.add(suggestion.anchorLocalId);
        else return (0, $8nvEM.DecorationSet).empty;
    }
    const decorations = [];
    const matchedLocalIds = new Set();
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs ?? {};
        if (localId && targetLocalIds.has(localId)) {
            matchedLocalIds.add(localId);
            const typeName = node.type.name;
            const to = pos + node.nodeSize;
            if ($f19306cd2f195aad$var$excludedHoverNodeTypes.has(typeName)) ;
            else if (node.isInline) decorations.push((0, $8nvEM.Decoration).inline(pos, to, {
                style: $f19306cd2f195aad$var$hoverHighlightStyle
            }));
            else if (typeName === 'table') decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.table
            }));
            else if ($f19306cd2f195aad$var$overlayHoverNodeTypes.has(typeName)) decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.overlay
            }));
            else if ($f19306cd2f195aad$var$extensionHoverNodeTypes.has(typeName)) decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.extension
            }));
            else if (typeName === 'rule') decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.rule
            }));
            else decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                style: $f19306cd2f195aad$var$hoverHighlightStyle
            }));
        }
        return matchedLocalIds.size < targetLocalIds.size;
    });
    return decorations.length ? (0, $8nvEM.DecorationSet).create(doc, decorations) : (0, $8nvEM.DecorationSet).empty;
}


const $e304709e40e65587$export$f6edc6b3f6e003d = 'ai-suggestions-remix-placeholder';
const $e304709e40e65587$export$982b3b3c93427e30 = 'ai-suggestions-remix-placeholder-container';
function $e304709e40e65587$export$516004d46b807715() {
    const element = document.createElement('div');
    element.contentEditable = 'false';
    element.setAttribute('data-testid', $e304709e40e65587$export$982b3b3c93427e30);
    // Set once here, never mutated: the scroll margin gives clearance when we scroll the host.
    element.setAttribute('style', `display: block; width: 100%; pointer-events: none; scroll-margin-top: ${"var(--ds-space-400, 32px)"};`);
    return element;
}



function $3d32a865531fd601$export$232f392504ff18fb(doc, localIds) {
    if (localIds.length === 0) return undefined;
    const targetLocalIds = new Set(localIds);
    let position;
    doc.descendants((node, pos)=>{
        const id = node.attrs?.localId;
        if (typeof id === 'string' && targetLocalIds.has(id)) {
            position = pos + node.nodeSize;
            return false;
        }
        return true;
    });
    return position;
}








// Facade progress hovers at a randomised target (85-95%) until completion.
const $4d8c0f76a4c8d5f6$var$pickProgressTarget = ()=>85 + Math.random() * 10;
const $4d8c0f76a4c8d5f6$export$1acc4db37d317889 = new (0, $kCECX.PluginKey)('aiSuggestionsThinkingPlugin');
function $4d8c0f76a4c8d5f6$export$145797582d57a3db({ dispatch: dispatch, getSuggestionIds: getSuggestionIds }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $4d8c0f76a4c8d5f6$export$1acc4db37d317889,
        state: {
            init () {
                return {
                    status: 'idle',
                    startedAt: null,
                    progressTarget: null,
                    error: null,
                    reviewingAgent: null
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let result = pluginState;
                const meta = tr.getMeta($4d8c0f76a4c8d5f6$export$1acc4db37d317889);
                const isStatusChange = !!meta && meta.status !== undefined && meta.status !== pluginState.status;
                const isAgentChange = !!meta && meta.reviewingAgent !== undefined && meta.reviewingAgent !== pluginState.reviewingAgent;
                if (meta && (isStatusChange || isAgentChange)) {
                    let { status: status, startedAt: startedAt, progressTarget: progressTarget, error: error, reviewingAgent: reviewingAgent, baselineIds: baselineIds, reviewResults: reviewResults } = pluginState;
                    if (isStatusChange && meta.status) {
                        status = meta.status;
                        if (status === 'thinking') {
                            // Start of a new session: anchor the shared timing/target once.
                            startedAt = Date.now();
                            progressTarget = $4d8c0f76a4c8d5f6$var$pickProgressTarget();
                            baselineIds = getSuggestionIds?.(oldState);
                        } else if (status === 'idle') {
                            // Session ended/cancelled: clear so the next session starts fresh.
                            startedAt = null;
                            progressTarget = null;
                            baselineIds = undefined;
                        }
                        // 'complete' and 'error' keep startedAt/progressTarget so the bar can
                        // settle its progress before showing the ready / error state.
                        // A status transition starts (or ends) a session, so the previous
                        // session's results no longer apply.
                        reviewResults = undefined;
                        // Carry the error payload only into the 'error' state; clear otherwise.
                        error = status === 'error' ? meta.error ?? {
                            template: 'UNKNOWN'
                        } : null;
                    }
                    if (isAgentChange) reviewingAgent = meta.reviewingAgent ?? null;
                    result = {
                        baselineIds: baselineIds,
                        reviewResults: reviewResults,
                        status: status,
                        startedAt: startedAt,
                        progressTarget: progressTarget,
                        error: error,
                        reviewingAgent: reviewingAgent
                    };
                }
                const suggestionIds = getSuggestionIds?.(newState);
                if (result.status === 'thinking' && !result.baselineIds && suggestionIds) result = {
                    ...result,
                    baselineIds: suggestionIds
                };
                // Refreshes already update suggestions asynchronously after completion.
                // Keep the count in sync with that existing flow without delaying the bar.
                if (result.status === 'complete' && result.baselineIds && suggestionIds && (!result.reviewResults || suggestionIds !== getSuggestionIds?.(oldState))) {
                    const baseline = new Set(result.baselineIds);
                    const count = suggestionIds.filter((id)=>!baseline.has(id)).length;
                    if (result.reviewResults?.count !== count) result = {
                        ...result,
                        reviewResults: {
                            count: count,
                            hadExistingSuggestions: baseline.size > 0
                        }
                    };
                }
                if (result !== pluginState) dispatch($4d8c0f76a4c8d5f6$export$1acc4db37d317889, result);
                return result;
            }
        }
    });
}


/**
 * Whether `node`'s DOM element can hold a stray anchor span directly. Structural containers
 * (`table`, `tableRow`, `layoutSection`, a list) can't — the browser reparents it into an
 * anonymous row/cell (EDITOR-8442) or an extra grid item.
 */ function $3e8bb7c5c711e11c$var$canHostAnchor(node) {
    return node.type.inlineContent || node.type.contentMatch.matchType(node.type.schema.nodes.paragraph) !== null;
}
/**
 * The position within `range` closest to its `edge` whose parent can host an anchor widget,
 * walking one token at a time. `undefined` when the whole range is unhostable.
 */ function $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, range, edge) {
    const step = edge === 'start' ? 1 : -1;
    for(let pos = edge === 'start' ? range.start : range.end; pos >= range.start && pos <= range.end; pos += step){
        if ($3e8bb7c5c711e11c$var$canHostAnchor(doc.resolve(pos).parent)) return pos;
    }
    return undefined;
}
/**
 * The boundary of the node at `fromDepth`, moved outward while the enclosing node can't host an
 * anchor widget. Always resolves — at worst to the target's own top-level block, since the doc
 * itself always can.
 */ function $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, fromDepth) {
    let depth = fromDepth;
    while(depth > 1 && !$3e8bb7c5c711e11c$var$canHostAnchor($pos.node(depth - 1)))depth--;
    return {
        startPos: $pos.before(depth),
        endPos: $pos.after(depth)
    };
}
/**
 * The target node's own outer boundary — what `main.tsx` falls back to when this module has
 * nothing more specific to offer.
 */ function $3e8bb7c5c711e11c$var$ownNodeBoundaryRange(doc, pos) {
    const node = doc.nodeAt(pos);
    return node ? {
        startPos: pos,
        endPos: pos + node.nodeSize
    } : undefined;
}
/**
 * Pairs a primary range with its fallback, dropping the fallback if it's identical to the
 * primary, and promoting it to `primary` if there's no primary at all.
 */ function $3e8bb7c5c711e11c$var$withOutwardFallback(primary, outward) {
    if (!primary) return {
        primary: outward
    };
    return primary.startPos === outward.startPos && primary.endPos === outward.endPos ? {
        primary: primary
    } : {
        primary: primary,
        fallback: outward
    };
}
/**
 * The `primary`/`fallback` pair ignoring any enclosing expand. Split out so
 * `findSuggestionCardAnchorRanges` can run it first and then substitute its own fallback once it
 * knows whether an expand is involved.
 */ function $3e8bb7c5c711e11c$var$findContentAnchorRanges(doc, $pos, pos, tableCellDepth) {
    // `$pos.parent` is the target's own parent, since `pos` sits right before it. When that
    // parent can't host a widget (a `<tr>` between cells, a `<table>` between rows, a layout
    // between columns), the target's own boundary is unusable and we have to reach into its
    // content instead.
    if (!$3e8bb7c5c711e11c$var$canHostAnchor($pos.parent)) {
        const nodeAtPos = doc.nodeAt(pos);
        const innerRange = nodeAtPos ? {
            start: pos + 1,
            end: pos + nodeAtPos.nodeSize - 1
        } : undefined;
        const innerStartPos = innerRange && $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, innerRange, 'start');
        const innerEndPos = innerRange && $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, innerRange, 'end');
        // Reaching into the target's own content is preferred, but that's also the range a diff
        // can hide, hence the outward fallback.
        return $3e8bb7c5c711e11c$var$withOutwardFallback(innerStartPos !== undefined && innerEndPos !== undefined ? {
            startPos: innerStartPos,
            endPos: innerEndPos
        } : undefined, $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, $pos.depth));
    }
    if (tableCellDepth === undefined) return {};
    // `$pos.parent` already passed `canHostAnchor`, so the target's own boundary is always safe
    // to anchor at directly — pinning to the whole cell instead would swallow untouched sibling
    // content. The fallback (for when the target itself is diff-hidden) reaches into the cell's
    // own content bounds instead of escalating past the cell/row all the way to the table.
    return $3e8bb7c5c711e11c$var$withOutwardFallback($3e8bb7c5c711e11c$var$ownNodeBoundaryRange(doc, pos), {
        startPos: $pos.start(tableCellDepth),
        endPos: $pos.end(tableCellDepth)
    });
}
function $3e8bb7c5c711e11c$export$32941c25cf8ac8f7(doc, pos) {
    const $pos = doc.resolve(pos);
    let outermostExpandDepth;
    let tableCellDepth;
    for(let depth = $pos.depth; depth > 0; depth--){
        const typeName = $pos.node(depth).type.name;
        if (typeName === 'expand' || typeName === 'nestedExpand') outermostExpandDepth = depth;
        else if ((typeName === 'tableCell' || typeName === 'tableHeader') && tableCellDepth === undefined) tableCellDepth = depth;
    }
    const contentRanges = $3e8bb7c5c711e11c$var$findContentAnchorRanges(doc, $pos, pos, tableCellDepth);
    if (outermostExpandDepth === undefined) return contentRanges;
    // `contentRanges.primary` may be empty (falls back to `ownNodeBoundaryRange`, matching what
    // `findSuggestionCardAnchorRanges` does outside this function), but it's already as close to
    // the target's content as it gets. An expand's body is `display: none` while collapsed, hiding that content anchor
    // entirely, so its own outer boundary — always rendered — replaces whatever fallback
    // `contentRanges` computed.
    return $3e8bb7c5c711e11c$var$withOutwardFallback(contentRanges.primary ?? $3e8bb7c5c711e11c$var$ownNodeBoundaryRange(doc, pos), {
        startPos: $pos.before(outermostExpandDepth),
        endPos: $pos.after(outermostExpandDepth)
    });
}
/**
 * Whether `pos` sits between two table cells. The diff never renders a widget there — it decorates
 * a changed cell in place — so a tool call edge there has nothing outside the cell to cover.
 */ function $3e8bb7c5c711e11c$var$isBetweenTableCells(doc, pos) {
    return doc.resolve(pos).parent.type.name === 'tableRow';
}
/**
 * Grows `range` over `toolCallRange`, where the diff renders widgets for the suggestion's inserted
 * content (see `getSuggestionToolCallRange`). Each edge walks outward to the nearest position that
 * can host an anchor span.
 */ function $3e8bb7c5c711e11c$var$extendAnchorRangeToToolCalls(doc, range, toolCallRange) {
    if (!toolCallRange) return range;
    const startPos = toolCallRange.from < range.startPos && !$3e8bb7c5c711e11c$var$isBetweenTableCells(doc, toolCallRange.from) ? $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, {
        start: 0,
        end: toolCallRange.from
    }, 'end') : undefined;
    const endPos = toolCallRange.to > range.endPos && !$3e8bb7c5c711e11c$var$isBetweenTableCells(doc, toolCallRange.to) ? $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, {
        start: toolCallRange.to,
        end: doc.content.size
    }, 'start') : undefined;
    return {
        startPos: Math.min(startPos ?? range.startPos, range.startPos),
        endPos: Math.max(endPos ?? range.endPos, range.endPos)
    };
}
function $3e8bb7c5c711e11c$export$213833a0759111eb(doc, { startNode: startNode, endNode: endNode, toolCallRange: toolCallRange }) {
    const startRanges = $3e8bb7c5c711e11c$export$32941c25cf8ac8f7(doc, startNode.pos);
    const endRanges = endNode ? $3e8bb7c5c711e11c$export$32941c25cf8ac8f7(doc, endNode.pos) : startRanges;
    const lastNode = endNode ?? startNode;
    const primary = $3e8bb7c5c711e11c$var$extendAnchorRangeToToolCalls(doc, {
        startPos: startRanges.primary?.startPos ?? startNode.pos,
        endPos: endRanges.primary?.endPos ?? lastNode.pos + lastNode.nodeSize
    }, toolCallRange);
    if (!startRanges.fallback && !endRanges.fallback) return {
        primary: primary
    };
    return {
        primary: primary,
        fallback: {
            startPos: Math.min(startRanges.fallback?.startPos ?? primary.startPos, primary.startPos),
            endPos: Math.max(endRanges.fallback?.endPos ?? primary.endPos, primary.endPos)
        }
    };
}






function $74e8e721b5e9cc36$export$d55980c0f6b9bb5(doc, suggestion) {
    if (!suggestion.toolCalls?.length) return undefined;
    let transform;
    try {
        transform = (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
            tr: new (0, $eOaGc.Transform)(doc),
            suggestion: suggestion
        });
    } catch  {
        return undefined;
    }
    const stepMaps = transform.steps.map((step)=>step.getMap());
    let from = Infinity;
    let to = -Infinity;
    stepMaps.forEach((stepMap, index)=>{
        // Built explicitly: `Mapping.slice(...).invert()` inverts every map, not just the slice's.
        const toOriginalDoc = new (0, $eOaGc.Mapping)(stepMaps.slice(0, index).reverse().map((map)=>map.invert()));
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            if (newEnd > newStart) {
                from = Math.min(from, toOriginalDoc.map(oldStart, -1));
                to = Math.max(to, toOriginalDoc.map(oldEnd, 1));
            }
        });
    });
    return from <= to ? {
        from: from,
        to: to
    } : undefined;
}





function $0b504009849b7a0d$export$82a97b36758288e5(groups) {
    const ids = new Set();
    for (const group of groups ?? [])for (const suggestion of group.suggestions)ids.add(suggestion.id);
    return ids;
}
function $0b504009849b7a0d$export$e4a1d22be49a81bd(pluginState) {
    return pluginState.orderedSuggestionIds.map((id)=>pluginState.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
}
function $0b504009849b7a0d$var$isPmHistoryMeta(meta) {
    return typeof meta === 'object' && meta !== null && typeof meta.redo === 'boolean';
}
function $0b504009849b7a0d$export$4a859a7b0093f8a2(tr) {
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    if (!$0b504009849b7a0d$var$isPmHistoryMeta(historyMeta)) return undefined;
    return historyMeta.redo ? 'redo' : 'undo';
}
function $0b504009849b7a0d$export$686b6c582e8762c9(tr) {
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    return historyMeta?.historyState?.done?.eventCount;
}
function $0b504009849b7a0d$export$28a08778956fc267(api) {
    return api?.history?.sharedState.currentState()?.done.eventCount ?? 0;
}


/**
 * We have different adjustments for aligned headings vs. non-aligned headings because
 * they have different margins for some reason, see platform/packages/editor/editor-common/src/styles/shared/headings.ts
 *
 * This is just hard coded at the moment to mimic the positioning logic of block controls plugin, and won't be needed
 * once the icon button positioning logic is moved to a new block controls plugin API.
 */ const $1b159f40bd8b3a1f$var$nodeTopAdjustments = {
    table: 12,
    paragraph: 2,
    heading1: 5,
    heading2: 2,
    heading3: -1,
    heading4: -3,
    heading5: -3,
    heading6: -3,
    heading1_aligned: 5,
    heading2_aligned: 2,
    heading3_aligned: -1,
    heading4_aligned: -3,
    heading5_aligned: -3,
    heading6_aligned: -3,
    layoutSection: 8
};
/**
 * It would be easier to get the margin from the DOM but we don't have access to the view / DOM here
 * so we hard code these values for now, until everything's moved to the block controls plugin.
 */ const $1b159f40bd8b3a1f$var$nodeTopMargins = {
    table: 12,
    paragraph: 12,
    bulletList: 12,
    orderedList: 12,
    decisionList: 8,
    taskList: 12,
    codeBlock: 12,
    panel: 12,
    rule: 4,
    heading1: 40,
    heading2: 32,
    heading3: 24,
    heading4: 20,
    heading5: 20,
    heading6: 20,
    heading1_aligned: 45,
    heading2_aligned: 41,
    heading3_aligned: 36,
    heading4_aligned: 21,
    heading5_aligned: 22,
    heading6_aligned: 18,
    blockquote: 12,
    expand: 4
};
/**
 * Bottom margins of nodes that affect how the icon button is positioned
 */ const $1b159f40bd8b3a1f$var$nodeBeforeAdjustments = {
    rule: 24,
    extension: 12
};
const $1b159f40bd8b3a1f$var$constructHeadingAdjustmentKey = (node)=>{
    if (node.type.name === 'heading') {
        const level = node.attrs.level;
        const hasAlignment = node.marks.some((mark)=>mark.type.name === 'alignment');
        return `heading${level}${hasAlignment ? '_aligned' : ''}`;
    }
    return node.type.name;
};
/**
 * Anchor widget empty marks:
 * `marks: []` tells ProseMirror the widget belongs to no mark wrapper, so `syncToMarks` hoists it out of any
 * enclosing `breakout` wrapper instead of tucking it inside the next sibling's. Without it, a
 * widget with `side >= 0` placed before a breakout-marked sibling is inserted into that sibling's
 * (non-spanning) wrapper, and ProseMirror then destroys and re-creates the sibling and every
 * breakout-marked block after it on each update
 */ const $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS = [];
/**
 * How far apart `createCardAnchorDecorations` pushes its `side` pair:
 * - `-1`: the fallback pair (expand/table/row/layout boundary) — nothing else renders there.
 * - `1`: the primary (content) pair — wide enough to wrap any `editor-plugin-show-diff` widget
 *   sharing that position, since widgets there render in ascending `side` order.
 * - `0`: no bias, both widgets at `side: 0`.
 */ const $1b159f40bd8b3a1f$var$CARD_ANCHOR_SIDE = {
    [-1]: {
        end: 2,
        start: -2
    },
    [0]: {
        end: 0,
        start: 0
    },
    [1]: {
        end: 1000,
        start: -1000
    }
};
/**
 * The paired start/end anchor widgets a card positions from, named `<startName>` / `<endName>`.
 *
 * Emitted twice per card — once for the primary range and once for the outward fallback (see
 * `findSuggestionCardAnchorRanges`) — so the consumer can chain them with `anchor()`'s fallback
 * argument.
 */ /** Whether `$pos` is the end of a table cell's content. */ function $1b159f40bd8b3a1f$var$isAtTableCellEnd($pos) {
    const typeName = $pos.parent.type.name;
    return (typeName === 'tableCell' || typeName === 'tableHeader') && $pos.pos === $pos.end();
}
function $1b159f40bd8b3a1f$var$createCardAnchorDecorations(doc, names, range, bias = -1) {
    const side = $1b159f40bd8b3a1f$var$CARD_ANCHOR_SIDE[bias];
    // A cell's content ends above its bottom whenever a sibling cell is taller, so an anchor at the
    // end of a cell's content is pinned to the cell's bottom (cells are `position: relative`). A start
    // only lands there when it steps back into the previous row, so skip a cell merged past that row.
    const $start = doc.resolve(range.startPos);
    const isStartAtCellEnd = $1b159f40bd8b3a1f$var$isAtTableCellEnd($start) && ($start.parent.attrs.rowspan ?? 1) === 1;
    const isEndAtCellEnd = $1b159f40bd8b3a1f$var$isAtTableCellEnd(doc.resolve(range.endPos));
    return [
        (0, $8nvEM.Decoration).widget(range.startPos, ()=>$1b159f40bd8b3a1f$var$createAnchorSpan(names.start, isStartAtCellEnd), {
            side: side.start,
            // Stable key so rebuilding the DecorationSet (e.g. on SET_SUGGESTIONS from a
            // regeneration) reuses this span instead of remounting it — otherwise the CSS anchor
            // briefly disappears and the card flickers / mis-positions.
            key: names.start,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        }),
        (0, $8nvEM.Decoration).widget(range.endPos, ()=>$1b159f40bd8b3a1f$var$createAnchorSpan(names.end, isEndAtCellEnd), {
            side: side.end,
            key: names.end,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        })
    ];
}
/** Takes a card anchor out of flow and pins it to the bottom-right corner of its table cell. */ const $1b159f40bd8b3a1f$var$CELL_BOTTOM_ANCHOR_STYLE = {
    position: 'absolute',
    insetBlockEnd: 0,
    insetInlineEnd: 0
};
/**
 * An empty span carrying `anchor-name`, used as a CSS anchor target for the cards. When
 * `isAtCellEnd`, it is pinned to its table cell's bottom-right corner.
 */ function $1b159f40bd8b3a1f$var$createAnchorSpan(anchorName, isAtCellEnd = false) {
    const spanElement = document.createElement('span');
    spanElement.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        anchorName: anchorName,
        ...isAtCellEnd && $1b159f40bd8b3a1f$var$CELL_BOTTOM_ANCHOR_STYLE
    }));
    return spanElement;
}
/**
 * Horizontal anchor for the follow-up card: a point in the right gutter of the removed
 * suggestion's block, where the suggestion card was anchored.
 *
 * The suggestion card anchors to the icon button's span (`SuggestionIconButton`), but that span
 * is empty whenever a card is open — the button hides while its suggestion is selected — so only
 * the gutter offset needs reproducing, not the button's size or alignment.
 */ function $1b159f40bd8b3a1f$var$createFollowUpCardBaseAnchor() {
    // Full-width, zero-height block to offset the anchor from the content's right edge.
    const container = document.createElement('span');
    container.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        width: '100%',
        display: 'block',
        pointerEvents: 'none'
    }));
    const anchor = document.createElement('span');
    anchor.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        // gutter + object actions container width
        right: `calc(${"var(--ds-space-negative-300, -24px)"} + ${"var(--ds-space-negative-300, -24px)"})`,
        anchorName: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).base
    }));
    container.appendChild(anchor);
    return container;
}
/** Position and size of the first node in `doc` carrying `localId`. */ function $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, localId) {
    if (!localId) return undefined;
    let result;
    doc.descendants((node, pos)=>{
        if (result !== undefined) return false;
        if (node.attrs?.localId === localId) {
            result = {
                pos: pos,
                nodeSize: node.nodeSize
            };
            return false;
        }
        return true;
    });
    return result;
}
/**
 * Whether the selected suggestion's card can still be positioned against the document.
 * Runs on every doc-changing transaction while a card is open, so it avoids a full-document
 * traversal.
 */ function $1b159f40bd8b3a1f$var$canPositionSelectedCard(doc, pluginState) {
    const selectedId = pluginState.selectedSuggestion;
    if (!selectedId) return true;
    const suggestion = pluginState.suggestionById.get(selectedId);
    if (!suggestion) return true;
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
    const baseLocalId = pluginState.baseLocalIdBySuggestionId.get(selectedId);
    if (!anchorLocalId) return true;
    if (!baseLocalId) return false;
    let baseNode;
    for(let index = 0; index < doc.childCount; index++){
        const child = doc.child(index);
        if (child.attrs?.localId === baseLocalId) {
            baseNode = child;
            break;
        }
    }
    if (!baseNode) return false;
    if (anchorLocalId === baseLocalId) return true;
    // The anchor spans are only emitted from within the base node, so an anchor node that
    // survives elsewhere in the doc (moved out by a cut/paste, say) is just as unpositionable
    // as a deleted one.
    let hasAnchorDescendant = false;
    baseNode.descendants((descendant)=>{
        if (hasAnchorDescendant) return false;
        if (descendant.attrs?.localId === anchorLocalId) {
            hasAnchorDescendant = true;
            return false;
        }
        return true;
    });
    return hasAnchorDescendant;
}
/**
 * Anchor spans for the follow-up card. Emitted for a suggestion that no longer exists, which is
 * the point: they keep the removed card's position addressable through resizes and reflow.
 *
 * Either localId can outlive the other (accepting a suggestion can delete the anchored node, or
 * the block the icon button sat on), so each anchor falls back to the other. With neither in the
 * doc no anchors are emitted and `position-visibility: anchors-valid` keeps the card hidden.
 */ function $1b159f40bd8b3a1f$var$calculateFollowUpCardDecorations(doc, followUpCard) {
    if (!followUpCard) return [];
    const anchorNode = $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, followUpCard.anchorLocalId);
    const baseNode = $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, followUpCard.baseLocalId);
    const verticalNode = anchorNode ?? baseNode;
    const horizontalNode = baseNode ?? anchorNode;
    if (!verticalNode || !horizontalNode) return [];
    // Same treatment as the suggestion card: pin to the enclosing expand or table
    // row so the card lines up with the block the user actually sees.
    const anchorRanges = (0, $3e8bb7c5c711e11c$export$213833a0759111eb)(doc, {
        startNode: verticalNode
    });
    return [
        ...$1b159f40bd8b3a1f$var$createCardAnchorDecorations(doc, (0, $56b1bb8689d88b40$export$c88671e3a419bb99), anchorRanges.primary, 1),
        ...anchorRanges.fallback ? $1b159f40bd8b3a1f$var$createCardAnchorDecorations(doc, {
            start: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).outerStart,
            end: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).outerEnd
        }, anchorRanges.fallback) : [],
        (0, $8nvEM.Decoration).widget(horizontalNode.pos, $1b159f40bd8b3a1f$var$createFollowUpCardBaseAnchor, {
            side: -2,
            key: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).base,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        })
    ];
}
const $1b159f40bd8b3a1f$export$dbbefe45c19011aa = new (0, $kCECX.PluginKey)('aiSuggestionsPlugin');
/** Returns cached base-block ids affected by suggestion surface state changes. */ const $1b159f40bd8b3a1f$var$getSuggestionSurfaceInvalidationIds = (transactions, oldState, newState)=>{
    const metas = transactions.map((transaction)=>transaction.getMeta($1b159f40bd8b3a1f$export$dbbefe45c19011aa)).filter((meta)=>meta !== undefined);
    if (metas.length === 0) return [];
    const changesSurfaceVisibility = metas.some((meta)=>meta.action !== 'SET_REGENERATING' && meta.action !== 'DISMISS_FOLLOW_UP_CARD');
    if (!changesSurfaceVisibility) return [];
    // Use both snapshots so removals and base-local-id remapping invalidate the previous anchors too.
    const ids = new Set([
        ...$1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(oldState)?.suggestionIdsByBaseLocalId.keys() ?? [],
        ...$1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(newState)?.suggestionIdsByBaseLocalId.keys() ?? []
    ]);
    return [
        ...ids
    ];
};
const $1b159f40bd8b3a1f$var$pointTouchesRange = (point, range)=>point >= range.from && point <= range.to;
const $1b159f40bd8b3a1f$var$rangesOverlap = (rangeA, rangeB)=>{
    if (rangeA.from === rangeA.to) return $1b159f40bd8b3a1f$var$pointTouchesRange(rangeA.from, rangeB);
    if (rangeB.from === rangeB.to) return $1b159f40bd8b3a1f$var$pointTouchesRange(rangeB.from, rangeA);
    return rangeA.from < rangeB.to && rangeB.from < rangeA.to;
};
const $1b159f40bd8b3a1f$var$getDecoratedNodeRanges = (doc, suggestionIdsByBaseLocalId)=>{
    const decoratedNodeRanges = [];
    doc.descendants((node, pos)=>{
        if (suggestionIdsByBaseLocalId.has(node.attrs?.localId)) {
            decoratedNodeRanges.push({
                from: pos,
                to: pos + node.nodeSize
            });
            return false;
        }
        return true;
    });
    return decoratedNodeRanges;
};
const $1b159f40bd8b3a1f$var$docChangeAffectsDecorations = ({ doc: doc, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, tr: tr })=>{
    if (!tr.docChanged || suggestionIdsByBaseLocalId.size === 0) return false;
    const decoratedNodeRanges = $1b159f40bd8b3a1f$var$getDecoratedNodeRanges(doc, suggestionIdsByBaseLocalId);
    if (decoratedNodeRanges.length === 0) return false;
    return tr.mapping.maps.some((stepMap)=>{
        let affectsDecorations = false;
        stepMap.forEach((oldStart, oldEnd)=>{
            if (affectsDecorations) return;
            const changedRange = {
                from: oldStart,
                to: oldEnd
            };
            affectsDecorations = decoratedNodeRanges.some((decoratedRange)=>$1b159f40bd8b3a1f$var$rangesOverlap(changedRange, decoratedRange));
        });
        return affectsDecorations;
    });
};
function $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({ doc: doc, followUpCard: followUpCard, suggestionById: suggestionById, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, api: api, intl: intl, selectedSuggestion: selectedSuggestion, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    // The follow-up card outlives the suggestion it replaces, so its anchors are emitted
    // independently of `suggestionById` — including when that map is empty, which is exactly when
    // the card shows.
    const followUpCardDecorations = $1b159f40bd8b3a1f$var$calculateFollowUpCardDecorations(doc, followUpCard);
    if (suggestionById.size === 0) return followUpCardDecorations.length > 0 ? (0, $8nvEM.DecorationSet).create(doc, followUpCardDecorations) : (0, $8nvEM.DecorationSet).empty;
    const decorations = [
        ...followUpCardDecorations
    ];
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs;
        if (localId) {
            const suggestionsAtLocalId = suggestionIdsByBaseLocalId.get(localId);
            if (suggestionsAtLocalId?.size) {
                const firstSuggestionId = suggestionsAtLocalId.values().next().value;
                const firstSuggestion = firstSuggestionId ? suggestionById.get(firstSuggestionId) : undefined;
                if (firstSuggestion) {
                    const element = document.createElement('span');
                    const nodeTypeName = node.type.name === 'heading' ? $1b159f40bd8b3a1f$var$constructHeadingAdjustmentKey(node) : node.type.name;
                    element.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
                        position: 'relative',
                        width: '100%',
                        display: 'block',
                        pointerEvents: 'none'
                    }));
                    const isSelected = Boolean(selectedSuggestion && suggestionsAtLocalId.has(selectedSuggestion));
                    const isTableNode = node.type.name === 'table';
                    // Tables don't use breakout for resizing, the width is stored in the attrs
                    // but will be clamped by the max content width (100cqw)
                    // The (-4px) is mimicking spacing of the remix icon button in block controls plugin
                    const leftAdjustment = isTableNode && typeof node.attrs?.width === 'number' ? `calc(((min(100cqw - (72px * 2), ${node.attrs.width}px) - 760px) / 2) - 4px)` : undefined;
                    const nodeBefore = doc.resolve(pos).nodeBefore;
                    const isBlockLeafNodeBefore = nodeBefore?.isBlock && nodeBefore.isLeaf;
                    const topAdjustment = $1b159f40bd8b3a1f$var$nodeTopAdjustments[nodeTypeName] ?? 0;
                    const topMargin = $1b159f40bd8b3a1f$var$nodeTopMargins[nodeTypeName] ?? 0;
                    const nodeBeforeAdjustment = $1b159f40bd8b3a1f$var$nodeBeforeAdjustments[nodeBefore?.type.name ?? ''] ?? 0;
                    const calculatedTopAdjustment = (pos === 0 ? isTableNode ? topAdjustment : 0 : isBlockLeafNodeBefore ? Math.max(0, topMargin - nodeBeforeAdjustment) : topMargin) + topAdjustment;
                    /**
           * Stable key so rebuilding the DecorationSet (e.g. a SELECT_SUGGESTION, or a
           * SET_SUGGESTIONS from a regeneration) reuses this widget instead of replacing
           * its DOM. The widget hosts the `--button-<localId>` anchor the card is
           * positioned from, and the portal that renders it is flushed on a throttled
           * update — so recreating the element left a window on every rebuild where the
           * anchor resolved to nothing, and anything measuring the card's anchor position
           * in that window (see `useSuggestionCardPositioning`) read a static-position
           * fallback instead of the button's real position.
           *
           * The geometry inputs are part of the key because ProseMirror skips `toDOM` for
           * a reused widget, so a stale `leftAdjustment` / `topAdjustment` could not be
           * corrected by a re-render. Everything else `SuggestionIconButton` needs it
           * reads from plugin state itself, so selection and suggestion changes re-render
           * the button without disturbing the anchor.
           */ const key = `--button-${localId}|${calculatedTopAdjustment}|${leftAdjustment ?? ''}`;
                    // EDITOR-8771: the icon button is registered via the UI Control Registry API
                    // (see `SuggestionRightSurfaceButton`/`aiSuggestionsPlugin.tsx`) once the migration
                    // gate is on, so skip the legacy widget here to avoid rendering it twice. Every
                    // other decoration below (card anchors, remix placeholder) is unrelated to which
                    // system renders the icon button and must still run regardless of this gate.
                    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) decorations.push((0, $8nvEM.Decoration).widget(pos, ()=>{
                        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $10017670bb6714bc$export$b6eb36123ab7ffdf), {
                                leftAdjustment: leftAdjustment,
                                topAdjustment: calculatedTopAdjustment,
                                localId: localId,
                                api: api,
                                intl: intl
                            }), element, key);
                        return element;
                    }, {
                        side: -2,
                        key: key,
                        marks: node.marks.filter((mark)=>mark.type.name === 'breakout'),
                        destroy: ()=>{
                        // Clean up properly
                        // nodeViewPortalProviderAPI.remove(key);
                        }
                    }));
                    if (isSelected) {
                        const selectedSuggestionData = selectedSuggestion ? suggestionById.get(selectedSuggestion) : undefined;
                        const anchorLocalId = selectedSuggestionData ? (0, $c08510c480bfb65f$export$e644b4e6be3487e)(selectedSuggestionData) : undefined;
                        const anchorEndLocalId = selectedSuggestionData ? (0, $c08510c480bfb65f$export$f5640f1db7cc9e30)(selectedSuggestionData) : anchorLocalId;
                        // The remix placeholder is emitted separately (see
                        // `calculateRemixPlaceholderDecorations`).
                        if (anchorLocalId) {
                            let anchorNodePosition;
                            if (anchorLocalId === localId) anchorNodePosition = {
                                pos: pos,
                                nodeSize: node.nodeSize
                            };
                            else node.descendants((descendant, descendantPos)=>{
                                if (anchorNodePosition) return false;
                                const descendantLocalId = descendant.attrs?.localId;
                                if (descendantLocalId === anchorLocalId) {
                                    anchorNodePosition = {
                                        pos: pos + descendantPos + 1,
                                        nodeSize: descendant.nodeSize
                                    };
                                    return false;
                                }
                                return true;
                            });
                            // Pin the card anchors to the enclosing expand or table row so the spans
                            // render at that block's boundary rather than deep inside it, keeping the
                            // card aligned with the row the user sees while staying out of the grid
                            // `<tr>` (EDITOR-8442), and extend them over widgets the tool calls insert
                            // outside the target. See `findSuggestionCardAnchorRanges`.
                            const { primary: primaryRange, fallback: fallbackRange } = (0, $3e8bb7c5c711e11c$export$213833a0759111eb)(doc, {
                                startNode: anchorNodePosition ?? {
                                    pos: pos,
                                    nodeSize: node.nodeSize
                                },
                                endNode: $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, anchorEndLocalId),
                                toolCallRange: selectedSuggestionData ? (0, $74e8e721b5e9cc36$export$d55980c0f6b9bb5)(doc, selectedSuggestionData) : undefined
                            });
                            /**
               * These decoration widgets are used to track the top and bottom of the localId,
               * also accounting for other decoration widgets (such as diffs).
               */ decorations.push(...$1b159f40bd8b3a1f$var$createCardAnchorDecorations(doc, {
                                start: `--card-${anchorLocalId}-start`,
                                end: `--card-${anchorEndLocalId}-end`
                            }, primaryRange, 1));
                            // Only emitted when the primary range sits inside the target, i.e. where the
                            // diff can hide it. The card chains the two with `anchor()`'s fallback
                            // argument, so these are inert while the primary anchors are rendered.
                            if (fallbackRange) decorations.push(...$1b159f40bd8b3a1f$var$createCardAnchorDecorations(doc, {
                                start: `--card-${anchorLocalId}-outer-start`,
                                end: `--card-${anchorEndLocalId}-outer-end`
                            }, fallbackRange));
                        }
                    }
                }
            }
        }
        return false;
    });
    if (!decorations.length) return (0, $8nvEM.DecorationSet).empty;
    return (0, $8nvEM.DecorationSet).create(doc, decorations);
}
// Whether a `SUGGESTED_REMIX` card is selected; gates the manual placeholder-portal teardown.
function $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive(pluginState) {
    if (!pluginState?.selectedSuggestion) return false;
    return pluginState.suggestionById.get(pluginState.selectedSuggestion)?.actionKind === 'SUGGESTED_REMIX';
}
function $1b159f40bd8b3a1f$var$shouldRetainSelectedSuggestionHighlight(suggestion) {
    return suggestion?.actionKind === 'INFORMATIONAL' || suggestion?.actionKind === 'SUGGESTED_REMIX';
}
function $1b159f40bd8b3a1f$var$getSelectedSuggestionForHighlight(pluginState) {
    const selectedSuggestion = pluginState.selectedSuggestion ? pluginState.suggestionById.get(pluginState.selectedSuggestion) : undefined;
    return $1b159f40bd8b3a1f$var$shouldRetainSelectedSuggestionHighlight(selectedSuggestion) ? selectedSuggestion : undefined;
}
function $1b159f40bd8b3a1f$var$calculateSelectedSuggestionDecorations(doc, pluginState, isEditorInViewMode) {
    return isEditorInViewMode ? (0, $8nvEM.DecorationSet).empty : (0, $f19306cd2f195aad$export$277f5ff788d0fe35)(doc, $1b159f40bd8b3a1f$var$getSelectedSuggestionForHighlight(pluginState));
}
/**
 * Placeholder marking where a selected `SUGGESTED_REMIX` result will land. Emitted
 * independently of the sparkle-UI `decorations`, mirroring
 * `calculateSelectedSuggestionDecorations`.
 */ function $1b159f40bd8b3a1f$var$calculateRemixPlaceholderDecorations(doc, pluginState, isEditorInViewMode, nodeViewPortalProviderAPI) {
    if (isEditorInViewMode) return (0, $8nvEM.DecorationSet).empty;
    const selectedSuggestionData = pluginState.selectedSuggestion ? pluginState.suggestionById.get(pluginState.selectedSuggestion) : undefined;
    if (selectedSuggestionData?.actionKind !== 'SUGGESTED_REMIX') return (0, $8nvEM.DecorationSet).empty;
    // Drop the placeholder after the last source localId (falling back to the anchor).
    const placeholderPos = (0, $3d32a865531fd601$export$232f392504ff18fb)(doc, (0, $292ce7789767c97d$export$793e1650d3921fb5)(selectedSuggestionData));
    if (placeholderPos === undefined) return (0, $8nvEM.DecorationSet).empty;
    const placeholderElement = (0, $e304709e40e65587$export$516004d46b807715)();
    // No `destroy`; the portal is removed manually when the card goes inactive (see plugin `view`).
    return (0, $8nvEM.DecorationSet).create(doc, [
        (0, $8nvEM.Decoration).widget(placeholderPos, ()=>{
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc8365e3016e62d6$export$ad96c1fdd46ef47e), {}), placeholderElement, (0, $e304709e40e65587$export$f6edc6b3f6e003d));
            return placeholderElement;
        }, {
            key: (0, $e304709e40e65587$export$f6edc6b3f6e003d),
            side: -1
        })
    ]);
}
/**
 * Rebuild the suggestion-driven slice of plugin state (maps + decorations) for a given
 * set of suggestions against `doc`. Shared by accept (removing cards) and undo/redo
 * (restoring/removing cards) so they all produce a consistent state and decorations.
 */ function $1b159f40bd8b3a1f$var$rebuildSuggestionsState({ pluginState: pluginState, suggestions: suggestions, doc: doc, suggestionsHidden: suggestionsHidden, api: api, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
        doc: doc,
        suggestions: suggestions
    });
    return {
        ...pluginState,
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
        orderedSuggestionIds: orderedSuggestionIds,
        selectedSuggestion: undefined,
        followUpCard: undefined,
        hoveredSuggestionId: undefined,
        hoverDecorations: (0, $8nvEM.DecorationSet).empty,
        selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
        decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
            doc: doc,
            followUpCard: undefined,
            suggestionById: suggestionById,
            suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
            api: api,
            intl: intl,
            selectedSuggestion: undefined,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        })
    };
}
const { suggestionById: $1b159f40bd8b3a1f$var$initSuggestionById, suggestionIdsByBaseLocalId: $1b159f40bd8b3a1f$var$initSuggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: $1b159f40bd8b3a1f$var$initBaseLocalIdBySuggestionId, orderedSuggestionIds: $1b159f40bd8b3a1f$var$initOrderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)(undefined);
const $1b159f40bd8b3a1f$var$initState = {
    contentAri: undefined,
    decorations: (0, $8nvEM.DecorationSet).empty,
    followUpCard: undefined,
    hoverDecorations: (0, $8nvEM.DecorationSet).empty,
    hoveredSuggestionId: undefined,
    mergedDecorations: (0, $8nvEM.DecorationSet).empty,
    isHidden: false,
    selectedSuggestion: undefined,
    suggestionById: $1b159f40bd8b3a1f$var$initSuggestionById,
    suggestionIdsByBaseLocalId: $1b159f40bd8b3a1f$var$initSuggestionIdsByBaseLocalId,
    baseLocalIdBySuggestionId: $1b159f40bd8b3a1f$var$initBaseLocalIdBySuggestionId,
    orderedSuggestionIds: $1b159f40bd8b3a1f$var$initOrderedSuggestionIds,
    regeneratingSuggestionIds: new Set(),
    selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
    remixPlaceholderDecorations: (0, $8nvEM.DecorationSet).empty,
    undoableAcceptedSuggestions: [],
    redoableAcceptedSuggestions: []
};
// View mode is a hard override for the suggestions UI: the document is read-only, so a suggestion
// can't be meaningfully accepted/discarded. Checked at the source so it can't be undone by a stray
// `setUIVisibility(false)`.
const $1b159f40bd8b3a1f$var$isViewMode = (api)=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
function $1b159f40bd8b3a1f$export$ae829ec7b2625219({ api: api, intl: intl, contentAri: contentAri, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $1b159f40bd8b3a1f$export$dbbefe45c19011aa,
        state: {
            init (_config, _state) {
                return $1b159f40bd8b3a1f$var$initState;
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($1b159f40bd8b3a1f$export$dbbefe45c19011aa);
                let nextState = pluginState;
                // View mode is a hard override: suggestions UI must never be shown while read-only,
                // regardless of the `isHidden` flag (which can be toggled by `setUIVisibility`).
                const suggestionsHidden = pluginState.isHidden || $1b159f40bd8b3a1f$var$isViewMode(api);
                if (meta) switch(meta.action){
                    case 'SET_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                suggestions: meta.suggestions,
                                doc: newState.doc
                            });
                            // Track the content these suggestions belong to. Prefer the explicit
                            // `contentAri` on the meta, falling back to the suggestions' own
                            // `contentAri` so direct dispatchers are covered too. `||` (not `??`)
                            // is intentional so an empty-string `contentAri` is treated as "not
                            // provided" rather than a distinct page (which would cause a spurious
                            // reset against a previously-tracked ARI).
                            const incomingContentAri = meta.contentAri || meta.suggestions[0]?.contentAri;
                            // When the suggestions belong to a different page than the one currently
                            // tracked, the selection (and its diff) is stale — reset it. Suggestions
                            // refreshed for the *same* page keep the existing selection.
                            const contentChanged = incomingContentAri !== undefined && pluginState.contentAri !== undefined && incomingContentAri !== pluginState.contentAri;
                            const nextSelectedSuggestion = contentChanged ? undefined : pluginState.selectedSuggestion;
                            // A follow-up card belongs to the page whose suggestion was removed.
                            const nextFollowUpCard = contentChanged ? undefined : pluginState.followUpCard;
                            nextState = {
                                ...pluginState,
                                contentAri: incomingContentAri ?? pluginState.contentAri,
                                selectedSuggestion: nextSelectedSuggestion,
                                followUpCard: nextFollowUpCard,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: nextSelectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'CLEAR_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: []
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: undefined,
                                decorations: (0, $8nvEM.DecorationSet).empty,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined
                            };
                            break;
                        }
                    case 'REMOVE_SUGGESTIONS':
                        {
                            const removedSuggestionIds = new Set(meta.ids);
                            const remainingSuggestions = pluginState.orderedSuggestionIds.filter((id)=>!removedSuggestionIds.has(id)).map((id)=>pluginState.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: remainingSuggestions
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: undefined,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                }),
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined
                            };
                            break;
                        }
                    case 'SET_REGENERATING':
                        nextState = {
                            ...pluginState,
                            regeneratingSuggestionIds: new Set(meta.ids)
                        };
                        break;
                    case 'SELECT_SUGGESTION':
                        {
                            // Opening a suggestion card supersedes the follow-up card, so both are never on
                            // screen at once. Deselecting leaves it alone, so a stray
                            // `selectSuggestion(null)` can't close it.
                            const nextFollowUpCard = meta.id ? undefined : pluginState.followUpCard;
                            nextState = {
                                ...pluginState,
                                selectedSuggestion: meta.id,
                                followUpCard: nextFollowUpCard,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: pluginState.suggestionById,
                                    suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: meta.id,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'SET_UI_VISIBILITY':
                        {
                            // Persist the requested `isHidden`, but gate the actual UI on view mode too so a
                            // `setUIVisibility(false)` can never reveal suggestions while read-only.
                            const hidden = meta.isHidden || $1b159f40bd8b3a1f$var$isViewMode(api);
                            nextState = {
                                ...pluginState,
                                isHidden: meta.isHidden,
                                // Hiding the suggestions UI closes the card for good, rather than parking it
                                // to reappear later out of context.
                                followUpCard: hidden ? undefined : pluginState.followUpCard,
                                hoverDecorations: hidden ? (0, $8nvEM.DecorationSet).empty : pluginState.hoverDecorations,
                                hoveredSuggestionId: hidden ? undefined : pluginState.hoveredSuggestionId,
                                decorations: hidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: pluginState.followUpCard,
                                    suggestionById: pluginState.suggestionById,
                                    suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: pluginState.selectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'ACCEPT_SUGGESTION':
                        {
                            const acceptedSuggestions = [
                                meta.suggestion
                            ];
                            const acceptedIds = new Set(acceptedSuggestions.map(({ id: id })=>id));
                            const remainingSuggestions = (0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!acceptedIds.has(suggestion.id));
                            const acceptedGroup = {
                                suggestions: acceptedSuggestions,
                                undoDepthAtAccept: (0, $0b504009849b7a0d$export$28a08778956fc267)(api) + 1
                            };
                            nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                                pluginState: pluginState,
                                suggestions: remainingSuggestions,
                                doc: newState.doc,
                                suggestionsHidden: suggestionsHidden,
                                api: api,
                                intl: intl,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            });
                            nextState = {
                                ...nextState,
                                undoableAcceptedSuggestions: [
                                    ...pluginState.undoableAcceptedSuggestions,
                                    acceptedGroup
                                ],
                                redoableAcceptedSuggestions: []
                            };
                            break;
                        }
                    case 'REMOVE_SUGGESTION':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = pluginState;
                            const removedId = meta.id;
                            const suggestion = suggestionById.get(removedId);
                            if (!suggestion) {
                                nextState = {
                                    ...pluginState,
                                    decorations: $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                        doc: newState.doc,
                                        followUpCard: pluginState.followUpCard,
                                        suggestionById: suggestionById,
                                        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                        api: api,
                                        intl: intl,
                                        selectedSuggestion: undefined,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                    })
                                };
                                break;
                            }
                            const nextOrderedSuggestionIds = orderedSuggestionIds.filter((id)=>id !== removedId);
                            // Only the last suggestion leaves a follow-up card behind — while others remain
                            // the user carries on reviewing them. Captured before the maps are pruned
                            // below, which drops the localIds the card anchors itself with.
                            const isLastSuggestion = nextOrderedSuggestionIds.length === 0;
                            const nextFollowUpCard = isLastSuggestion && (0, $56b1bb8689d88b40$export$20931deba49a7f12)(suggestion) ? {
                                suggestionId: removedId,
                                anchorLocalId: (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion),
                                baseLocalId: baseLocalIdBySuggestionId.get(removedId)
                            } : undefined;
                            suggestionById.delete(removedId);
                            const baseLocalId = baseLocalIdBySuggestionId.get(removedId);
                            baseLocalIdBySuggestionId.delete(removedId);
                            if (baseLocalId) suggestionIdsByBaseLocalId.get(baseLocalId)?.delete(removedId);
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                orderedSuggestionIds: nextOrderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: nextFollowUpCard,
                                decorations: $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'DISMISS_FOLLOW_UP_CARD':
                        if (!pluginState.followUpCard) break;
                        nextState = {
                            ...pluginState,
                            followUpCard: undefined,
                            // Recalculated rather than mapped, so the card's anchor spans leave the DOM
                            // along with it.
                            decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                doc: newState.doc,
                                followUpCard: undefined,
                                suggestionById: pluginState.suggestionById,
                                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                api: api,
                                intl: intl,
                                selectedSuggestion: pluginState.selectedSuggestion,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                        };
                        break;
                    case 'HOVER_SUGGESTION':
                        {
                            const hoveredSuggestion = meta.id ? pluginState.suggestionById.get(meta.id) : undefined;
                            nextState = {
                                ...pluginState,
                                hoveredSuggestionId: meta.id,
                                hoverDecorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : (0, $f19306cd2f195aad$export$277f5ff788d0fe35)(newState.doc, hoveredSuggestion)
                            };
                            break;
                        }
                    default:
                        break;
                }
                else if (tr.docChanged && (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) === 'undo' && pluginState.undoableAcceptedSuggestions.length > 0 && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) !== undefined && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) < pluginState.undoableAcceptedSuggestions[pluginState.undoableAcceptedSuggestions.length - 1].undoDepthAtAccept) {
                    const restoredGroup = pluginState.undoableAcceptedSuggestions[pluginState.undoableAcceptedSuggestions.length - 1];
                    const restoredGroups = [
                        restoredGroup
                    ];
                    const remainingUndoable = pluginState.undoableAcceptedSuggestions.slice(0, -1);
                    const restoredIds = new Set(restoredGroup.suggestions.map(({ id: id })=>id));
                    const nextSuggestions = [
                        ...(0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!restoredIds.has(suggestion.id)),
                        ...restoredGroups.flatMap((group)=>group.suggestions)
                    ];
                    nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                        pluginState: pluginState,
                        suggestions: nextSuggestions,
                        doc: newState.doc,
                        suggestionsHidden: suggestionsHidden,
                        api: api,
                        intl: intl,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                    });
                    nextState = {
                        ...nextState,
                        undoableAcceptedSuggestions: remainingUndoable,
                        redoableAcceptedSuggestions: [
                            ...pluginState.redoableAcceptedSuggestions,
                            ...restoredGroups
                        ]
                    };
                } else if (tr.docChanged && (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) === 'redo' && pluginState.redoableAcceptedSuggestions.length > 0 && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) !== undefined && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) >= pluginState.redoableAcceptedSuggestions[pluginState.redoableAcceptedSuggestions.length - 1].undoDepthAtAccept) {
                    const reAcceptedGroup = pluginState.redoableAcceptedSuggestions[pluginState.redoableAcceptedSuggestions.length - 1];
                    const reAcceptedGroups = [
                        reAcceptedGroup
                    ];
                    const remainingRedoable = pluginState.redoableAcceptedSuggestions.slice(0, -1);
                    const reAcceptedIds = new Set(reAcceptedGroup.suggestions.map(({ id: id })=>id));
                    const nextSuggestions = (0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!reAcceptedIds.has(suggestion.id));
                    nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                        pluginState: pluginState,
                        suggestions: nextSuggestions,
                        doc: newState.doc,
                        suggestionsHidden: suggestionsHidden,
                        api: api,
                        intl: intl,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                    });
                    nextState = {
                        ...nextState,
                        undoableAcceptedSuggestions: [
                            ...pluginState.undoableAcceptedSuggestions,
                            ...reAcceptedGroups
                        ],
                        redoableAcceptedSuggestions: remainingRedoable
                    };
                } else {
                    const shouldRecalculateDecorations = $1b159f40bd8b3a1f$var$docChangeAffectsDecorations({
                        doc: _oldState.doc,
                        suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                        tr: tr
                    });
                    const shouldReconcileSuggestionAnchors = tr.docChanged && (shouldRecalculateDecorations || (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) !== undefined);
                    const reconciledSuggestionMaps = shouldReconcileSuggestionAnchors ? (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                        doc: newState.doc,
                        suggestions: [
                            ...pluginState.suggestionById.values()
                        ]
                    }) : undefined;
                    const suggestionById = reconciledSuggestionMaps?.suggestionById ?? pluginState.suggestionById;
                    const suggestionIdsByBaseLocalId = reconciledSuggestionMaps?.suggestionIdsByBaseLocalId ?? pluginState.suggestionIdsByBaseLocalId;
                    nextState = {
                        ...pluginState,
                        ...reconciledSuggestionMaps ?? {},
                        hoverDecorations: suggestionsHidden || pluginState.hoverDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.hoverDecorations.map(tr.mapping, tr.doc),
                        selectedSuggestionDecorations: pluginState.selectedSuggestionDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.selectedSuggestionDecorations.map(tr.mapping, tr.doc),
                        remixPlaceholderDecorations: pluginState.remixPlaceholderDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.remixPlaceholderDecorations.map(tr.mapping, tr.doc),
                        decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : shouldRecalculateDecorations || shouldReconcileSuggestionAnchors ? $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                            doc: newState.doc,
                            followUpCard: pluginState.followUpCard,
                            suggestionById: suggestionById,
                            suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                            api: api,
                            intl: intl,
                            selectedSuggestion: pluginState.selectedSuggestion,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        }) : pluginState.decorations.map(tr.mapping, tr.doc)
                    };
                }
                if (nextState === pluginState) return nextState;
                const shouldRecalculateSelectionDecorations = Boolean(meta) || (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) !== undefined;
                const selectedSuggestionDecorations = shouldRecalculateSelectionDecorations ? $1b159f40bd8b3a1f$var$calculateSelectedSuggestionDecorations(newState.doc, nextState, $1b159f40bd8b3a1f$var$isViewMode(api)) : nextState.selectedSuggestionDecorations;
                const remixPlaceholderDecorations = shouldRecalculateSelectionDecorations ? $1b159f40bd8b3a1f$var$calculateRemixPlaceholderDecorations(newState.doc, nextState, $1b159f40bd8b3a1f$var$isViewMode(api), nodeViewPortalProviderAPI) : nextState.remixPlaceholderDecorations;
                const activeHighlightDecorations = nextState.hoverDecorations === (0, $8nvEM.DecorationSet).empty ? selectedSuggestionDecorations : nextState.hoverDecorations;
                // Merge the icon widgets with the active highlight and the remix placeholder
                // once here so the `decorations` prop returns a stable set. Reuse the
                // `decorations` reference (no allocation) when there is nothing extra.
                const extraDecorations = [
                    ...activeHighlightDecorations.find(),
                    ...remixPlaceholderDecorations.find()
                ];
                return {
                    ...nextState,
                    selectedSuggestionDecorations: selectedSuggestionDecorations,
                    remixPlaceholderDecorations: remixPlaceholderDecorations,
                    mergedDecorations: extraDecorations.length === 0 ? nextState.decorations : nextState.decorations.add(newState.doc, extraDecorations)
                };
            }
        },
        /**
     * The diff lives in the (separate) show-diff plugin, so it can't be reset from
     * this plugin's `apply`. When the tracked `contentAri` changes — i.e. the
     * suggestions now belong to a different page than the one whose diff is on
     * screen — hide the diff so a stale diff doesn't linger on the new page (which
     * can otherwise re-render whenever the new page contains a node with the same
     * `localId`). The matching selection/decoration reset happens in the
     * `SET_SUGGESTIONS` handler above.
     *
     * Also deselects the open suggestion once the content it is anchored to is gone —
     * see below.
     */ appendTransaction (transactions, oldState, newState) {
            const invalidationIds = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $1b159f40bd8b3a1f$var$getSuggestionSurfaceInvalidationIds(transactions, oldState, newState) : [];
            const addSurfaceInvalidation = (tr)=>{
                if (invalidationIds.length > 0) (0, $4PdTO.invalidateBlockControlsSurfaces)(tr, {
                    ids: invalidationIds
                });
                return tr;
            };
            const previousContentAri = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(oldState)?.contentAri;
            const nextState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(newState);
            const contentChanged = previousContentAri !== undefined && nextState?.contentAri !== undefined && previousContentAri !== nextState.contentAri;
            if (contentChanged) {
                const { tr: tr } = newState;
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                    status: 'idle'
                });
                return addSurfaceInvalidation(tr);
            }
            const isUndoRedo = transactions.some((transaction)=>(0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(transaction) !== undefined);
            if (isUndoRedo) {
                const previousPluginState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(oldState);
                const previousRedoableIds = (0, $0b504009849b7a0d$export$82a97b36758288e5)(previousPluginState?.redoableAcceptedSuggestions);
                const nextRedoableIds = (0, $0b504009849b7a0d$export$82a97b36758288e5)(nextState?.redoableAcceptedSuggestions);
                // An undo moves an accept from the undo pool INTO the redo pool: the accept has been
                // reverted, so its suggestion goes back to PENDING. A redo moves it OUT of the redo pool
                // (back to the undo pool): the accept is re-applied, so its suggestion is ACTIONED again.
                const revertedToPendingIds = [
                    ...nextRedoableIds
                ].filter((id)=>!previousRedoableIds.has(id));
                const reAppliedToActionedIds = [
                    ...previousRedoableIds
                ].filter((id)=>!nextRedoableIds.has(id));
                if (revertedToPendingIds.length > 0) (0, $61b8b9734ab6a330$export$1d496d000386893c)({
                    updates: revertedToPendingIds.map((id)=>({
                            id: id,
                            status: 'PENDING'
                        }))
                });
                if (reAppliedToActionedIds.length > 0) (0, $61b8b9734ab6a330$export$1d496d000386893c)({
                    updates: reAppliedToActionedIds.map((id)=>({
                            id: id,
                            status: 'ACTIONED'
                        }))
                });
                const previousSelectedId = previousPluginState?.selectedSuggestion;
                const nextSelectedId = nextState?.selectedSuggestion;
                const selectionChanged = nextSelectedId !== previousSelectedId;
                // Surface refresh on undo/redo is handled in the view.update hook (post-DOM-flush); here we
                // only handle the open card's diff/selection.
                if (selectionChanged) {
                    const { tr: tr } = newState;
                    const nextSelected = nextSelectedId ? nextState?.suggestionById.get(nextSelectedId) : undefined;
                    if (nextSelected) {
                        (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
                            api: api,
                            suggestion: nextSelected,
                            tr: tr
                        });
                        api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
                            tr: tr
                        });
                    } else {
                        api?.showDiff?.commands.hideDiff?.({
                            tr: tr
                        });
                        api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                    }
                    tr.setMeta('addToHistory', false);
                    return tr;
                }
            }
            /**
       * If the content that the card is anchored to is deleted, the card is dangling
       * Deselect it if the corresponding localId is no longer present in the doc.
       */ const shouldDeselect = nextState?.selectedSuggestion !== undefined && transactions.some((transaction)=>transaction.docChanged) && !$1b159f40bd8b3a1f$var$canPositionSelectedCard(newState.doc, nextState);
            if (shouldDeselect) {
                const { tr: tr } = newState;
                tr.setMeta($1b159f40bd8b3a1f$export$dbbefe45c19011aa, {
                    action: 'SELECT_SUGGESTION',
                    id: undefined
                });
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return addSurfaceInvalidation(tr);
            }
            return invalidationIds.length > 0 ? addSurfaceInvalidation(newState.tr) : null;
        },
        props: {
            decorations (state) {
                const pluginState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(state);
                return pluginState?.mergedDecorations ?? (0, $8nvEM.DecorationSet).empty;
            }
        },
        view: (editorView)=>{
            const abortController = new AbortController();
            if (contentAri && api) (0, $575d15e6a5835c33$export$740daa9a9ce77ea8)({
                contentAri: contentAri,
                api: api,
                signal: abortController.signal,
                /**
           * getDoc is a function so it will get the most up to date
           * doc when it eventually gets called when
           * checking for staleness
           */ getDoc: ()=>editorView.state.doc,
                shouldRegenerate: true
            });
            // A view-mode change (edit ↔ view) isn't an ai-suggestions transaction, so the suggestion
            // decorations/diff won't otherwise refresh. Deselecting recomputes the decorations (empty
            // in view mode, restored in edit mode) and hides any open diff via the selectSuggestion
            // action — covering all surfaces without extra machinery.
            const unsubscribeViewMode = api?.editorViewMode?.sharedState.onChange?.(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.mode === prevSharedState?.mode) return;
                api?.aiSuggestions?.actions.selectSuggestion(null);
            });
            const unsubscribeAnnotation = (0, $2pQiO.UNSAFE_expValNoExposure)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', false) ? api?.annotation?.sharedState.onChange?.(({ nextSharedState: nextSharedState })=>{
                const isInlineCommentOpen = !nextSharedState?.isInlineCommentViewClosed && (nextSharedState?.isDrafting || Boolean(nextSharedState?.selectedAnnotations?.length));
                const hasSelectedSuggestion = Boolean($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(editorView.state)?.selectedSuggestion);
                if (isInlineCommentOpen && hasSelectedSuggestion) api?.aiSuggestions?.actions.selectSuggestion(null);
            }) : undefined;
            return {
                update: (view, prevState)=>{
                    // Remove the remix placeholder portal once, on the active → inactive transition.
                    const wasActive = $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(prevState));
                    const isActive = $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(view.state));
                    if (wasActive && !isActive) nodeViewPortalProviderAPI.remove((0, $e304709e40e65587$export$f6edc6b3f6e003d));
                },
                destroy: ()=>{
                    abortController.abort();
                    unsubscribeViewMode?.();
                    unsubscribeAnnotation?.();
                    nodeViewPortalProviderAPI.remove((0, $e304709e40e65587$export$f6edc6b3f6e003d));
                }
            };
        }
    });
}


function $cae1b4cc9a9bf61d$export$9e133524747bf9c({ launchOptions: launchOptions, userPrompt: userPrompt }) {
    return {
        userPrompt: userPrompt,
        dynamicUiType: launchOptions?.dynamicUiType,
        dynamicUiSubtype: launchOptions?.dynamicUiSubtype,
        aspectRatio: launchOptions?.aspectRatio,
        remixSource: 'suggestedRemix'
    };
}
function $cae1b4cc9a9bf61d$export$42d6e4bc0dd0cdb6({ api: api, launchOptions: launchOptions, localIds: localIds, userPrompt: userPrompt }) {
    if (!api?.core) return undefined;
    const request = {
        localIds: localIds,
        metadata: $cae1b4cc9a9bf61d$export$9e133524747bf9c({
            launchOptions: launchOptions,
            userPrompt: userPrompt
        })
    };
    const startRemix = api.malleableUi?.commands?.startRemix;
    if (startRemix) api.core.actions.execute(startRemix({
        localIds: request.localIds,
        remixModalMetadata: request.metadata
    }));
    return request;
}





const $61cbf5e36086ffd7$export$11f54cceda85c938 = (api)=>(id, interactionPoint = 'sidebar', isDiffHidden = false)=>{
        const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
        if (!suggestion) return false;
        const isRemix = suggestion.actionKind === 'SUGGESTED_REMIX';
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$f1a852c299619cdc)(api?.analytics?.actions)(tr, suggestion, interactionPoint, isDiffHidden);
            tr.setMeta('addToHistory', false);
            return tr;
        });
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            if (isRemix) tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: id
            });
            else {
                (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
                    tr: tr,
                    suggestion: suggestion
                });
                tr.setMeta('scrollIntoView', false);
                tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                    action: 'ACCEPT_SUGGESTION',
                    suggestion: suggestion
                });
            }
            return tr;
        });
        (0, $61b8b9734ab6a330$export$1d496d000386893c)({
            updates: [
                {
                    id: id,
                    status: 'ACTIONED'
                }
            ]
        });
        if (isRemix) {
            const action = suggestion.action;
            (0, $cae1b4cc9a9bf61d$export$42d6e4bc0dd0cdb6)({
                api: api,
                launchOptions: action?.launchOptions,
                localIds: action?.localIds,
                userPrompt: action?.userPrompt
            });
        }
        return true;
    };





const $8bb2f22922f0bfc3$export$7cd05c39d88c72e0 = (api)=>()=>{
        const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
        if (!suggestionById || suggestionById.size === 0) return false;
        const suggestions = Array.from(suggestionById.values());
        const ids = suggestions.map(({ id: id })=>id);
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$906733f59ab51f3d)(api?.analytics?.actions)(tr, suggestions);
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'CLEAR_SUGGESTIONS'
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        const updates = ids.map((id)=>({
                id: id,
                status: 'DISMISSED'
            }));
        (0, $61b8b9734ab6a330$export$1d496d000386893c)({
            updates: updates
        });
        return true;
    };





const $f22f7a878bb21ed6$export$97ae1e6707b788ba = (api)=>(id, interactionPoint = 'sidebar')=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const pluginState = api?.aiSuggestions?.sharedState.currentState();
            const suggestion = pluginState?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            (0, $2a4bc64013915ea2$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, suggestion, interactionPoint);
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        if (found) (0, $61b8b9734ab6a330$export$1d496d000386893c)({
            updates: [
                {
                    id: id,
                    status: 'DISMISSED'
                }
            ]
        });
        return found;
    };


const $9c533a1ee7f54d08$export$63a2edde6c848f66 = (api)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        return true;
    };



const $943e90f24ff1479e$export$8c023f02ab5dbd45 = (api, contentAri)=>{
    return async (options)=>{
        if (!api) return false;
        const regenerateOnly = options?.regenerateOnly ?? false;
        /**
		 * Quick way to get the doc PMNode
		 * since we don't have access to editorView here
		 */ const getDoc = ()=>{
            let doc;
            api.core?.actions.execute(({ tr: tr })=>{
                doc = tr.doc;
                return null;
            });
            return doc;
        };
        await (0, $575d15e6a5835c33$export$740daa9a9ce77ea8)({
            api: api,
            contentAri: contentAri,
            getDoc: getDoc,
            shouldRegenerate: true,
            regenerateOnly: regenerateOnly,
            regenerationTrigger: options?.regenerationTrigger ?? 'suggestionsUpdated'
        });
        return true;
    };
};





/** Block nodes render their localId as `data-local-id`, so the source block is queryable. */ function $94e63d8ce16fe951$var$findLastSourceBlock(suggestion) {
    const localIds = (0, $292ce7789767c97d$export$793e1650d3921fb5)(suggestion);
    const lastLocalId = localIds[localIds.length - 1];
    if (!lastLocalId) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    return document.querySelector(`[data-local-id="${CSS.escape(lastLocalId)}"]`);
}
function $94e63d8ce16fe951$export$5bb0850f70a9e20b(suggestion) {
    if (!(0, $292ce7789767c97d$export$41c5fd813e13fc6c)(suggestion)) return false;
    // The placeholder renders directly after the last source block and carries its own scroll
    // margin, so prefer it; once it is gone the source block is the closest stable landmark.
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const placeholder = document.querySelector(`[data-testid="${(0, $e304709e40e65587$export$982b3b3c93427e30)}"]`);
    const target = placeholder ?? $94e63d8ce16fe951$var$findLastSourceBlock(suggestion);
    if (!target) return false;
    target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
    return true;
}






/**
 * Show the diff for a suggestion in its own transaction (then scroll if there is
 * no diff). Used to refresh the diff after a stale suggestion is regenerated —
 * deliberately does NOT go through `selectSuggestion`, which would re-trigger
 * regeneration and loop.
 */ function $93a0ea89424771d8$var$showDiffForSuggestion({ api: api, suggestion: suggestion, options: options }) {
    let noDiffScrollPos;
    api?.core?.actions.execute(({ tr: tr })=>{
        noDiffScrollPos = (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
            api: api,
            suggestion: suggestion,
            tr: tr,
            options: options
        });
        api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
            tr: tr
        });
        return tr;
    });
    if (!(0, $94e63d8ce16fe951$export$5bb0850f70a9e20b)(suggestion) && noDiffScrollPos !== undefined) api?.core?.actions.scrollToPos(noDiffScrollPos, {
        behavior: 'smooth',
        block: 'start'
    });
}
/**
 * On select, check the selected suggestion (or all suggestions when
 * `regenerateAll`) for staleness and regenerate any stale ones, retaining every
 * suggestion in place (each stale one is swapped for its regenerated counterpart,
 * which carries its new status + changes). No navigation or removal. Guarded so
 * only one regeneration batch runs at a time. The selected suggestion's diff is
 * refreshed (or hidden if it came back stale) once its data settles.
 */ async function $93a0ea89424771d8$var$regenerateOnSelect({ api: api, selectedId: selectedId, regenerateAll: regenerateAll, options: options }) {
    const state = api?.aiSuggestions?.sharedState.currentState();
    if (!state) return;
    // One regeneration batch at a time — rapid re-selects skip while one runs.
    if (state.regeneratingSuggestionIds.size > 0) return;
    const originalSelected = state.suggestionById.get(selectedId);
    const contentAri = originalSelected?.contentAri;
    if (!contentAri) return;
    // The suggestions to check: all, or just the selected one.
    const scope = (regenerateAll ? state.orderedSuggestionIds : [
        selectedId
    ]).map((id)=>state.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
    // Read the current doc without dispatching (the command returns null).
    const getDoc = ()=>{
        let doc;
        api?.core?.actions.execute(({ tr: tr })=>{
            doc = tr.doc;
            return null;
        });
        return doc;
    };
    const reconcile = (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
        regenerationTrigger: 'suggestionSelected',
        shouldRetainStale: true
    });
    const updatedScope = await reconcile(scope);
    // Same reference back means nothing was regenerated (nothing stale / failed).
    if (updatedScope === scope) return;
    // Merge the (possibly scoped) updated suggestions back into the full list.
    const latest = api?.aiSuggestions?.sharedState.currentState();
    if (!latest) return;
    const updatedById = new Map(updatedScope.map((suggestion)=>[
            suggestion.id,
            suggestion
        ]));
    const mergedSuggestions = latest.orderedSuggestionIds.map((id)=>updatedById.get(id) ?? latest.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
    api?.core?.actions.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: mergedSuggestions,
            contentAri: contentAri
        });
        return tr;
    });
    // The selected suggestion was regenerated when its object identity changed.
    // Refresh its diff (fresh) or hide it (stale) — only while it's still selected.
    const afterMerge = api?.aiSuggestions?.sharedState.currentState();
    const updatedSelected = afterMerge?.suggestionById.get(selectedId);
    if (afterMerge?.selectedSuggestion === selectedId && updatedSelected && updatedSelected !== originalSelected) {
        if (updatedSelected.status === 'STALE') api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        else $93a0ea89424771d8$var$showDiffForSuggestion({
            api: api,
            suggestion: updatedSelected,
            options: options
        });
    }
}
const $93a0ea89424771d8$export$85c07d6dab7fe6b1 = (api)=>(id, options)=>{
        // Captured during the `execute` callback so we can run the scroll after the
        // transaction has been dispatched — that way `SELECT_SUGGESTION` has already
        // flowed through the plugin state and the card anchors are in the DOM by
        // the time the viewport moves into place.
        let noDiffScrollPos;
        // Read thinking status before execute to check if we should dismiss the
        // 'ready' bar — only when thinking is 'complete', not while still 'thinking'.
        const currentState = api?.aiSuggestions?.sharedState.currentState();
        const isSelectingNewSuggestion = currentState?.selectedSuggestion !== id;
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$c37411486d5e33f8)({
                currentState: currentState,
                editorAnalyticsAPI: api?.analytics?.actions,
                interactionPoint: options?.interactionPoint,
                nextSuggestionId: id,
                transaction: tr
            });
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: id ?? undefined
            });
            tr.setMeta('addToHistory', false);
            // Close the 'ready' bar when a suggestion is opened,
            // but only if thinking is complete (don't dismiss while still thinking).
            if (id !== null && currentState?.thinkingStatus === 'complete') tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                status: 'idle'
            });
            if (id === null) {
                // Deselecting — hide the diff and clear the reviewing intent so node floating
                // toolbars become available again.
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
            } else {
                // Selecting — show the diff for this suggestion
                const suggestion = currentState?.suggestionById.get(id);
                if (suggestion) {
                    if (options?.interactionPoint && isSelectingNewSuggestion) (0, $2a4bc64013915ea2$export$aaae075a5bab9523)(api?.analytics?.actions)(tr, suggestion, options.interactionPoint);
                    noDiffScrollPos = (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
                        api: api,
                        suggestion: suggestion,
                        tr: tr,
                        options: options
                    });
                }
                // Reviewing a suggestion card: suppress node floating toolbars so they don't overlap
                // or mis-position against the card / diff decorations. Set last so it wins over the
                // `viewingDiff`/`default` intent that showDiff/hideDiff write on this same transaction.
                api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
                    tr: tr
                });
            }
            return tr;
        });
        const selectedSuggestion = id === null ? undefined : currentState?.suggestionById.get(id);
        const scrolledRemix = selectedSuggestion ? (0, $94e63d8ce16fe951$export$5bb0850f70a9e20b)(selectedSuggestion) : false;
        if (!scrolledRemix && noDiffScrollPos !== undefined) api?.core?.actions.scrollToPos(noDiffScrollPos, {
            behavior: 'smooth',
            block: 'start'
        });
        // Reconcile staleness in the background. Fresh → diff refreshed;
        // stale → kept and marked STALE for the card to render differently.
        if (id !== null) $93a0ea89424771d8$var$regenerateOnSelect({
            api: api,
            selectedId: id,
            regenerateAll: options?.regenerateAll ?? false,
            options: options
        });
        return true;
    };



const $4ab3071695fa3411$export$e543cf01c40ad1eb = (api)=>(agent)=>api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                reviewingAgent: agent
            });
            return tr;
        }) || false;



const $19b7760d1a1a9061$export$6525a287b5847561 = (api)=>(isHidden)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'SET_UI_VISIBILITY',
                isHidden: isHidden
            });
            return tr;
        });
        return true;
    };






const $95d83135ce202b5d$export$abeb109a09e4f140 = (api)=>(id, options)=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            // Apply tool calls to an isolated transaction so we can read its `steps`
            // and `before` for diff visualisation without affecting the source transaction.
            // PM nodes are immutable, so reusing tr.doc is safe.
            const isolatedTr = (0, $kCECX.EditorState).create({
                doc: tr.doc
            }).tr;
            const appliedTr = (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
                tr: isolatedTr,
                suggestion: suggestion
            });
            const stepAttribution = suggestion.createdByAgent?.accountId ? {
                agentId: suggestion.createdByAgent.accountId,
                agentType: suggestion.createdByAgent.agentType
            } : undefined;
            api?.showDiff?.commands.showDiff({
                // Each step's positions live in the doc BEFORE that step is applied
                // (= `appliedTr.docs[i]`). Inverting every step against
                // `appliedTr.before` throws `RangeError` for any step past index 0
                // in a multi-tool-call suggestion. Reverse afterwards so the inverted
                // steps replay back to the original doc when the diff plugin applies
                // them to `appliedTr.doc`.
                stepsWithAttribution: appliedTr.steps.map((step, i)=>({
                        step: step.invert(appliedTr.docs[i]),
                        stepAttribution: stepAttribution
                    })).reverse(),
                originalDoc: appliedTr.doc,
                isInverted: true,
                diffType: 'step',
                hideDeletedDiffs: options?.hideDeletedDiffs,
                scrollIntoView: true
            })({
                tr: tr
            });
            return tr;
        });
        return found;
    };





// Number of top-level blocks either side of a targeted block to include for context.
const $7f796363d3edeeee$var$ADJACENT_NODE_RADIUS = 1;
// Build a minimal ADF doc from the targeted top-level block(s) plus adjacent siblings (de-duped, in document order).
const $7f796363d3edeeee$var$buildTargetNodeAdf = (doc, suggestion)=>{
    const radius = $7f796363d3edeeee$var$ADJACENT_NODE_RADIUS;
    const lastIndex = doc.childCount - 1;
    // Collect top-level indices to emit, merging each targeted node's adjacency window.
    const selectedIndices = new Set();
    for (const localId of (0, $c7070bf070f88a5c$export$d4c6a6d5c208b0f9)(suggestion)){
        const positions = (0, $f40c730c85c0fd70$export$3a685203b954911f)(doc, localId);
        if (!positions) continue;
        // Top-level block (direct child of doc) containing this position.
        const topLevelIndex = doc.resolve(positions.from).index(0);
        const start = Math.max(0, topLevelIndex - radius);
        const end = Math.min(lastIndex, topLevelIndex + radius);
        for(let index = start; index <= end; index++)selectedIndices.add(index);
    }
    // Emit whole blocks in document order.
    const content = [];
    for (const index of [
        ...selectedIndices
    ].sort((a, b)=>a - b))content.push(doc.child(index).toJSON());
    return content.length > 0 ? {
        version: 1,
        type: 'doc',
        content: content
    } : undefined;
};
const $7f796363d3edeeee$export$be7787b2fea0b5c6 = (api, onSubmitSuggestionFeedback)=>(id, sentiment, options)=>{
        const pluginState = api?.aiSuggestions?.sharedState.currentState();
        const suggestion = pluginState?.suggestionById.get(id);
        if (!suggestion) return false;
        const interactionPoint = options?.interactionPoint ?? 'card';
        (0, $2a4bc64013915ea2$export$6bd5a709c87f4c35)(api?.analytics?.actions, sentiment, id, interactionPoint);
        // Snapshot the ADF of just the targeted node(s) so the product can save a
        // compact artifact for reproducing the suggestion locally.
        let documentAdf;
        api?.core?.actions.execute(({ tr: tr })=>{
            documentAdf = $7f796363d3edeeee$var$buildTargetNodeAdf(tr.doc, suggestion);
            return tr;
        });
        // Forward feedback plus the full payload and targeted node ADF.
        onSubmitSuggestionFeedback?.({
            interactionPoint: interactionPoint,
            sentiment: sentiment,
            suggestionId: id,
            suggestionType: suggestion.type,
            suggestion: suggestion,
            documentAdf: documentAdf
        });
        return true;
    };




const $2d7f810d13618094$export$bf49a0593cfa46b5 = (api)=>(state, options)=>api?.core?.actions.execute(({ tr: tr })=>{
            if (state === 'thinking') {
                if (options?.entryPoint) {
                    // TODO: EDITOR-8269 - placeholder id; may come from the backend once the
                    // unified suggested-edits analytics structure is finalised.
                    const singleInstrumentationId = crypto.randomUUID();
                    (0, $2a4bc64013915ea2$export$33e4f7f2497d28c1)(api?.analytics?.actions)(tr, options.entryPoint);
                    (0, $2a4bc64013915ea2$export$94b303e4fd9baa4e)(api?.analytics?.actions, options.entryPoint, singleInstrumentationId);
                }
                if (options?.isRetry) (0, $2a4bc64013915ea2$export$23faece8799b6885)(api?.analytics?.actions)(tr);
            }
            tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                status: state,
                ...state === 'error' && options?.template ? {
                    error: {
                        template: options.template
                    }
                } : {}
            });
            return tr;
        }) || false;












const $dedd473f4e1cf0d3$var$acceptShimmerPluginKey = new (0, $kCECX.PluginKey)('aiSuggestionsAcceptShimmer');
const $dedd473f4e1cf0d3$var$SHIMMER_FALLBACK_DURATION_MS = 1300;
const $dedd473f4e1cf0d3$var$SHIMMER_MS_PER_PIXEL = 0.6;
const $dedd473f4e1cf0d3$var$SHIMMER_MIN_DURATION_MS = 800;
const $dedd473f4e1cf0d3$var$SHIMMER_MAX_DURATION_MS = 1600;
const $dedd473f4e1cf0d3$export$2afa3e09b9018323 = (state)=>$dedd473f4e1cf0d3$var$acceptShimmerPluginKey.getState(state)?.shimmerDuration ?? 0;
const $dedd473f4e1cf0d3$var$getShimmerDurationForWidth = (width)=>{
    if (width === undefined) return $dedd473f4e1cf0d3$var$SHIMMER_FALLBACK_DURATION_MS;
    return Math.min($dedd473f4e1cf0d3$var$SHIMMER_MAX_DURATION_MS, Math.round($dedd473f4e1cf0d3$var$SHIMMER_MIN_DURATION_MS + width * $dedd473f4e1cf0d3$var$SHIMMER_MS_PER_PIXEL));
};
/** Map each step's inserted/replaced range into the final document before finding text blocks. */ const $dedd473f4e1cf0d3$var$getAcceptedTextBlockDecorations = (tr, doc)=>{
    const decorations = [];
    const seenPositions = new Set();
    tr.mapping.maps.forEach((stepMap, stepIndex)=>{
        stepMap.forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            if (newStart === newEnd) return;
            const remainingMapping = tr.mapping.slice(stepIndex + 1);
            const from = remainingMapping.map(newStart, 1);
            const to = remainingMapping.map(newEnd, -1);
            if (from >= to) return;
            doc.nodesBetween(from, to, (node, pos)=>{
                if (node.isTextblock && node.textContent && !seenPositions.has(pos)) {
                    seenPositions.add(pos);
                    decorations.push((0, $8nvEM.Decoration).inline(pos + 1, pos + node.nodeSize - 1, {
                        class: 'ai-suggestions-accept-shimmer-background'
                    }));
                }
            });
        });
    });
    return decorations.length > 0 ? (0, $8nvEM.DecorationSet).create(doc, decorations) : (0, $8nvEM.DecorationSet).empty;
};
const $dedd473f4e1cf0d3$var$setSweepEdges = (editorDom)=>{
    let left = Infinity;
    let right = -Infinity;
    for (const block of editorDom.querySelectorAll('.ai-suggestions-accept-shimmer-background')){
        const range = editorDom.ownerDocument.createRange();
        range.selectNodeContents(block);
        const rects = range.getClientRects();
        for(let i = 0; i < rects.length; i++){
            const rect = rects[i];
            if (rect.width > 0 && rect.height > 0) {
                left = Math.min(left, rect.left);
                right = Math.max(right, rect.right);
            }
        }
    }
    if (Number.isFinite(left) && Number.isFinite(right)) {
        editorDom.style.setProperty('--ai-accept-shimmer-left-edge', `${left}px`);
        editorDom.style.setProperty('--ai-accept-shimmer-right-edge', `${right}px`);
        return right - left;
    }
    return undefined;
};
const $dedd473f4e1cf0d3$export$4201d16e5928890e = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $dedd473f4e1cf0d3$var$acceptShimmerPluginKey,
        state: {
            init: ()=>({
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    shimmerDuration: 0
                }),
            apply (tr, state, _oldState, newState) {
                const shimmerMeta = tr.getMeta($dedd473f4e1cf0d3$var$acceptShimmerPluginKey);
                const meta = tr.getMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa));
                if (shimmerMeta?.action === 'CLEAR') return {
                    ...state,
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    shimmerDuration: 0
                };
                if (shimmerMeta?.action === 'SET_DURATION') return {
                    ...state,
                    shimmerDuration: shimmerMeta.duration
                };
                if (meta?.action === 'ACCEPT_SUGGESTION') {
                    const decorations = $dedd473f4e1cf0d3$var$getAcceptedTextBlockDecorations(tr, newState.doc);
                    return {
                        decorations: decorations,
                        newSuggestionId: meta.suggestion.id,
                        shimmerDuration: decorations === (0, $8nvEM.DecorationSet).empty ? 0 : $dedd473f4e1cf0d3$var$SHIMMER_FALLBACK_DURATION_MS
                    };
                }
                if (!tr.docChanged) return state;
                const decorations = state.decorations.map(tr.mapping, newState.doc);
                return {
                    ...state,
                    decorations: decorations,
                    shimmerDuration: decorations === (0, $8nvEM.DecorationSet).empty ? 0 : state.shimmerDuration
                };
            }
        },
        props: {
            decorations (editorState) {
                return $dedd473f4e1cf0d3$var$acceptShimmerPluginKey.getState(editorState)?.decorations ?? (0, $8nvEM.DecorationSet).empty;
            }
        },
        view: (editorView)=>{
            let timeout;
            let lastSuggestionId;
            const clearSweepEdges = ()=>{
                editorView.dom.style.removeProperty('--ai-accept-shimmer-left-edge');
                editorView.dom.style.removeProperty('--ai-accept-shimmer-right-edge');
                editorView.dom.style.removeProperty('--ai-accept-shimmer-duration');
            };
            return {
                update () {
                    const state = $dedd473f4e1cf0d3$var$acceptShimmerPluginKey.getState(editorView.state);
                    if (!state || state.newSuggestionId === lastSuggestionId) return;
                    lastSuggestionId = state.newSuggestionId;
                    if (timeout) clearTimeout(timeout);
                    clearSweepEdges();
                    if (state.decorations === (0, $8nvEM.DecorationSet).empty) return;
                    const width = $dedd473f4e1cf0d3$var$setSweepEdges(editorView.dom);
                    const duration = $dedd473f4e1cf0d3$var$getShimmerDurationForWidth(width);
                    editorView.dom.style.setProperty('--ai-accept-shimmer-duration', `${duration}ms`);
                    timeout = setTimeout(()=>{
                        editorView.dispatch(editorView.state.tr.setMeta($dedd473f4e1cf0d3$var$acceptShimmerPluginKey, {
                            action: 'CLEAR'
                        }).setMeta('addToHistory', false));
                        clearSweepEdges();
                    }, duration);
                    editorView.dispatch(editorView.state.tr.setMeta($dedd473f4e1cf0d3$var$acceptShimmerPluginKey, {
                        action: 'SET_DURATION',
                        duration: duration
                    }).setMeta('addToHistory', false));
                },
                destroy () {
                    if (timeout) clearTimeout(timeout);
                    clearSweepEdges();
                }
            };
        }
    });
};







parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

// these colours do not exist in ads yet but are from figma see: https://hello.atlassian.net/wiki/spaces/DST/pages/6378806627/AI+Components+Patterns+Inventory
const $2e83e0ce18b0d41b$var$backgroundRainbow = `linear-gradient(to right,
	#1F69DA 20%,
	#C16CD4 30%,
	#F5A117 70%,
	#79AE44 80%)`;
const $2e83e0ce18b0d41b$var$acceptBackgroundShimmerSweep = (0, $lOiVq.keyframes)({
    from: {
        backgroundPosition: 'calc(40% - 40vw + var(--ai-accept-shimmer-right-edge, 100vw)) 0, var(--ai-accept-shimmer-left-edge, 0px) 0'
    },
    to: {
        backgroundPosition: 'calc(60% - 60vw + var(--ai-accept-shimmer-left-edge, 0px)) 0, var(--ai-accept-shimmer-left-edge, 0px) 0'
    }
});
const $2e83e0ce18b0d41b$var$acceptShimmerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-accept-shimmer-background': {
        // Edge cases: Apply the shimmer background directly to the lozenge text and text highlight mark
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.statusView-content-wrap), & .lozenge-text, & .fabric-text-color-mark': {
            '--ai-accept-shimmer-width': 'calc(var(--ai-accept-shimmer-right-edge, 100vw) - var(--ai-accept-shimmer-left-edge, 0px))',
            backgroundColor: 'currentColor',
            backgroundImage: `linear-gradient(90deg, currentColor 40%, transparent 45%, transparent 55%, currentColor 60%), var(--ai-accept-shimmer-rainbow, ${$2e83e0ce18b0d41b$var$backgroundRainbow})`,
            backgroundAttachment: 'fixed, fixed',
            backgroundSize: 'calc(var(--ai-accept-shimmer-width) + var(--ai-accept-shimmer-width) + var(--ai-accept-shimmer-width)) 100vh, var(--ai-accept-shimmer-width) 100vh',
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: `${$2e83e0ce18b0d41b$var$acceptBackgroundShimmerSweep} var(--ai-accept-shimmer-duration, 1300ms) cubic-bezier(.4, 0, .5, 1) both`,
            '@media (prefers-reduced-motion: reduce), (forced-colors: active)': {
                animation: 'none',
                backgroundImage: 'none',
                WebkitTextFillColor: 'currentColor'
            }
        }
    },
    // Do not clear the colour of emojis so they don't appear as black squares
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-accept-shimmer-background[data-emoji-id]': {
        WebkitTextFillColor: 'currentColor'
    },
    // Do not clear the text highlight colour during the shimmer
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-accept-shimmer-background.text-highlight': {
        WebkitTextFillColor: 'currentColor'
    }
});
const $2e83e0ce18b0d41b$export$a1c179297c0c35eb = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOiVq.Global), {
        styles: $2e83e0ce18b0d41b$var$acceptShimmerStyles
    });


/* FollowUpCardContentComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
















var $3z1p5 = parcelRequire("3z1p5");


var $lJ6db = parcelRequire("lJ6db");


var $eKjv9 = parcelRequire("eKjv9");




var $cha5E = parcelRequire("cha5E");

const $19944a85f91ff832$export$183509673cddb866 = 'platform_editor_ai_content_reviewer_agent_config';
const $19944a85f91ff832$var$AGENT_ID_PARAMETER = 'value';
function $19944a85f91ff832$export$91708cba61270117() {
    try {
        const value = (0, $cha5E.expVal)($19944a85f91ff832$export$183509673cddb866, $19944a85f91ff832$var$AGENT_ID_PARAMETER, '');
        const normalizedAgentIds = [
            ...new Set(value.split(',').map((id)=>id.trim()).filter(Boolean))
        ];
        return normalizedAgentIds.length ? normalizedAgentIds : undefined;
    } catch  {
        return undefined;
    }
}
function $19944a85f91ff832$export$bc0c8fb7f661940a() {
    return $19944a85f91ff832$export$91708cba61270117()?.[0];
}


const $b272a1ed87714e54$var$useAgentByIdResolver = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const assistanceServiceRef = (0, $cozmU.useRef)(assistanceService);
    assistanceServiceRef.current = assistanceService;
    return (0, $cozmU.useCallback)((agentId)=>assistanceServiceRef.current.getAgentDetails(agentId), []);
});
function $b272a1ed87714e54$export$a966ab2407ae668d({ api: api }) {
    // The Rovo provider owns the product/site identity the assistance service needs, so read it
    // from global config rather than making this plugin's consumers pass it in.
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId } = (0, $eKjv9.useGlobalConfig)();
    const assistanceServiceParams = {
        product: productHeader,
        experienceId: experienceId,
        siteId: siteId,
        touchpointSource: 'editor-ai'
    };
    const { getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference } = (0, $3z1p5.usePaginatedAgentByConfigReference)({
        assistanceServiceParams: assistanceServiceParams
    });
    const getAgentById = $b272a1ed87714e54$var$useAgentByIdResolver({
        assistanceServiceParams: assistanceServiceParams
    });
    // Read through refs so the resolver stays stable however often the global config values —
    // and with them the lookup's identity — change.
    const getAgentRef = (0, $cozmU.useRef)(getAndStoreAgentByExternalConfigReference);
    getAgentRef.current = getAndStoreAgentByExternalConfigReference;
    const getAgentByIdRef = (0, $cozmU.useRef)(getAgentById);
    getAgentByIdRef.current = getAgentById;
    const siteIdRef = (0, $cozmU.useRef)(siteId);
    siteIdRef.current = siteId;
    const analyticsApiRef = (0, $cozmU.useRef)(api?.analytics?.actions);
    analyticsApiRef.current = api?.analytics?.actions;
    const resolveAgent = (0, $cozmU.useCallback)(async ({ signal: signal, skipProvisioning: skipProvisioning, agentId: agentId } = {})=>{
        if (agentId) return getAgentByIdRef.current(agentId);
        const configuredAgentId = (0, $19944a85f91ff832$export$bc0c8fb7f661940a)();
        if (configuredAgentId) return getAgentByIdRef.current(configuredAgentId);
        // Provisioning is idempotent and must happen first: on a site that has never used
        // suggested edits the agent doesn't exist yet, so the lookup would come back empty. A
        // failure isn't fatal — the agent may exist from an earlier session — so report and
        // still attempt the lookup.
        //
        // `skipProvisioning` callers accept that empty result rather than provision an agent
        // the user hasn't asked for. Nothing is cached on a miss, so the send path still
        // provisions and resolves normally afterwards.
        if (!skipProvisioning) try {
            await (0, $61b8b9734ab6a330$export$8f943592d88201ff)({
                cloudId: siteIdRef.current,
                signal: signal
            });
        } catch (error) {
            (0, $2a4bc64013915ea2$export$f79b8848e86580c7)(analyticsApiRef.current, error);
        }
        return getAgentRef.current({
            externalConfigReference: (0, $61b8b9734ab6a330$export$eab6f356b10dc881)
        });
    }, []);
    // Memoised so the object is as stable as the resolver it carries, and safe to use directly
    // in a caller's effect deps.
    return (0, $cozmU.useMemo)(()=>({
            resolveAgent: resolveAgent
        }), [
        resolveAgent
    ]);
}



/* AnchoredCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $k8PFz = parcelRequire("k8PFz");


var $lLsh6 = parcelRequire("lLsh6");


var $1jz5K = parcelRequire("1jz5K");







const $9c1b84e35bed847a$var$SCROLL_MARGIN = 32;
const $9c1b84e35bed847a$export$6de12354ad55c9c0 = 99999;
/**
 * Fallback for the card's measured width, which must stay in sync with the `card`
 * style in `SuggestionCard.tsx`.
 *
 * `cardWidth` is read off the ref during render, so it is 0 on the first render after
 * the card mounts (the ref is only attached on commit) — and the horizontal observer
 * built from that render would use a right inset of just `SCROLL_MARGIN`, reporting
 * room on the right for any target with ≥32px to spare.
 */ const $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK = 280;
const $9c1b84e35bed847a$export$8d7a4d77df9967d4 = ({ id: id, root: root, targetStart: targetStart, targetBase: targetBase, targetEnd: targetEnd, cardRef: cardRef, stickyHeaderOffset: stickyHeaderOffset = 0 })=>{
    const [isTargetAboveViewport, setIsTargetAboveViewport] = (0, $cozmU.useState)(false);
    const [isTargetBelowViewport, setIsTargetBelowViewport] = (0, $cozmU.useState)(false);
    const [isCardBottomBelowViewport, setIsCardBottomBelowViewport] = (0, $cozmU.useState)(false);
    const [isTargetRightOfViewport, setIsTargetRightOfViewport] = (0, $cozmU.useState)(false);
    const [isTargetEndAboveViewport, setIsTargetEndAboveViewport] = (0, $cozmU.useState)(false);
    const [isTargetEndBelowViewport, setIsTargetEndBelowViewport] = (0, $cozmU.useState)(false);
    const [isTargetInitiallyOutsideViewport, setIsTargetInitiallyOutsideViewport] = (0, $cozmU.useState)(false);
    const [isMeasured, setIsMeasured] = (0, $cozmU.useState)(false);
    const cardHeight = cardRef.current?.offsetHeight ?? 0;
    // `|| CARD_WIDTH_FALLBACK` rather than `??` so a 0 from an unmounted (or
    // not-yet-laid-out) card also falls back instead of collapsing the inset.
    const cardWidth = cardRef.current?.offsetWidth || $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK;
    const measure = (0, $cozmU.useCallback)(()=>{
        const card = cardRef.current;
        if (!id || !root || !targetStart || !targetEnd || !targetBase || !card) return null;
        const rootRect = root.getBoundingClientRect();
        // IntersectionObserver resolves an element root against its content-clip box —
        // the padding box minus scrollbars — which is what client* describes.
        const rootTop = rootRect.top + root.clientTop;
        const rootBottom = rootTop + root.clientHeight;
        const rootRight = rootRect.left + root.clientLeft + root.clientWidth;
        const height = card.offsetHeight;
        const width = card.offsetWidth || $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK;
        const startRect = targetStart.getBoundingClientRect();
        const endRect = targetEnd.getBoundingClientRect();
        const baseRect = targetBase.getBoundingClientRect();
        // These mirror each observer's `rootMargin` below; keep the two in step.
        const targetAbove = startRect.top < rootTop + $9c1b84e35bed847a$var$SCROLL_MARGIN + stickyHeaderOffset;
        const targetEndAbove = endRect.top < rootTop + stickyHeaderOffset;
        const targetBelow = startRect.top > rootBottom - $9c1b84e35bed847a$var$SCROLL_MARGIN;
        const targetEndBelow = endRect.bottom > rootBottom - (height + $9c1b84e35bed847a$var$SCROLL_MARGIN + 24);
        setIsTargetAboveViewport(targetAbove);
        setIsCardBottomBelowViewport(startRect.bottom > rootBottom - (height + $9c1b84e35bed847a$var$SCROLL_MARGIN));
        setIsTargetBelowViewport(targetBelow);
        setIsTargetEndAboveViewport(targetEndAbove);
        setIsTargetEndBelowViewport(targetEndBelow);
        // With no base anchor there is nothing to align the card's inline start with, so fall back
        // to the right-constrained positioning used when there's no room on the right.
        const isBaseAnchorMissing = baseRect.right < rootRect.left - $9c1b84e35bed847a$export$6de12354ad55c9c0 / 2;
        setIsTargetRightOfViewport(isBaseAnchorMissing || baseRect.right > rootRight - (width + $9c1b84e35bed847a$var$SCROLL_MARGIN));
        const isOutsideViewport = targetAbove && targetEndAbove || targetBelow && targetEndBelow;
        return isOutsideViewport;
    }, [
        id,
        root,
        targetStart,
        targetBase,
        targetEnd,
        cardRef,
        stickyHeaderOffset
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measure();
        const frame = requestAnimationFrame(()=>{
            const isOutsideViewport = measure();
            if (isOutsideViewport === null) return;
            setIsTargetInitiallyOutsideViewport(isOutsideViewport);
            setIsMeasured(true);
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        measure
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!id || !root || !targetStart || !targetEnd || !cardRef.current || !targetBase) {
            setIsTargetRightOfViewport(false);
            setIsTargetEndAboveViewport(false);
            setIsTargetEndBelowViewport(false);
            setIsTargetBelowViewport(false);
            setIsTargetAboveViewport(false);
            setIsCardBottomBelowViewport(false);
            setIsTargetInitiallyOutsideViewport(false);
            setIsMeasured(false);
            return;
        }
        /**
		 * A notification may only *release* `isTargetInitiallyOutsideViewport` — as soon as the
		 * target is no longer wholly out of view, because the user scrolled back or a smooth
		 * scroll landed — so that a later scroll-away gets the normal card-to-button hand-off
		 * rather than the immediate swap. Re-arming here would make the flag indistinguishable
		 * from `shouldScrollUp || shouldScrollDown`.
		 */ const notify = ()=>{
            if (measure() === false) setIsTargetInitiallyOutsideViewport(false);
        };
        const verticalCardPositionObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `-${stickyHeaderOffset + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px -${cardHeight + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px`
        });
        const verticalTargetObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `${cardHeight + stickyHeaderOffset + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px -${$9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px`
        });
        const targetEndObserver = new IntersectionObserver(notify, {
            root: root,
            // Extra 24 for the gap above card and content
            rootMargin: `-${stickyHeaderOffset}px 0px -${cardHeight + $9c1b84e35bed847a$var$SCROLL_MARGIN + 24}px 0px`
        });
        /**
		 * This observer is for determining if there's enough space on the right side to display the card.
		 * We use arbitrarily large root margins to ensure that the intersection observer detects it even
		 * when the targetBase anchor (anchored to the icon button) is off the screen.
		 *
		 * A hypotheical edge case is if a toolcall's localid position is more than 99999px further than the
		 * doc-level node's local id, but that is really unlikely.
		 */ const horizontalObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `99999px -${cardWidth + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 99999px 0px`
        });
        verticalCardPositionObserver.observe(targetStart);
        horizontalObserver.observe(targetBase);
        targetEndObserver.observe(targetEnd);
        verticalTargetObserver.observe(targetStart);
        return ()=>{
            verticalCardPositionObserver.disconnect();
            horizontalObserver.disconnect();
            targetEndObserver.disconnect();
            verticalTargetObserver.disconnect();
        };
    }, [
        targetStart,
        targetBase,
        cardRef,
        root,
        targetEnd,
        cardHeight,
        cardWidth,
        id,
        measure,
        stickyHeaderOffset
    ]);
    return {
        isTargetAboveViewport: isTargetAboveViewport,
        isTargetBelowViewport: isTargetBelowViewport,
        isCardBottomBelowViewport: isCardBottomBelowViewport,
        isTargetRightOfViewport: isTargetRightOfViewport,
        isTargetEndAboveViewport: isTargetEndAboveViewport,
        isTargetEndBelowViewport: isTargetEndBelowViewport,
        isTargetInitiallyOutsideViewport: isTargetInitiallyOutsideViewport,
        isMeasured: isMeasured
    };
};


/* ScrollBackToSuggestionButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $ad7Ou = parcelRequire("ad7Ou");





var $fS8Zl = parcelRequire("fS8Zl");


var $f6cdQ = parcelRequire("f6cdQ");


var $4aRua = parcelRequire("4aRua");

const $b409976b87630c23$var$styles = {
    buttonContainer: "_0bjKvDyzSk _30huDKYbGa _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXruqi9L _2OUyjtGk8v"
};
const $b409976b87630c23$export$1f302f0e3d37f52d = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardScrollBackToSuggestionLabel);
    const ArrowIcon = (0, $cozmU.useCallback)(()=>{
        return direction === 'up' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: "",
            size: "small"
        });
    }, [
        direction
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $b409976b87630c23$var$styles.buttonContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: ArrowIcon,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "medium",
                color: "color.text.subtle",
                children: label
            })
        })
    });
};


const $b79c09504f84e6ab$var$getTargetPosForLocalId = (view, targetLocalId)=>{
    if (!view || !targetLocalId) return undefined;
    let targetPos;
    view.state.doc.descendants((node, pos)=>{
        if (node.attrs?.localId === targetLocalId) {
            targetPos = pos;
            return false;
        }
        return true;
    });
    if (targetPos === undefined) return undefined;
    return targetPos;
};
const $b79c09504f84e6ab$var$styles = {
    targetAnchoring: "_3iDTPbvLZJ _1mT5xdWVPG _2I62gzEScs _3iC0zdNRM5",
    baseAnchoringFallback: "_3iC0zdnwqy",
    cardContainer: "_42Yu6B6zpv _2RljVs3MbP _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKxt7V",
    preMeasurement: "_1YKVNsdnbC",
    fadeIn: "_1gBibygnQY _0nFVCGRLuw _43vdfTjwM9 _3Y6bKp38c8 _39Ohv4YbGa",
    scrollBackContainer: "_39xV02ehCh _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdy1CL",
    scrollBackTop: "_2fBhteo1qc _2IhTonNHnM",
    scrollBackBottom: "_2fBhte0t9Q _0Bm75GNHnM",
    scrollBackAnimation: "_1jakNnpCLV _3Y6bKpZSoF _39Ohv4YbGa",
    scrollBackAnimationQuick: "_1jakNnBMlD _3Y6bKpZSoF _39Ohv4YbGa",
    scrollBackRight: "_4ApkO208ky",
    pinnedBottomRight: "_1mT5xdy1CL _0Bm75GNHnM _4ApkO208ky",
    anchoredToTargetEnd: "_1mT5xdWVPG _4ApkO208ky",
    pinnedTop: "_1mT5xdy1CL _2IhTonNHnM",
    pinnedBottom: "_1mT5xdy1CL _0Bm75GNHnM",
    anchoredToTarget: "_1mT5xdWVPG",
    slideUp: "_1YKVNsdnbC _1VJPcaY45Z _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKjwM9 _3OZqoKUoWQ",
    slideDown: "_1YKVNsdnbC _1VJPcat7Id _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKjwM9 _3OZqoKUoWQ",
    hiddenForScrollBack: "_1YKVNsdnbC _1pp6NdYbGa _3Z9K0wxlqh"
};
const $b79c09504f84e6ab$var$anchorWithFallback = (name, side, fallbackName)=>fallbackName ? `anchor(${name} ${side}, anchor(${fallbackName} ${side}))` : `anchor(${name} ${side})`;
const $b79c09504f84e6ab$export$8f339c4f2834aeec = ({ anchorNames: anchorNames, cardRef: cardRef, children: children, onScrollBack: onScrollBack, targetId: targetId, targetLocalId: targetLocalId, view: view })=>{
    /**
   * State-backed refs, so the card mounts correctly after its anchor does. Start and end are
   * separate spans (top and bottom of the block) so we can tell when the target leaves the
   * editor viewport.
   */ const [targetStart, setTargetStart] = (0, $cozmU.useState)();
    const targetStartRef = (0, $cozmU.useCallback)((node)=>{
        setTargetStart(node);
    }, []);
    const [targetEnd, setTargetEnd] = (0, $cozmU.useState)();
    const targetEndRef = (0, $cozmU.useCallback)((node)=>{
        setTargetEnd(node);
    }, []);
    const [targetBase, setTargetBase] = (0, $cozmU.useState)();
    const targetBaseRef = (0, $cozmU.useCallback)((node)=>{
        setTargetBase(node);
    }, []);
    const [root, setRoot] = (0, $cozmU.useState)();
    const [stickyHeaderOffset, setStickyHeaderOffset] = (0, $cozmU.useState)(0);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!view?.dom) {
            setRoot(undefined);
            return;
        }
        const _root = (0, $1jz5K.findOverflowScrollParent)(view.dom);
        setRoot(_root || undefined);
    }, [
        view
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) return;
        let resizeObserver;
        const frame = requestAnimationFrame(()=>{
            const targetPos = $b79c09504f84e6ab$var$getTargetPosForLocalId(view, targetLocalId);
            if (targetPos === undefined || !view) {
                setStickyHeaderOffset(0);
                return;
            }
            const stickyHeaderHeight = (0, $lLsh6.getStickyHeaderHeight)(view, targetPos);
            if (stickyHeaderHeight === undefined) {
                setStickyHeaderOffset(0);
                return;
            }
            const updateStickyHeaderOffset = ()=>{
                const stickyHeaderHeight = (0, $lLsh6.getStickyHeaderHeight)(view, targetPos);
                const newStickyHeaderOffset = stickyHeaderHeight === undefined ? 0 : stickyHeaderHeight + (0, $k8PFz.tableMarginTop);
                setStickyHeaderOffset((currentOffset)=>currentOffset === newStickyHeaderOffset ? currentOffset : newStickyHeaderOffset);
            };
            updateStickyHeaderOffset();
            resizeObserver = new ResizeObserver(updateStickyHeaderOffset);
            resizeObserver.observe(view.dom);
        });
        return ()=>{
            cancelAnimationFrame(frame);
            resizeObserver?.disconnect();
        };
    }, [
        targetId,
        targetLocalId,
        view
    ]);
    const { isMeasured: isMeasured, isTargetAboveViewport: isTargetAboveViewport, isTargetBelowViewport: isTargetBelowViewport, isCardBottomBelowViewport: isCardBottomBelowViewport, isTargetRightOfViewport: isTargetRightOfViewport, isTargetEndAboveViewport: isTargetEndAboveViewport, isTargetEndBelowViewport: isTargetEndBelowViewport, isTargetInitiallyOutsideViewport: isTargetInitiallyOutsideViewport } = (0, $9c1b84e35bed847a$export$8d7a4d77df9967d4)({
        root: root,
        targetStart: targetStart,
        targetEnd: targetEnd,
        targetBase: targetBase,
        cardRef: cardRef,
        id: targetId,
        stickyHeaderOffset: stickyHeaderOffset
    });
    const shouldScrollUp = isTargetEndAboveViewport && isTargetAboveViewport;
    const shouldScrollDown = isTargetBelowViewport && isTargetEndBelowViewport;
    const isScrollBackVisible = onScrollBack && (shouldScrollUp || shouldScrollDown); /**
                                                                                     * The target was already out of view when this card was opened, so there is no
                                                                                     * card-to-button hand-off to play: show the scroll-back pill at once and never paint the
                                                                                     * card. When the target scrolls out of view *while* the card is open, the delayed
                                                                                     * slide-away + fade-in below still runs, which is what it was designed for.
                                                                                     */ 
    const shouldSkipScrollBackTransition = isTargetInitiallyOutsideViewport && (shouldScrollUp || shouldScrollDown); /**
                                                                                                                    * The fade-in is a keyframe animation, so removing its class and adding it back *restarts*
                                                                                                                    * it — the card re-animates. That is exactly what happens when the card is revealed while
                                                                                                                    * `shouldSkipScrollBackTransition` is true and it later goes false (a target that was out of
                                                                                                                    * view on select is scrolled back to), so latch it: once the card has faded in it keeps the
                                                                                                                    * class for the rest of its life, and the finished animation holds no value that could
                                                                                                                    * interfere with the slide/hidden states. A different card gets a fresh fade because the
                                                                                                                    * `key` in the consumer remounts this component.
                                                                                                                    */ 
    const [hasFadedIn, setHasFadedIn] = (0, $cozmU.useState)(false);
    if (isMeasured && !shouldSkipScrollBackTransition && !hasFadedIn) // Set during render, not in an effect: an effect would land the class one frame after
    // `preMeasurement` stops hiding the card, which paints a frame at full opacity — the very
    // flash the fade-in exists to smooth over.
    setHasFadedIn(true);
     /**
     * Mutually exclusive positioning modes, one per combination of viewport state:
     *  - `isPinnedBottomRight`     : fixed to the bottom-right of the viewport
     *  - `isAnchoredToTargetEnd`   : absolutely anchored to the end of the target
     *  - `isPinnedTop`             : fixed to the top of the viewport
     *  - `isPinnedBottom`          : fixed to the bottom of the viewport
     *  - `isAnchoredToTarget`      : absolutely anchored to the target (default)
     */ 
    const isPinnedBottomRight = isTargetRightOfViewport && isTargetEndBelowViewport;
    const isAnchoredToTargetEnd = isTargetRightOfViewport && !isTargetEndBelowViewport;
    const isPinnedTop = !isTargetRightOfViewport && isTargetAboveViewport;
    const isPinnedBottom = !isTargetRightOfViewport && !isTargetAboveViewport && (isCardBottomBelowViewport || isTargetBelowViewport);
    const isAnchoredToTarget = !isPinnedBottomRight && !isAnchoredToTargetEnd && !isPinnedTop && !isPinnedBottom;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetEndRef,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'start', anchorNames.outerEnd),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetInlineStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'end', anchorNames.outerEnd)
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetStartRef,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'start', anchorNames.outerStart),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetInlineStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'end', anchorNames.outerStart)
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetBaseRef,
                style: {
                    positionAnchor: anchorNames.base
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring,
                    $b79c09504f84e6ab$var$styles.baseAnchoringFallback
                ])
            }),
            isScrollBackVisible && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...!isTargetRightOfViewport && {
                        insetInlineStart: `anchor(${anchorNames.base} start)`
                    }
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.cardContainer,
                    $b79c09504f84e6ab$var$styles.scrollBackContainer,
                    isTargetRightOfViewport && $b79c09504f84e6ab$var$styles.scrollBackRight,
                    shouldScrollUp ? $b79c09504f84e6ab$var$styles.scrollBackTop : $b79c09504f84e6ab$var$styles.scrollBackBottom,
                    shouldSkipScrollBackTransition ? $b79c09504f84e6ab$var$styles.scrollBackAnimationQuick : $b79c09504f84e6ab$var$styles.scrollBackAnimation
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b409976b87630c23$export$1f302f0e3d37f52d), {
                    direction: shouldScrollUp ? 'up' : 'down',
                    onClick: onScrollBack
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    // Modes that aren't right-constrained align the card's inline start with the icon
                    // button's inline end. The two that are use a `right` offset from their styles
                    // instead, so they must not also get an inline start.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...!isTargetRightOfViewport && {
                        insetInlineStart: `anchor(${anchorNames.base} end)`
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...isAnchoredToTarget && {
                        insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'start', anchorNames.outerStart)
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...isAnchoredToTargetEnd && {
                        insetBlockStart: `calc(${$b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'start', anchorNames.outerEnd)} + ${"var(--ds-space-300, 24px)"})`
                    }
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.cardContainer,
                    hasFadedIn && $b79c09504f84e6ab$var$styles.fadeIn,
                    isPinnedBottomRight && $b79c09504f84e6ab$var$styles.pinnedBottomRight,
                    isAnchoredToTargetEnd && $b79c09504f84e6ab$var$styles.anchoredToTargetEnd,
                    isPinnedTop && $b79c09504f84e6ab$var$styles.pinnedTop,
                    isPinnedBottom && $b79c09504f84e6ab$var$styles.pinnedBottom,
                    isAnchoredToTarget && $b79c09504f84e6ab$var$styles.anchoredToTarget,
                    !isMeasured && $b79c09504f84e6ab$var$styles.preMeasurement,
                    shouldScrollUp && !shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.slideUp,
                    shouldScrollDown && !shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.slideDown,
                    shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.hiddenForScrollBack
                ]),
                children: children
            })
        ]
    });
};


/* FollowUpCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $4u3xL = parcelRequire("4u3xL");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");




var $6gGPb = parcelRequire("6gGPb");

const $0c747e6c17d2a0bd$var$styles = {
    card: "_0bjKvDyzSk _2mHwu85zaO _1mT5xdRAKS _0KLXrulfZc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _2OUyjtGk8v _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc"
}; /**
    * Shown in place of the suggestion card once the last suggestion has been removed, offering to
    * generate suggestions for the rest of the page.
    */ 
const $0c747e6c17d2a0bd$export$1eaf41494299ca89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function FollowUpCard({ agent: agent, onDismiss: onDismiss, onReview: onReview }, ref) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: ref,
        "data-testid": 'ai-suggestion-follow-up-card',
        className: (0, $hekY6.default)([
            $0c747e6c17d2a0bd$var$styles.card
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                                agentId: agent?.id,
                                agentNamedId: agent?.external_config_reference ?? agent?.named_id,
                                agentIdentityAccountId: agent?.identity_account_id,
                                size: "small",
                                label: agent?.name ?? '',
                                showBorder: false
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "large",
                                weight: "medium",
                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardTitle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        color: "color.text",
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardDescription)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
                        onClick: onReview,
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardReviewButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "subtle",
                        onClick: onDismiss,
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDismissButtonLabel)
                    })
                ]
            })
        ]
    });
});


const $a07fe340660de233$export$b37784161dbefc65 = ({ api: api, view: view })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const { followUpCard: followUpCard, isHidden: isHidden } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>({
            followUpCard: state?.aiSuggestionsState?.followUpCard,
            // View mode is a hard override: never show the suggestions UI while read-only.
            isHidden: (state?.aiSuggestionsState?.isHidden ?? false) || state?.editorViewModeState?.mode === 'view'
        })); // Resolved only while the card is on screen, so nothing is provisioned or fetched for a card
    // that isn't shown. Until it lands the card falls back to the Rovo mark. The agent store
    // caches the lookup, so re-opening doesn't refetch.
    const [agent, setAgent] = (0, $cozmU.useState)();
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    });
    const isCardShown = Boolean(followUpCard) && !isHidden;
    (0, $cozmU.useEffect)(()=>{
        if (!isCardShown || agent || !(0, $iDrrr.fg)('content_reviewer_agent')) return;
        let isActive = true;
        const abortController = new AbortController();
        resolveAgent({
            signal: abortController.signal
        }).then((resolved)=>{
            if (isActive && resolved) setAgent(resolved);
        });
        return ()=>{
            isActive = false;
            abortController.abort();
        };
    }, [
        agent,
        isCardShown,
        resolveAgent
    ]);
    const onDismiss = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'DISMISS_FOLLOW_UP_CARD'
            });
            return tr;
        });
    }, [
        api
    ]);
    const onReview = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            entryPoint: 'followUpCard'
        }); // The thinking bar takes over from here.
        onDismiss();
    }, [
        api,
        onDismiss
    ]);
    if (!followUpCard || isHidden) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b79c09504f84e6ab$export$8f339c4f2834aeec // Remounts per suggestion, so a card replacing another one fades in rather than
    ), {
        anchorNames: (0, $56b1bb8689d88b40$export$c88671e3a419bb99),
        cardRef: cardRef,
        targetId: followUpCard.suggestionId,
        view: view,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0c747e6c17d2a0bd$export$1eaf41494299ca89), {
            agent: agent,
            ref: cardRef,
            onDismiss: onDismiss,
            onReview: onReview
        })
    }, followUpCard.suggestionId);
};





parcelRequire("cozmU");




/**
 * Per-node-type hover highlight styles for the suggestion icon hover, mirroring
 * how the block controls "remix" selection treats container, extension and rule
 * nodes. Default text blocks and cards keep the inline box-shadow highlight set
 * directly on their decoration, so they aren't styled here.
 *
 * The class selectors below are inlined as string literals (rather than imported
 * from `hoverHighlightClassNames`) because the ui-styling-standard rules disallow
 * dynamic/imported object-style keys. Keep them in sync with
 * `hoverHighlightClassNames` in `../../pm-plugins/hoverHighlightDecorations`.
 */ const $997801478ebdd729$var$hoverHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Container nodes (panel, codeBlock, expand, layoutSection): a translucent blue
    // blanket overlay on top of the content + a subtle ring, instead of a
    // box-shadow that would look wrong on full-bleed nodes.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-overlay': {
        position: 'relative',
        boxShadow: `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-overlay::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
    },
    // Tables: draw a uniform 1px blue border + translucent blue background on every
    // cell via the cell's ::after overlay, mirroring how "remix" highlights a
    // selected table. The -1px offsets (matching the editor's own selected-cell
    // overlay) make the border sit on top of the collapsed shared borders so both
    // horizontal and vertical lines render, and header cells get the same uniform
    // border.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-table td, .ProseMirror .ai-suggestions-hover-table th': {
        position: 'relative'
    },
    // !important overrides the table plugin's own base cell ::after, which has
    // higher selector specificity and uses width/height: 100% with no offsets.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-table td::after, .ProseMirror .ai-suggestions-hover-table th::after': {
        content: '""',
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ top: '-1px !important',
        right: '-1px !important',
        bottom: '-1px !important',
        left: '-1px !important',
        width: 'auto !important',
        height: 'auto !important',
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-focused, #4688EC)"} !important`,
        backgroundColor: `${"var(--ds-blanket-selected, #388BFF14)"} !important`
    },
    // Extensions: highlight the inner container rather than the wrapper.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-extension .extension-container': {
        boxShadow: `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
    },
    // Rule: fill the line so the thin node is visibly highlighted.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-rule': {
        backgroundColor: "var(--ds-border-focused, #4688EC)"
    }
});
const $997801478ebdd729$export$a1fd8428be46e11c = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOiVq.Global), {
        styles: $997801478ebdd729$var$hoverHighlightStyles
    });


/* SuggestionCardContentComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
















const $e40b4e35496d16c5$export$4cbf498e35d8c873 = (suggestion, isRegenerating)=>{
    const id = suggestion?.id;
    const isStale = suggestion?.status === 'STALE';
    const [tracking, setTracking] = (0, $cozmU.useState)({
        id: id,
        isRegenerating: isRegenerating,
        isJustUpdated: false
    });
    const isSameSuggestion = tracking.id === id;
    const justFinishedRegenerating = isSameSuggestion && tracking.isRegenerating && !isRegenerating;
    const isJustUpdated = justFinishedRegenerating ? !isStale : isSameSuggestion && tracking.isJustUpdated;
    if (tracking.id !== id || tracking.isRegenerating !== isRegenerating || tracking.isJustUpdated !== isJustUpdated) setTracking({
        id: id,
        isRegenerating: isRegenerating,
        isJustUpdated: isJustUpdated
    });
    if (isRegenerating) return 'regenerating';
    if (isJustUpdated) return 'updated';
    if (isStale) return 'stale';
    return undefined;
};





const $3ff3f4249608fe22$var$selectSelectedSuggestion = (state)=>{
    const { selectedSuggestion: selectedId, suggestionById: suggestionById } = state ?? {};
    return selectedId !== undefined && suggestionById !== undefined ? suggestionById.get(selectedId) : undefined;
};
const $3ff3f4249608fe22$var$selectBaseLocalId = (state)=>{
    const { selectedSuggestion: selectedId, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = state ?? {};
    return baseLocalIdBySuggestionId && selectedId ? baseLocalIdBySuggestionId.get(selectedId) : undefined;
};
const $3ff3f4249608fe22$export$12e742fdeff6e7ba = (api)=>{
    const [selectedSuggestion, setSelectedSuggestion] = (0, $cozmU.useState)(()=>$3ff3f4249608fe22$var$selectSelectedSuggestion(api?.aiSuggestions?.sharedState.currentState()));
    const [baseLocalId, setBaseLocalId] = (0, $cozmU.useState)(()=>$3ff3f4249608fe22$var$selectBaseLocalId(api?.aiSuggestions?.sharedState.currentState()));
    (0, $cozmU.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        const initial = aiSuggestions.sharedState.currentState();
        setSelectedSuggestion($3ff3f4249608fe22$var$selectSelectedSuggestion(initial));
        setBaseLocalId($3ff3f4249608fe22$var$selectBaseLocalId(initial));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setSelectedSuggestion($3ff3f4249608fe22$var$selectSelectedSuggestion(nextSharedState));
            setBaseLocalId($3ff3f4249608fe22$var$selectBaseLocalId(nextSharedState));
        });
    }, [
        api
    ]);
    return {
        selectedSuggestion: selectedSuggestion,
        baseLocalId: baseLocalId
    };
};





/* StatusBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 





parcelRequire("cozmU");








var $fxbF1 = parcelRequire("fxbF1");


var $iZMIZ = parcelRequire("iZMIZ");





var $lfoFx = parcelRequire("lfoFx");

const $59fa28a6d850aa68$var$styles = {
    banner: "_0bjKvDKTcp _2sNsIg7NXe _24h04i2Njc _39xV02N91d _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXrunmFW _1UtDYzZpcK",
    bannerSuccess: "_0KLXruzaZe _1UtDYzGL5O"
};
function $59fa28a6d850aa68$var$getBannerContent(status) {
    return ({
        regenerating: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "xsmall"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardRegeneratingBannerLabel
        },
        updated: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardUpdatedBannerLabel
        },
        stale: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardStaleBannerLabel
        }
    })[status];
} /**
   * Status banner shown at the top of a suggestion card body — while the
   * suggestion is being regenerated, once it's confirmed updated, or when it's
   * out of date (stale).
   */ 
const $59fa28a6d850aa68$export$fcf9195d8c4d40ff = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { icon: icon, label: label } = $59fa28a6d850aa68$var$getBannerContent(status);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $59fa28a6d850aa68$var$styles.banner,
            status === 'updated' && $59fa28a6d850aa68$var$styles.bannerSuccess
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            children: [
                icon,
                formatMessage(label)
            ]
        })
    });
};


/* SuggestionCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");








var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $j6vyT = parcelRequire("j6vyT");


var $l3wuH = parcelRequire("l3wuH");


var $a79Sy = parcelRequire("a79Sy");


var $bsSbN = parcelRequire("bsSbN");


var $4efpo = parcelRequire("4efpo");


var $gDx2k = parcelRequire("gDx2k");


var $6TaGl = parcelRequire("6TaGl");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $aCJyI = parcelRequire("aCJyI");


var $4ez2K = parcelRequire("4ez2K");



var $hBYtq = parcelRequire("hBYtq");






var $lpNn5 = parcelRequire("lpNn5");

/* SuggestionAgentIdentity.tsx generated by @compiled/babel-plugin v3.0.2 */ 





parcelRequire("cozmU");





var $arQY7 = parcelRequire("arQY7");


var $7zsi1 = parcelRequire("7zsi1");





var $bUd6P = parcelRequire("bUd6P");







parcelRequire("cozmU");

const $e7c1909c2cca938c$var$DEFAULT_AVATAR_SIZE = 24;
const $e7c1909c2cca938c$var$getVendorBrand = (agentName)=>{
    const knownNames = [
        {
            name: 'Claude Code',
            brand: 'claude'
        },
        {
            name: 'Claude',
            brand: 'claude'
        },
        {
            name: 'ChatGPT',
            brand: 'chatgpt'
        }
    ];
    return knownNames.find(({ name: name })=>agentName === name || agentName.startsWith(`${name} (`))?.brand;
};
const $e7c1909c2cca938c$var$ClaudeIcon = ({ label: label, size: size })=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                width: "48",
                height: "48",
                fill: "#D97757"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M14.2785 29.274L20.5732 25.7445L20.6785 25.4369L20.5732 25.2669H20.2653L19.2122 25.2021L15.6152 25.105L12.4962 24.9755L9.47443 24.8136L8.71291 24.6517L8 23.7126L8.07291 23.2431L8.71291 22.8141L9.62835 22.895L11.6537 23.0326L14.6916 23.2431L16.8952 23.3726L20.16 23.7126H20.6785L20.7514 23.5022L20.5732 23.3726L20.4354 23.2431L17.2922 21.1141L13.8896 18.8636L12.1073 17.5684L11.1433 16.9127L10.6572 16.2975L10.4466 14.9537L11.3215 13.9904L12.4962 14.0713L12.7959 14.1523L13.9868 15.067L16.5306 17.0342L19.8522 19.4789L20.3382 19.8836L20.5327 19.746L20.557 19.6489L20.3382 19.2846L18.5316 16.0223L16.6035 12.7033L15.7448 11.3271L15.518 10.5014C15.437 10.1614 15.3803 9.87807 15.3803 9.52998L16.3767 8.17809L16.9276 8L18.2562 8.17809L18.8152 8.6638L19.6415 10.55L20.9782 13.5209L23.0522 17.5603L23.6597 18.7584L23.9838 19.8674L24.1053 20.2074H24.3159V20.0132L24.4861 17.7384L24.802 14.9456L25.1099 11.3514L25.2152 10.3395L25.7175 9.12522L26.7139 8.46952L27.4916 8.84189L28.1316 9.75664L28.0425 10.3476L27.6618 12.8166L26.9165 16.6861L26.4304 19.2765H26.7139L27.038 18.9527L28.3504 17.2122L30.5539 14.4599L31.5261 13.3671L32.6603 12.1609L33.3894 11.5861H34.7666L35.7792 13.0918L35.3256 14.6461L33.9079 16.4432L32.7332 17.9651L31.0481 20.2317L29.9949 22.045L30.0922 22.1907L30.3433 22.1665L34.1509 21.3569L36.2086 20.9846L38.6633 20.5636L39.7732 21.0817L39.8947 21.6079L39.4572 22.6845L36.8324 23.3322L33.7539 23.9474L29.1686 25.0321L29.1119 25.0726L29.1767 25.1536L31.2425 25.3478L32.1256 25.3964H34.2886L38.3149 25.6959L39.3681 26.3921L40 27.2421L39.8947 27.8897L38.2744 28.7154L36.0871 28.1973L30.9833 26.9831L29.2334 26.5459H28.9904V26.6916L30.4486 28.1164L33.122 30.5287L36.4678 33.6372L36.638 34.4063L36.2086 35.0134L35.7549 34.9486L32.8142 32.7387L31.68 31.743L29.1119 29.5816H28.9418V29.8082L29.5332 30.6744L32.6603 35.3696L32.8223 36.8105L32.5954 37.28L31.7853 37.5634L30.8942 37.4015L29.0633 34.8353L27.1757 31.9454L25.6527 29.3549L25.4663 29.4602L24.5671 39.1338L24.1458 39.6276L23.1737 40L22.3635 39.3848L21.9342 38.3891L22.3635 36.422L22.882 33.8558L23.3033 31.8158L23.6841 29.2821L23.9109 28.4402L23.8947 28.3835L23.7084 28.4078L21.7965 31.0306L18.8881 34.9567L16.5873 37.4177L16.0365 37.6362L15.0805 37.1424L15.1696 36.2601L15.7043 35.4748L18.8881 31.4273L20.8081 28.9178L22.0476 27.4688L22.0395 27.2583H21.9666L13.5089 32.7468L12.002 32.9411L11.3539 32.3339L11.4349 31.3382L11.7428 31.0144L14.2866 29.2659L14.2785 29.274Z",
                fill: "white"
            })
        ]
    });
const $e7c1909c2cca938c$var$OpenAiIcon = ({ label: label, size: size })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                width: "48",
                height: "48",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M20.5063 19.92V17.0699C20.5063 16.8299 20.5956 16.6498 20.8037 16.53L26.4827 13.23C27.2557 12.78 28.1774 12.5701 29.1287 12.5701C32.6965 12.5701 34.9564 15.3602 34.9564 18.33C34.9564 18.54 34.9564 18.78 34.9266 19.02L29.0395 15.54C28.6828 15.3301 28.3259 15.3301 27.9691 15.54L20.5063 19.92ZM33.7669 31.02V24.2099C33.7669 23.7898 33.5884 23.4898 33.2317 23.2799L25.769 18.8999L28.207 17.4898C28.4151 17.3699 28.5935 17.3699 28.8016 17.4898L34.4806 20.7898C36.116 21.7499 37.2159 23.7898 37.2159 25.7697C37.2159 28.0496 35.8781 30.1497 33.7669 31.0198V31.02ZM18.7522 25.0201L16.3141 23.5802C16.1061 23.4603 16.0168 23.2802 16.0168 23.0401V16.4402C16.0168 13.2303 18.4548 10.8001 21.7552 10.8001C23.0041 10.8001 24.1634 11.2202 25.1448 11.9702L19.2876 15.3903C18.9309 15.6002 18.7525 15.9002 18.7525 16.3203V25.0203L18.7522 25.0201ZM24 28.08L20.5063 26.1V21.9002L24 19.9203L27.4933 21.9002V26.1L24 28.08ZM26.2447 37.2001C24.9959 37.2001 23.8366 36.78 22.8552 36.0301L28.7123 32.61C29.0691 32.4001 29.2475 32.1001 29.2475 31.6799V22.9799L31.7154 24.4198C31.9235 24.5397 32.0128 24.7198 32.0128 24.9599V31.5598C32.0128 34.7697 29.5448 37.1999 26.2447 37.1999V37.2001ZM19.1981 30.5102L13.5191 27.2102C11.8837 26.25 10.7837 24.2102 10.7837 22.2303C10.7837 19.9203 12.1515 17.8503 14.2623 16.9802V23.8202C14.2623 24.2403 14.4408 24.5403 14.7975 24.7502L22.2307 29.1001L19.7927 30.5102C19.5847 30.63 19.4061 30.63 19.1981 30.5102ZM18.8713 35.4301C15.5115 35.4301 13.0436 32.8801 13.0436 29.7301C13.0436 29.4901 13.0734 29.2501 13.103 29.01L18.9602 32.4301C19.3169 32.6401 19.6739 32.6401 20.0306 32.4301L27.4933 28.0803V30.9303C27.4933 31.1703 27.4041 31.3504 27.196 31.4703L21.5171 34.7703C20.744 35.2203 19.8222 35.4301 18.8709 35.4301H18.8713ZM26.2447 39C29.8424 39 32.8452 36.4201 33.5293 33C36.8593 32.1299 39 28.9799 39 25.77C39 23.6699 38.1081 21.63 36.5025 20.16C36.6512 19.5299 36.7404 18.8999 36.7404 18.2701C36.7404 13.9802 33.2914 10.77 29.3072 10.77C28.5046 10.77 27.7315 10.8898 26.9585 11.16C25.6203 9.83994 23.7769 9 21.7552 9C18.1576 9 15.1548 11.5799 14.4707 15C11.1407 15.87 9 19.02 9 22.23C9 24.3301 9.89187 26.3699 11.4975 27.84C11.3488 28.47 11.2596 29.1001 11.2596 29.7299C11.2596 34.0198 14.7086 37.23 18.6927 37.23C19.4954 37.23 20.2685 37.1101 21.0415 36.8399C22.3794 38.16 24.2228 39 26.2447 39Z",
                fill: "black"
            })
        ]
    });
};
const $e7c1909c2cca938c$export$3b6b7db30cb5c9e7 = (agentName)=>$e7c1909c2cca938c$var$getVendorBrand(agentName.trim()) !== undefined;
const $e7c1909c2cca938c$export$df5614c444137531 = ({ agentName: agentName, fallback: fallback, size: size = $e7c1909c2cca938c$var$DEFAULT_AVATAR_SIZE })=>{
    const trimmedAgentName = agentName.trim();
    // TODO: COMMIT-30119 - Remove this vendor-name fallback once Identity supplies canonical agent avatars.
    const vendorBrand = $e7c1909c2cca938c$var$getVendorBrand(trimmedAgentName);
    if (vendorBrand === 'claude') return /*#__PURE__*/ (0, $8aG6j.jsx)($e7c1909c2cca938c$var$ClaudeIcon, {
        label: trimmedAgentName,
        size: size
    });
    if (vendorBrand === 'chatgpt') return /*#__PURE__*/ (0, $8aG6j.jsx)($e7c1909c2cca938c$var$OpenAiIcon, {
        label: trimmedAgentName,
        size: size
    });
    return fallback;
};


// per the styling standard's "no cross-file styles" rule.
const $bec308cf666f8943$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)'; // `Avatar` always draws a `space.025` margin around its own content (so avatars can sit flush in a
// group). Centering the agent avatar within `stack`'s exact `space.300` box cancels that margin out,
// so the visible hex icon — not `Avatar`'s larger margin box — lines up with `stack`'s edges.
const $bec308cf666f8943$var$styles = {
    stack: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0jFU0VNHnM _39xV02NHnM",
    userBadge: "_1mT5xdWVPG _1ZB6UyJ2Cl _1OKFqYJ2Cl _3iDTPbQ4SZ _1VJPca8SLj _0yKXXapeI4",
    vendorIconClip: "_1mT5xdRAKS _0jFU0VwOVE _39xV02wOVE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1uo2ZfTcEg"
}; /** Renders the compact Rovo identity used when no agent avatar is available. */ 
function $bec308cf666f8943$var$RovoIdentity() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bUd6P.RovoHexIcon), {
        label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
        size: "small"
    });
}
function $bec308cf666f8943$var$AuthorsTooltip({ agentName: agentName, children: children, userName: userName }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: userName ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardAuthorsTooltipLabel, {
            agentName: agentName,
            userName: userName
        }) : agentName,
        ignoreTooltipPointerEvents: true,
        position: "bottom",
        children: children
    });
} /** Renders the agent and user identities associated with a suggestion. */ 
function $bec308cf666f8943$export$17e466db07db7ac6({ agent: agent, user: user }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const agentName = agent?.name?.trim();
    const userName = user?.name?.trim();
    const validAgent = agent?.accountId && agentName ? {
        name: agentName,
        picture: agent.picture?.trim() || undefined
    } : undefined;
    const validUser = user?.accountId && userName ? {
        name: userName,
        picture: user.picture?.trim() || undefined
    } : undefined; // A vendor icon is a bare SVG, so `AvatarContent` has to draw the hexagon shape for it. A
    // backend-provided agent avatar brings its own via `Avatar`'s `src`/`appearance` props.
    // `borderColor="transparent"` drops the ring `Avatar` draws by default — the user avatar badge
    // now provides the only visual separation.
    const agentSlot = validAgent ? (0, $e7c1909c2cca938c$export$3b6b7db30cb5c9e7)(validAgent.name) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        appearance: "hexagon",
        borderColor: "transparent",
        label: validAgent.name,
        size: "small",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $bec308cf666f8943$var$styles.vendorIconClip
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e7c1909c2cca938c$export$df5614c444137531), {
                    agentName: validAgent.name,
                    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {})
                })
            })
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        appearance: "hexagon",
        borderColor: "transparent",
        label: validAgent.name,
        name: validAgent.name,
        size: "small",
        src: validAgent.picture
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        appearance: "hexagon",
        borderColor: "transparent",
        label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
        size: "small",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($bec308cf666f8943$var$RovoIdentity, {})
        })
    });
    const authorAvatars = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $bec308cf666f8943$var$styles.stack
        ]),
        children: [
            agentSlot,
            validUser && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-testid": "suggestion-agent-identity-user-badge",
                className: (0, $hekY6.default)([
                    $bec308cf666f8943$var$styles.userBadge
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                    label: validUser.name,
                    name: validUser.name,
                    size: "small",
                    src: validUser.picture
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($bec308cf666f8943$var$AuthorsTooltip, {
        agentName: validAgent?.name ?? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
        userName: validUser?.name,
        children: authorAvatars
    });
}


/* SuggestionCardSources.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $9EOlJ = parcelRequire("9EOlJ");








var $aZ9If = parcelRequire("aZ9If");







var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");


var $jdA6O = parcelRequire("jdA6O");

/* sourceApps.tsx generated by @compiled/babel-plugin v3.0.2 */ 





parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $9NPFC = parcelRequire("9NPFC");


var $ivSJV = parcelRequire("ivSJV");

const $10adb955dbb9cdfb$var$SOURCE_APP_NAMES = {
    bitbucket: 'Bitbucket',
    confluence: 'Confluence',
    goals: 'Goals',
    home: 'Home',
    jira: 'Jira',
    loom: 'Loom',
    projects: 'Projects',
    slack: 'Slack',
    teams: 'Teams'
};
/** Shared by every unattributed source so they collapse to a single globe in the app stack. */ const $10adb955dbb9cdfb$var$UNATTRIBUTED_KEY = 'unattributed'; /** Hosts whose URLs `getSourceType` may attribute to a named source app. */ 
const $10adb955dbb9cdfb$var$ATTRIBUTED_SOURCE_HOST = /(^|\.)(atlassian\.(net|com|cloud)|bitbucket\.org|loom\.com|slack\.com)$/u;
const $10adb955dbb9cdfb$var$LEADING_WWW = /^www\./u; /** Names an unattributed source by its host, which is the most we can say without resolving it. */ 
const $10adb955dbb9cdfb$var$getHostname = (url)=>{
    try {
        return new URL(url).hostname.replace($10adb955dbb9cdfb$var$LEADING_WWW, '');
    } catch  {
        return null;
    }
}; /** The app a source URL belongs to. Known source apps are attributed; the rest show a globe. */ 
const $10adb955dbb9cdfb$export$911a858a1d74cb31 = (url)=>{
    if (!url) return null;
    const hostname = $10adb955dbb9cdfb$var$getHostname(url);
    if (!hostname) return null;
     // `getSourceType` matches on substrings of the whole URL, so it reads any `/wiki/` path as
    // Confluence, any `/browse/` as Jira, and so on. Checking the host first keeps a link such as
    // `en.wikipedia.org/wiki/Penguin` from being attributed to a named source app.
    if ($10adb955dbb9cdfb$var$ATTRIBUTED_SOURCE_HOST.test(hostname)) {
        const sourceType = (0, $ivSJV.getSourceType)(url);
        if (sourceType !== 'unknown') return {
            key: sourceType,
            Logo: (0, $ivSJV.getLogoForSourceType)(sourceType),
            name: $10adb955dbb9cdfb$var$SOURCE_APP_NAMES[sourceType]
        };
    }
    return {
        key: $10adb955dbb9cdfb$var$UNATTRIBUTED_KEY,
        name: hostname
    };
};
const $10adb955dbb9cdfb$export$10542f0e75dbe131 = (sources)=>{
    // Keyed so each app is kept once. Re-setting a key holds its original position, which is how the
    // globe stays where the first unattributed source appeared once its name is known.
    const apps = new Map();
    const unattributedHosts = new Set();
    for (const { url: url } of sources ?? []){
        const app = $10adb955dbb9cdfb$export$911a858a1d74cb31(url);
        if (!app) continue;
        if (!app.Logo) unattributedHosts.add(app.name);
        if (!apps.has(app.key)) apps.set(app.key, app);
    }
    if (unattributedHosts.size > 0) apps.set($10adb955dbb9cdfb$var$UNATTRIBUTED_KEY, {
        key: $10adb955dbb9cdfb$var$UNATTRIBUTED_KEY,
        name: [
            ...unattributedHosts
        ].join(', ')
    });
    return [
        ...apps.values()
    ];
};
const $10adb955dbb9cdfb$var$styles = {
    logo: "_3iDTPbQ4SZ _26BoRwdnbC"
};
function $10adb955dbb9cdfb$export$12c0736d3fa492e9({ app: app, size: size }) {
    const { Logo: Logo } = app;
    if (Logo) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $10adb955dbb9cdfb$var$styles.logo
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Logo, {
            label: "",
            size: size
        })
    });
     // `Tile` has no `elevation.surface` background, so the tile is transparent over the card body.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        backgroundColor: "transparent",
        hasBorder: true,
        label: "",
        size: size,
        testId: "ai-suggestion-source-globe",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })
    });
}


const $cd2ba89ca6eab913$var$cardUiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    theme: (0, $4yYAm.SmartLinkTheme).Black
};
const $cd2ba89ca6eab913$var$styles = {
    sourcesContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _2mHwu82ADO _39xV02N91d _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    sourceLabel: "_1Znuxb8HPE _2Zuz6Q8HPE",
    sourceCard: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02N91d _24h04i2Njc _4ouGXIdnbC _4kiQYAkG2W _1Znuxb8HPE _2Zuz6Q8HPE",
    cardLoading: "_0fKRyPnQyn",
    skeletonOverlay: "_49OCfRPgdg _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
};
// without an ancestor <SmartCardProvider> (e.g. outside the editor), where the smart
// Card throws. Hoisted so the reference is stable across renders.
const $cd2ba89ca6eab913$var$renderNoSources = ()=>null; /** Skeleton stand-in for the card's title and footer while the URL resolves. */ 
function $cd2ba89ca6eab913$var$SourceSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $cd2ba89ca6eab913$var$styles.skeletonOverlay
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
            width: "65%",
            height: 12,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })
    });
}
function $cd2ba89ca6eab913$var$SourceCard({ url: url }) {
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('loading');
    const handleResolve = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setStatus('resolved'), []);
    const handleError = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setStatus('errored'), []);
    if (status === 'errored') return null;
    const app = (0, $10adb955dbb9cdfb$export$911a858a1d74cb31)(url);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    status === 'loading' && $cd2ba89ca6eab913$var$styles.cardLoading
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                    appearance: "inline",
                    ui: $cd2ba89ca6eab913$var$cardUiOptions,
                    url: url,
                    onResolve: handleResolve,
                    onError: handleError,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jdA6O.TitleBlock), {
                        maxLines: 1,
                        icon: app ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10adb955dbb9cdfb$export$12c0736d3fa492e9), {
                            app: app,
                            size: "xxsmall"
                        }) : undefined
                    })
                })
            }),
            status === 'loading' && /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SourceSkeleton, {})
        ]
    });
}
function $cd2ba89ca6eab913$var$SuggestionCardSourcesInner({ sources: sources }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // The backend supplies the URL, so a source without one can't be linked to and is
    // dropped — even when it has an ARI. De-duplicated so the same URL sent twice doesn't
    // render two identical cards.
    const urls = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const unique = new Set();
        for (const { url: url } of sources)if (url) unique.add(url);
        return Array.from(unique);
    }, [
        sources
    ]);
    if (urls.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $cd2ba89ca6eab913$var$styles.sourcesContainer
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                xcss: $cd2ba89ca6eab913$var$styles.sourceLabel,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
                        label: "",
                        size: "medium",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "span",
                        color: "color.text.subtle",
                        size: "medium",
                        weight: "medium",
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).teamworkGraphLabel)
                    })
                ]
            }),
            urls.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $cd2ba89ca6eab913$var$styles.sourceCard
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SourceCard, {
                        url: url
                    })
                }, url))
        ]
    });
} /** Displays the resolvable sources associated with a suggestion. */ 
function $cd2ba89ca6eab913$export$bedb00e2a4ac3f71({ sources: sources }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: $cd2ba89ca6eab913$var$renderNoSources,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SuggestionCardSourcesInner, {
            sources: sources
        })
    });
}


















var $8EgKx = parcelRequire("8EgKx");


const $fc031696110d746a$export$387983f036737d8 = 'ai-suggestion-source-app-stack';
/**
 * Caps how many logos are shown. The design shows two; a third leaves room for a genuinely
 * multi-app suggestion without the stack crowding the Details row it shares with the
 * Restricted lozenge.
 */ const $fc031696110d746a$var$MAX_VISIBLE_APPS = 3;
/** Binds an icon to its app for `AppStack`, cached by key so the component identity stays stable. */ const $fc031696110d746a$var$iconCache = new Map();
const $fc031696110d746a$var$getAppStackIcon = (app)=>{
    const cached = $fc031696110d746a$var$iconCache.get(app.key);
    if (cached) return cached;
    const Icon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $10adb955dbb9cdfb$export$12c0736d3fa492e9), {
            app: app,
            size: "xsmall"
        });
    Icon.displayName = `${app.key}AppStackIcon`;
    $fc031696110d746a$var$iconCache.set(app.key, Icon);
    return Icon;
};
function $fc031696110d746a$export$38ea68c086fb8e7d({ sources: sources }) {
    const { formatList: formatList, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sourceApps = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $10adb955dbb9cdfb$export$10542f0e75dbe131)(sources), [
        sources
    ]);
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>sourceApps.map((app)=>({
                component: $fc031696110d746a$var$getAppStackIcon(app),
                label: ''
            })), [
        sourceApps
    ]);
    if (data.length === 0) return null;
    const sourceAppsLabel = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardSourceAppsTooltip, {
        apps: formatList(sourceApps.map(({ name: name })=>name))
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: sourceAppsLabel,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8EgKx.default), {
            data: data,
            // `xsmall` is the design's 20px tile, and gives the -4px overlap it shows.
            size: "xsmall",
            maxCount: $fc031696110d746a$var$MAX_VISIBLE_APPS,
            label: sourceAppsLabel,
            testId: $fc031696110d746a$export$387983f036737d8
        })
    });
}


const $1bd78593134dbc9f$export$302061637fb228b9 = 'ai-suggestion-card';
const $1bd78593134dbc9f$var$tooltipAbove = {
    position: 'top'
};
// Shimmer applied to the description while the suggestion is regenerating.
// Copied from rovo-platform-ui-components' ShimmerText so we don't couple to it.
const $1bd78593134dbc9f$var$shimmerAnimation = null;
const $1bd78593134dbc9f$var$shimmerGradient = null;
const $1bd78593134dbc9f$var$styles = {
    sourceButton: "_2mHwu8gVvo _3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _1ZnuxbPgdg _2Zuz6QPgdg _1UtDYzZpcK _24bGaTot27",
    detailsContainer: "_0bjKvD8fU6 _4c065U8HPE _39xV02N91d _0KLXrumhAQ _3CkH9oJW0e _3OqcjTzSkR _1DJ2rVEHne",
    reasoningContent: "_1Znuxb8HPE _2Zuz6Q8HPE",
    card: "_0bjKvDyzSk _2mHwu85zaO _3vBAKHxCOs _3hxITi6wH8 _2V7sgOmVJw _1mT5xdRAKS _0KLXruwawV _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _2OUyjtGk8v _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc",
    privateMetadata: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    restrictedMetadata: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _0wOv4Q18ZR _3iDTPbQ4SZ",
    restrictedContent: "_0hPCNLDIqT _17lj8pPgdg _3iDTPbkfkE _2iEGP2emYi _2xTnZxt7Uv _0GTcwRt7Uv _3Z9K0wLrT7 _1kOSYtLM0u _0qk6IKxt7V _1RrJLit2nV",
    restrictedContentExpanded: "_17lj8p1Y8M _2iEGP2cMcx _2xTnZxPgdg _0GTcwRPgdg",
    restrictedLabel: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIPgdg _1YKVNsdnbC _3Z9K0wLrT7 _1kOSYt9v2r _0qk6IKjwM9 _1ANEUSLRg7",
    restrictedLabelExpanded: "_1YKVNs7dHp",
    reasoningHeader: "_39xV02N91d"
};
const $1bd78593134dbc9f$export$5864b77b647e728c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function SuggestionCard({ banner: banner, onAccept: onAccept, onDiscard: onDiscard, onDismiss: onDismiss, onGoodSuggestion: onGoodSuggestion, onBadSuggestion: onBadSuggestion, onNavigate: onNavigate, onReasoningViewed: onReasoningViewed, onClose: onClose, onShowSidebar: onShowSidebar, onToggleDeletedDiffs: onToggleDeletedDiffs, isHidingDeletedDiffs: isHidingDeletedDiffs, isRegenerating: isRegenerating = false, showComparisonButton: showComparisonButton = false, suggestion: suggestion }, ref) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSourcesExpanded, setIsSourcesExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isRestrictedHovered, setIsRestrictedHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const handleSourcesToggle = (0, $cozmU.useCallback)(()=>{
        if (!isSourcesExpanded) onReasoningViewed?.();
        setIsSourcesExpanded((previous)=>!previous);
    }, [
        isSourcesExpanded,
        onReasoningViewed
    ]);
    const renderMoreOptionsTrigger = (0, $cozmU.useCallback)(({ triggerRef: triggerRef, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            ref: triggerRef,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            isDisabled: isRegenerating,
            isSelected: isSelected,
            onClick: onClick,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
            label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardMoreOptionsButtonLabel),
            isTooltipDisabled: false,
            tooltip: $1bd78593134dbc9f$var$tooltipAbove,
            appearance: "subtle",
            spacing: "default"
        }), [
        formatMessage,
        isRegenerating
    ]); // `IconButton` already renders its `label` as both the accessible name and the
    // tooltip, so these icons are decorative.
    const ChevronUpSmall = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: "",
            size: "small"
        });
    }, []);
    const ChevronDownSmall = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        });
    }, []);
    const isInsight = suggestion.actionKind === 'INFORMATIONAL'; // An out-of-date suggestion can no longer be safely applied — only discard.
    const isStale = suggestion.status === 'STALE'; // The restricted lozenge warns that the suggestion's sources aren't visible to
    // every editor, so it's only meaningful when the suggestion has sources.
    const hasSources = !!suggestion.sources?.length;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: ref,
        "data-testid": $1bd78593134dbc9f$export$302061637fb228b9,
        "data-suggestion-id": suggestion.id,
        className: (0, $hekY6.default)([
            $1bd78593134dbc9f$var$styles.card
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.0",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: ChevronUpSmall,
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardPreviousSuggestionButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('up') : undefined
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: ChevronDownSmall,
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardNextSuggestionButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('down') : undefined
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            onShowSidebar && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardShowSidebarButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                onClick: onShowSidebar
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardCloseButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }),
            banner,
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                children: [
                    isRegenerating ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            as: "p",
                            size: "medium",
                            weight: "medium",
                            color: isRegenerating ? 'color.text.disabled' : 'color.text.subtlest',
                            children: suggestion.description
                        })
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        size: "medium",
                        weight: "medium",
                        color: "color.text",
                        children: suggestion.description
                    }),
                    suggestion.reasoning && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        alignItems: "start",
                        direction: "column",
                        gap: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                xcss: $1bd78593134dbc9f$var$styles.reasoningHeader,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                                        xcss: $1bd78593134dbc9f$var$styles.sourceButton,
                                        onClick: handleSourcesToggle,
                                        isDisabled: isRegenerating,
                                        "aria-expanded": isSourcesExpanded,
                                        children: [
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                size: "medium",
                                                weight: "medium",
                                                color: "inherit",
                                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDetailsButtonLabel)
                                            }),
                                            isSourcesExpanded ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                                                label: "",
                                                size: "small"
                                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                                                label: "",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    hasSources && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                        space: "space.050",
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                                className: (0, $hekY6.default)([
                                                    $1bd78593134dbc9f$var$styles.privateMetadata
                                                ]),
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                                                    position: "top",
                                                    content: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRestrictedTooltipLabel),
                                                    ignoreTooltipPointerEvents: true,
                                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                                        "data-testid": "ai-suggestion-card-restricted",
                                                        onMouseEnter: ()=>setIsRestrictedHovered(true),
                                                        onMouseLeave: ()=>setIsRestrictedHovered(false),
                                                        onFocus: ()=>setIsRestrictedHovered(true),
                                                        onBlur: ()=>setIsRestrictedHovered(false),
                                                        className: (0, $hekY6.default)([
                                                            $1bd78593134dbc9f$var$styles.restrictedMetadata
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aCJyI.default), {
                                                            appearance: "neutral",
                                                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                                                                className: (0, $hekY6.default)([
                                                                    $1bd78593134dbc9f$var$styles.restrictedContent,
                                                                    isRestrictedHovered && $1bd78593134dbc9f$var$styles.restrictedContentExpanded
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
                                                                        label: "",
                                                                        size: "small",
                                                                        color: "var(--ds-icon-subtle, #505258)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                                                        className: (0, $hekY6.default)([
                                                                            $1bd78593134dbc9f$var$styles.restrictedLabel,
                                                                            isRestrictedHovered && $1bd78593134dbc9f$var$styles.restrictedLabelExpanded
                                                                        ]),
                                                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                                            as: "span",
                                                                            color: "inherit",
                                                                            size: "small",
                                                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRestrictedLabel)
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc031696110d746a$export$38ea68c086fb8e7d), {
                                                sources: suggestion.sources
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isSourcesExpanded && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                                xcss: $1bd78593134dbc9f$var$styles.detailsContainer,
                                space: "space.250",
                                testId: "ai-suggestion-card-details",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                        className: (0, $hekY6.default)([
                                            $1bd78593134dbc9f$var$styles.reasoningContent
                                        ]),
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                            as: "p",
                                            color: "color.text",
                                            children: suggestion.reasoning
                                        })
                                    }),
                                    !!suggestion?.sources?.length && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cd2ba89ca6eab913$export$bedb00e2a4ac3f71), {
                                        sources: suggestion.sources
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                alignItems: "center",
                justifyContent: "space-between",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bec308cf666f8943$export$17e466db07db7ac6), {
                        agent: suggestion.createdByAgent,
                        user: suggestion.createdByUser
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            !isInsight && (onToggleDeletedDiffs || onGoodSuggestion || onBadSuggestion) && (showComparisonButton && onToggleDeletedDiffs ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                        icon: isHidingDeletedDiffs ? (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))) : (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
                                        label: formatMessage(isHidingDeletedDiffs ? (0, $gVCFw.aiSuggestionsMessages).cardShowDeletedDiffsLabel : (0, $gVCFw.aiSuggestionsMessages).cardHideDeletedDiffsLabel),
                                        appearance: "subtle",
                                        spacing: "compact",
                                        isDisabled: isRegenerating,
                                        onClick: onToggleDeletedDiffs
                                    }),
                                    (onGoodSuggestion || onBadSuggestion) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                                        placement: "bottom-end",
                                        trigger: renderMoreOptionsTrigger,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
                                            children: [
                                                onGoodSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                    elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                                                        label: ""
                                                    }),
                                                    onClick: onGoodSuggestion,
                                                    children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardGoodSuggestionLabel)
                                                }),
                                                onBadSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                    elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                                                        label: ""
                                                    }),
                                                    onClick: onBadSuggestion,
                                                    children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardBadSuggestionLabel)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                                placement: "bottom-end",
                                trigger: renderMoreOptionsTrigger,
                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
                                    children: [
                                        onToggleDeletedDiffs && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default // The same icon in both states: the item's label already says which
                                        ), {
                                            // way the toggle goes, so a changing icon just adds noise.
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                                                label: ""
                                            }),
                                            onClick: onToggleDeletedDiffs,
                                            children: isHidingDeletedDiffs ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardShowDeletedDiffsLabel) : formatMessage((0, $gVCFw.aiSuggestionsMessages).cardHideDeletedDiffsLabel)
                                        }),
                                        onGoodSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                                                label: ""
                                            }),
                                            onClick: onGoodSuggestion,
                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardGoodSuggestionLabel)
                                        }),
                                        onBadSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                                                label: ""
                                            }),
                                            onClick: onBadSuggestion,
                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardBadSuggestionLabel)
                                        })
                                    ]
                                })
                            })),
                            isInsight ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                onClick: onDismiss,
                                isDisabled: isRegenerating,
                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDismissButtonLabel)
                            }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                        appearance: isStale ? 'primary' : 'subtle',
                                        onClick: onDiscard,
                                        isDisabled: isRegenerating,
                                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDiscardButtonLabel)
                                    }),
                                    !isStale && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        isDisabled: isRegenerating,
                                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardAcceptButtonLabel)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});


// render at its anchor while the card is still there.
const $d79d0d9956135474$var$SUGGESTED_REMIX_NAVIGATE_DELAY_MS = 2000; /**
                                                 * We render this in a content component because rendering directly in a Decoration widget
                                                 * will cause it to inherit font stylings from Editor which is not appropriate for this component.
                                                 */ 
const $d79d0d9956135474$export$b9f1c5d82af9ea41 = ({ api: api, onShowSidebar: onShowSidebar, view: view })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const navigationTimeoutRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>()=>clearTimeout(navigationTimeoutRef.current), []);
    const suggestedEditsDefaultOn = (0, $cozmU.useMemo)(()=>(0, $295ac436451fb879$export$ef2b3f5e81ffeef8)(), []);
    const [isHidingDeletedDiffs, setIsHidingDeletedDiffs] = (0, $cozmU.useState)(suggestedEditsDefaultOn); // Positioning-critical slice — kept synchronous (no debounce) so the CSS-anchor references
    // stay in lock-step with the ProseMirror transaction that swapped the selection.
    const { selectedSuggestion: selectedSuggestion, baseLocalId: baseLocalId } = (0, $3ff3f4249608fe22$export$12e742fdeff6e7ba)(api); // Reset the toggle to the experiment default whenever the selected suggestion changes.
    (0, $cozmU.useEffect)(()=>{
        setIsHidingDeletedDiffs(suggestedEditsDefaultOn);
    }, [
        selectedSuggestion?.id,
        suggestedEditsDefaultOn
    ]);
    const anchorLocalId = selectedSuggestion ? (0, $c08510c480bfb65f$export$e644b4e6be3487e)(selectedSuggestion) : undefined;
    const anchorEndLocalId = selectedSuggestion ? (0, $c08510c480bfb65f$export$f5640f1db7cc9e30)(selectedSuggestion) : undefined;
    const { orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden, regeneratingSuggestionIds: regeneratingSuggestionIds } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>{
        const { orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden, regeneratingSuggestionIds: regeneratingSuggestionIds } = state?.aiSuggestionsState ?? {};
        return {
            orderedSuggestionIds: orderedSuggestionIds,
            // View mode is a hard override: never show the suggestion card while read-only.
            isHidden: (isHidden ?? false) || state?.editorViewModeState?.mode === 'view',
            regeneratingSuggestionIds: regeneratingSuggestionIds
        };
    });
    // Checked against the synced `selectedSuggestion.id` (not the debounced plugin
    // state's own `selectedSuggestion`) so this always reflects the suggestion
    // actually being rendered — otherwise a quick navigation away from a
    // regenerating suggestion can transiently attribute its regenerating status to
    // whichever suggestion is selected next.
    const isRegenerating = selectedSuggestion ? regeneratingSuggestionIds?.has(selectedSuggestion.id) ?? false : false;
    const regenerationStatus = (0, $e40b4e35496d16c5$export$4cbf498e35d8c873)(selectedSuggestion, isRegenerating);
    const banner = regenerationStatus ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59fa28a6d850aa68$export$fcf9195d8c4d40ff), {
        status: regenerationStatus
    }) : undefined;
    const anchorNames = (0, $cozmU.useMemo)(()=>({
            start: `--card-${anchorLocalId}-start`,
            end: `--card-${anchorEndLocalId}-end`,
            // Emitted only for targets whose primary anchors sit inside them, where the diff can
            // hide the anchor. Naming them unconditionally is harmless: `anchor()` treats an
            // unmatched name as invalid, exactly as it treats the primary when that is the one
            // missing, so the chain still resolves to the primary.
            outerStart: `--card-${anchorLocalId}-outer-start`,
            outerEnd: `--card-${anchorEndLocalId}-outer-end`,
            base: `--button-${baseLocalId}`
        }), [
        anchorEndLocalId,
        anchorLocalId,
        baseLocalId
    ]);
    const onScrollBackClick = (0, $cozmU.useCallback)(()=>{
        if (!selectedSuggestion) return;
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id, {
            hideDeletedDiffs: isHidingDeletedDiffs
        });
    }, [
        api,
        isHidingDeletedDiffs,
        selectedSuggestion
    ]);
    const onToggleDeletedDiffs = (0, $cozmU.useCallback)(()=>{
        if (!selectedSuggestion) return;
        const updatedHideDeletedDiffs = !isHidingDeletedDiffs;
        setIsHidingDeletedDiffs(updatedHideDeletedDiffs);
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id, {
            hideDeletedDiffs: updatedHideDeletedDiffs,
            scrollIntoView: false
        });
    }, [
        api,
        isHidingDeletedDiffs,
        selectedSuggestion
    ]);
    if (selectedSuggestion === undefined || isHidden) return;
    const onClose = ()=>{
        api?.aiSuggestions?.actions.selectSuggestion(null, {
            interactionPoint: 'card'
        });
    };
    const onDiscard = ()=>{
        api?.aiSuggestions?.actions.discardSuggestion(selectedSuggestion.id, 'card'); // navigate to the next suggestion
        onNavigate('down');
    };
    const onAccept = ()=>{
        api?.aiSuggestions?.actions.acceptSuggestion(selectedSuggestion.id, 'card', isHidingDeletedDiffs);
        if (selectedSuggestion.actionKind === 'SUGGESTED_REMIX') {
            // Give the remix a beat to appear at the anchor before the card jumps to the next suggestion.
            navigationTimeoutRef.current = setTimeout(()=>onNavigate('down'), $d79d0d9956135474$var$SUGGESTED_REMIX_NAVIGATE_DELAY_MS);
            return;
        }
        const shimmerDuration = api?.aiSuggestions?.sharedState.currentState()?.acceptShimmerDuration ?? 0;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_ai_content_suggested_edits_labs') && shimmerDuration > 0) {
            navigationTimeoutRef.current = setTimeout(()=>onNavigate('down'), shimmerDuration);
            return;
        } // navigate to the next suggestion
        onNavigate('down');
    };
    const onDismiss = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            return tr;
        });
        onNavigate('down');
    };
    const onGoodSuggestion = ()=>{
        api?.aiSuggestions?.actions.submitSuggestionFeedback(selectedSuggestion.id, 'good', {
            interactionPoint: 'card'
        });
    };
    const onBadSuggestion = ()=>{
        api?.aiSuggestions?.actions.submitSuggestionFeedback(selectedSuggestion.id, 'bad', {
            interactionPoint: 'card'
        });
    };
    const onReasoningViewed = ()=>{
        (0, $2a4bc64013915ea2$export$22bc65b38809466)(api?.analytics?.actions, selectedSuggestion, 'card');
    };
    const onNavigate = (direction)=>{
        const currentId = selectedSuggestion.id;
        if (!orderedSuggestionIds || orderedSuggestionIds?.length === 0) return undefined;
        const idx = orderedSuggestionIds.indexOf(currentId);
        if (idx === -1) return undefined;
        const delta = direction === 'up' ? -1 : 1;
        const nextIdx = (idx + delta + orderedSuggestionIds.length) % orderedSuggestionIds.length;
        const nextId = orderedSuggestionIds[nextIdx]; // When only one suggestion exists, the modulo wraps back to the current id.
        // Skip navigation in that case so we don't re-select the suggestion that's about to be removed.
        if (nextId === currentId) return undefined;
        api?.aiSuggestions?.actions.selectSuggestion(nextId, {
            interactionPoint: 'card'
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b79c09504f84e6ab$export$8f339c4f2834aeec // Remounts when a different suggestion is opened, which replays the fade-in — the
    ), {
        anchorNames: anchorNames,
        cardRef: cardRef,
        onScrollBack: onScrollBackClick,
        targetId: baseLocalId,
        targetLocalId: anchorLocalId,
        view: view,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1bd78593134dbc9f$export$5864b77b647e728c), {
            ref: cardRef,
            suggestion: selectedSuggestion,
            onNavigate: orderedSuggestionIds && orderedSuggestionIds.length > 1 ? onNavigate : undefined,
            onClose: onClose,
            onDiscard: onDiscard,
            onDismiss: onDismiss,
            onAccept: onAccept,
            onGoodSuggestion: onGoodSuggestion,
            onBadSuggestion: onBadSuggestion,
            onReasoningViewed: onReasoningViewed,
            onShowSidebar: onShowSidebar,
            onToggleDeletedDiffs: onToggleDeletedDiffs,
            isHidingDeletedDiffs: isHidingDeletedDiffs,
            isRegenerating: isRegenerating,
            showComparisonButton: suggestedEditsDefaultOn,
            banner: banner
        })
    }, selectedSuggestion.id);
};


/* SuggestionRightSurfaceButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















function $6b167ecb058e19e8$export$6c43944391554e2e(suggestionIds, suggestionById) {
    const profilesByAccountId = new Map();
    for (const suggestionId of suggestionIds ?? []){
        const suggestion = suggestionById?.get(suggestionId);
        if (!suggestion) continue;
        const agent = suggestion.createdByAgent ?? undefined;
        if (!profilesByAccountId.has(agent?.accountId)) profilesByAccountId.set(agent?.accountId, {
            profile: agent
        });
    }
    return Array.from(profilesByAccountId.values());
}


/* SuggestionAvatarIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $9Ke0t = parcelRequire("9Ke0t");




/* SuggestionAvatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");











const $fb1ab760787ae2e9$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $fb1ab760787ae2e9$var$styles = {
    avatarRingWrapper: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V5zaO _39xV025zaO",
    agentAvatarRing: "_49OCfRpgTj _1mT5xdWVPG _42Yu6BdnbC _0KLXruxCOs _1uo2ZfTcEg",
    avatarRingContent: "_1mT5xdRAKS _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V5zaO _39xV025zaO _4ya3eEdnbC",
    vendorIconClip: "_1mT5xdRAKS _0jFU0VwOVE _39xV02wOVE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1uo2ZfTcEg"
};
function $fb1ab760787ae2e9$export$6fb32e417ef0be07({ profile: profile }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        className: (0, $hekY6.default)([
            $fb1ab760787ae2e9$var$styles.avatarRingWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $fb1ab760787ae2e9$var$styles.agentAvatarRing
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $fb1ab760787ae2e9$var$styles.avatarRingContent
                ]),
                children: profile ? (0, $e7c1909c2cca938c$export$3b6b7db30cb5c9e7)(profile.name) ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        $fb1ab760787ae2e9$var$styles.vendorIconClip
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e7c1909c2cca938c$export$df5614c444137531), {
                        agentName: profile.name,
                        size: 16,
                        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {})
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                    imageUrl: profile.picture?.trim() || undefined,
                    agentIdentityAccountId: profile.accountId,
                    name: profile.name,
                    label: profile.name,
                    size: "xxsmall",
                    showBorder: false
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bUd6P.RovoHexIcon), {
                    size: "xxsmall"
                })
            })
        ]
    });
}


// `indicatorBase`'s width below, so this real flex item grows and pushes sibling right-surface
// controls instead of overlapping them.
const $d31faf014d0f6436$var$avatarCountVar = '--suggestion-avatar-count';
const $d31faf014d0f6436$var$MAX_VISIBLE_AVATARS = 3; // Shared by `indicatorActive` and `avatarStackPillRevealed` below — the container and the pill
// must grow by the exact same formula, or the pill overflows its flex slot.
const $d31faf014d0f6436$var$stackWidthCalc = `calc(${"var(--ds-space-300, 24px)"} + ${"var(--ds-space-150, 12px)"} * (var(${$d31faf014d0f6436$var$avatarCountVar}, 1) - 1))`;
const $d31faf014d0f6436$var$avatarStackPillRevealTransition = `opacity ${"var(--ds-duration-xshort, 100ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}, width ${"var(--ds-duration-medium, 200ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`;
const $d31faf014d0f6436$var$styles = {
    indicatorBase: "_23rrnHvplL _1mT5xdRAKS _3iDTPbvLZJ _0jFU0VNHnM _39xV02NHnM",
    indicatorActive: "_39xV02BS27",
    iconLayer: "_49OCfRdnbC _23rrnHbMfy _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1YKVNs7dHp",
    iconLayerHidden: "_1YKVNsdnbC",
    avatarStackPillWrapper: "_23rrnHvUpb _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _24h04i2Njc _0jFU0VNHnM _39xV02NHnM _1YKVNsdnbC",
    avatarStackPillWrapperRevealed: "_1YKVNs7dHp _39xV02BS27",
    avatarStackPill: "_30huDKYbGa _0bjKvDS5Zs _2sNsIgOLYo _4c065UgVvo _2Y7lL4gVvo _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VN91d _39xV02N91d _0KLXruwawV _0wOv4Q7zJH",
    avatarStackPillInteractive: "_23rrnHyKLB _1eOmH6rWzL _3fSdSTFYNq _3sFUREiSCN _3gzVzLgE2d",
    avatarStackRow: "_3iDTPbQ4SZ _0hPCNLDIqT _2YgrGrP0S5",
    avatar: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0jFU0V8HPE _39xV028HPE",
    avatarSlide: "_23rrnHdEki"
};
const $d31faf014d0f6436$var$AnimatedIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $d31faf014d0f6436$var$styles.iconLayer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        })
    });
function $d31faf014d0f6436$export$a3ce2c0cf1a02890({ isActive: isActive, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, profiles: profiles, tooltip: tooltip }) {
    // Hovering/focusing this icon directly also reveals the stack, on top of `isActive`.
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const showAvatars = (isActive || isHovered) && profiles.length > 0;
    const visibleProfiles = profiles.slice(0, $d31faf014d0f6436$var$MAX_VISIBLE_AVATARS);
    const containerRef = (0, $cozmU.useRef)(null); // `@atlaskit/tooltip` only flips vertically for viewport overflow, not horizontally — so a
    // bubble near the right edge still gets cropped. We measure the trigger ourselves and switch
    // our requested alignment from 'start' to 'end' to work around that.
    const [horizontalAlign, setHorizontalAlign] = (0, $cozmU.useState)('start');
    const measureHorizontalAlign = (0, $cozmU.useCallback)(()=>{
        const node = containerRef.current;
        if (!node) return;
         // Matches `SuggestionTooltip`'s `maxWidth`.
        const tooltipMaxWidth = 240;
        const { left: left } = node.getBoundingClientRect();
        setHorizontalAlign(left + tooltipMaxWidth > window.innerWidth ? 'end' : 'start');
    }, []);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        measureHorizontalAlign();
        setIsHovered(true);
        onMouseEnter?.();
    }, [
        measureHorizontalAlign,
        onMouseEnter
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onMouseLeave?.();
    }, [
        onMouseLeave
    ]);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        measureHorizontalAlign();
        setIsHovered(true);
        onFocus?.();
    }, [
        measureHorizontalAlign,
        onFocus
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onBlur?.();
    }, [
        onBlur
    ]);
    const resolvedTooltip = (0, $cozmU.useMemo)(()=>{
        const verticalSide = typeof tooltip.position === 'string' ? tooltip.position.split('-')[0] : 'top';
        return {
            ...tooltip,
            position: `${verticalSide}-${horizontalAlign}`
        };
    }, [
        tooltip,
        horizontalAlign
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        ref: containerRef,
        style: {
            [$d31faf014d0f6436$var$avatarCountVar]: visibleProfiles.length || 1
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        className: (0, $hekY6.default)([
            $d31faf014d0f6436$var$styles.indicatorBase,
            showAvatars && $d31faf014d0f6436$var$styles.indicatorActive
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    pointerEvents: showAvatars ? 'none' : 'auto'
                },
                className: (0, $hekY6.default)([
                    $d31faf014d0f6436$var$styles.iconLayer,
                    showAvatars && $d31faf014d0f6436$var$styles.iconLayerHidden
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    isTooltipDisabled: false,
                    tooltip: resolvedTooltip,
                    shape: "circle",
                    type: "button",
                    label: label,
                    onClick: onClick,
                    appearance: "subtle",
                    spacing: "compact",
                    icon: $d31faf014d0f6436$var$AnimatedIcon
                })
            }),
            profiles.length > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    pointerEvents: showAvatars ? 'auto' : 'none'
                },
                className: (0, $hekY6.default)([
                    $d31faf014d0f6436$var$styles.avatarStackPillWrapper,
                    showAvatars && $d31faf014d0f6436$var$styles.avatarStackPillWrapperRevealed
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: resolvedTooltip.content ?? label,
                    position: resolvedTooltip.position,
                    component: resolvedTooltip.component,
                    delay: resolvedTooltip.delay,
                    ignoreTooltipPointerEvents: resolvedTooltip.ignoreTooltipPointerEvents,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                        type: "button",
                        onClick: onClick,
                        "aria-label": label,
                        className: (0, $hekY6.default)([
                            $d31faf014d0f6436$var$styles.avatarStackPill,
                            $d31faf014d0f6436$var$styles.avatarStackPillInteractive
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $d31faf014d0f6436$var$styles.avatarStackRow
                            ]),
                            children: visibleProfiles.map((avatarProfile, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    style: {
                                        // Earlier avatars stack in front of later ones.
                                        zIndex: visibleProfiles.length - index,
                                        // Hidden: each avatar slides left by index * 12px (its slot width),
                                        // stacking on avatar 0. Revealed: no offset, natural flex position.
                                        transform: `translateX(${showAvatars ? 0 : -index * 12}px)`
                                    },
                                    className: (0, $hekY6.default)([
                                        $d31faf014d0f6436$var$styles.avatar,
                                        $d31faf014d0f6436$var$styles.avatarSlide
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fb1ab760787ae2e9$export$6fb32e417ef0be07), {
                                        profile: avatarProfile.profile
                                    })
                                }, avatarProfile.profile?.accountId ?? index))
                        })
                    })
                })
            })
        ]
    });
}


/* SuggestionTooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $1B9Aq = parcelRequire("1B9Aq");

const $ba4ab5594767adb9$var$styles = {
    base: "_2mHwu82ADO _2sNsIg7NXe _2V7sgONvrM _3hxITi6wH8 _3vBAKHxCOs _4c065U2ADO _2Y7lL48HPE _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1EqgXlGVdc _0KLXrugozt _2OUyjtFYNq _1UtDYze5R3 _3zvHkHwPeg _1T2N03wPeg",
    notchBottomLeft: "_2C2kUQyzSk _1Lz9loyzSk _3XDz3ByzSk _1v9SsVKxmn",
    notchBottomRight: "_2C2kUQyzSk _1Lz9loyzSk _3XDz3BKxmn _1v9SsVyzSk",
    notchTopLeft: "_2C2kUQKxmn _1Lz9loyzSk _3XDz3ByzSk _1v9SsVyzSk",
    notchTopRight: "_2C2kUQyzSk _1Lz9loKxmn _3XDz3ByzSk _1v9SsVyzSk"
};
const $ba4ab5594767adb9$export$faf6d8e1d1b7acad = /*#__PURE__*/ (0, $cozmU.forwardRef)(function SuggestionTooltip({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const isBelowTrigger = placement?.startsWith('bottom');
    const isEndAligned = placement?.endsWith('end');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1B9Aq.default), {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            $ba4ab5594767adb9$var$styles.base,
            !isBelowTrigger && !isEndAligned && $ba4ab5594767adb9$var$styles.notchBottomLeft,
            !isBelowTrigger && isEndAligned && $ba4ab5594767adb9$var$styles.notchBottomRight,
            isBelowTrigger && !isEndAligned && $ba4ab5594767adb9$var$styles.notchTopLeft,
            isBelowTrigger && isEndAligned && $ba4ab5594767adb9$var$styles.notchTopRight,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});


const $92877f9d742eca51$var$styles = {
    container: "_1mT5xdRAKS _1pp6NdYsOL"
};
function $92877f9d742eca51$export$509594734c522b9c({ api: api, surfaceContext: surfaceContext }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const localId = context?.targetNode.node.attrs?.localId; // True while block-controls has this block (or a node nested inside it, e.g. a paragraph in
    // a panel) as the active node.
    const isBlockActive = Boolean(context?.activeNode && context.rootNode.pos === context.targetNode.pos); // Derived primitives (rather than the state maps) so the hook's shallow
    // equality check can skip re-renders that don't affect this button.
    const { firstSuggestionId: firstSuggestionId, isAnySuggestionSelected: isAnySuggestionSelected, isSelected: isSelected, isViewMode: isViewMode, profiles: profiles, shortDescription: shortDescription, suggestionsCount: suggestionsCount } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>{
        const { suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, suggestionById: suggestionById, selectedSuggestion: selectedSuggestion } = state?.aiSuggestionsState ?? {};
        const suggestionIds = localId ? suggestionIdsByBaseLocalId?.get(localId) : undefined;
        const firstSuggestionId = suggestionIds?.values().next().value;
        return {
            firstSuggestionId: firstSuggestionId,
            isAnySuggestionSelected: Boolean(selectedSuggestion),
            isSelected: Boolean(selectedSuggestion && suggestionIds?.has(selectedSuggestion)),
            isViewMode: state?.editorViewModeState?.mode === 'view',
            profiles: (0, $6b167ecb058e19e8$export$6c43944391554e2e)(suggestionIds, suggestionById),
            shortDescription: firstSuggestionId ? suggestionById?.get(firstSuggestionId)?.shortDescription : undefined,
            suggestionsCount: suggestionIds?.size ?? 0
        };
    });
    // `SuggestionAvatarIndicator` ORs in one more trigger (hovering the icon directly), so it
    // only needs this single combined boolean from here.
    const isActive = isAnySuggestionSelected || isBlockActive;
    const isSelectingSuggestionRef = (0, $cozmU.useRef)(false);
    const onSelectSuggestion = (0, $cozmU.useCallback)(()=>{
        if (isSelectingSuggestionRef.current) return;
        isSelectingSuggestionRef.current = true;
        const selectSuggestion = async ()=>{
            try {
                const canCloseComment = await api?.annotation?.actions.requestCloseInlineComment?.() ?? true;
                if (!canCloseComment || !firstSuggestionId) return;
                api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId, {
                    interactionPoint: 'card'
                });
            } finally{
                isSelectingSuggestionRef.current = false;
            }
        };
        selectSuggestion();
    }, [
        api,
        firstSuggestionId
    ]);
    const setHoveredSuggestion = (0, $cozmU.useCallback)((id)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'HOVER_SUGGESTION',
                id: id
            });
            return tr;
        });
    }, [
        api
    ]);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(firstSuggestionId), [
        setHoveredSuggestion,
        firstSuggestionId
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(undefined), [
        setHoveredSuggestion
    ]);
    const onFocus = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(firstSuggestionId), [
        setHoveredSuggestion,
        firstSuggestionId
    ]);
    const onBlur = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(undefined), [
        setHoveredSuggestion
    ]);
    const tooltip = (0, $cozmU.useMemo)(()=>({
            content: suggestionsCount > 1 ? formatMessage((0, $gVCFw.aiSuggestionsMessages).iconButtonSuggestionsCountLabel, {
                count: suggestionsCount
            }) || (shortDescription ?? '') : shortDescription ?? '',
            position: 'top-start',
            component: (0, $ba4ab5594767adb9$export$faf6d8e1d1b7acad),
            delay: 0,
            ignoreTooltipPointerEvents: true
        }), [
        formatMessage,
        shortDescription,
        suggestionsCount
    ]);
    if (isViewMode || !localId || !firstSuggestionId) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            anchorName: `--button-${localId}`
        },
        className: (0, $hekY6.default)([
            $92877f9d742eca51$var$styles.container
        ]),
        children: // We keep the anchorName span rendered so that the suggestion card can reference it
        !isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d31faf014d0f6436$export$a3ce2c0cf1a02890), {
            isActive: isActive,
            profiles: profiles,
            tooltip: tooltip,
            label: tooltip.content,
            onClick: onSelectSuggestion,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            onBlur: onBlur
        })
    });
}


/* ThinkingContentComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $cbY7C = parcelRequire("cbY7C");























var $7vK9E = parcelRequire("7vK9E");





var $doA2E = parcelRequire("doA2E");


var $bGNkz = parcelRequire("bGNkz");


var $3sXr4 = parcelRequire("3sXr4");


var $eKGgo = parcelRequire("eKGgo");


var $eR1aL = parcelRequire("eR1aL");















var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $3TxKn = parcelRequire("3TxKn");

var $kuGC4 = parcelRequire("kuGC4");




var $eBgZa = parcelRequire("eBgZa");

const $2aabca309590cf92$var$KNOWN_TEMPLATES = new Set([
    'RATE_LIMIT',
    'ACCEPTABLE_USE_VIOLATIONS',
    'TOKEN_LIMIT_EXCEEDED'
]);
// Reads the raw StreamError frame directly (onError's input); other inputs go through ai-mate's
// createStoreError (shared with Rovo inline chat) to stay in lockstep for thrown error classes.
const $2aabca309590cf92$var$extractErrorFields = (error)=>{
    const frameMessage = error?.message;
    if (frameMessage && (frameMessage.message_template || frameMessage.status_code !== undefined)) return {
        message_template: frameMessage.message_template,
        status_code: frameMessage.status_code
    };
    const { message_template: message_template, status_code: status_code } = (0, $eBgZa.createStoreError)(error);
    return {
        message_template: message_template,
        status_code: status_code
    };
};
const $2aabca309590cf92$export$41586e6680e6a992 = (error)=>{
    const { message_template: message_template, status_code: status_code } = $2aabca309590cf92$var$extractErrorFields(error);
    if (message_template && $2aabca309590cf92$var$KNOWN_TEMPLATES.has(message_template)) return message_template;
    if (status_code === 429) return 'RATE_LIMIT';
    return 'UNKNOWN';
};


function $5db1897bc0e36535$export$a26aa93e6ecac1b(agent) {
    const name = agent?.name?.trim();
    if (!agent?.id || !name) return null;
    return {
        id: agent.id,
        name: name,
        namedId: agent.external_config_reference ?? agent.named_id,
        identityAccountId: agent.identity_account_id
    };
}



const $4ad7534fec02b2d0$export$20928c7586c5104e = (precedingText)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: precedingText
                    },
                    {
                        type: 'inlineExtension',
                        attrs: {
                            extensionKey: 'skill:skillTag',
                            extensionType: 'com.atlassian.rovo.skill',
                            parameters: {
                                slug: 'add-suggestions-to-content'
                            }
                        }
                    }
                ]
            }
        ]
    });
const $4ad7534fec02b2d0$export$514433bce93f0391 = (text)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text
                    }
                ]
            }
        ]
    });
function $4ad7534fec02b2d0$export$d4b080f8bd589023({ api: api, thinkingStatus: thinkingStatus, isRovoMounted: isRovoMounted }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage, abortRequests: abortRequests, setConversationData: setConversationData, setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    // Resolves (and provisions) the agent the prompt is sent at. Stable, so it can't re-trigger
    // the send effect mid-session.
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    });
    // The legacy route owns its optimistic id. Content Reviewer starts from AI Mate's
    // supported empty slot and records the canonical id minted by the first-message flow.
    const conversationIdRef = (0, $cozmU.useRef)(null);
    if (!(0, $iDrrr.fg)('content_reviewer_agent') && thinkingStatus === 'thinking' && !conversationIdRef.current) conversationIdRef.current = crypto.randomUUID();
    const legacyConversationId = conversationIdRef.current;
    const contentReviewerConversationIdRef = (0, $cozmU.useRef)(null);
    const [contentReviewerConversationId, setContentReviewerConversationId] = (0, $cozmU.useState)(null);
    const parallelConversationIdsRef = (0, $cozmU.useRef)([]);
    const parallelSessionRef = (0, $cozmU.useRef)(null);
    const sessionRef = (0, $cozmU.useRef)(null);
    const completedSessionRef = (0, $cozmU.useRef)(null);
    if (thinkingStatus === 'thinking' && !sessionRef.current) sessionRef.current = {};
    const session = thinkingStatus === 'thinking' ? sessionRef.current : null;
    const activeConversation = (0, $kuGC4.useConversationById)({
        conversationId: (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationId ?? '' : legacyConversationId ?? ''
    });
    // The stream callbacks are created once at send time but fire later, after Rovo
    // may have mounted/unmounted. Read the latest value through a ref so completion
    // branches on the current mount state (matching the old status-driven effect).
    const isRovoMountedRef = (0, $cozmU.useRef)(isRovoMounted);
    isRovoMountedRef.current = isRovoMounted;
    /**
   * Backend assigned assistant_message_id to be used as
   * singleInstrumentationId for Unified Instrumentation Events.
   *
   * Stub for now until we have unified analytics
   */ const [_, setAssistantMessageId] = (0, $cozmU.useState)(undefined);
    // Kick off the add-suggestions-to-content skill once per thinking session.
    (0, $cozmU.useEffect)(()=>{
        if (!session) return;
        const promptPrefix = formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsPromptPrefix);
        const agentPrompt = formatMessage((0, $gVCFw.aiSuggestionsMessages).contentReviewAgentPrompt);
        let didFireStreamErrorAnalytics = false;
        let cancelled = false;
        /**
     * Provisioning and resolving the agent are slow, so the session can end while
     * `run` is still between awaits. Everything that dispatches after an await —
     * sending the prompt, driving the thinking state — has to check this first.
     * The ref no longer holding this session's id means the abort effect cleared
     * it (user stopped) or a later render minted a new one; the flag covers this
     * effect being torn down, which the ref alone doesn't catch.
     */ const isCancelled = ()=>cancelled || sessionRef.current !== session;
        const runParallelConfiguredAgents = async (agentIds)=>{
            parallelSessionRef.current = session;
            const resolved = await Promise.all(agentIds.map(async (agentId)=>{
                try {
                    return await resolveAgent({
                        agentId: agentId
                    });
                } catch  {
                    return undefined;
                }
            }));
            if (isCancelled()) return;
            const agents = resolved.filter((agent)=>agent !== undefined);
            if (!agents.length) {
                (0, $2a4bc64013915ea2$export$340d751fde574e23)(api?.analytics?.actions);
                api?.aiSuggestions?.actions.setThinkingState('error');
                return;
            }
            // AI Mate mints a fresh local ID for each first-message send from its empty slot.
            contentReviewerConversationIdRef.current = (0, $4m5jb.EMPTY_CONVERSATION_ID);
            setContentReviewerConversationId((0, $4m5jb.EMPTY_CONVERSATION_ID));
            const reviewingAgent = (0, $5db1897bc0e36535$export$a26aa93e6ecac1b)(agents[0]);
            if (reviewingAgent) api?.aiSuggestions?.actions.setReviewingAgent(reviewingAgent);
            const settled = new Set();
            let hasSucceeded = false;
            let lastError;
            const settle = async (index, succeeded, error)=>{
                if (isCancelled() || settled.has(index)) return;
                settled.add(index);
                hasSucceeded || (hasSucceeded = succeeded);
                if (!succeeded) lastError = error;
                if (settled.size !== agents.length) return;
                if (hasSucceeded) completedSessionRef.current = session;
                if (!hasSucceeded) api?.aiSuggestions?.actions.setThinkingState('error', {
                    template: (0, $2aabca309590cf92$export$41586e6680e6a992)(lastError)
                });
                else if (isRovoMountedRef.current) api?.aiSuggestions?.actions.setThinkingState('idle');
                else {
                    const refreshed = await api?.aiSuggestions?.actions.refreshSuggestions({
                        regenerationTrigger: 'reviewCompleted'
                    }).catch(()=>false);
                    if (!isCancelled()) api?.aiSuggestions?.actions.setThinkingState(refreshed ? 'complete' : 'error');
                }
            };
            // Start every send before awaiting any stream, so the agents run in parallel.
            await Promise.all(agents.map(async (agent, index)=>{
                try {
                    await sendMessage({
                        prompt: $4ad7534fec02b2d0$export$514433bce93f0391(agentPrompt),
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                        agent: agent,
                        storeUserMessages: true,
                        fastModeEnabled: true,
                        addCurrentPageAsContextUserPreference: true,
                        onTempMessageIdReplacedOverride: (_, newId)=>{
                            if (index === 0) setAssistantMessageId(newId);
                        },
                        onNewConversationIdAvailable: (canonicalId)=>{
                            if (isCancelled()) return;
                            parallelConversationIdsRef.current[index] = canonicalId;
                            if (index === 0) {
                                contentReviewerConversationIdRef.current = canonicalId;
                                setContentReviewerConversationId(canonicalId);
                            }
                        },
                        promptStreamHook: {
                            onFinalResponse: ()=>settle(index, true),
                            onError: (error)=>{
                                if (!isCancelled()) {
                                    didFireStreamErrorAnalytics = true;
                                    (0, $2a4bc64013915ea2$export$c2bc44992302850a)(api?.analytics?.actions, error);
                                }
                                return settle(index, false, error);
                            }
                        }
                    });
                    // A send that ends without a final response cannot leave the toolbar spinning.
                    await settle(index, false);
                } catch (error) {
                    if (!isCancelled() && !settled.has(index)) (0, $2a4bc64013915ea2$export$4ca37dd723b35752)(api?.analytics?.actions, error);
                    await settle(index, false, error);
                }
            }));
        };
        const run = async ()=>{
            const configuredAgentIds = (0, $iDrrr.fg)('content_reviewer_agent') ? (0, $19944a85f91ff832$export$91708cba61270117)() : undefined;
            if (configuredAgentIds && configuredAgentIds.length > 1) {
                await runParallelConfiguredAgents(configuredAgentIds);
                return;
            }
            let contentReviewerAgent;
            if ((0, $iDrrr.fg)('content_reviewer_agent')) {
                contentReviewerConversationIdRef.current = (0, $4m5jb.EMPTY_CONVERSATION_ID);
                setContentReviewerConversationId((0, $4m5jb.EMPTY_CONVERSATION_ID));
                await createConversationOptimistically({
                    id: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat
                });
                if (isCancelled()) return;
                contentReviewerAgent = await resolveAgent();
                // The empty-agent branch below dispatches and then returns, so it never
                // reaches the check before the send — it needs its own.
                if (isCancelled()) return;
                if (!contentReviewerAgent) {
                    // No agent to run the skill: clean up the store and show the error screen.
                    await setConversationData({
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                        data: {
                            status: (0, $igOtY.CHAT_STORE_STATUS).idle
                        }
                    });
                    (0, $2a4bc64013915ea2$export$340d751fde574e23)(api?.analytics?.actions);
                    api?.aiSuggestions?.actions.setThinkingState('error');
                    return;
                }
                // Publish the agent actually handling the review, so every loading surface can
                // name it. This is the authoritative resolution — unlike the pre-resolve in the
                // thinking bar it provisions, so it's also what lands on a site's first review.
                const reviewingAgent = (0, $5db1897bc0e36535$export$a26aa93e6ecac1b)(contentReviewerAgent);
                if (reviewingAgent) api?.aiSuggestions?.actions.setReviewingAgent(reviewingAgent);
                await setConversationData({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    data: {
                        sourceAgentId: contentReviewerAgent.id,
                        agent: {
                            agent_id: contentReviewerAgent.id,
                            agent_named_id: contentReviewerAgent.external_config_reference ?? contentReviewerAgent.named_id,
                            agent_name: contentReviewerAgent.name,
                            creator_type: contentReviewerAgent.creator_type,
                            is_default: contentReviewerAgent.is_default,
                            identity_account_id: contentReviewerAgent.identity_account_id ?? undefined
                        }
                    }
                });
            } else if (legacyConversationId) await createConversationOptimistically({
                id: legacyConversationId
            });
            if (isCancelled()) return;
            await sendMessage({
                // The agent has the add-suggestions-to-content skill built in, so it only needs a
                // plain review prompt. Without the agent the skill has to be invoked explicitly.
                prompt: (0, $iDrrr.fg)('content_reviewer_agent') ? $4ad7534fec02b2d0$export$514433bce93f0391(agentPrompt) : $4ad7534fec02b2d0$export$20928c7586c5104e(promptPrefix),
                conversationId: (0, $iDrrr.fg)('content_reviewer_agent') ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : legacyConversationId ?? undefined,
                // If contentReviewerAgent is undefined it won't go to agent
                agent: contentReviewerAgent,
                storeUserMessages: true,
                fastModeEnabled: true,
                addCurrentPageAsContextUserPreference: true,
                /**
         * This fires when the temporary message id is replaced with the
         * backend-assigned assistant_message_id.
         */ onTempMessageIdReplacedOverride: (_, newId)=>{
                    setAssistantMessageId(newId);
                },
                ...(0, $iDrrr.fg)('content_reviewer_agent') ? {
                    onNewConversationIdAvailable: (conversationId)=>{
                        if (isCancelled()) return;
                        contentReviewerConversationIdRef.current = conversationId;
                        setContentReviewerConversationId(conversationId);
                    }
                } : {},
                promptStreamHook: {
                    /**
           * Fires when the FINAL_RESPONSE stream chunk is processed — the
           * add-suggestions-to-content skill has produced its answer.
           *   - Rovo mounted   → setThinkingState('idle') (Rovo chat takes over, no bar)
           *   - Rovo unmounted → refreshSuggestions then setThinkingState('complete')
           *
           * Ignored once cancelled, so a late response can't reopen the bar.
           */ onFinalResponse: async ()=>{
                        if (isCancelled()) return;
                        completedSessionRef.current = session;
                        if (isRovoMountedRef.current) api?.aiSuggestions?.actions.setThinkingState('idle');
                        else {
                            const refreshed = await api?.aiSuggestions?.actions.refreshSuggestions({
                                regenerationTrigger: 'reviewCompleted'
                            }).catch(()=>false);
                            if (isCancelled()) return;
                            api?.aiSuggestions?.actions.setThinkingState(refreshed ? 'complete' : 'error');
                        }
                    },
                    /**
           * Fires on an in-stream ERROR / ACTION_ERROR chunk, and on send rejection —
           * which includes the `AbortError` from stopping, hence the cancel check.
           */ onError: (error)=>{
                        if (isCancelled()) return Promise.resolve();
                        didFireStreamErrorAnalytics = true;
                        (0, $2a4bc64013915ea2$export$c2bc44992302850a)(api?.analytics?.actions, error);
                        // Classify the backend error so the bar shows the matching copy/links.
                        api?.aiSuggestions?.actions.setThinkingState('error', {
                            template: (0, $2aabca309590cf92$export$41586e6680e6a992)(error)
                        });
                        return Promise.resolve();
                    }
                }
            });
        };
        run().catch((error)=>{
            // Stopping the session aborts the in-flight request, so the rejection that
            // follows is the expected outcome of a user cancellation rather than a
            // failure worth reporting — and stopping again would end whichever session
            // is current by now.
            if (isCancelled()) return;
            if (!didFireStreamErrorAnalytics) (0, $2a4bc64013915ea2$export$4ca37dd723b35752)(api?.analytics?.actions, error);
            if (parallelSessionRef.current === session) parallelConversationIdsRef.current.forEach((conversationId)=>{
                setConversationData({
                    conversationId: conversationId,
                    data: {
                        status: (0, $igOtY.CHAT_STORE_STATUS).idle
                    }
                });
            });
            else if ((0, $iDrrr.fg)('content_reviewer_agent')) setConversationData({
                conversationId: contentReviewerConversationIdRef.current ?? (0, $4m5jb.EMPTY_CONVERSATION_ID),
                data: {
                    status: (0, $igOtY.CHAT_STORE_STATUS).idle
                }
            });
            api?.aiSuggestions?.actions.setThinkingState('error');
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        session,
        api,
        createConversationOptimistically,
        legacyConversationId,
        sendMessage,
        setConversationData,
        formatMessage,
        resolveAgent
    ]);
    // Clear the conversation id whenever a thinking session ends (both 'idle' and
    // 'complete') so the next "Review" mints a fresh id and re-triggers the skill.
    // Abort sessions that end before a final response. FINAL_RESPONSE can update
    // the UI before the send action clears its abort controller, so controller
    // presence alone does not mean the user cancelled the review.
    (0, $cozmU.useEffect)(()=>{
        if (thinkingStatus === 'thinking') return;
        if (completedSessionRef.current !== sessionRef.current) {
            if (parallelSessionRef.current) parallelConversationIdsRef.current.forEach((conversationId)=>{
                abortRequests?.({
                    conversationId: conversationId
                });
            });
            else {
                const conversationId = (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationIdRef.current : conversationIdRef.current;
                if (conversationId) abortRequests?.({
                    conversationId: conversationId
                });
            }
        }
        parallelConversationIdsRef.current = [];
        parallelSessionRef.current = null;
        conversationIdRef.current = null;
        contentReviewerConversationIdRef.current = null;
        completedSessionRef.current = null;
        setContentReviewerConversationId(null);
        sessionRef.current = null;
        setAssistantMessageId(undefined);
    }, [
        thinkingStatus,
        abortRequests
    ]);
    // React to conversation status changes reported by the store and drive the
    // editor thinking state accordingly:
    //   - store idle + Rovo mounted   → setThinkingState('idle') (Rovo chat takes over)
    //   - store idle + Rovo unmounted → setThinkingState('complete')
    //   - deactivatedAgentError       → setThinkingState('error')
    (0, $cozmU.useEffect)(()=>{
        /**
     * Note - because promptStreamHook already handles onFinalResponse,
     * this hook shouldn't need to do anything unless the conversation
     * somehow terminates without a final response (e.g. deactivatedAgentError)
     * or has an error that isn't caught by onError.
     */ // A multi-agent review settles only when all streams have finished.
        if (parallelSessionRef.current) return;
        if (!activeConversation) return;
        if ((0, $iDrrr.fg)('content_reviewer_agent') && activeConversation.id !== contentReviewerConversationIdRef.current) return;
        let cancelled = false;
        switch(activeConversation.status){
            case (0, $igOtY.CHAT_STORE_STATUS).idle:
                // Returning to idle mid-thinking means the session finished. The first
                // idle has lastAgentMessageStatus undefined; once set, it's done.
                if (thinkingStatus === 'thinking' && activeConversation.lastAgentMessageStatus !== undefined) {
                    // FAILED/CANCELLED means no suggestions — show the error screen
                    // instead of completing (which would overwrite the error state).
                    const lastAgentMessageFailed = activeConversation.lastAgentMessageStatus === 'FAILED' || activeConversation.lastAgentMessageStatus === 'CANCELLED';
                    if (activeConversation.lastAgentMessageStatus === 'SUCCESSFUL') completedSessionRef.current = sessionRef.current;
                    if (lastAgentMessageFailed) api?.aiSuggestions?.actions.setThinkingState('error');
                    else if (isRovoMountedRef.current) // Rovo chat is open, so don't show the thinking bar on completion.
                    api?.aiSuggestions?.actions.setThinkingState('idle');
                    else api?.aiSuggestions?.actions.refreshSuggestions({
                        regenerationTrigger: 'reviewCompleted'
                    }).catch(()=>false).then((refreshed)=>{
                        if (cancelled) return;
                        api?.aiSuggestions?.actions.setThinkingState(refreshed ? 'complete' : 'error');
                    });
                } else if (thinkingStatus === 'thinking' && !(0, $iDrrr.fg)('content_reviewer_agent') && isRovoMountedRef.current) api?.aiSuggestions?.actions.setThinkingState('idle');
                break;
            case (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError:
                (0, $2a4bc64013915ea2$export$b36e176162c1ac33)(api?.analytics?.actions);
                api?.aiSuggestions?.actions.setThinkingState('error');
                break;
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        activeConversation,
        api,
        thinkingStatus
    ]);
    // When Rovo chat is open and a conversation is active, surface it in the
    // Rovo panel so the user can follow along in real time.
    (0, $cozmU.useEffect)(()=>{
        const conversationId = (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationId : legacyConversationId;
        if (isRovoMounted && thinkingStatus !== 'idle' && conversationId) setSelectedConversation({
            conversationId: conversationId
        });
    }, [
        contentReviewerConversationId,
        isRovoMounted,
        legacyConversationId,
        setSelectedConversation,
        thinkingStatus
    ]);
}





const $7dbfdbb5e4f21539$var$selectThinkingStatus = (state)=>state?.thinkingStatus;
const $7dbfdbb5e4f21539$export$ddd92d4bbdb8026a = (api)=>{
    const [thinkingStatus, setThinkingStatus] = (0, $cozmU.useState)(()=>$7dbfdbb5e4f21539$var$selectThinkingStatus(api?.aiSuggestions?.sharedState.currentState()));
    (0, $cozmU.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        setThinkingStatus($7dbfdbb5e4f21539$var$selectThinkingStatus(aiSuggestions.sharedState.currentState()));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setThinkingStatus($7dbfdbb5e4f21539$var$selectThinkingStatus(nextSharedState));
        });
    }, [
        api
    ]);
    return thinkingStatus;
};







function $087d4f5bdd623c49$export$90d508d21304099c(formatMessage, reviewResults, reviewer) {
    const { count: count, hadExistingSuggestions: hadExistingSuggestions } = reviewResults;
    if (count === 0) return formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNoSuggestionsUpdated);
    const message = reviewer ? hadExistingSuggestions ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNewSuggestionCount : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteSuggestionCount : hadExistingSuggestions ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNewSuggestionCountWithoutReviewer : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteSuggestionCountWithoutReviewer;
    return formatMessage(message, {
        count: count,
        reviewer: reviewer
    });
}
function $087d4f5bdd623c49$export$7db74264aed7f36b(formatMessage) {
    return [
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingReviewingContent),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingMayTakeAFewMinutes),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingGatheringContext),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingReviewingConsistency),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingCheckingWritingClarity),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingIdentifyingImprovements),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingGeneratingAiSuggestions),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingRefiningAiSuggestions),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingPrioritizingAiSuggestions)
    ];
}
function $087d4f5bdd623c49$export$4dbf531e0d81d760(formatMessage, agentName) {
    return formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingReviewingContentWithAgent, {
        agentName: agentName
    });
}


const $031367d96107a088$var$AUTO_CLOSE_DELAY_MS = 3000;
const $031367d96107a088$var$styles = {
    container: "_1mT5xdy1CL _0Bm75GNHnM _4ouGXIHakr _42Yu6BFIQA _3OE6xY715P _1VJPcajssS",
    resizableContainer: "_1EqgXlgxv1",
    hidden: "_3iDTPbYbGa"
};
function $031367d96107a088$export$58900a3f971bc8cc({ api: api, editorView: editorView }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const thinkingStatus = (0, $7dbfdbb5e4f21539$export$ddd92d4bbdb8026a)(api);
    const minimizationRef = (0, $cozmU.useRef)(null);
    const isRequestingInlineCommentCloseRef = (0, $cozmU.useRef)(false); /**
                                                            * We use this to detect when to hide / show the thinking component
                                                            */ 
    const { mounted: isRovoMounted } = (0, $bGNkz.useUIStore)();
    const { firstSuggestionId: firstSuggestionId, isHidden: isHidden, thinkingStartedAt: thinkingStartedAt, thinkingProgressTarget: thinkingProgressTarget, thinkingError: thinkingError, reviewResults: reviewResults, agent: agent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>({
            firstSuggestionId: state?.aiSuggestionsState?.orderedSuggestionIds?.[0],
            reviewResults: state?.aiSuggestionsState?.reviewResults,
            // View mode is a hard override: never show the suggestions UI while read-only.
            isHidden: (state?.aiSuggestionsState?.isHidden ?? false) || state?.editorViewModeState?.mode === 'view',
            // Shared thinking-session anchor so this bar and the sidebar bar keep
            // their progress/rotation in sync across mount/unmount.
            thinkingStartedAt: state?.aiSuggestionsState?.thinkingStartedAt ?? null,
            thinkingProgressTarget: state?.aiSuggestionsState?.thinkingProgressTarget ?? null,
            thinkingError: state?.aiSuggestionsState?.thinkingError ?? null,
            // Resolved once per editor and shared, so this bar and the product's own
            // loading states name the same agent.
            agent: state?.aiSuggestionsState?.reviewingAgent ?? null
        }));
    (0, $4ad7534fec02b2d0$export$d4b080f8bd589023)({
        api: api,
        thinkingStatus: thinkingStatus,
        isRovoMounted: isRovoMounted
    });
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    }); // Resolve the reviewing agent up front — this component is always mounted, so
    // the lookup runs well before the user triggers a review. That way the first
    // thinking status can name the agent and show its avatar from the very first
    // frame, instead of showing the generic status and swapping the agent in mid
    // rotation once a lookup started at thinking-time resolves. The agent store
    // caches the lookup, so this doesn't refetch. Gated on the same flag that
    // determines whether an agent actually handles the review.
    //
    // Provisioning is skipped: this runs without the user having asked for a review,
    // so it looks up an existing agent only. On a site that has never run a review the
    // lookup comes back empty and the surfaces stay on generic copy until the send
    // path (`useSkill`) provisions and publishes the agent.
    (0, $cozmU.useEffect)(()=>{
        if (agent || !(0, $iDrrr.fg)('content_reviewer_agent')) return;
        let isActive = true;
        const abortController = new AbortController();
        resolveAgent({
            signal: abortController.signal,
            skipProvisioning: true
        }).then((resolved)=>{
            const reviewingAgent = (0, $5db1897bc0e36535$export$a26aa93e6ecac1b)(resolved);
            if (isActive && reviewingAgent) api?.aiSuggestions?.actions.setReviewingAgent(reviewingAgent);
        });
        return ()=>{
            isActive = false;
            abortController.abort();
        };
    }, [
        agent,
        api,
        resolveAgent
    ]); // Collapse the thinking bar into the pill as soon as the user scrolls the
    // editor, so it stays out of the way while they read/navigate. Only wired up
    // while actively thinking (the pill is only shown then); the listener binds
    // to the editor's real overflow-scroll ancestor, falling back to the window
    // when the page itself scrolls.
    (0, $cozmU.useEffect)(()=>{
        if (thinkingStatus !== 'thinking' || !editorView) return;
        const scrollTarget = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || window;
        return (0, $cbY7C.bind)(scrollTarget, {
            type: 'scroll',
            listener: ()=>{
                minimizationRef.current?.minimize();
            },
            options: {
                passive: true
            }
        });
    }, [
        editorView,
        thinkingStatus
    ]);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        (0, $2a4bc64013915ea2$export$ed9c3ad08dbed35a)(api?.analytics?.actions, 'statusBar');
        api?.aiSuggestions?.actions.setThinkingState('idle');
    }, [
        api
    ]);
    const onViewSuggestions = (0, $cozmU.useCallback)(()=>{
        const viewSuggestions = async ()=>{
            if ((0, $2pQiO.UNSAFE_expValNoExposure)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', false)) {
                if (isRequestingInlineCommentCloseRef.current) return;
                isRequestingInlineCommentCloseRef.current = true;
                const canCloseComment = await (api?.annotation?.actions.requestCloseInlineComment?.() ?? Promise.resolve(true)).finally(()=>{
                    isRequestingInlineCommentCloseRef.current = false;
                });
                if (!canCloseComment) return;
            }
            api?.aiSuggestions?.actions.setThinkingState('idle');
            api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId ?? null, firstSuggestionId ? {
                interactionPoint: 'statusBar'
            } : undefined);
        };
        viewSuggestions();
    }, [
        api,
        firstSuggestionId
    ]);
    const customRotatingMessages = (0, $cozmU.useMemo)(()=>(0, $087d4f5bdd623c49$export$7db74264aed7f36b)(formatMessage), [
        formatMessage
    ]); // Once the reviewing agent resolves, override the first status to name it and
    // show its avatar in place of the usual thinking icon.
    const firstMessage = (0, $cozmU.useMemo)(()=>{
        if (!agent) return undefined;
        return {
            text: (0, $087d4f5bdd623c49$export$4dbf531e0d81d760)(formatMessage, agent.name),
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                agentId: agent.id,
                agentNamedId: agent.namedId,
                agentIdentityAccountId: agent.identityAccountId,
                size: "small",
                showBorder: false
            })
        };
    }, [
        agent,
        formatMessage
    ]); // When the auto-close timer fires, only dismiss (return to idle) if there
    // are no suggestions — matching the legacy ThinkingTransitionWrapper
    // behaviour where the complete bar stayed visible until the user clicked
    // "View Suggestions" or "Close".
    const handleClose = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('idle');
    }, [
        api
    ]);
    const handleTryAgain = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            isRetry: true
        });
    }, [
        api
    ]);
    const isError = thinkingStatus === 'error';
    const isReady = thinkingStatus === 'complete';
    const hasSuggestions = !!firstSuggestionId;
    const readyText = reviewResults ? (0, $087d4f5bdd623c49$export$90d508d21304099c)(formatMessage, reviewResults, agent?.name) : hasSuggestions ? formatMessage((0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteReviewCompleteUpdated : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteReviewComplete) : formatMessage((0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNoSuggestionsUpdated : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNoSuggestions);
    const thinkingBarProps = (0, $cozmU.useMemo)(()=>({
            onStop: handleStop,
            showProgressBar: true,
            useRotatingTitle: true,
            customRotatingMessages: customRotatingMessages,
            startedAt: thinkingStartedAt,
            progressTarget: thinkingProgressTarget,
            firstMessage: firstMessage
        }), [
        handleStop,
        customRotatingMessages,
        thinkingStartedAt,
        thinkingProgressTarget,
        firstMessage
    ]);
    const thinkingReadyProps = (0, $cozmU.useMemo)(()=>({
            onClose: handleClose,
            onView: hasSuggestions ? onViewSuggestions : undefined,
            readyText: readyText,
            successIcon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))), {
                label: "",
                size: "medium"
            })
        }), [
        handleClose,
        hasSuggestions,
        onViewSuggestions,
        readyText
    ]); // Resolve the error copy/links from the template, mirroring inline chat's ErrorView.
    const { errorText: errorText, canRetry: canRetry } = (0, $cozmU.useMemo)(()=>{
        switch(thinkingError?.template){
            case 'RATE_LIMIT':
                return {
                    errorText: formatMessage((0, $doA2E.default).rateLimited, {
                        a: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                                target: "_blank",
                                children: chunks
                            })
                    }),
                    canRetry: false
                };
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return {
                    errorText: formatMessage((0, $doA2E.default).aupViolation, {
                        a: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                                target: "_blank",
                                children: chunks
                            })
                    }),
                    canRetry: false
                };
            case 'TOKEN_LIMIT_EXCEEDED':
                return {
                    errorText: formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingErrorTokenLimitExceeded),
                    canRetry: true
                };
            default:
                return {
                    errorText: formatMessage((0, $doA2E.default).unknownError),
                    canRetry: true
                };
        }
    }, [
        thinkingError,
        formatMessage
    ]);
    const thinkingErrorProps = (0, $cozmU.useMemo)(()=>({
            onClose: handleClose,
            // Hide "Try again" for non-retryable errors (rate limit, AUP).
            onTryAgain: canRetry ? handleTryAgain : undefined,
            errorText: errorText
        }), [
        handleClose,
        handleTryAgain,
        canRetry,
        errorText
    ]);
    if (thinkingStatus === 'idle' || thinkingStatus === undefined) return null;
     // Errors bypass the isRovoMounted hide so they show even when Rovo chat is open.
    const isContainerHidden = isError ? isHidden : isRovoMounted || isHidden;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $031367d96107a088$var$styles.container,
            (0, $iDrrr.fg)('rovo_ready_bar_ui_update') && $031367d96107a088$var$styles.resizableContainer,
            isContainerHidden && $031367d96107a088$var$styles.hidden
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKGgo.RovoThinkingMinimization), {
            ref: minimizationRef,
            isThinking: thinkingStatus === 'thinking',
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3sXr4.RovoThinkingBarWrapper), {
                isThinking: thinkingStatus === 'thinking',
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eR1aL.RovoThinkingReadyTransition), {
                    isReady: isReady,
                    autoClose: !hasSuggestions,
                    autoCloseDelay: $031367d96107a088$var$AUTO_CLOSE_DELAY_MS,
                    resizeToReadyContent: (0, $iDrrr.fg)('rovo_ready_bar_ui_update'),
                    thinkingBarProps: thinkingBarProps,
                    thinkingReadyProps: thinkingReadyProps,
                    isError: isError,
                    thinkingErrorProps: thinkingErrorProps
                })
            })
        })
    });
}


















var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $6t3CY = parcelRequire("6t3CY");

var $5AKbu = parcelRequire("5AKbu");











const $73af48bb16180a81$export$b8df0cc5d101b7a3 = ()=>{
    const exposedEntryPoints = new Set();
    return {
        hasBeenExposed: (entryPoint)=>exposedEntryPoints.has(entryPoint),
        markExposed: (entryPoint)=>{
            exposedEntryPoints.add(entryPoint);
        }
    };
};
const $73af48bb16180a81$export$461fbf8dec24c525 = ({ api: api, entryPoint: entryPoint, exposureSession: exposureSession })=>{
    const buttonRef = (0, $cozmU.useRef)(null);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element || hasFiredRef.current || exposureSession.hasBeenExposed(entryPoint)) return;
        const fireIfVisible = ()=>{
            if (hasFiredRef.current || exposureSession.hasBeenExposed(entryPoint)) return;
            const style = window.getComputedStyle(element);
            const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
            if (isVisible) {
                (0, $2a4bc64013915ea2$export$5a116e8d20eb61e1)(api?.analytics?.actions, entryPoint);
                hasFiredRef.current = true;
                exposureSession.markExposed(entryPoint);
            }
        };
        // In tests or older browsers, wait one frame so layout/CSS can settle before checking visibility.
        if (typeof window.IntersectionObserver === 'undefined') {
            const frame = window.requestAnimationFrame(fireIfVisible);
            return ()=>window.cancelAnimationFrame(frame);
        }
        // Watch for the button becoming visible after responsive/container-query layout resolves.
        const observer = new window.IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) {
                fireIfVisible();
                observer.disconnect();
            }
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        api,
        entryPoint,
        exposureSession
    ]);
    return buttonRef;
};


const $f0a9c0a88855b568$var$AiSuggestionsButton = ({ api: api, exposureSession: exposureSession })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsButtonLabel);
    const exposureRef = (0, $73af48bb16180a81$export$461fbf8dec24c525)({
        api: api,
        entryPoint: 'primaryToolbar',
        exposureSession: exposureSession
    });
    const isThinking = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>state.aiSuggestionsState?.thinkingStatus === 'thinking');
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isThinking) return;
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            entryPoint: 'primaryToolbar'
        });
    }, [
        api,
        isThinking
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsButtonTooltip),
        position: "top",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            ref: exposureRef,
            onClick: handleClick,
            testId: "editor-toolbar__ai-suggestions-button",
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))), {
                label: label,
                size: "small"
            }),
            ignoreInteractionDisabled: true,
            isDisabled: isThinking,
            children: label
        })
    });
};
const $f0a9c0a88855b568$export$e43f2f89cc843502 = ({ api: api })=>{
    // Scope exposure tracking to this toolbar registration, not the whole browser session.
    const exposureSession = (0, $73af48bb16180a81$export$b8df0cc5d101b7a3)();
    return [
        // AI SUGGESTIONS GROUP — only registered in the pinned primary toolbar sections,
        // not in AI_SECTION (which is used by the floating toolbar).
        //
        // The group wraps its children in <Show above="lg"> so it hides below the breakpoint
        {
            type: (0, $3nacY.AI_SUGGESTIONS_GROUP).type,
            key: (0, $3nacY.AI_SUGGESTIONS_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        },
        // AI SUGGESTIONS BUTTON — shown as a full labelled button when space is available
        // (via AI_SUGGESTIONS_GROUP above "lg"), or as an icon-only button with tooltip
        // inside ROVO_GROUP_DISPLAY_SMALL when space is tight (below "lg").
        {
            type: (0, $3nacY.AI_SUGGESTIONS_BUTTON).type,
            key: (0, $3nacY.AI_SUGGESTIONS_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SUGGESTIONS_GROUP).type,
                    key: (0, $3nacY.AI_SUGGESTIONS_GROUP).key,
                    rank: (0, $hVLmg.AI_SUGGESTIONS_GROUP_RANK)[(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]
                },
                {
                    type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($f0a9c0a88855b568$var$AiSuggestionsButton, {
                    api: api,
                    exposureSession: exposureSession
                })
        }
    ];
};


const $bd706ffb3e69dbe0$export$e4fa509a217898d8 = ({ api: api, config: config })=>{
    const { contentAri: contentAri, onShowSidebar: onShowSidebar, ConversationAssistant: ConversationAssistant, onSubmitSuggestionFeedback: onSubmitSuggestionFeedback } = config;
    if (api?.toolbar) api.toolbar.actions.registerComponents((0, $f0a9c0a88855b568$export$e43f2f89cc843502)({
        api: api
    }));
    // EDITOR-8771: prefer the right surface via the UI Control Registry API once the migration
    // gate is on, falling back to the legacy widget decoration built in `calculateSuggestionsDecorations`
    // (see `main.tsx`) when it is off.
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
        const suggestionRightSurfaceButton = {
            component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $92877f9d742eca51$export$509594734c522b9c), {
                    surfaceContext: surfaceContext,
                    api: api
                }),
            isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return true;
                const aiSuggestionsState = api?.aiSuggestions?.sharedState.currentState();
                // `setUIVisibility(false)` hides every sparkle block control, not just the cards.
                if (aiSuggestionsState?.isHidden) return true;
                const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
                const localId = context?.targetNode.node.attrs?.localId;
                if (!localId) return true;
                const suggestionIds = aiSuggestionsState?.suggestionIdsByBaseLocalId.get(localId);
                return !suggestionIds || suggestionIds.size === 0;
            },
            key: 'ai-suggestions-right-surface-button',
            parents: [
                {
                    ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
                    rank: 100
                }
            ],
            type: 'button'
        };
        api?.uiControlRegistry?.actions.register([
            suggestionRightSurfaceButton
        ]);
    }
    return {
        name: 'aiSuggestions',
        actions: {
            acceptSuggestion: (0, $61cbf5e36086ffd7$export$11f54cceda85c938)(api),
            discardSuggestion: (0, $f22f7a878bb21ed6$export$97ae1e6707b788ba)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            showSuggestionDiff: (0, $95d83135ce202b5d$export$abeb109a09e4f140)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            hideSuggestionDiff: (0, $9c533a1ee7f54d08$export$63a2edde6c848f66)(api),
            discardAllSuggestions: (0, $8bb2f22922f0bfc3$export$7cd05c39d88c72e0)(api),
            refreshSuggestions: (0, $943e90f24ff1479e$export$8c023f02ab5dbd45)(api, contentAri),
            selectSuggestion: (0, $93a0ea89424771d8$export$85c07d6dab7fe6b1)(api),
            setReviewingAgent: (0, $4ab3071695fa3411$export$e543cf01c40ad1eb)(api),
            setThinkingState: (0, $2d7f810d13618094$export$bf49a0593cfa46b5)(api),
            setUIVisibility: (0, $19b7760d1a1a9061$export$6525a287b5847561)(api),
            submitSuggestionFeedback: (0, $7f796363d3edeeee$export$be7787b2fea0b5c6)(api, onSubmitSuggestionFeedback)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa).getState(editorState);
            if (!pluginState) return undefined;
            const thinkingState = (0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889).getState(editorState);
            return {
                acceptShimmerDuration: (0, $dedd473f4e1cf0d3$export$2afa3e09b9018323)(editorState),
                reviewResults: thinkingState?.reviewResults,
                isHidden: pluginState.isHidden,
                selectedSuggestion: pluginState.selectedSuggestion,
                suggestionById: pluginState.suggestionById,
                baseLocalIdBySuggestionId: pluginState.baseLocalIdBySuggestionId,
                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                orderedSuggestionIds: pluginState.orderedSuggestionIds,
                followUpCard: pluginState.followUpCard,
                regeneratingSuggestionIds: pluginState.regeneratingSuggestionIds,
                thinkingStatus: thinkingState?.status ?? 'idle',
                thinkingStartedAt: thinkingState?.startedAt ?? null,
                thinkingProgressTarget: thinkingState?.progressTarget ?? null,
                thinkingError: thinkingState?.error ?? null,
                reviewingAgent: thinkingState?.reviewingAgent ?? null
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'aiSuggestionsPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const intl = getIntl?.();
                        return (0, $1b159f40bd8b3a1f$export$ae829ec7b2625219)({
                            api: api,
                            intl: intl,
                            contentAri: contentAri,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                },
                ...(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_content_suggested_edits_labs') ? [
                    {
                        name: 'aiSuggestionsAcceptShimmerPlugin',
                        plugin: ()=>(0, $dedd473f4e1cf0d3$export$4201d16e5928890e)()
                    }
                ] : [],
                {
                    name: 'aiSuggestionsThinkingPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $4d8c0f76a4c8d5f6$export$145797582d57a3db)({
                            dispatch: dispatch,
                            getSuggestionIds: (state)=>{
                                const suggestions = (0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa).getState(state);
                                return suggestions?.contentAri !== undefined ? suggestions.orderedSuggestionIds : undefined;
                            }
                        });
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_content_suggested_edits_labs') && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2e83e0ce18b0d41b$export$a1c179297c0c35eb), {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $997801478ebdd729$export$a1fd8428be46e11c), {}),
                    /**
         * Both need the ConversationAssistant store: the thinking surface to invoke the
         * skill, track thinking states and abort requests, and the follow-up card to
         * resolve the Content Reviewer agent for its avatar.
         */ ConversationAssistant && /*#__PURE__*/ (0, $8aG6j.jsxs)(ConversationAssistant, {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $031367d96107a088$export$58900a3f971bc8cc), {
                                api: api,
                                editorView: editorView
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a07fe340660de233$export$b37784161dbefc65), {
                                api: api,
                                view: editorView
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d79d0d9956135474$export$b9f1c5d82af9ea41), {
                        api: api,
                        onShowSidebar: onShowSidebar,
                        view: editorView
                    })
                ]
            });
        }
    };
};
module.exports["aiSuggestionsPlugin"] = $bd706ffb3e69dbe0$export$e4fa509a217898d8;

});

parcelRegister("83dR4", function(module, exports) {
function $0c1697ece550cffc$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $0c1697ece550cffc$export$13aeab2a71badd1e;

});

parcelRegister("2H7bJ", function(module, exports) {
function $8fd9d5f3e39c04b8$export$a9185f12eb6f9427({ options: options }) {
    return options;
}
module.exports["aiImageGenerationPluginOptions"] = $8fd9d5f3e39c04b8$export$a9185f12eb6f9427;

});

parcelRegister("b0PJa", function(module, exports) {
function $e8192d24f72a522a$export$a2b90416e38bfd44({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
    return options;
}
module.exports["aiPluginOptions"] = $e8192d24f72a522a$export$a2b90416e38bfd44;

});

parcelRegister("emOXs", function(module, exports) {
function $5bddf9453bb6896b$export$bc5ff52c1b8ecb7e({ options: options }) {
    return {
        streamFlowPacerEnabled: options?.streamFlowPacerEnabled,
        telemetryEventsEnabled: true
    };
}
module.exports["aiStreamingOrchestratorPluginOptions"] = $5bddf9453bb6896b$export$bc5ff52c1b8ecb7e;

});

parcelRegister("b11Eg", function(module, exports) {
function $8e54f803183465b8$export$ac204ba03d7a4a41({ options: options }) {
    return options;
}
module.exports["aiSuggestionsOptions"] = $8e54f803183465b8$export$ac204ba03d7a4a41;

});

parcelRegister("hYVYG", function(module, exports) {
function $bad4e0ae48934f00$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $bad4e0ae48934f00$export$bfd53895e8497571;

});

parcelRegister("458fo", function(module, exports) {
function $7015f0e5b11954a6$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $7015f0e5b11954a6$export$b3e029fd31f94f55;

});

parcelRegister("gGfnN", function(module, exports) {
function $ebeab0a1417a59cc$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $ebeab0a1417a59cc$export$eeaea850bc5c5797;

});

parcelRegister("2j2nv", function(module, exports) {
function $9526f0ade8be7db5$export$a23b3fa66082f163() {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}
module.exports["basePluginOptions"] = $9526f0ade8be7db5$export$a23b3fa66082f163;

});

parcelRegister("37pZs", function(module, exports) {
function $8c14fc49394a0032$export$817c0e398e6ff750({}) {
    return {
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $8c14fc49394a0032$export$817c0e398e6ff750;

});

parcelRegister("ccSax", function(module, exports) {
function $d7cf87936bb69c1a$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}
module.exports["breakoutPluginOptions"] = $d7cf87936bb69c1a$export$3be6b735d5cbc3e6;

});

parcelRegister("21YtE", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $mW7G5 = parcelRequire("mW7G5");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $46d140459d17e176$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $46d140459d17e176$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        smartCardContext: options.smartCardContext,
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $46d140459d17e176$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $4iudd.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt,
        enablePasteDisplayAsMenu: [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))
    };
}
module.exports["cardPluginOptions"] = $46d140459d17e176$export$514131654bb897e2;

});

parcelRegister("1aAo1", function(module, exports) {
function $2e18ec67f19caff3$export$74cc43e84bb9c20({ providers: providers }) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false,
        formatCodeProvider: providers.formatCodeProvider
    };
}
module.exports["codeBlockPluginOptions"] = $2e18ec67f19caff3$export$74cc43e84bb9c20;

});

parcelRegister("6HTz8", function(module, exports) {

var $jj5K7 = parcelRequire("jj5K7");

function $71921227359166a3$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: true,
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $jj5K7.shouldForceTracking)()
    };
}
module.exports["collabEditPluginOptions"] = $71921227359166a3$export$c1ebe19806bc53b1;

});

parcelRegister("UzlxI", function(module, exports) {
function $04b012c1cc13df71$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}
module.exports["contentFormatPluginOptions"] = $04b012c1cc13df71$export$8a4106078b67336e;

});

parcelRegister("lMcW5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $7ebe3cdb2b372331$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $7ebe3cdb2b372331$export$48a60d81b6bb28e3;

});

parcelRegister("5gRoW", function(module, exports) {
function $544934f3b4646806$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $544934f3b4646806$export$de47eee62065048e;

});

parcelRegister("dUIcZ", function(module, exports) {
function $f92bb1f96a602b3d$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $f92bb1f96a602b3d$export$36a79e2b5698697a;

});

parcelRegister("n7lIn", function(module, exports) {
function $090afbe8b4f614b7$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $090afbe8b4f614b7$export$128eafe7f843e327;

});

parcelRegister("1oaTe", function(module, exports) {
function $2b2ae13c81f0b3eb$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight,
        getUnsupportedContent: options.getUnsupportedContent
    };
}
module.exports["extensionPluginOptions"] = $2b2ae13c81f0b3eb$export$c18b9102cd0790c9;

});

parcelRegister("k1Nk4", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $b7925b5fe11bfb81$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $b7925b5fe11bfb81$export$3bff061e5229a7;

});

parcelRegister("6fxhr", function(module, exports) {
function $59b29edff314acad$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $59b29edff314acad$export$2a67100cd9c61f05;

});

parcelRegister("3psuc", function(module, exports) {
function $b368953c3f0aa2c8$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $b368953c3f0aa2c8$export$ab9ae3984d5aef33;

});

parcelRegister("fqvyt", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $fb62125893162074$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        itemFilter: options.itemFilter,
        toolbarButtons: options.toolbarButtons
    };
}
module.exports["insertBlockPluginOptions"] = $fb62125893162074$export$1e11b615e9dc119e;

});

parcelRegister("19EZx", function(module, exports) {
function $9db31477b8097e5d$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}
module.exports["limitedModePluginOptions"] = $9db31477b8097e5d$export$d384a797e800fdbe;

});

parcelRegister("7OeAC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $049fc7d34c7d1ed8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


const $31fa319867936cb4$var$STORAGE_SUPPORTS_REGEX = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
function $31fa319867936cb4$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: options.allowResizing ?? true,
        allowResizingInTables: options.allowResizing ?? true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: options.allowCaptions ?? true,
        allowMediaInlineImages: true,
        allowPixelResizing: options.allowResizing ?? true,
        altTextValidator: (text)=>{
            if (!$31fa319867936cb4$var$STORAGE_SUPPORTS_REGEX.test(text)) return [
                intl.formatMessage((0, $049fc7d34c7d1ed8$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions,
        fallbackMediaNameFetcher: options.fallbackMediaNameFetcher,
        onMediaRenderEvent: options.onMediaRenderEvent
    };
}
module.exports["mediaPluginOptions"] = $31fa319867936cb4$export$484123ae56f6fbd9;

});

parcelRegister("18rHt", function(module, exports) {
function $5c4ff6f59d771305$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $5c4ff6f59d771305$export$4677177d82484aef;

});

parcelRegister("aMwfi", function(module, exports) {

var $5nazv = parcelRequire("5nazv");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $dff5f32f186d1f2d$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $dff5f32f186d1f2d$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $dff5f32f186d1f2d$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true,
        markdownToPmConverter: ({ markdown: markdown, schema: schema })=>(0, $5nazv.markdownToAdf)(markdown, schema).content
    };
}
module.exports["pastePluginOptions"] = $dff5f32f186d1f2d$export$6b1ad42d09c74964;

});

parcelRegister("bslVh", function(module, exports) {

var $aBPpS = parcelRequire("aBPpS");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $kSwu1 = parcelRequire("kSwu1");

const $dafb8934c28d33a1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    },
    markdownModePlaceholder: {
        id: "editor-presets-confluence.placeholder.markdown-mode-placeholder",
        defaultMessage: "Type or paste markdown"
    }
});


function $163f0518a77200ef$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming');
    const isMarkdownModeLivePage = options.isMarkdownMode && options.isLivePage;
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // In a Markdown Mode Live Doc the document is plain markdown, so the slash /
        // mention / AI discovery hints don't apply. Show a markdown-specific
        // placeholder instead. Scoped to Live Pages only.
        if (isMarkdownModeLivePage) return options.markdownModePlaceholder || intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).markdownModePlaceholder);
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled) return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).defaultPlaceholder);
        return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        // In a Markdown Mode Live Doc we always show the plain markdown placeholder
        // text, never the Rovo space-shortcut ADF placeholder (which would take
        // precedence).
        if (isMarkdownModeLivePage) return undefined;
        if (shouldShowSpaceShortcut) return (0, $aBPpS.createADFFromHTML)(intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        }));
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: !isMarkdownModeLivePage && (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? true
    };
}
module.exports["placeholderPluginOptions"] = $163f0518a77200ef$export$c6841f879d4c8aef;

});

parcelRegister("78oCu", function(module, exports) {
function $206dc13ba5886fc7$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $206dc13ba5886fc7$export$44901d053a58e418;

});

parcelRegister("3rW2U", function(module, exports) {
function $fd656c1cd222df94$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined,
        // EDITOR-6558: forward consumer-supplied item filter (used by Markdown Mode
        // to allowlist GFM-compatible items in the `/` menu).
        itemFilter: typeof options.quickInsert === 'object' ? options.quickInsert.itemFilter : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $fd656c1cd222df94$export$26cff1f2fe9f781b;

});

parcelRegister("8o1oU", function(module, exports) {
function $6a1b601b5e4a419b$export$13a2743c2a93c688({ options: options }) {
    return {
        api: options.referentialityContext.api ?? undefined,
        // A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
        appearance: options.referentialityContext.options.appearance,
        extensionHandlers: options.referentialityContext.options.extensionHandlers,
        externalObservers: options.referentialityContext.options.externalObservers,
        nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
        nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
        editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
        editorView: options.referentialityContext.options.editorView,
        featureFlags: options.referentialityContext.options.featureFlags,
        __livePage: options.referentialityContext.options.__livePage,
        __rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
        getExtensionHeight: options.referentialityContext.options.getExtensionHeight
    };
}
module.exports["referentialityPluginOptions"] = $6a1b601b5e4a419b$export$13a2743c2a93c688;

});

parcelRegister("1JkrY", function(module, exports) {
function $62e442d5cfea030d$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $62e442d5cfea030d$export$222c5aa4c9fb0805;

});

parcelRegister("gLRz8", function(module, exports) {
function $79cda04ea30939d7$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: true
    };
// END SECTION
}
module.exports["selectionMarkerPluginOptions"] = $79cda04ea30939d7$export$197b78e13e8987d2;

});

parcelRegister("5S8Qw", function(module, exports) {
function $ee8355711183845c$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $ee8355711183845c$export$ddc2936355c1da67;

});

parcelRegister("1cNjj", function(module, exports) {
function $91c7d2c6009f534c$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}
module.exports["selectionToolbarPluginOptions"] = $91c7d2c6009f534c$export$bc6dcb3c2a6112e1;

});

parcelRegister("9ph8N", function(module, exports) {
function $cd0022ff6e424209$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}
module.exports["showDiffPluginOptions"] = $cd0022ff6e424209$export$5c1f265f89d46b24;

});

parcelRegister("4C8JA", function(module, exports) {
function $407ddb9ddabe5b31$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $407ddb9ddabe5b31$export$3612ff8a6b94af71;

});

parcelRegister("cySgy", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $04c59ad83d435dc1$export$9868b594778cf535({ options: options }) {
    return {
        __livePage: options.__livePage,
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: true
    };
}
module.exports["tablePluginOptions"] = $04c59ad83d435dc1$export$9868b594778cf535;

});

parcelRegister("crhNi", function(module, exports) {
function $d8ceff324dc40ac6$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $d8ceff324dc40ac6$export$1d23e03c42bfc1ac;

});

parcelRegister("h9jUa", function(module, exports) {
function $f698d6c6136be97b$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $f698d6c6136be97b$export$cb883a3a9320698e;

});

parcelRegister("a5Ohw", function(module, exports) {
function $587f0a47ebcb0984$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        componentFilter: options.componentFilter,
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["toolbarPluginOptions"] = $587f0a47ebcb0984$export$2d206ce8fa0c3d37;

});

parcelRegister("7cvtX", function(module, exports) {
function $1aebe55f66fd55ea$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $1aebe55f66fd55ea$export$612ea2d32c3e4c96;

});

parcelRegister("d1OC7", function(module, exports) {
function $8c606f8053d9e8e7$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $8c606f8053d9e8e7$export$abdb0d09187eec69;

});

parcelRegister("bveWD", function(module, exports) {
/* markdownModePlugin.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $hVLmg = parcelRequire("hVLmg");

var $3nacY = parcelRequire("3nacY");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");





var $kCECX = parcelRequire("kCECX");

const $9e7aa44e1133a0cd$export$160e35dbff8be862 = new (0, $kCECX.PluginKey)('markdownMode');


const $6ac889fd0f465b1a$var$MAC_PLATFORM_REGEX = new RegExp('Mac', 'iu');
const $6ac889fd0f465b1a$var$isMac = typeof navigator !== 'undefined' && $6ac889fd0f465b1a$var$MAC_PLATFORM_REGEX.test(navigator.userAgentData?.platform ?? navigator.platform);
const $6ac889fd0f465b1a$export$2fa7e76a57ca53b0 = (e)=>{
    const modifierMatch = $6ac889fd0f465b1a$var$isMac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
    return modifierMatch && !e.altKey && !e.shiftKey && e.code === 'KeyE';
};
/**
 * Selector matching the wrapping container that holds both the ProseMirror
 * editor DOM and any plugin-rendered content (e.g. the markdown source view
 * mounted via `PluginSlot`). Defined in
 * `editor-core/src/ui/Appearance/FullPage/FullPageContentArea.tsx` as
 * `EDITOR_CONTAINER`.
 */ const $6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR = '[data-editor-container="true"]';
const $6ac889fd0f465b1a$export$f3fcac9ec039b10c = (editorView)=>{
    const activeElement = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
    // No active element / focus on body — fall through and allow toggle.
    // `document.body` is reported as `activeElement` in browsers when nothing
    // else is focused; treat that the same as "no focus".
    const hasMeaningfulFocus = activeElement !== null && activeElement !== (0, $1hQ0e.getDocument)()?.body && activeElement !== (0, $1hQ0e.getDocument)()?.documentElement;
    if (!hasMeaningfulFocus) return true;
    if (editorView.dom.contains(activeElement)) return true;
    const ourContainer = typeof editorView.dom.closest === 'function' ? editorView.dom.closest($6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (ourContainer && ourContainer.contains(activeElement)) return true;
    // Multi-editor safety: if focus is inside SOME OTHER editor container,
    // only that editor should respond — not this one.
    const focusedContainer = typeof activeElement.closest === 'function' ? activeElement.closest($6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (focusedContainer && focusedContainer !== ourContainer) return false;
    // Focus is outside any editor container (e.g. a popup, side panel, an
    // unrelated input). Allow the toggle so the shortcut works from "anywhere
    // on the page" — in particular right after clicking the view-mode toggle
    // button, which moves focus out of the editor.
    return true;
};
const $6ac889fd0f465b1a$export$ed529ff4eb54147f = (api, getEditorView)=>{
    return (e)=>{
        if (!$6ac889fd0f465b1a$export$2fa7e76a57ca53b0(e)) return;
        const editorView = getEditorView();
        if (!editorView || editorView.isDestroyed) return;
        // Multi-editor guard: if focus is inside a DIFFERENT editor, only that
        // one should toggle. When focus is outside any editor (e.g. body, a
        // popup, a button) we still toggle so the shortcut works "anywhere on
        // the page", including immediately after the user clicked the toggle
        // button (which moves focus out of the editor).
        if (!$6ac889fd0f465b1a$export$f3fcac9ec039b10c(editorView)) return;
        const pluginState = (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorView.state);
        if (!pluginState?.isMarkdownMode) return;
        const currentView = pluginState.view ?? 'preview';
        // Only syntax and preview participate in the runtime toggle cycle.
        // Any other value is treated as non-toggleable.
        if (currentView !== 'syntax' && currentView !== 'preview') return;
        e.preventDefault();
        // Cycle through available views. When split view is enabled in the
        // future, add 'split-view' to this array.
        const viewCycle = [
            'preview',
            'syntax'
        ];
        const currentIndex = viewCycle.indexOf(currentView);
        const nextView = viewCycle[(currentIndex + 1) % viewCycle.length];
        api?.markdownMode?.actions.setView(nextView);
    };
};



/**
 * @file source-view-utils.ts
 *
 * Foundation utilities for interacting with the CodeMirror 6 source view in
 * markdown mode. Provides two layers:
 *
 *  1. **Context queries** - pure functions over `EditorState` that use the
 *     Lezer syntax tree to answer semantic questions about the current cursor
 *     position / selection (e.g. "is the cursor inside a code block?").
 *
 *  2. **Syntax primitive factories** - functions that return `SourceViewCommand`
 *     values (the standard CM6 command signature) for common markdown text
 *     transformations (e.g. wrapping a selection in `**...**`).
 *
 * These utilities are the shared foundation that toolbar-contributing plugins
 * compose into their own `SourceViewCommand` implementations. All CM6 and
 * Lezer knowledge is centralised here so individual plugins remain ignorant of
 * CodeMirror internals.
 *
 * No React or side-effect imports - this module is pure logic and is safe to
 * import in any context.
 */ 
var $9R6p6 = parcelRequire("9R6p6");


var $4lK5a = parcelRequire("4lK5a");


var $b2ZzE = parcelRequire("b2ZzE");

const $b8e7170495150c53$var$ATX_HEADING_REGEX = /^ATXHeading(\d)$/u;
const $b8e7170495150c53$var$SETEXT_HEADING_REGEX = /^SetextHeading(\d)$/u;
const $b8e7170495150c53$var$TASK_PREFIX_REGEX = /^(\s*)(?:[-*+]|\d+\.)\s+\[[ xX]\]\s+/u;
const $b8e7170495150c53$var$LIST_PREFIX_PATTERN_REGEX = /^(\s*)(?:[-*+]|\d+\.)\s+/u;
const $b8e7170495150c53$var$LIST_MARKER_REGEX = /^(\s*)([-*+]|\d+\.)\s+/u;
const $b8e7170495150c53$var$ORDERED_MARKER_REGEX = /^\d+\.$/u;
const $b8e7170495150c53$var$LEADING_WHITESPACE_REGEX = /^\s*/u;
const $b8e7170495150c53$var$ATX_HEADING_PREFIX_REGEX = /^(#{1,6}) /u;
const $b8e7170495150c53$export$2d73244c2182ac32 = Object.fromEntries((0, $9R6p6.markdownLanguage).parser.nodeSet.types.map((t)=>[
        t.name,
        t.name
    ]));
// ---------------------------------------------------------------------------
// Word counting
//
// Word count is locale-aware: `@codemirror` has no document word-count API
// (only `EditorState.wordAt`, which returns the word at a single position), so
// we segment the document text with `Intl.Segmenter`. Unlike a naive
// whitespace split, the segmenter correctly counts words in scripts that do
// not delimit words with spaces (e.g. Chinese / Japanese / Thai) and ignores
// punctuation-only segments (so markdown syntax like `**`, `#`, `>` is not
// counted as a word).
//
// The segmenter is created with the editor's runtime locale (the caller threads
// it through from `useIntl().locale` / `getIntl().locale`), so word boundaries
// match the user's language. When no locale is supplied we pass `undefined` to
// `Intl.Segmenter`, which uses the host environment's default locale.
// ---------------------------------------------------------------------------
// Lazily-created, reused segmenters keyed by locale (`undefined` = host default
// locale). Constructing an `Intl.Segmenter` is comparatively expensive, so we
// build one per locale and reuse it. A `null` value means `Intl.Segmenter` is
// genuinely unavailable on this runtime and we should use the whitespace
// fallback.
const $b8e7170495150c53$var$wordSegmenters = new Map();
/**
 * Build an `Intl.Segmenter` for `locale`, or return `null` when the runtime has
 * no `Intl.Segmenter` at all.
 *
 * A malformed `locale` (e.g. a bad `intl.locale` such as `"not a valid locale"`)
 * makes the constructor throw `RangeError`. We must NOT degrade to the
 * whitespace fallback in that case — that miscounts scripts without spaces
 * (CJK / Thai). Instead we retry with the host default locale, which still
 * segments correctly, and emit a one-time diagnostic so the bad locale is
 * observable rather than silently wrong.
 */ function $b8e7170495150c53$var$createWordSegmenter(locale) {
    if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return null;
    try {
        // `undefined` locale → host environment default.
        return new Intl.Segmenter(locale, {
            granularity: 'word'
        });
    } catch (err) {
        if (locale !== undefined) {
            // eslint-disable-next-line no-console
            console.warn(`[MarkdownSourceView] Intl.Segmenter could not be created for locale "${locale}"; falling back to the host default locale for word counting.`, err);
            try {
                return new Intl.Segmenter(undefined, {
                    granularity: 'word'
                });
            } catch  {
            // Host default also failed (very unlikely) — use whitespace split.
            }
        }
        return null;
    }
}
function $b8e7170495150c53$var$getWordSegmenter(locale) {
    const existing = $b8e7170495150c53$var$wordSegmenters.get(locale);
    if (existing !== undefined) return existing;
    // Cache the resolved segmenter (built from `locale` or the host-default
    // fallback) under the requested key so the throwing construction — and its
    // diagnostic — runs at most once per locale.
    const segmenter = $b8e7170495150c53$var$createWordSegmenter(locale);
    $b8e7170495150c53$var$wordSegmenters.set(locale, segmenter);
    return segmenter;
}
/**
 * Count the number of words in `text` for the given `locale` (or the host
 * default locale when omitted). Prefers `Intl.Segmenter` (locale-aware, counts
 * word-like segments only). Falls back to a whitespace split on runtimes
 * without `Intl.Segmenter`.
 */ function $b8e7170495150c53$var$countWordsInText(text, locale) {
    if (text.length === 0) return 0;
    const segmenter = $b8e7170495150c53$var$getWordSegmenter(locale);
    if (segmenter) {
        let count = 0;
        for (const segment of segmenter.segment(text))if (segment.isWordLike) count++;
        return count;
    }
    // Fallback: count whitespace-delimited tokens.
    const matches = text.match(/\S+/gu);
    return matches ? matches.length : 0;
}
// Cache word counts keyed on the immutable CM6 `Text` document instance. CM6
// reuses the same `Text` object when only the selection changes, so this makes
// selection-only updates O(1) and avoids re-scanning the whole document (which
// would add input latency on large documents). A new `Text` instance is
// created on every document edit, so edits recompute exactly once. The cached
// locale is stored alongside the count so a locale change (rare, mid-session)
// correctly invalidates the entry rather than returning a stale count.
const $b8e7170495150c53$var$wordCountCache = new WeakMap();
function $b8e7170495150c53$export$a063438ffa4b0154(doc, locale) {
    const cached = $b8e7170495150c53$var$wordCountCache.get(doc);
    if (cached !== undefined && cached.locale === locale) return cached.count;
    const count = $b8e7170495150c53$var$countWordsInText(doc.toString(), locale);
    $b8e7170495150c53$var$wordCountCache.set(doc, {
        count: count,
        locale: locale
    });
    return count;
}
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
/**
 * Walk the Lezer syntax tree upward from `pos`, returning the names of every
 * ancestor node (inclusive of the node at `pos`).
 */ function $b8e7170495150c53$var$ancestorNames(state, pos) {
    const names = [];
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        names.push(node.type.name);
        node = node.parent;
    }
    return names;
}
/**
 * Return true if any ancestor node at `pos` has one of the given type names.
 */ function $b8e7170495150c53$var$hasAncestor(state, pos, ...typeNames) {
    const names = new Set(typeNames);
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        if (names.has(node.type.name)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * Return true if any Lezer node overlapping [from, to] has one of the given
 * type names. Uses syntaxTree.iterate() for an exact answer - no sampling.
 */ function $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, ...typeNames) {
    const names = new Set(typeNames);
    let found = false;
    (0, $4lK5a.syntaxTree)(state).iterate({
        from: from,
        to: to,
        enter (node) {
            if (names.has(node.type.name)) {
                found = true;
                return false; // stop iteration early
            }
        }
    });
    return found;
}
/** Canonical wrap syntax for each inline format (used for toggle-on). */ const $b8e7170495150c53$var$INLINE_FORMAT_SYNTAX = {
    bold: '**',
    italic: '*',
    inlineCode: '`',
    strikethrough: '~~'
};
/** Lezer node type for each inline format (used for toggle-off detection). */ const $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE = {
    bold: 'StrongEmphasis',
    italic: 'Emphasis',
    inlineCode: 'InlineCode',
    strikethrough: 'Strikethrough'
};
/**
 * The Lezer node types that represent "code contexts" - positions where inline
 * markdown formatting (bold, italic, etc.) is meaningless or invalid.
 */ const $b8e7170495150c53$var$CODE_CONTEXT_NODES = [
    'FencedCode',
    'CodeBlock',
    'InlineCode',
    'CodeText',
    'CodeInfo'
];
function $b8e7170495150c53$export$340f88d26d8d1507(state) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
}
function $b8e7170495150c53$export$59eae5fcd69a8ca2(state) {
    const { from: from, to: to } = state.selection.main;
    // For a collapsed cursor, use the ancestor walk (faster).
    if (from === to) return $b8e7170495150c53$var$hasAncestor(state, from, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
    return $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
}
function $b8e7170495150c53$var$isSelectionInBlockCodeContext(state) {
    const { from: from, to: to } = state.selection.main;
    if (from === to) return $b8e7170495150c53$var$hasAncestor(state, from, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock);
    return $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock);
}
function $b8e7170495150c53$export$8970a27599376db5(state) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.URL);
}
function $b8e7170495150c53$export$35f4bb6bae3e9d74(state) {
    const { head: head } = state.selection.main;
    const line = state.doc.lineAt(head);
    return {
        columnNumber: head - line.from + 1,
        lineCount: state.doc.lines,
        lineNumber: line.number
    };
}
function $b8e7170495150c53$export$3d308a0a07f3d571(state, locale) {
    return {
        ...$b8e7170495150c53$export$35f4bb6bae3e9d74(state),
        wordCount: $b8e7170495150c53$export$a063438ffa4b0154(state.doc, locale)
    };
}
function $b8e7170495150c53$export$bd3fd8da835721f8(state) {
    return !$b8e7170495150c53$export$340f88d26d8d1507(state) && !$b8e7170495150c53$export$8970a27599376db5(state);
}
function $b8e7170495150c53$export$753a775122b7b63b(state, lezerNodeType) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, lezerNodeType);
}
function $b8e7170495150c53$export$8e72f433f86285(state) {
    // Helper: extract heading level from a list of ancestor node names.
    function levelFromNames(names) {
        for (const name of names){
            const atx = name.match($b8e7170495150c53$var$ATX_HEADING_REGEX);
            if (atx) return parseInt(atx[1], 10);
            const setext = name.match($b8e7170495150c53$var$SETEXT_HEADING_REGEX);
            if (setext) return parseInt(setext[1], 10);
        }
        return null;
    }
    const { head: head } = state.selection.main;
    // First try the cursor position directly.
    const direct = levelFromNames($b8e7170495150c53$var$ancestorNames(state, head));
    if (direct !== null) return direct;
    // When the cursor is at the very end of a line (on the \n character),
    // Lezer places it outside the ATXHeading node boundary. Fall back to
    // the last character of the line to detect the heading correctly.
    const line = state.doc.lineAt(head);
    if (head === line.to && line.to > line.from) return levelFromNames($b8e7170495150c53$var$ancestorNames(state, line.to - 1));
    return null;
}
/**
 * Returns true if the primary selection head is inside `typeName`, including
 * the common CM6 edge case where the cursor sits at the end of a non-empty
 * line and Lezer resolves it onto the trailing newline outside the node.
 */ function $b8e7170495150c53$var$isAtCursorOrLineEnd(state, typeName) {
    const { head: head } = state.selection.main;
    if ($b8e7170495150c53$var$hasAncestor(state, head, typeName)) return true;
    const line = state.doc.lineAt(head);
    return head === line.to && line.to > line.from && $b8e7170495150c53$var$hasAncestor(state, line.to - 1, typeName);
}
function $b8e7170495150c53$export$8533b10fb9ecef78(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.Blockquote);
}
function $b8e7170495150c53$export$857ab4b4af2c663a(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.BulletList);
}
function $b8e7170495150c53$export$bcf034afbca8b7b1(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.OrderedList);
}
function $b8e7170495150c53$export$2ee0ef920e12bb1f(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.Task) || $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.TaskMarker);
}
function $b8e7170495150c53$export$b777e8b4e40fe375(state, format) {
    return $b8e7170495150c53$export$753a775122b7b63b(state, $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE[format]);
}
function $b8e7170495150c53$export$5069c0cb22ba97e6(state) {
    return {
        boldActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'bold'),
        italicActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'italic'),
        codeActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'inlineCode'),
        strikeActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'strikethrough'),
        inlineFormattingAvailable: $b8e7170495150c53$export$bd3fd8da835721f8(state)
    };
}
function $b8e7170495150c53$export$96bc0c55bfc3ec38(state) {
    const { head: head } = state.selection.main;
    return {
        headingLevel: $b8e7170495150c53$export$8e72f433f86285(state),
        inBlockquote: $b8e7170495150c53$export$8533b10fb9ecef78(state),
        inCodeBlock: $b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock)
    };
}
function $b8e7170495150c53$export$19f8516089a6ae9b(state) {
    // Derive list type from the actual text prefix on the cursor's line.
    // This is the ground truth — whichever marker appears first on the line
    // determines the list type, avoiding ambiguity from Lezer ancestor checks
    // that can overlap (e.g. task list nodes live inside BulletList nodes).
    //
    // Regex groups:
    //   TASK_PREFIX_REGEX   — bullet/ordered marker followed by `[ ]` checkbox
    //   LIST_MARKER_REGEX — any list marker; group 2 distinguishes type:
    //     \d+\. → ordered list
    //     [-*+]  → bullet list
    const { head: head } = state.selection.main;
    const lineText = state.doc.lineAt(head).text;
    if ($b8e7170495150c53$var$TASK_PREFIX_REGEX.test(lineText)) return {
        inBulletList: false,
        inOrderedList: false,
        inTaskList: true
    };
    const listMatch = lineText.match($b8e7170495150c53$var$LIST_MARKER_REGEX);
    if (listMatch) {
        const marker = listMatch[2];
        const isOrdered = $b8e7170495150c53$var$ORDERED_MARKER_REGEX.test(marker);
        return {
            inBulletList: !isOrdered,
            inOrderedList: isOrdered,
            inTaskList: false
        };
    }
    return {
        inBulletList: false,
        inOrderedList: false,
        inTaskList: false
    };
}
// ---------------------------------------------------------------------------
// Syntax primitive factories - return SourceViewCommand values
// ---------------------------------------------------------------------------
/**
 * The Lezer mark node types used to delimit inline formatting. These are the
 * nodes whose text we remove when toggling off a format.
 */ const $b8e7170495150c53$var$INLINE_MARK_NODE_TYPES = new Set([
    $b8e7170495150c53$export$2d73244c2182ac32.EmphasisMark,
    $b8e7170495150c53$export$2d73244c2182ac32.StrikethroughMark,
    $b8e7170495150c53$export$2d73244c2182ac32.CodeMark
]);
/**
 * Find the innermost enclosing Lezer node of `nodeType` at `pos`, then return
 * the positions of its opening and closing mark child nodes. Returns null if
 * no such node is found or if the marks cannot be located.
 */ function $b8e7170495150c53$var$findEnclosingMarkPositions(state, pos, nodeType) {
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent && node.type.name !== nodeType)node = node.parent;
    if (node.type.name !== nodeType) return null;
    let openMark = node.firstChild;
    while(openMark && !$b8e7170495150c53$var$INLINE_MARK_NODE_TYPES.has(openMark.type.name))openMark = openMark.nextSibling;
    let closeMark = node.lastChild;
    while(closeMark && !$b8e7170495150c53$var$INLINE_MARK_NODE_TYPES.has(closeMark.type.name))closeMark = closeMark.prevSibling;
    if (!openMark || !closeMark || openMark === closeMark) return null;
    return {
        openFrom: openMark.from,
        openTo: openMark.to,
        closeFrom: closeMark.from,
        closeTo: closeMark.to
    };
}
function $b8e7170495150c53$export$a43514489bd58733(format) {
    return (view)=>{
        const { state: state } = view;
        const syntax = $b8e7170495150c53$var$INLINE_FORMAT_SYNTAX[format];
        const lezerNodeType = $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE[format];
        if (format !== 'inlineCode' && ($b8e7170495150c53$export$59eae5fcd69a8ca2(state) || $b8e7170495150c53$export$8970a27599376db5(state))) return false;
        const range = state.selection.main;
        const { from: from, to: to } = range;
        // Toggle off via Lezer tree - variant-agnostic, handles combined marks.
        const marks = $b8e7170495150c53$var$findEnclosingMarkPositions(state, range.head, lezerNodeType);
        if (marks) {
            const { openFrom: openFrom, openTo: openTo, closeFrom: closeFrom, closeTo: closeTo } = marks;
            const changes = [
                {
                    from: openFrom,
                    to: openTo,
                    insert: ''
                },
                {
                    from: closeFrom,
                    to: closeTo,
                    insert: ''
                }
            ];
            const changeSet = state.changes(changes);
            const mappedSelection = (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
            view.dispatch(state.update({
                changes: changes,
                selection: mappedSelection
            }));
            return true;
        }
        // No selection - insert pair and place cursor between.
        if (range.empty) {
            view.dispatch(state.update({
                changes: {
                    from: from,
                    insert: syntax + syntax
                },
                selection: {
                    anchor: from + syntax.length
                }
            }));
            return true;
        }
        // Toggle on - wrap selection.
        view.dispatch(state.update({
            changes: [
                {
                    from: from,
                    insert: syntax
                },
                {
                    from: to,
                    insert: syntax
                }
            ],
            selection: {
                anchor: from + syntax.length,
                head: to + syntax.length
            }
        }));
        return true;
    };
}
function $b8e7170495150c53$export$f3072de57f1b974a(prefix, options = {}) {
    const { stripConflictingList: stripConflictingList = false } = options;
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const allHavePrefix = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i)).every((line)=>line.text.startsWith(prefix));
        const changes = [];
        // When inserting a prefix on a blank line with a trailing '\n' to preserve
        // CommonMark block separation, we need to explicitly place the cursor after
        // the prefix (not after the '\n'). Track that position here.
        let explicitCursorPos = null;
        for(let n = firstLine.number; n <= lastLine.number; n++){
            const line = doc.line(n);
            if (allHavePrefix) changes.push({
                from: line.from,
                to: line.from + prefix.length,
                insert: ''
            });
            else if (!line.text.startsWith(prefix)) {
                // When switching list types, strip any existing list prefix before
                // inserting the new one so that bullet and ordered lists remain
                // mutually exclusive (fixes: both list types active simultaneously).
                if (stripConflictingList) {
                    const existingListMatch = line.text.match($b8e7170495150c53$var$LIST_MARKER_REGEX);
                    if (existingListMatch) {
                        changes.push({
                            from: line.from,
                            to: line.from + existingListMatch[0].length,
                            insert: prefix
                        });
                        continue;
                    }
                }
                if (line.text === '' && n === firstLine.number && n === lastLine.number) {
                    // Inserting a list/quote prefix on a blank line between paragraphs.
                    // Without a trailing blank line, the next paragraph would be parsed
                    // as a lazy continuation of this list item by CommonMark. Insert
                    // a blank line after the prefix to keep the blocks separate.
                    const nextLine = n < doc.lines ? doc.line(n + 1) : null;
                    if (nextLine && nextLine.text !== '') {
                        changes.push({
                            from: line.from,
                            insert: prefix + '\n'
                        });
                        // Cursor should land after the prefix, not after the inserted '\n'.
                        explicitCursorPos = line.from + prefix.length;
                    } else changes.push({
                        from: line.from,
                        insert: prefix
                    });
                } else changes.push({
                    from: line.from,
                    insert: prefix
                });
            }
        }
        const changeSet = state.changes(changes);
        // If we inserted "prefix\n" on a blank line, place the cursor explicitly
        // after the prefix so it stays on the same (now prefixed) line.
        // Otherwise, map the selection through the changes. Use assoc=1 so that positions
        // that coincide with an insertion point (e.g. cursor at col 0 when we
        // insert a prefix there) are moved forward rather than left behind.
        const mappedSelection = explicitCursorPos !== null ? (0, $b2ZzE.EditorSelection).cursor(explicitCursorPos) : (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        const tr = state.update({
            changes: changes,
            selection: mappedSelection
        });
        view.dispatch(tr);
        return true;
    };
}
function $b8e7170495150c53$export$f27293a683e57637() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const lines = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i));
        const allHaveTaskPrefix = lines.every((line)=>$b8e7170495150c53$var$TASK_PREFIX_REGEX.test(line.text));
        const changes = [];
        for (const line of lines){
            const taskMatch = line.text.match($b8e7170495150c53$var$TASK_PREFIX_REGEX);
            if (allHaveTaskPrefix && taskMatch) {
                changes.push({
                    from: line.from + taskMatch[1].length,
                    to: line.from + taskMatch[0].length,
                    insert: ''
                });
                continue;
            }
            if (taskMatch) continue;
            const listMatch = line.text.match($b8e7170495150c53$var$LIST_PREFIX_PATTERN_REGEX);
            if (listMatch) {
                changes.push({
                    from: line.from + listMatch[1].length,
                    to: line.from + listMatch[0].length,
                    insert: '- [ ] '
                });
                continue;
            }
            const indentation = line.text.match($b8e7170495150c53$var$LEADING_WHITESPACE_REGEX)?.[0] ?? '';
            if (line.text === '' && line.number === firstLine.number && line.number === lastLine.number) {
                const nextLine = line.number < doc.lines ? doc.line(line.number + 1) : null;
                changes.push({
                    from: line.from,
                    insert: nextLine && nextLine.text !== '' ? '- [ ] \n' : '- [ ] '
                });
            } else changes.push({
                from: line.from + indentation.length,
                insert: '- [ ] '
            });
        }
        const changeSet = state.changes(changes);
        const mappedSelection = (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        view.dispatch(state.update({
            changes: changes,
            selection: mappedSelection
        }));
        return true;
    };
}
function $b8e7170495150c53$export$fdf2c1c8534e927b(level) {
    return (view)=>{
        const { state: state } = view;
        const { head: head } = state.selection.main;
        if ($b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock)) return false;
        const line = state.doc.lineAt(head);
        const text = line.text;
        const existingMatch = text.match($b8e7170495150c53$var$ATX_HEADING_PREFIX_REGEX);
        const targetPrefix = '#'.repeat(level) + ' ';
        const existingHeadingLevel = $b8e7170495150c53$export$8e72f433f86285(state);
        if (existingMatch) {
            const existingPrefix = existingMatch[0];
            if (existingPrefix === targetPrefix) view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: ''
                }
            }));
            else view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: targetPrefix
                }
            }));
        } else if (existingHeadingLevel !== null) return false;
        else view.dispatch(state.update({
            changes: {
                from: line.from,
                insert: targetPrefix
            }
        }));
        return true;
    };
}
function $b8e7170495150c53$export$3b2204dc19d35ba4() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$hasAncestor(state, from, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode)) {
            let node = (0, $4lK5a.syntaxTree)(state).resolveInner(from, 1);
            while(node.parent && node.type.name !== $b8e7170495150c53$export$2d73244c2182ac32.FencedCode)node = node.parent;
            if (node.type.name === $b8e7170495150c53$export$2d73244c2182ac32.FencedCode) {
                const fenceText = state.doc.sliceString(node.from, node.to);
                const openFenceEnd = fenceText.indexOf('\n');
                const closeFenceStart = fenceText.lastIndexOf('\n');
                if (openFenceEnd !== -1) {
                    const inner = fenceText.slice(openFenceEnd + 1, closeFenceStart);
                    view.dispatch(state.update({
                        changes: {
                            from: node.from,
                            to: node.to,
                            insert: inner
                        }
                    }));
                    return true;
                }
            }
        }
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const selectedText = doc.sliceString(firstLine.from, lastLine.to);
        view.dispatch(state.update({
            changes: {
                from: firstLine.from,
                to: lastLine.to,
                insert: '```\n' + selectedText + '\n```'
            },
            selection: {
                anchor: firstLine.from + 4
            }
        }));
        return true;
    };
}
const $b8e7170495150c53$export$b850a936f66192a3 = $b8e7170495150c53$export$a43514489bd58733('bold');
const $b8e7170495150c53$export$227b5ef404be9031 = $b8e7170495150c53$export$a43514489bd58733('italic');
const $b8e7170495150c53$export$e7d955a85cfe503c = $b8e7170495150c53$export$a43514489bd58733('inlineCode');
const $b8e7170495150c53$export$a46d65f808b4881d = $b8e7170495150c53$export$a43514489bd58733('strikethrough');
const $b8e7170495150c53$export$2cd68375ac1e5429 = $b8e7170495150c53$export$f3072de57f1b974a('> ');
const $b8e7170495150c53$export$71c898cbdfd51c6e = $b8e7170495150c53$export$f3072de57f1b974a('* ', {
    stripConflictingList: true
});
const $b8e7170495150c53$export$744c9722bde8c6b3 = $b8e7170495150c53$export$f3072de57f1b974a('1. ', {
    stripConflictingList: true
});
const $b8e7170495150c53$export$49b8416aa3f9522a = $b8e7170495150c53$export$f27293a683e57637();
const $b8e7170495150c53$export$4e0d444e5782abea = $b8e7170495150c53$export$fdf2c1c8534e927b(1);
const $b8e7170495150c53$export$b8d734de6aecb0a3 = $b8e7170495150c53$export$fdf2c1c8534e927b(2);
const $b8e7170495150c53$export$df05910f74b29e0 = $b8e7170495150c53$export$fdf2c1c8534e927b(3);
const $b8e7170495150c53$export$ca48da5fbbd68542 = $b8e7170495150c53$export$fdf2c1c8534e927b(4);
const $b8e7170495150c53$export$1335885ed6c2d3ac = $b8e7170495150c53$export$fdf2c1c8534e927b(5);
const $b8e7170495150c53$export$8381ca7ddcf8db0d = $b8e7170495150c53$export$fdf2c1c8534e927b(6);
const $b8e7170495150c53$export$b420bd8551521778 = $b8e7170495150c53$export$3b2204dc19d35ba4();
/**
 * Builds a markdown table string with the given number of rows and columns.
 * Row count includes the header row (so rowsCount=3 → 1 header + 2 data rows).
 * Used by `insertSourceTableCommand` to insert tables at the CM cursor.
 */ function $b8e7170495150c53$var$buildMarkdownTable(rowsCount, colsCount) {
    const emptyRow = `| ${Array.from({
        length: colsCount
    }, ()=>' ').join(' | ')} |`;
    const separator = `| ${Array.from({
        length: colsCount
    }, ()=>'-').join(' | ')} |`;
    const dataRows = Array.from({
        length: rowsCount - 1
    }, ()=>emptyRow);
    return [
        emptyRow,
        separator,
        ...dataRows
    ].join('\n');
}
function $b8e7170495150c53$export$feb50cc511a53ca1(rowsCount = 3, colsCount = 3) {
    return (view)=>{
        const markdownTable = $b8e7170495150c53$var$buildMarkdownTable(rowsCount, colsCount);
        const { from: from, to: to } = view.state.selection.main;
        view.dispatch(view.state.update({
            changes: {
                from: from,
                to: to,
                insert: markdownTable
            },
            selection: {
                anchor: from + markdownTable.length
            }
        }));
        return true;
    };
}


/**
 * MarkdownModeContentComponentDiff — writes source-view edits back to the
 * live ProseMirror doc as surgical `Step`s (via `@atlassian/content-reconciler`) instead of a
 * single full-document `replaceWith`.
 *
 * Selected by the plugin as the sole content-writeback component. All other
 * behaviour — snapshot, dispatch tap, source/preview rendering, format-state
 * plumbing — matches the legacy component.
 *
 * Differences vs `MarkdownModeContentComponent`:
 *  - `handleSourceMarkdownChange` and `handleMarkdownCommit` call
 *    `applyDiffSteps(editorView, adfNode)` instead of building a
 *    `replaceWith` transaction.
 *  - Annotations are passed to `@atlassian/content-reconciler` as ignored mark types
 *    (`{ ignoreMarkTypes: ['annotation'] }`). The library then:
 *      · doesn't fork prefix/suffix or similarity decisions on annotations,
 *      · inherits annotation marks into Replace/Insert slices from the old
 *        doc, so text edited inside an annotated span keeps the annotation
 *        without an explicit re-paint,
 *      · never emits `AddMark`/`RemoveMark` for annotation marks.
 *    Cross-boundary edits (an edit that spans two annotations, or partially
 *    overlaps one) are still ambiguous — the inheritance rule picks a side.
 *    Snapshot-time annotation ranges are passed to the source view so
 *    highlights render, and `onAnnotationClick` opens the comment popup.
 *  - Collab-safe. Steps are diffed against `seedPmDocRef` and rebased
 *    through `interveningMappingRef` (non-own txs since the seed). Both
 *    refs reset on snapshot and after every successful writeback.
 */ 






var $eOaGc = parcelRequire("eOaGc");





var $5nazv = parcelRequire("5nazv");

/**
 * Diff `seedDoc` → `newAdfNode` via `@atlassian/content-reconciler` and
 * dispatch the resulting Steps as one `addToHistory: false` tx. Each Step
 * is rebased through `interveningMapping` (non-own txs since the seed)
 * before dispatch, making the writeback safe to interleave with remote
 * collab steps. The tx carries `OWN_WRITEBACK_META` so the orchestrator's
 * dispatch tap can echo-filter it synchronously.
 */ 



var $aPdNQ = parcelRequire("aPdNQ");










function $1b24bfcd447ec548$export$c04a05f66108dc98(content) {
    const out = [];
    let acc = null;
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        if (child.isText && child.text !== undefined) {
            const text = child.text;
            if (acc === null) acc = {
                kind: 'textRun',
                text: text,
                spans: [
                    {
                        start: 0,
                        end: text.length,
                        marks: child.marks
                    }
                ]
            };
            else {
                const start = acc.text.length;
                acc.text += text;
                acc.spans.push({
                    start: start,
                    end: acc.text.length,
                    marks: child.marks
                });
            }
        } else {
            if (acc) {
                out.push(acc);
                acc = null;
            }
            out.push({
                kind: 'node',
                node: child
            });
        }
    }
    if (acc) out.push(acc);
    return out;
}
function $1b24bfcd447ec548$export$865f3f3e3ebbacd6(run, from, to, mkText, extraMarks = []) {
    if (from >= to) return [];
    const out = [];
    let pos = from;
    while(pos < to){
        const span = $1b24bfcd447ec548$var$spanCovering(run.spans, pos);
        const segEnd = Math.min(span?.end ?? to, to);
        const segText = run.text.slice(pos, segEnd);
        if (segText.length > 0) {
            const baseMarks = span?.marks ?? [];
            const marks = extraMarks.length === 0 ? baseMarks : $1b24bfcd447ec548$var$mergeMarks(baseMarks, extraMarks);
            out.push(mkText(segText, marks));
        }
        pos = segEnd;
    }
    return out;
}
function $1b24bfcd447ec548$export$772de15c541bba1a(run, pos, keep) {
    if (keep.size === 0) return [];
    const span = $1b24bfcd447ec548$var$spanCovering(run.spans, pos);
    if (!span) return [];
    return span.marks.filter((m)=>keep.has(m.type.name));
}
function $1b24bfcd447ec548$var$mergeMarks(a, b) {
    const out = [
        ...a
    ];
    for (const m of b)if (!out.some((existing)=>existing.eq(m))) out.push(m);
    return out;
}
function $1b24bfcd447ec548$var$spanCovering(spans, pos) {
    // Linear scan is fine for the typical case (one or two text runs per paragraph).
    // Switch to binary search if benchmarks show this matters.
    for (const s of spans){
        if (pos >= s.start && pos < s.end) return s;
    }
    return null;
}



/**
 * Hirschberg's LCS algorithm: O(m*n) time, O(min(m,n)) space.
 * Returns matching index pairs (i in xs, j in ys).
 *
 * Ported from `core/lcs/Hirschberg.kt` in adf-content-reconciler.
 *
 * `maxRegions` is a safety cutoff: if the LCS would produce more than this many
 * distinct match runs (heuristically: the number of returned pairs is an upper
 * bound on the number of regions), we bail out and return `null` so the caller
 * can fall back to emitting a single Replace over the whole range. This protects
 * against pathological diffs on large inputs where surgical steps offer no real
 * benefit.
 */ function $c586b7a08c6a9153$export$99056b812f67789a(xs, ys, equal, maxRegions = 0) {
    return $c586b7a08c6a9153$var$hirschbergView(xs, 0, xs.length, ys, 0, ys.length, equal, maxRegions);
}
function $c586b7a08c6a9153$var$hirschbergView(xs, xLo, xHi, ys, yLo, yHi, equal, maxRegions) {
    const xLen = xHi - xLo;
    const yLen = yHi - yLo;
    if (xLen === 0 || yLen === 0) return [];
    if (xLen === 1) {
        for(let j = 0; j < yLen; j++){
            if (equal(xs[xLo], ys[yLo + j])) return [
                [
                    xLo,
                    yLo + j
                ]
            ];
        }
        return [];
    }
    if (yLen === 1) {
        for(let i = 0; i < xLen; i++){
            if (equal(xs[xLo + i], ys[yLo])) return [
                [
                    xLo + i,
                    yLo
                ]
            ];
        }
        return [];
    }
    const midX = xLo + (xLen >> 1);
    const l1 = $c586b7a08c6a9153$var$lcsRow(xs, xLo, midX, ys, yLo, yHi, equal, /*reverse*/ false);
    const l2 = $c586b7a08c6a9153$var$lcsRow(xs, midX, xHi, ys, yLo, yHi, equal, /*reverse*/ true);
    // Find optimal split point in Y (relative offset into ys[yLo..yHi]).
    let bestK = 0;
    let bestSum = -1;
    for(let k = 0; k <= yLen; k++){
        const sum = l1[k] + l2[k];
        if (sum > bestSum) {
            bestSum = sum;
            bestK = k;
        }
    }
    const split = yLo + bestK;
    const left = $c586b7a08c6a9153$var$hirschbergView(xs, xLo, midX, ys, yLo, split, equal, maxRegions);
    if (left === null) return null;
    if (maxRegions > 0 && left.length > maxRegions) return null;
    const right = $c586b7a08c6a9153$var$hirschbergView(xs, midX, xHi, ys, split, yHi, equal, maxRegions);
    if (right === null) return null;
    if (maxRegions > 0 && left.length + right.length > maxRegions) return null;
    // Indices in `right` are already absolute (we passed absolute xs/ys plus bounds).
    return left.concat(right);
}
/**
 * One row of the LCS DP. When `reverse` is true, iterates from the high end
 * backwards, which produces the suffix-LCS lengths needed by the Hirschberg split.
 */ function $c586b7a08c6a9153$var$lcsRow(xs, xLo, xHi, ys, yLo, yHi, equal, reverse) {
    const yLen = yHi - yLo;
    const dp = new Array(yLen + 1).fill(0);
    const xStart = reverse ? xHi - 1 : xLo;
    const xEnd = reverse ? xLo - 1 : xHi;
    const xStep = reverse ? -1 : 1;
    for(let i = xStart; i !== xEnd; i += xStep){
        let prev = 0;
        const yStart = reverse ? yLen - 1 : 0;
        const yEnd = reverse ? -1 : yLen;
        const yStep = reverse ? -1 : 1;
        for(let j = yStart; j !== yEnd; j += yStep){
            // Forward: dp[j+1] = match? prev+1 : max(dp[j+1], dp[j])
            // Reverse: dp[j]   = match? prev+1 : max(dp[j],   dp[j+1])
            const cur = reverse ? j : j + 1;
            const other = reverse ? j + 1 : j;
            const temp = dp[cur];
            dp[cur] = equal(xs[i], ys[yLo + j]) ? prev + 1 : Math.max(dp[cur], dp[other]);
            prev = temp;
        }
    }
    return dp;
}


function $73c8b1fe933177ea$export$268be64a1d1b0703(oldList, newList, emit, similarity = (a, b)=>a === b, maxRegions = 0, strictEqual = similarity) {
    const oldSize = oldList.length;
    const newSize = newList.length;
    // Common prefix
    let prefix = 0;
    while(prefix < Math.min(oldSize, newSize) && strictEqual(oldList[prefix], newList[prefix]))prefix++;
    // Common suffix (only over the part not already consumed by prefix)
    let suffix = 0;
    while(suffix < Math.min(oldSize, newSize) - prefix && strictEqual(oldList[oldSize - 1 - suffix], newList[newSize - 1 - suffix]))suffix++;
    if (prefix > 0) emit({
        kind: 'match',
        oldIndex: 0,
        newIndex: 0,
        length: prefix
    });
    if (suffix > 0) emit({
        kind: 'match',
        oldIndex: oldSize - suffix,
        newIndex: newSize - suffix,
        length: suffix
    });
    if (prefix === oldSize && prefix === newSize) return;
    const oldMidLo = prefix;
    const oldMidHi = oldSize - suffix;
    const newMidLo = prefix;
    const newMidHi = newSize - suffix;
    const oldMid = oldList.slice(oldMidLo, oldMidHi);
    const newMid = newList.slice(newMidLo, newMidHi);
    // Phase 1: lock strict-equal pairs as anchors.
    // If `strictEqual` is the same function reference as `similarity` (the
    // default), the anchor pass is degenerate with the LCS pass below; skip it.
    const anchors = strictEqual === similarity ? [] : (0, $c586b7a08c6a9153$export$99056b812f67789a)(oldMid, newMid, strictEqual, 0) ?? [];
    // Phase 2: run same-type LCS inside each gap between anchors.
    // The result `lcsRelative` is the union of all anchor pairs and gap LCS
    // pairs, in increasing order, in coords relative to oldMid / newMid.
    let lcsRelative = [];
    let lastOldEnd = 0;
    let lastNewEnd = 0;
    const runGap = (oldLo, oldHi, newLo, newHi)=>{
        if (lcsRelative === null) return;
        if (oldHi - oldLo === 0 || newHi - newLo === 0) return;
        const gapPairs = (0, $c586b7a08c6a9153$export$99056b812f67789a)(oldMid.slice(oldLo, oldHi), newMid.slice(newLo, newHi), similarity, maxRegions);
        if (gapPairs === null) {
            lcsRelative = null;
            return;
        }
        for (const [i, j] of gapPairs)lcsRelative.push([
            oldLo + i,
            newLo + j
        ]);
    };
    for (const [aOld, aNew] of anchors){
        runGap(lastOldEnd, aOld, lastNewEnd, aNew);
        if (lcsRelative === null) break;
        lcsRelative.push([
            aOld,
            aNew
        ]);
        lastOldEnd = aOld + 1;
        lastNewEnd = aNew + 1;
    }
    if (lcsRelative !== null) runGap(lastOldEnd, oldMid.length, lastNewEnd, newMid.length);
    // LCS aborted (too many regions in some gap) → collapse to a single replace
    // over the entire middle. Anchors are discarded here on purpose: once we've
    // decided to fall back to wholesale replace, partial anchoring would emit a
    // weird mix of small matches plus a giant replace around them.
    if (lcsRelative === null) {
        emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Adjust LCS pairs back to absolute indices.
    const lcs = lcsRelative.map(([i, j])=>[
            i + prefix,
            j + prefix
        ]);
    if (lcs.length === 0) {
        // No matches in the middle - one of insert/delete/replace
        if (oldMidHi - oldMidLo === 0) emit({
            kind: 'insert',
            insertAt: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        else if (newMidHi - newMidLo === 0) emit({
            kind: 'delete',
            from: oldMidLo,
            to: oldMidHi
        });
        else emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Walk old/new in tandem, emitting Match/Insert/Delete runs based on LCS pairs.
    let oldIdx = prefix;
    let newIdx = prefix;
    let lcsIdx = 0;
    const matched = ()=>lcsIdx < lcs.length && oldIdx === lcs[lcsIdx][0] && newIdx === lcs[lcsIdx][1];
    const shouldInsert = ()=>{
        if (newIdx >= newSize) return false;
        if (lcsIdx < lcs.length) return newIdx < lcs[lcsIdx][1];
        return newSize - newIdx > oldSize - oldIdx;
    };
    const shouldDelete = ()=>{
        if (oldIdx >= oldSize) return false;
        if (lcsIdx < lcs.length) return oldIdx < lcs[lcsIdx][0];
        return oldSize - oldIdx > newSize - newIdx;
    };
    while(oldIdx + suffix < oldSize || newIdx + suffix < newSize){
        if (matched()) {
            const oldStart = oldIdx;
            const newStart = newIdx;
            let len = 0;
            do {
                oldIdx++;
                newIdx++;
                lcsIdx++;
                len++;
            }while (matched());
            emit({
                kind: 'match',
                oldIndex: oldStart,
                newIndex: newStart,
                length: len
            });
        } else if (shouldInsert()) {
            const start = newIdx;
            do newIdx++;
            while (shouldInsert());
            emit({
                kind: 'insert',
                insertAt: oldIdx,
                from: start,
                to: newIdx
            });
        } else {
            const start = oldIdx;
            do oldIdx++;
            while (shouldDelete());
            emit({
                kind: 'delete',
                from: start,
                to: oldIdx
            });
        }
    }
}








function $1cd935bd164bf76f$export$8f0d278bb8862aee(marks, ignore) {
    if (ignore.size === 0) return marks;
    if (!marks.some((m)=>ignore.has(m.type.name))) return marks;
    return marks.filter((m)=>!ignore.has(m.type.name));
}
const $1cd935bd164bf76f$export$499e45ef1aa79998 = (v)=>{
    if (v === null || typeof v !== 'object') return JSON.stringify(v) ?? 'null';
    if (Array.isArray(v)) return `[${v.map($1cd935bd164bf76f$export$499e45ef1aa79998).join(',')}]`;
    const o = v;
    return `{${Object.keys(o).sort().map((k)=>`${JSON.stringify(k)}:${$1cd935bd164bf76f$export$499e45ef1aa79998(o[k])}`).join(',')}}`;
};
function $1cd935bd164bf76f$export$88a30e5386bda853(a, b, ignore) {
    if (ignore.size === 0) return a.eq(b);
    if (a.eq(b)) return true; // fast path; covers the common case
    if (a.type !== b.type) return false;
    if (!$1cd935bd164bf76f$var$sameMarkSet($1cd935bd164bf76f$export$8f0d278bb8862aee(a.marks, ignore), $1cd935bd164bf76f$export$8f0d278bb8862aee(b.marks, ignore))) return false;
    // PM attrs are plain JSON values; compare them independent of object key order.
    if ($1cd935bd164bf76f$export$499e45ef1aa79998(a.attrs ?? {}) !== $1cd935bd164bf76f$export$499e45ef1aa79998(b.attrs ?? {})) return false;
    if (a.isText) return a.text === b.text;
    if (a.type.inlineContent) return $1cd935bd164bf76f$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$1cd935bd164bf76f$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
/**
 * Inline-aware equality: walks two inline-content fragments as a character
 * stream + non-text token stream, applying mark filtering per character. This
 * sidesteps PM's text-node auto-merging differences between the two sides.
 */ function $1cd935bd164bf76f$var$inlineContentEqIgnoring(a, b, ignore) {
    const tokens = (frag)=>{
        const out = [];
        for(let i = 0; i < frag.childCount; i++){
            const child = frag.child(i);
            if (child.isText && child.text !== undefined) {
                const marks = $1cd935bd164bf76f$export$8f0d278bb8862aee(child.marks, ignore);
                for (const ch of child.text)out.push({
                    kind: 'char',
                    ch: ch,
                    marks: marks
                });
            } else out.push({
                kind: 'node',
                node: child
            });
        }
        return out;
    };
    const at = tokens(a);
    const bt = tokens(b);
    if (at.length !== bt.length) return false;
    for(let i = 0; i < at.length; i++){
        const x = at[i];
        const y = bt[i];
        if (x.kind !== y.kind) return false;
        if (x.kind === 'char' && y.kind === 'char') {
            if (x.ch !== y.ch) return false;
            if (!$1cd935bd164bf76f$var$sameMarkSet(x.marks, y.marks)) return false;
        } else if (x.kind === 'node' && y.kind === 'node') {
            if (!$1cd935bd164bf76f$export$88a30e5386bda853(x.node, y.node, ignore)) return false;
        }
    }
    return true;
}
function $1cd935bd164bf76f$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $1cd935bd164bf76f$export$fbd56eac4544ec5f(a, b, ignore) {
    if (a.type.inlineContent || b.type.inlineContent) return $1cd935bd164bf76f$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$1cd935bd164bf76f$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
const $1cd935bd164bf76f$export$51d01ce5f35c1d = (i)=>i.kind === 'textRun';


function $1bb2f819ff5b602a$export$6edd5090aa051c73(oldNode, newNode, pos, ctx) {
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return null;
    // ---------------------------------------------------------------------------
    // Case 1: same content, different shell (type and/or attrs+marks)
    // ---------------------------------------------------------------------------
    // Same type with different attrs is handled by AttrStep elsewhere, so this
    // pattern is meaningful only when the type itself changes.
    if (oldNode.type !== newNode.type && (0, $1cd935bd164bf76f$export$fbd56eac4544ec5f)(oldNode, newNode, ctx.ignoreMarks)) return $1bb2f819ff5b602a$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos + 1, /* gapTo  */ pos + 1 + oldNode.content.size, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 2: wrap (newNode has a single child equal to oldNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (newNode.childCount === 1 && (0, $1cd935bd164bf76f$export$88a30e5386bda853)(newNode.firstChild, oldNode, ctx.ignoreMarks)) return $1bb2f819ff5b602a$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos, /* gapTo  */ pos + oldNode.nodeSize, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 3: unwrap (oldNode has a single child equal to newNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (oldNode.childCount === 1 && (0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode.firstChild, newNode, ctx.ignoreMarks)) return new (0, $eOaGc.ReplaceAroundStep)(pos, pos + oldNode.nodeSize, pos + 1, pos + 1 + newNode.nodeSize, (0, $aPdNQ.Slice).empty, 0, /* structure */ true);
    return null;
}
function $1bb2f819ff5b602a$var$wrapStep(from, to, gapFrom, gapTo, shell, insert) {
    return new (0, $eOaGc.ReplaceAroundStep)(from, to, gapFrom, gapTo, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(shell), 0, 0), insert, /* structure */ true);
}











const $6128bbb40a9f2a1f$var$markKey = (m)=>`${m.type.name}:${(0, $1cd935bd164bf76f$export$499e45ef1aa79998)(m.attrs ?? {})}`;
const $6128bbb40a9f2a1f$export$9171f3c03db619a = (a, b)=>{
    if (a.length !== b.length) return false;
    const bKeys = new Set(b.map($6128bbb40a9f2a1f$var$markKey));
    return a.every((m)=>bKeys.has($6128bbb40a9f2a1f$var$markKey(m)));
};
/**
 * Returns marks present in `as` but not in `bs` (by type + attrs).
 */ function $6128bbb40a9f2a1f$var$subtractMarks(as, bs) {
    const bKeys = new Set(bs.map($6128bbb40a9f2a1f$var$markKey));
    return as.filter((m)=>!bKeys.has($6128bbb40a9f2a1f$var$markKey(m)));
}
function $6128bbb40a9f2a1f$export$95843026304694ba(oldSpans, newSpans) {
    const events = [];
    for (const s of oldSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: true,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: true,
            marks: s.marks
        });
    }
    for (const s of newSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: false,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: false,
            marks: s.marks
        });
    }
    // Sort by pos; for equal positions, OLD events first so the new state
    // takes effect for any sub-range starting at that boundary.
    events.sort((a, b)=>a.pos - b.pos || (a.fromOld === b.fromOld ? 0 : a.fromOld ? -1 : 1));
    const deltas = [];
    let curOld = [];
    let curNew = [];
    let last = 0;
    for (const ev of events){
        if (!ev.isStart && last < ev.pos) {
            for (const m of $6128bbb40a9f2a1f$var$subtractMarks(curNew, curOld))deltas.push({
                type: 'insert',
                from: last,
                to: ev.pos,
                mark: m
            });
            for (const m of $6128bbb40a9f2a1f$var$subtractMarks(curOld, curNew))deltas.push({
                type: 'delete',
                from: last,
                to: ev.pos,
                mark: m
            });
        }
        if (ev.fromOld) curOld = ev.marks;
        else curNew = ev.marks;
        last = ev.pos;
    }
    return deltas;
}
function $6128bbb40a9f2a1f$export$8c5998c7a945df3e(spans, from, to) {
    if (from >= to) return [];
    const result = [];
    for (const s of spans){
        if (s.end <= from) continue;
        if (s.start >= to) break;
        result.push({
            start: Math.max(s.start, from),
            end: Math.min(s.end, to),
            marks: s.marks
        });
    }
    return result;
}



function $408fdb1e6962a9ee$export$7f227f8ae15d3928(oldRun, newRun, parentPos, ctx) {
    const schema = ctx.schema;
    const ignore = ctx.ignoreMarks;
    const steps = [];
    if (oldRun.text.length === 0 && newRun.text.length === 0) return [];
    if (oldRun.text.length === 0) {
        const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, 0, newRun.text.length, schema.text.bind(schema));
        steps.push(new (0, $eOaGc.ReplaceStep)(parentPos, parentPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
        return steps;
    }
    if (newRun.text.length === 0) {
        steps.push(new (0, $eOaGc.ReplaceStep)(parentPos, parentPos + oldRun.text.length, (0, $aPdNQ.Slice).empty));
        return steps;
    }
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(Array.from(oldRun.text), Array.from(newRun.text), (op)=>{
        switch(op.kind){
            case 'match':
                {
                    const oldClipped = $408fdb1e6962a9ee$var$filteredClipped(oldRun.spans, op.oldIndex, op.oldIndex + op.length, op.oldIndex, ignore);
                    const newClipped = $408fdb1e6962a9ee$var$filteredClipped(newRun.spans, op.newIndex, op.newIndex + op.length, op.newIndex, ignore);
                    for (const d of (0, $6128bbb40a9f2a1f$export$95843026304694ba)(oldClipped, newClipped)){
                        const from = parentPos + op.oldIndex + d.from;
                        const to = parentPos + op.oldIndex + d.to;
                        steps.push(d.type === 'insert' ? new (0, $eOaGc.AddMarkStep)(from, to, d.mark) : new (0, $eOaGc.RemoveMarkStep)(from, to, d.mark));
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = parentPos + op.insertAt;
                    // Inherit ignored marks from the char just before the insertion point
                    // (or position 0 if we're at the start of the run).
                    const inheritFrom = Math.max(0, op.insertAt - 1);
                    const inherited = (0, $1b24bfcd447ec548$export$772de15c541bba1a)(oldRun, inheritFrom, ignore);
                    const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(parentPos + op.from, parentPos + op.to, (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    // Inherit ignored marks from the start of the replaced range.
                    // (Crossing an annotation boundary mid-range is an inherent
                    // ambiguity; the start-position rule keeps the typical "edit text
                    // inside one annotation" case correct.)
                    const inherited = (0, $1b24bfcd447ec548$export$772de15c541bba1a)(oldRun, op.replaceFrom, ignore);
                    const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $eOaGc.ReplaceStep)(parentPos + op.replaceFrom, parentPos + op.replaceTo, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, (a, b)=>a === b, ctx.maxTextRegions);
    return steps;
}
/**
 * Clips spans to `[from, to)`, normalises them to range-local coordinates
 * (subtracting `origin`), and strips marks whose type is in `ignore`. Used by
 * the Match handler so mark-delta computation runs on the visible mark set
 * only.
 */ function $408fdb1e6962a9ee$var$filteredClipped(spans, from, to, origin, ignore) {
    return (0, $6128bbb40a9f2a1f$export$8c5998c7a945df3e)(spans, from, to).map((s)=>({
            start: s.start - origin,
            end: s.end - origin,
            marks: (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(s.marks, ignore)
        }));
}



const $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS = 200;
function $3656d0ee2718f52e$export$b02b9ec391dbf2d0(oldContent, newContent, parentPos, ctx) {
    const oldKids = [];
    for(let i = 0; i < oldContent.childCount; i++)oldKids.push(oldContent.child(i));
    const newKids = [];
    for(let i = 0; i < newContent.childCount; i++)newKids.push(newContent.child(i));
    const positions = $3656d0ee2718f52e$var$childPositions(parentPos, oldKids);
    const steps = [];
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(oldKids, newKids, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        steps.push(...(0, $5666e4f591805d8d$export$f8dfe7066e572f15)(oldKids[op.oldIndex + i], newKids[op.newIndex + i], childPos, ctx));
                        childPos += oldKids[op.oldIndex + i].nodeSize;
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const slice = $3656d0ee2718f52e$var$blockSlice(newKids.slice(op.from, op.to));
                    // structure=true on Insert is safe (the range is empty) and gives
                    // better rebase semantics: a concurrent insert at the same position
                    // won't be silently clobbered.
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, slice, true));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.from], positions[op.to], (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    // Single-node-to-single-node Replace ops are the only shape where a
                    // structural ReplaceAround can apply (type change preserving content,
                    // wrap, or unwrap). Try that first; fall back to a wholesale
                    // ReplaceStep for anything more complex.
                    if (op.replaceTo - op.replaceFrom === 1 && op.to - op.from === 1) {
                        const around = (0, $1bb2f819ff5b602a$export$6edd5090aa051c73)(oldKids[op.replaceFrom], newKids[op.from], positions[op.replaceFrom], ctx);
                        if (around) {
                            steps.push(around);
                            return;
                        }
                    }
                    const slice = $3656d0ee2718f52e$var$blockSlice(newKids.slice(op.from, op.to));
                    steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], slice));
                    return;
                }
        }
    }, $3656d0ee2718f52e$var$nodesMatchable, $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS, (a, b)=>(0, $1cd935bd164bf76f$export$88a30e5386bda853)(a, b, ctx.ignoreMarks));
    return steps;
}
function $3656d0ee2718f52e$export$c0c809a65b2f72dc(oldContent, newContent, parentPos, ctx) {
    const oldItems = (0, $1b24bfcd447ec548$export$c04a05f66108dc98)(oldContent);
    const newItems = (0, $1b24bfcd447ec548$export$c04a05f66108dc98)(newContent);
    const positions = $3656d0ee2718f52e$var$inlineChildPositions(parentPos, oldItems);
    const steps = [];
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(oldItems, newItems, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        const a = oldItems[op.oldIndex + i];
                        const b = newItems[op.newIndex + i];
                        if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
                            steps.push(...$3656d0ee2718f52e$var$diffTextRunPair(a, b, childPos, ctx));
                            childPos += a.text.length;
                        } else if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
                            steps.push(...(0, $5666e4f591805d8d$export$f8dfe7066e572f15)(a.node, b.node, childPos, ctx));
                            childPos += a.node.nodeSize;
                        } else // Shouldn't happen if `nodesMatchable` worked correctly.
                        throw new Error('inline match between textRun and non-text node');
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const nodes = $3656d0ee2718f52e$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.from], positions[op.to], (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    const nodes = $3656d0ee2718f52e$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, $3656d0ee2718f52e$var$inlineItemsMatchable, $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS, (a, b)=>$3656d0ee2718f52e$var$inlineItemsStrictEq(a, b, ctx.ignoreMarks));
    return steps;
}
/**
 * Strict equality for inline items, ignoring marks of types in `ignore`. Used
 * by the inline prefix/suffix strip so a TextRun that differs only in ignored
 * marks (e.g. an annotation present in pmBase but absent in pmNew) gets
 * stripped cheaply instead of going through the LCS path.
 */ function $3656d0ee2718f52e$var$inlineItemsStrictEq(a, b, ignore) {
    if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
        if (a.text !== b.text) return false;
        // Per-character mark equality on the filtered mark sets. Span boundaries
        // can differ between sides without that being a real difference, so we
        // compare position-by-position rather than span-by-span.
        let ai = 0;
        let bi = 0;
        for(let p = 0; p < a.text.length; p++){
            while(ai < a.spans.length && a.spans[ai].end <= p)ai++;
            while(bi < b.spans.length && b.spans[bi].end <= p)bi++;
            const aMarks = ai < a.spans.length ? (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(a.spans[ai].marks, ignore) : [];
            const bMarks = bi < b.spans.length ? (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(b.spans[bi].marks, ignore) : [];
            if (aMarks.length !== bMarks.length) return false;
            if (!aMarks.every((m)=>bMarks.some((n)=>n.eq(m)))) return false;
        }
        return true;
    }
    if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return a.node.eq(b.node);
    return false;
}
function $3656d0ee2718f52e$var$diffTextRunPair(a, b, pos, ctx) {
    return (0, $408fdb1e6962a9ee$export$7f227f8ae15d3928)(a, b, pos, ctx);
}
function $3656d0ee2718f52e$var$inlineNodesFromItems(items, ctx) {
    const schema = ctx.schema;
    const out = [];
    for (const it of items)if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(it)) out.push(...(0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(it, 0, it.text.length, schema.text.bind(schema)));
    else out.push(it.node);
    return out;
}
function $3656d0ee2718f52e$var$blockSlice(nodes) {
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0);
}
/**
 * "Similar enough to be a match candidate" for the block-level LCS:
 * - both nodes share the same type (attrs may differ; handled in recursion)
 * - text equality lives inside the inline path, not here
 */ function $3656d0ee2718f52e$var$nodesMatchable(a, b) {
    return a.type === b.type;
}
function $3656d0ee2718f52e$var$inlineItemsMatchable(a, b) {
    if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return true;
    if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return a.node.type === b.node.type;
    return false;
}
function $3656d0ee2718f52e$var$childPositions(parentPos, kids) {
    const out = new Array(kids.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < kids.length; i++)out[i + 1] = out[i] + kids[i].nodeSize;
    return out;
}
function $3656d0ee2718f52e$var$inlineChildPositions(parentPos, items) {
    const out = new Array(items.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < items.length; i++){
        const size = (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(items[i]) ? items[i].text.length : items[i].node.nodeSize;
        out[i + 1] = out[i] + size;
    }
    return out;
}




function $5666e4f591805d8d$export$f8dfe7066e572f15(oldNode, newNode, pos, ctx) {
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return [];
    // Text vs text: handled by the inline diff path normally, but if we get here
    // (e.g. a doc whose top-level child IS a text node, unusual but possible in
    // custom schemas) just produce a Replace.
    if (oldNode.isText && newNode.isText) {
        if (oldNode.text === newNode.text) // Same text, different marks - emit mark deltas via add/remove.
        return $5666e4f591805d8d$var$markDeltaSteps(oldNode.marks, newNode.marks, pos, pos + oldNode.nodeSize, /*isInline*/ true, ctx);
        return [
            new (0, $eOaGc.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, 0))
        ];
    }
    if (oldNode.type !== newNode.type) {
        // Type change → replace the whole node. structure=false because the range
        // contains real content (the old node's body); structure=true would reject.
        if (pos < 0) throw new Error('diffNodes: root doc node type mismatch');
        return [
            new (0, $eOaGc.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, 0))
        ];
    }
    // Same block type. Three orthogonal concerns:
    //   1. attrs   → AttrStep(s) on this node
    //   2. content → recurse (inline vs block path)
    //   3. marks   → AddNodeMark/RemoveNodeMark on this node
    const steps = [];
    if (pos >= 0) steps.push(...$5666e4f591805d8d$var$attrSteps(oldNode, newNode, pos));
    if (oldNode.type.inlineContent) steps.push(...(0, $3656d0ee2718f52e$export$c0c809a65b2f72dc)(oldNode.content, newNode.content, pos, ctx));
    else steps.push(...(0, $3656d0ee2718f52e$export$b02b9ec391dbf2d0)(oldNode.content, newNode.content, pos, ctx));
    if (pos >= 0) steps.push(...$5666e4f591805d8d$var$nodeMarkDeltaSteps(oldNode.marks, newNode.marks, pos, ctx));
    return steps;
}
function $5666e4f591805d8d$var$attrSteps(oldNode, newNode, pos) {
    const oldAttrs = oldNode.attrs ?? {};
    const newAttrs = newNode.attrs ?? {};
    const changed = [];
    const keys = new Set([
        ...Object.keys(oldAttrs),
        ...Object.keys(newAttrs)
    ]);
    for (const k of keys)if (!$5666e4f591805d8d$var$compareDeep(oldAttrs[k], newAttrs[k])) changed.push([
        k,
        newAttrs[k] ?? null
    ]);
    return changed.map(([k, v])=>new (0, $eOaGc.AttrStep)(pos, k, v));
}
// Mirrors prosemirror-model's compareDeep helper used for attribute equality.
function $5666e4f591805d8d$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a === 'object') || !(b && typeof b === 'object')) return false;
    const isArray = Array.isArray(a);
    if (Array.isArray(b) !== isArray) return false;
    if (isArray) {
        const aArray = a;
        const bArray = b;
        if (aArray.length !== bArray.length) return false;
        for(let i = 0; i < aArray.length; i++){
            if (!$5666e4f591805d8d$var$compareDeep(aArray[i], bArray[i])) return false;
        }
    } else {
        const aObject = a;
        const bObject = b;
        for(const prop in aObject){
            if (!(prop in bObject) || !$5666e4f591805d8d$var$compareDeep(aObject[prop], bObject[prop])) return false;
        }
        for(const prop in bObject){
            if (!(prop in aObject)) return false;
        }
    }
    return true;
}
function $5666e4f591805d8d$var$nodeMarkDeltaSteps(oldMarks, newMarks, pos, ctx) {
    const oldM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $6128bbb40a9f2a1f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(new (0, $eOaGc.AddNodeMarkStep)(pos, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(new (0, $eOaGc.RemoveNodeMarkStep)(pos, m));
    return steps;
}
function $5666e4f591805d8d$var$markDeltaSteps(oldMarks, newMarks, from, to, isInline, ctx) {
    const oldM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $6128bbb40a9f2a1f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(isInline ? new (0, $eOaGc.AddMarkStep)(from, to, m) : new (0, $eOaGc.AddNodeMarkStep)(from, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(isInline ? new (0, $eOaGc.RemoveMarkStep)(from, to, m) : new (0, $eOaGc.RemoveNodeMarkStep)(from, m));
    return steps;
}








function $d9e579ca8433f3c0$var$isStructural(step) {
    return step.structure === true;
}
function $d9e579ca8433f3c0$export$4a231d1a3b7e81fc(steps) {
    if (steps.length === 0) return [];
    const out = [
        steps[0]
    ];
    for(let i = 1; i < steps.length; i++){
        const next = steps[i];
        const last = out[out.length - 1];
        if (last instanceof (0, $eOaGc.ReplaceStep) && next instanceof (0, $eOaGc.ReplaceStep) && !$d9e579ca8433f3c0$var$isStructural(last) && !$d9e579ca8433f3c0$var$isStructural(next) && last.to === next.from && // All four opens must be 0: the merged slice is built `Slice(_, 0, 0)`,
        // so a non-zero open on either side would either misclaim the outer
        // opens or reinterpret an open-at-junction node as complete.
        last.slice.openStart === 0 && last.slice.openEnd === 0 && next.slice.openStart === 0 && next.slice.openEnd === 0) {
            out[out.length - 1] = new (0, $eOaGc.ReplaceStep)(last.from, next.to, $d9e579ca8433f3c0$var$mergeSlices(last.slice, next.slice));
            continue;
        }
        if (last instanceof (0, $eOaGc.AddMarkStep) && next instanceof (0, $eOaGc.AddMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $eOaGc.AddMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        if (last instanceof (0, $eOaGc.RemoveMarkStep) && next instanceof (0, $eOaGc.RemoveMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $eOaGc.RemoveMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        out.push(next);
    }
    return out;
}
function $d9e579ca8433f3c0$var$mergeSlices(a, b) {
    const aContent = a.content;
    const bContent = b.content;
    if (aContent.size === 0) return new (0, $aPdNQ.Slice)(bContent, 0, 0);
    if (bContent.size === 0) return new (0, $aPdNQ.Slice)(aContent, 0, 0);
    const aLast = aContent.child(aContent.childCount - 1);
    const bFirst = bContent.child(0);
    if (aLast.isText && bFirst.isText && $d9e579ca8433f3c0$var$sameMarkSet(aLast.marks, bFirst.marks)) {
        const merged = aLast.type.schema.text((aLast.text ?? '') + (bFirst.text ?? ''), aLast.marks);
        const aHead = (0, $aPdNQ.Fragment).from($d9e579ca8433f3c0$var$takeAll(aContent, aContent.childCount - 1));
        const bTail = (0, $aPdNQ.Fragment).from($d9e579ca8433f3c0$var$takeAllFrom(bContent, 1));
        return new (0, $aPdNQ.Slice)(aHead.append((0, $aPdNQ.Fragment).from(merged)).append(bTail), 0, 0);
    }
    return new (0, $aPdNQ.Slice)(aContent.append(bContent), 0, 0);
}
function $d9e579ca8433f3c0$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $d9e579ca8433f3c0$var$takeAll(frag, n) {
    const out = [];
    for(let i = 0; i < n; i++)out.push(frag.child(i));
    return out;
}
function $d9e579ca8433f3c0$var$takeAllFrom(frag, start) {
    const out = [];
    for(let i = start; i < frag.childCount; i++)out.push(frag.child(i));
    return out;
}



const $9621857a1a4fd633$var$DEFAULT_MAX_TEXT_REGIONS = 10;
function $9621857a1a4fd633$var$makeContext(schema, opts) {
    return {
        schema: schema,
        ignoreMarks: new Set(opts?.ignoreMarkTypes ?? []),
        maxTextRegions: opts?.maxTextRegions ?? $9621857a1a4fd633$var$DEFAULT_MAX_TEXT_REGIONS
    };
}
function $9621857a1a4fd633$export$96d86b1e79ab6058(oldDoc, newDoc, opts) {
    if (oldDoc.type.schema !== newDoc.type.schema) throw new Error('diffNodes: schemas differ between old and new doc');
    const ctx = $9621857a1a4fd633$var$makeContext(oldDoc.type.schema, opts);
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldDoc, newDoc, ctx.ignoreMarks)) return [];
    return (0, $d9e579ca8433f3c0$export$4a231d1a3b7e81fc)((0, $5666e4f591805d8d$export$f8dfe7066e572f15)(oldDoc, newDoc, -1, ctx));
}


const $68b04ed0ed4951fc$export$372e47604067462f = 'mdMode$ownWriteback';
/*
	The localId attribute is not produced from the markdown source as it has no concept of localIds.
	This can cause steps to be generated setting the localId attr on existing nodes to null.
	We suppress these as we rarely (if ever) want to actually remove or edit localIds of nodes during
	md -> adf reconciliation.
	This prevents unnecessary round-trips and makes markdown editing more stable.
 */ const $68b04ed0ed4951fc$var$shouldIgnoreLocalIdAttrStep = (step)=>step instanceof (0, $eOaGc.AttrStep) && step.attr === 'localId';
const $68b04ed0ed4951fc$export$c0dd7bd7f3654863 = (editorView, seedDoc, newAdfNode, interveningMapping, opts)=>{
    if (editorView.isDestroyed) return null;
    const steps = (0, $9621857a1a4fd633$export$96d86b1e79ab6058)(seedDoc, newAdfNode, opts).filter((step)=>!$68b04ed0ed4951fc$var$shouldIgnoreLocalIdAttrStep(step));
    if (steps.length === 0) return null;
    const tr = editorView.state.tr;
    for (const step of steps){
        const rebased = step.map(interveningMapping);
        if (!rebased) throw new Error('applyDiffSteps: step did not survive rebase');
        const mapped = rebased.map(tr.mapping);
        if (!mapped) throw new Error('applyDiffSteps: step could not be mapped');
        tr.step(mapped);
    }
    tr.setMeta('addToHistory', false);
    tr.setMeta($68b04ed0ed4951fc$export$372e47604067462f, true);
    editorView.dispatch(tr);
    return tr;
};








/**
 * Wire contract for the markdown-mode sync tracer.
 *
 * This file is the **single source of truth** for the trace event schema
 * described in `docs/devtools-tracing-design.md` §3. Both the producer (the
 * in-plugin tracer + instrumentation) and any consumer (Layer 1 console API,
 * Layer 2 in-app panel, Layer 3 external devtools client) import these types
 * so they cannot drift.
 *
 * ## Wire format
 *
 * Every event is **plain JSON** — it survives `structuredClone` /
 * `postMessage` / `JSON.stringify` losslessly. The `DocNode` and serialized
 * `Step[]` fields are already-serialized JSON, never live ProseMirror class
 * instances. This is what lets a Chrome DevTools
 * extension (a separate context, possibly a separate repo) consume the same
 * events the in-page console API sees.
 *
 * ## Portability note (for an out-of-AFM consumer, e.g. a Chrome extension)
 *
 * The imported types below are **type-only** and describe JSON shapes:
 *   - `DocNode` — ADF document JSON (`@atlaskit/adf-schema`)
 * A consumer outside the monorepo can either install that typing or vendor a
 * copy of this file and replace the import with a structural equivalent
 * (`unknown` / `Record<string, unknown>`). The runtime payloads are identical
 * either way.
 */ const $7337a1f3682a2eb7$export$da2ddd70869a7031 = 'atl-md-mode-tracer';
const $7337a1f3682a2eb7$export$435e830eb7c6eb9c = 'atl-md-mode-tracer-client';


var $5e1679443117df1d$var$_MarkdownModeTracer;
const $5e1679443117df1d$var$hasUrlEnableFlag = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        return new URLSearchParams(window.location.search).get('mdModeTracer') === '1';
    } catch  {
        return false;
    }
};
class $5e1679443117df1d$export$de8e565f923f53f9 {
    /**
   * Returns the singleton if the gate is on, else `null`. On first creation it
   * attaches the console API to `window.__markdownModeDebugger__` and installs
   * the postMessage subscribe listener.
   */ static getInstance() {
        if (!(0, $iDrrr.fg)('platform_editor_md_mode_tracer')) {
            // Gate evaluated off. If an instance was created earlier in this session
            // (gate on, then flipped off via a Statsig refresh / bucket change), tear
            // it down so the console API, the message listener, the live subscribers,
            // and any retained doc payloads don't outlive the master switch.
            if ($5e1679443117df1d$export$de8e565f923f53f9.instance) $5e1679443117df1d$export$de8e565f923f53f9.teardown();
            return null;
        }
        if (!$5e1679443117df1d$export$de8e565f923f53f9.instance) {
            $5e1679443117df1d$export$de8e565f923f53f9.instance = new $5e1679443117df1d$export$de8e565f923f53f9();
            $5e1679443117df1d$export$de8e565f923f53f9.instance.attachToWindow();
            $5e1679443117df1d$export$de8e565f923f53f9.instance.installMessageListener();
        }
        return $5e1679443117df1d$export$de8e565f923f53f9.instance;
    }
    /**
   * Opens a bound trace session for one top-level action. Returns `undefined`
   * when the gate is off or recording is disabled, so a callsite's `trace?.`
   * cheaply skips all instrumentation (no payload is ever built). This is the
   * entry point instrumentation should use — it bundles `getInstance()` +
   * `beginTrace()` and removes the need to thread both the tracer and the
   * `TraceContext` through every record call.
   */ static begin(trigger) {
        const tracer = $5e1679443117df1d$export$de8e565f923f53f9.getInstance();
        const ctx = tracer?.beginTrace(trigger);
        if (!tracer || !ctx) return undefined;
        return {
            id: ctx.id,
            sync: (build)=>tracer.recordSync(ctx, build)
        };
    }
    // --- Recording switch ---
    isEnabled() {
        return this.enabled;
    }
    enable() {
        this.enabled = true;
        // An explicit enable is sticky: don't let a later unsubscribe turn it off.
        this.autoEnabledForSubscribers = false;
    }
    disable() {
        this.enabled = false;
        this.autoEnabledForSubscribers = false;
    }
    /**
   * Opens a trace context for one top-level action. Returns `undefined` when
   * recording is disabled so callers cheaply skip all instrumentation.
   */ beginTrace(trigger) {
        if (!this.enabled) return undefined;
        return {
            id: `md-${++this.idCounter}`,
            trigger: trigger
        };
    }
    // --- Recording API (thunk form keeps zero cost when disabled) ---
    /** Record a sync decision. `build` is invoked only when recording is enabled. */ recordSync(ctx, build) {
        if (!this.enabled) return;
        // Observe-only: never let a builder/serialization/store failure escape into
        // the writeback path (a throw here would otherwise be caught by a caller's
        // catch and misread as a parse/rebase failure — see the conversion helpers).
        try {
            const input = build();
            const event = {
                kind: 'sync',
                id: ctx.id,
                trigger: ctx.trigger,
                ts: Date.now(),
                ...input,
                gates: input.gates ?? $5e1679443117df1d$export$de8e565f923f53f9.snapshotGates()
            };
            this.push(event);
        } catch  {
        // Swallow — a tracer bug must not change editor behaviour.
        }
    }
    /**
   * Snapshot the gates whose state is interesting when interpreting a sync
   * decision. `fg()` must be called with a string literal (the
   * static-feature-flags lint rule statically extracts flag keys), so each gate
   * is read explicitly rather than looped. `fg` can throw when a gate isn't
   * registered in this context, so each read is guarded and simply omitted.
   */ static snapshotGates() {
        const gates = {};
        const add = (key, read)=>{
            try {
                gates[key] = read();
            } catch  {
            // Gate not registered in this context — leave it out of the snapshot.
            }
        };
        add('platform_editor_md_source_sync_snapshot', ()=>(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot'));
        add('platform_editor_markdown_compatible_toolbar', ()=>(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar'));
        add('platform_editor_md_mode_rebase_fallback', ()=>(0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback'));
        add('platform_editor_md_mode_tracer', ()=>(0, $iDrrr.fg)('platform_editor_md_mode_tracer'));
        return gates;
    }
    push(event) {
        this.evictExpired();
        this.events.push(event);
        if (this.events.length > this.maxEvents) this.events.splice(0, this.events.length - this.maxEvents);
        this.emit(event, 'event');
    }
    evictExpired() {
        const now = Date.now();
        const cutoff = now - this.maxAgeMsec;
        // Events are pushed in time order, so drop the expired prefix.
        let firstLive = 0;
        while(firstLive < this.events.length && this.events[firstLive].ts < cutoff)firstLive++;
        if (firstLive > 0) this.events.splice(0, firstLive);
    }
    // --- Query API (exposed on window) ---
    getEvents(filter) {
        this.evictExpired();
        let result = this.events.slice();
        if (filter?.kind) result = result.filter((e)=>e.kind === filter.kind);
        if (filter?.trigger) result = result.filter((e)=>e.trigger === filter.trigger);
        if (filter?.id) result = result.filter((e)=>e.id === filter.id);
        if (filter?.decision) result = result.filter((e)=>e.kind === 'sync' && e.decision === filter.decision);
        return result;
    }
    getLastSync() {
        this.evictExpired();
        for(let i = this.events.length - 1; i >= 0; i--){
            const event = this.events[i];
            if (event.kind === 'sync') return event;
        }
        return undefined;
    }
    getTrace(id) {
        this.evictExpired();
        return this.events.filter((e)=>e.id === id);
    }
    clear() {
        this.events = [];
    }
    /**
   * Registers the active orchestrator's round-trip implementation (which holds
   * the editor schema). `roundTrip()` delegates to it.
   */ registerProbe(probe) {
        this.probe = probe;
    }
    roundTrip(input) {
        if (!this.probe) return {
            error: 'No editor registered. Open markdown mode in an editor first.'
        };
        try {
            return this.probe(input);
        } catch (err) {
            // The probe runs `markdownToAdf`, a "throws on parse error" boundary, so
            // malformed input would otherwise escape the console API as an uncaught
            // throw. Surface it as a structured result, matching the no-probe branch.
            return {
                error: err instanceof Error ? err.message : String(err)
            };
        }
    }
    // --- Layer 3 postMessage bridge (see design doc §5) ---
    installMessageListener() {
        if (typeof window === 'undefined' || this.unbindMessageListener) return;
        const messageListener = (event)=>{
            if (event.origin !== window.location.origin) return;
            const data = event.data;
            if (!data || data.source !== (0, $7337a1f3682a2eb7$export$435e830eb7c6eb9c)) return;
            const source = event.source;
            if (!source) return;
            if (data.type === 'subscribe') {
                const isNewSubscriber = !this.subscribers.has(source);
                this.subscribers.add(source);
                // Opening a devtools client is itself an explicit opt-in, so turn
                // recording on if it isn't already. We remember that we did so in
                // order to restore the prior state when the last client leaves.
                if (!this.enabled) {
                    this.enabled = true;
                    this.autoEnabledForSubscribers = true;
                }
                // Replay the current buffer only to a genuinely new subscriber. The
                // handshake (see design §6) tells an early-loading client to
                // re-subscribe on the `online` ping, so a duplicate `subscribe` from
                // an already-registered window must not replay the buffer twice.
                if (isNewSubscriber) for (const buffered of this.events)this.postTo(source, buffered, 'replay');
            } else if (data.type === 'unsubscribe') {
                this.subscribers.delete(source);
                this.restoreEnabledIfNoSubscribers();
            }
        };
        this.unbindMessageListener = (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: messageListener
        });
        // Announce that the tracer is now listening. A client that loaded before
        // the editor mounted (e.g. a content script injected at document_start)
        // will have sent its `subscribe` into the void; this prompts it to retry.
        this.announceOnline();
    }
    /** Broadcast a one-shot `online` ping so early-loading clients re-subscribe. */ announceOnline() {
        if (typeof window === 'undefined') return;
        const message = {
            source: (0, $7337a1f3682a2eb7$export$da2ddd70869a7031),
            type: 'online'
        };
        try {
            window.postMessage(message, window.location.origin);
        } catch  {
        // Ignore postMessage failures (e.g. opaque origin).
        }
    }
    /**
   * When the last subscriber disconnects, undo a subscribe-driven auto-enable so
   * recording returns to its default-off state once nothing is watching. A
   * manual `enable()` clears the auto flag, so this never overrides the user.
   */ restoreEnabledIfNoSubscribers() {
        if (this.subscribers.size === 0 && this.autoEnabledForSubscribers) {
            this.enabled = false;
            this.autoEnabledForSubscribers = false;
        }
    }
    emit(event, type) {
        if (this.subscribers.size === 0) return;
        // Iterate a snapshot: a failed `postTo` deletes the dead subscriber from the
        // live Set (and may flip the recording switch off) mid-broadcast, so we must
        // not mutate the Set we are iterating.
        for (const subscriber of [
            ...this.subscribers
        ])this.postTo(subscriber, event, type);
    }
    postTo(subscriber, event, type) {
        const message = {
            source: (0, $7337a1f3682a2eb7$export$da2ddd70869a7031),
            type: type,
            event: event
        };
        try {
            subscriber.postMessage(message, window.location.origin);
        } catch  {
            // Subscriber gone / cross-origin — drop it.
            this.subscribers.delete(subscriber);
            this.restoreEnabledIfNoSubscribers();
        }
    }
    attachToWindow() {
        if (typeof window === 'undefined') return;
        try {
            window.__markdownModeDebugger__ = {
                getEvents: (filter)=>this.getEvents(filter),
                getLastSync: ()=>this.getLastSync(),
                getTrace: (id)=>this.getTrace(id),
                roundTrip: (input)=>this.roundTrip(input),
                enable: ()=>this.enable(),
                disable: ()=>this.disable(),
                isEnabled: ()=>this.isEnabled(),
                clear: ()=>this.clear()
            };
        } catch  {
        // Ignore window access errors.
        }
    }
    /**
   * Fully dismantles the singleton: unbinds the message listener, drops all
   * subscribers, clears the buffer and recording flags, removes the `window`
   * global, and nulls the instance. Used both when the gate flips off after
   * creation and by `resetForTesting`, so neither leaves the bridge live.
   */ static teardown() {
        const instance = $5e1679443117df1d$export$de8e565f923f53f9.instance;
        if (instance) {
            instance.unbindMessageListener?.();
            instance.unbindMessageListener = null;
            instance.subscribers.clear();
            instance.probe = null;
            instance.events = [];
            instance.enabled = false;
            instance.autoEnabledForSubscribers = false;
        }
        if (typeof window !== 'undefined') window.__markdownModeDebugger__ = undefined;
        $5e1679443117df1d$export$de8e565f923f53f9.instance = null;
    }
    /**
   * Resets the singleton. Test-only.
   * @internal
   */ static resetForTesting() {
        $5e1679443117df1d$export$de8e565f923f53f9.teardown();
    }
    constructor(maxEvents = 200, maxAgeMsec = 1800000){
        this.events = [];
        this.idCounter = 0;
        this.enabled = void 0;
        /**
     * True when recording was switched on *because* a devtools client subscribed
     * (rather than via the URL flag or a manual `enable()`). We restore the prior
     * state when the last subscriber leaves, so the default-off privacy posture
     * returns once nothing is watching.
     */ this.autoEnabledForSubscribers = false;
        this.probe = null;
        this.subscribers = new Set();
        this.unbindMessageListener = null;
        /** Maximum number of events retained. */ this.maxEvents = void 0;
        /** Maximum age of an event in milliseconds before eviction. */ this.maxAgeMsec = void 0;
        this.maxEvents = maxEvents;
        this.maxAgeMsec = maxAgeMsec;
        this.enabled = $5e1679443117df1d$var$hasUrlEnableFlag();
    }
}
$5e1679443117df1d$var$_MarkdownModeTracer = $5e1679443117df1d$export$de8e565f923f53f9;
$5e1679443117df1d$export$de8e565f923f53f9.instance = null;


/**
 * Confluence appends a trailing empty paragraph to the live PM doc for cursor
 * placement; mdast strips trailing blank lines on round-trip, so without
 * padding the diff emits a wholesale delete of that paragraph on every
 * writeback. Cosmetic non-collab; collides with concurrent end-of-doc appends
 * under collab.
 */ 


const $51eaa0d358e75b0f$var$isEmptyParagraph = (node)=>!!node && node.type.name === 'paragraph' && node.childCount === 0;
const $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc = (oldDoc, newDoc)=>{
    if (!$51eaa0d358e75b0f$var$isEmptyParagraph(oldDoc.lastChild)) return newDoc;
    if ($51eaa0d358e75b0f$var$isEmptyParagraph(newDoc.lastChild)) return newDoc;
    const paragraphType = newDoc.type.schema.nodes.paragraph;
    if (!paragraphType) return newDoc;
    return newDoc.copy(newDoc.content.append((0, $aPdNQ.Fragment).from(paragraphType.create())));
};


/* MarkdownSourceView.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * MarkdownSourceView — markdown source editor for Confluence Live Docs in
 * Markdown Mode.
 *
 * Behaviour:
 *  - On mount, convert the live ProseMirror document (`initialAdfDoc`) to
 *    markdown via `@atlassian/mdast-util-from-pm` and seed a CodeMirror 6 editor
 *    with it.
 *  - User edits live in the CodeMirror EditorState; we do NOT push them back
 *    into the ProseMirror editor on every keystroke (too expensive and would
 *    fight the collab provider).
 *  - On unmount (i.e. when the user switches back to WYSIWYG / preview), we
 *    read the editor's current doc, validate it parses back to ADF via
 *    `@atlassian/mdast-util-to-pm`, and hand the markdown string
 *    off to the parent through `onMarkdownCommit`. The parent is responsible
 *    for applying it to the editor.
 *  - If the user did NOT actually edit the markdown buffer
 *    (`finalMarkdown === initialMarkdown`), we skip the commit entirely.
 *    This avoids a lossy ADF→markdown→ADF round-trip on every no-op visit
 *    to source view, which would otherwise reset collab cursors and undo
 *    history and could subtly mutate the doc (the markdown round-trip is
 *    not a strict identity).
 *  - If the markdown can't be parsed we `console.warn` and discard the change
 *    rather than crashing the editor. A user-facing surface for lossy
 *    round-trips is deferred — see TODO below.
 *
 * Re-seeding: callers may pass a `revision` prop. CodeMirror is destroyed
 * and re-mounted whenever `revision` changes, so the parent can force a
 * fresh seed (e.g. when re-entering source view with a new ADF snapshot).
 * The component is a single React tree across re-seeds — only the inner
 * CodeMirror state is recreated.
 *
 * The component intentionally takes a stable, narrow prop interface so other
 * agents (BRAVO's preview view + LivePageComponent plumbing, CHARLIE's tests)
 * can rely on it. Do not change the shape of `MarkdownSourceViewProps` without
 * coordinating with those agents.
 *
 * TODO(EDITOR-6558-source): surface lossy round-trips to the user (flag /
 * inline warning) instead of silently warning to the console.
 *
 * Ticket: https://hello.jira.atlassian.cloud/browse/EDITOR-6558
 * Parent epic: https://hello.jira.atlassian.cloud/browse/EDITOR-6490
 */ 






var $hekY6 = parcelRequire("hekY6");


var $7nRDp = parcelRequire("7nRDp");








var $725xj = parcelRequire("725xj");





var $3e6dc = parcelRequire("3e6dc");


var $kSwu1 = parcelRequire("kSwu1");


var $2VjJa = parcelRequire("2VjJa");





var $IQ4Dz = parcelRequire("IQ4Dz");





// Unclosed link — `[text` without a following `](` on the same line.
const $b5c8870ce01fabc3$var$UNCLOSED_LINK_REGEX = /\[[^\]]*$/u;
// Strip leading list-item marker: unordered (* / - / +) or ordered (N.) followed by at least one space.
const $b5c8870ce01fabc3$var$LIST_PREFIX_REGEX = /^(\s*(?:[*+\-]|\d+\.)\s+)/u;
// Fence delimiter lines.
const $b5c8870ce01fabc3$var$FENCE_DELIMITER_REGEX = /^```/u;
// Thematic break lines (e.g. `***`, `* * *`, `---`, `___`) are block-level syntax.
// Spec: three or more `*`, `-`, or `_`, optionally separated by spaces, with nothing else on the line.
const $b5c8870ce01fabc3$var$THEMATIC_BREAK_REGEX = /^\s{0,3}((\*[ \t]*){3,}|([ \t]*-){3,}|(_[ \t]*){3,})\s*$/u;
/**
 * Returns true if the given pre-processed line (escape sequences and balanced
 * inline code spans already stripped) has unbalanced markdown inline syntax —
 * e.g. the user has typed `*ital` but not yet the closing `*`.
 *
 * Tokens checked (all require balanced pairs on the same line):
 *   - `` ` `` (inline code) — odd count of backticks
 *   - `*` / `**` / `***` (em / strong / bold-italic) — odd count per run-length
 *   - `[` without a matching `](` later on the line (link syntax)
 */ function $b5c8870ce01fabc3$var$lineHasUnbalancedInlineSyntax(strippedLine) {
    // Odd backtick count → unclosed inline code span.
    const backtickCount = (strippedLine.match(/`/gu) ?? []).length;
    if (backtickCount % 2 !== 0) return true;
    // Each distinct asterisk run-length must appear an even number of times.
    // e.g. `**bol` has one `**` token → odd → unbalanced.
    const asteriskRuns = strippedLine.match(/\*+/gu) ?? [];
    const runCounts = new Map();
    for (const run of asteriskRuns){
        const len = run.length;
        runCounts.set(len, (runCounts.get(len) ?? 0) + 1);
    }
    for (const count of runCounts.values()){
        if (count % 2 !== 0) return true;
    }
    // Unclosed link — `[text` without a following `](` on the same line.
    if ($b5c8870ce01fabc3$var$UNCLOSED_LINK_REGEX.test(strippedLine)) return true;
    return false;
}
/**
 * Pre-processes a line for syntax balance checking: strips escape sequences,
 * balanced inline code spans, and leading list-item markers so they don't
 * skew token counts.
 *
 * List-item prefixes (`* `, `- `, `+ `, or `1. ` / `123. `) begin with a
 * `*` or `-` / `+` that is structural (a block-level marker), not inline
 * emphasis syntax. Stripping them before the asterisk-balance check prevents
 * false positives on every bullet-list line.
 */ function $b5c8870ce01fabc3$var$stripLineForBalanceCheck(line) {
    // Strip leading list-item marker: unordered (* / - / +) or ordered (N.)
    // followed by at least one space.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    const withoutListPrefix = line.replace($b5c8870ce01fabc3$var$LIST_PREFIX_REGEX, '');
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    return withoutListPrefix.replace(/\\.|`[^`]*`/gu, '');
}
function $b5c8870ce01fabc3$export$cf49bba3d053a321(markdown, cursorPos) {
    // Strip escape sequences first so `\`` doesn't interfere with fence detection.
    const unescaped = markdown.replace(/\\./gu, '');
    // --- Global check: unclosed fenced code block ---
    // Strip complete balanced fenced blocks (``` ... ```) so their content is
    // not counted. An odd number of remaining ``` markers means there is an
    // unclosed fence somewhere in the document.
    const withoutFences = unescaped.replace(RegExp("^```.*?^```", "gmsu"), '');
    const fenceCount = (withoutFences.match(/^```/gmu) ?? []).length;
    if (fenceCount % 2 !== 0) return true;
    // --- Per-line check: inline syntax on the cursor's line only ---
    // Find the line boundaries from the raw markdown (before escape-stripping)
    // so that cursorPos maps correctly to character offsets.
    const lineStart = markdown.lastIndexOf('\n', cursorPos - 1) + 1;
    const lineEndRaw = markdown.indexOf('\n', cursorPos);
    const lineEnd = lineEndRaw === -1 ? markdown.length : lineEndRaw;
    const currentLine = markdown.slice(lineStart, lineEnd);
    // Fence delimiter lines (``` ...) are not inline syntax — skip the check.
    if ($b5c8870ce01fabc3$var$FENCE_DELIMITER_REGEX.test(currentLine)) return false;
    // Thematic break lines (e.g. `***`, `* * *`, `---`, `___`) are block-level
    // syntax, not inline emphasis. A `***` line would otherwise be counted as
    // three unbalanced asterisks of length 1. Detect and skip.
    // Spec: three or more `*`, `-`, or `_`, optionally separated by spaces,
    // with nothing else on the line (except leading/trailing spaces).
    if ($b5c8870ce01fabc3$var$THEMATIC_BREAK_REGEX.test(currentLine)) return false;
    // If the cursor is inside a balanced fence block, the line is code content
    // not markdown syntax — skip the inline check.
    // We detect this by checking whether cursorPos falls within a stripped region.
    // Simple heuristic: count ``` markers before the cursor line in the unescaped
    // string; if the count is odd, we're inside a fence.
    const beforeCursor = unescaped.slice(0, lineStart);
    const fencesBeforeCursor = (beforeCursor.match(/^```/gmu) ?? []).length;
    if (fencesBeforeCursor % 2 !== 0) return false;
    return $b5c8870ce01fabc3$var$lineHasUnbalancedInlineSyntax($b5c8870ce01fabc3$var$stripLineForBalanceCheck(currentLine));
}


/**
 * Text-level diff helpers for the source view's non-clobbering live-refresh
 * path. Pure functions returning CM6-shaped `{from, to, insert}` ops; the
 * source view dispatches them via `view.dispatch({ changes })`.
 */ 
var $28Zil = parcelRequire("28Zil");

const $221c70a2c73ffadc$export$294aa3c46d6af4a5 = (oldText, newText)=>{
    const hunks = [];
    for (const [from, to, insert] of (0, $28Zil.calcPatch)(oldText, newText))hunks.push({
        from: from,
        to: to,
        insert: insert
    });
    return hunks;
};
const $221c70a2c73ffadc$export$e291136b00c395d = (seed, buffer, next)=>{
    const remoteHunks = $221c70a2c73ffadc$export$294aa3c46d6af4a5(seed, next);
    if (remoteHunks.length === 0) return [];
    const userHunks = $221c70a2c73ffadc$export$294aa3c46d6af4a5(seed, buffer);
    if (userHunks.length === 0) return remoteHunks;
    for (const rh of remoteHunks)for (const uh of userHunks){
        if ($221c70a2c73ffadc$var$rangesOverlap(rh, uh)) return null;
    }
    return remoteHunks.map((rh)=>{
        let delta = 0;
        for (const uh of userHunks)if (uh.to <= rh.from) delta += uh.insert.length - (uh.to - uh.from);
        return {
            from: rh.from + delta,
            to: rh.to + delta,
            insert: rh.insert
        };
    });
};
const $221c70a2c73ffadc$var$rangesOverlap = (a, b)=>{
    // Strict interior overlap.
    if (a.from < b.to && b.from < a.to) return true;
    // Concurrent zero-width inserts at the same position: ambiguous order.
    if (a.from === b.from && a.to === a.from && b.to === b.from) return true;
    return false;
};



/**
 * CodeMirror 6 syntax-highlight themes for the markdown source view
 * (EDITOR-7602). Styling is tag-based: `@lezer/markdown` tags its nodes and
 * `@codemirror/lang-markdown` nests embedded grammars (fenced code, raw HTML,
 * etc.), so we only map `@lezer/highlight` tags → styles here — no language is
 * treated specially.
 *
 * The default palette is Bitbucket-inspired (red headings + syntax punctuation,
 * blue code), built from ADS tokens which adapt to the active colour mode.
 * Themes are produced via `getMarkdownHighlightStyle(theme, mode)` with explicit
 * light/dark palettes — the seam for a future theme picker.
 */ 



var $lhXhg = parcelRequire("lhXhg");

// ADS accent tokens (which adapt to colour mode); the per-mode hexes are
// fallbacks. Kept as two definitions so either can diverge later.
const $6480260b9bb6fc4e$var$DEFAULT_PALETTES = {
    light: {
        heading: "var(--ds-text-accent-red, #AE2A19)",
        punctuation: "var(--ds-text-accent-red, #AE2A19)",
        code: "var(--ds-text-accent-blue, #0C66E4)",
        keyword: "var(--ds-text-accent-purple, #5E4DB2)",
        string: "var(--ds-text-accent-green, #216E4E)",
        literal: "var(--ds-text-accent-teal, #206A83)",
        type: "var(--ds-text-accent-blue, #0C66E4)",
        name: "var(--ds-text-accent-purple, #5E4DB2)",
        link: "var(--ds-link, #0C66E4)",
        comment: "var(--ds-text-subtlest, #626F86)",
        text: "var(--ds-text, #172B4D)"
    },
    dark: {
        heading: "var(--ds-text-accent-red, #FD9891)",
        punctuation: "var(--ds-text-accent-red, #FD9891)",
        code: "var(--ds-text-accent-blue, #579DFF)",
        keyword: "var(--ds-text-accent-purple, #9F8FEF)",
        string: "var(--ds-text-accent-green, #7EE2B8)",
        literal: "var(--ds-text-accent-teal, #9DD9EE)",
        type: "var(--ds-text-accent-blue, #579DFF)",
        name: "var(--ds-text-accent-purple, #9F8FEF)",
        link: "var(--ds-link, #579DFF)",
        comment: "var(--ds-text-subtlest, #8C9BAB)",
        text: "var(--ds-text, #C7D1DB)"
    }
};
const $6480260b9bb6fc4e$var$THEME_PALETTES = {
    default: $6480260b9bb6fc4e$var$DEFAULT_PALETTES
};
function $6480260b9bb6fc4e$var$buildHighlightStyle(p) {
    return (0, $4lK5a.HighlightStyle).define([
        {
            tag: (0, $lhXhg.tags).heading,
            color: p.heading,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        // Every syntax mark (`#`, `**`, `` ` ``, `>`, list/table marks) shares
        // `processingInstruction`; `tags.list` is left unstyled so item text
        // stays at the default foreground while the marker is coloured.
        {
            tag: (0, $lhXhg.tags).processingInstruction,
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).contentSeparator,
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).emphasis,
            fontStyle: 'italic'
        },
        {
            tag: (0, $lhXhg.tags).strong,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        {
            tag: (0, $lhXhg.tags).strikethrough,
            textDecoration: 'line-through'
        },
        {
            tag: [
                (0, $lhXhg.tags).link,
                (0, $lhXhg.tags).url
            ],
            color: p.link,
            textDecoration: 'underline'
        },
        {
            tag: (0, $lhXhg.tags).monospace,
            color: p.code
        },
        {
            tag: [
                (0, $lhXhg.tags).angleBracket,
                (0, $lhXhg.tags).tagName
            ],
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).attributeName,
            color: p.name
        },
        {
            tag: (0, $lhXhg.tags).attributeValue,
            color: p.string
        },
        {
            tag: (0, $lhXhg.tags).comment,
            color: p.comment,
            fontStyle: 'italic'
        },
        {
            tag: (0, $lhXhg.tags).keyword,
            color: p.keyword,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        {
            tag: [
                (0, $lhXhg.tags).string,
                (0, $lhXhg.tags).special((0, $lhXhg.tags).string),
                (0, $lhXhg.tags).inserted
            ],
            color: p.string
        },
        {
            tag: [
                (0, $lhXhg.tags).atom,
                (0, $lhXhg.tags).bool,
                (0, $lhXhg.tags).literal,
                (0, $lhXhg.tags).labelName,
                (0, $lhXhg.tags).number
            ],
            color: p.literal
        },
        {
            tag: [
                (0, $lhXhg.tags).typeName,
                (0, $lhXhg.tags).namespace
            ],
            color: p.type
        },
        {
            tag: [
                (0, $lhXhg.tags).className,
                (0, $lhXhg.tags).propertyName
            ],
            color: p.name
        },
        {
            tag: (0, $lhXhg.tags).deleted,
            color: p.punctuation
        },
        {
            tag: [
                (0, $lhXhg.tags).regexp,
                (0, $lhXhg.tags).escape
            ],
            color: p.literal
        },
        {
            tag: (0, $lhXhg.tags).variableName,
            color: p.text
        },
        {
            tag: (0, $lhXhg.tags).invalid,
            color: p.text
        }
    ]);
}
const $6480260b9bb6fc4e$var$themeCache = new Map();
function $6480260b9bb6fc4e$export$eb40053f1fb44ebf(theme = 'default', mode = 'light') {
    const key = `${theme}:${mode}`;
    const cached = $6480260b9bb6fc4e$var$themeCache.get(key);
    if (cached) return cached;
    const palettes = $6480260b9bb6fc4e$var$THEME_PALETTES[theme] ?? $6480260b9bb6fc4e$var$THEME_PALETTES.default;
    const style = $6480260b9bb6fc4e$var$buildHighlightStyle(palettes[mode] ?? palettes.light);
    $6480260b9bb6fc4e$var$themeCache.set(key, style);
    return style;
}
const $6480260b9bb6fc4e$export$83b6926f089ab19a = $6480260b9bb6fc4e$export$eb40053f1fb44ebf('default', 'light');


/* MarkdownSourceViewFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $2uDbg = parcelRequire("2uDbg");




const $f2806cae53c3f91e$var$footerStyles = {
    footer: "_2sNsIgmnOE _2mHwu85zaO _0hPCNLDIqT _1KhSQW9r67 _4hyvPa6wH8 _0vfIXINvrM _24h04i2Njc _3iDTPbQ4SZ _37wbyuI7V3 _0xmtko2ADO _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO _39xV02N91d",
    labelText: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    leftSection: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2mHwu85zaO _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _1UtDYzZpcK _3iDTPbQ4SZ _4ouGXIdnbC",
    lineNumbersControl: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _1ANEUSLRg7",
    rightSection: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _2mHwu82ADO _0hPCNLDIqT _1UtDYzZpcK _3iDTPbQ4SZ _1ANEUSLRg7",
    countSeparator: "_1UtDYzKGUX",
    wrapCodeControl: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _1ANEUSLRg7",
    statusText: "_3YEZNOdnbC _1ANEUSLRg7"
};
const $f2806cae53c3f91e$var$fullWidthFooterStyles = null;
const $f2806cae53c3f91e$var$DEFAULT_SOURCE_POSITION_STATE = {
    columnNumber: 1,
    lineCount: 1,
    lineNumber: 1,
    wordCount: 0
};
const $f2806cae53c3f91e$export$d36ee9c3e47d8d66 = ({ children: children, onShowLineNumbersChange: onShowLineNumbersChange, onWrapCodeChange: onWrapCodeChange, showLineNumbers: showLineNumbers, sourcePositionState: sourcePositionState, wrapCode: wrapCode = true })=>{
    const { columnNumber: columnNumber, lineCount: lineCount, lineNumber: lineNumber, wordCount: // `wordCount` is optional on the type for non-breaking adoption; default
    // it so a consumer-supplied state without a word count still renders.
    wordCount = 0 } = sourcePositionState ?? $f2806cae53c3f91e$var$DEFAULT_SOURCE_POSITION_STATE;
    const cursorPositionValues = (0, $cozmU.useMemo)(()=>({
            columnNumber: columnNumber,
            lineNumber: lineNumber
        }), [
        columnNumber,
        lineNumber
    ]);
    const lineCountValues = (0, $cozmU.useMemo)(()=>({
            lineCount: lineCount
        }), [
        lineCount
    ]);
    const wordCountValues = (0, $cozmU.useMemo)(()=>({
            wordCount: wordCount
        }), [
        wordCount
    ]);
    const handleLineNumbersChange = (0, $cozmU.useCallback)((event)=>{
        onShowLineNumbersChange?.(event.currentTarget.checked);
    }, [
        onShowLineNumbersChange
    ]);
    const handleWrapCodeChange = (0, $cozmU.useCallback)((event)=>{
        onWrapCodeChange?.(event.currentTarget.checked);
    }, [
        onWrapCodeChange
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0KLXrulfZc _3YEZNOdnbC _1EqgXlN91d _4ouGXIdnbC _39xV02N91d"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $f2806cae53c3f91e$var$footerStyles.footer,
            testId: "markdown-source-view-footer",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $f2806cae53c3f91e$var$footerStyles.leftSection,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.lineNumbersControl,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2uDbg.Checkbox), {
                                isChecked: showLineNumbers,
                                onChange: handleLineNumbersChange,
                                label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "content-markdown-mode.footer.line-numbers",
                                    defaultMessage: "Line numbers"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.wrapCodeControl,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2uDbg.Checkbox), {
                                isChecked: wrapCode,
                                onChange: handleWrapCodeChange,
                                label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "content-markdown-mode.footer.wrap-code",
                                    defaultMessage: "Wrap code"
                                })
                            })
                        }),
                        children,
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.statusText,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.cursor-position",
                                defaultMessage: "Ln {lineNumber}, Col {columnNumber}",
                                values: cursorPositionValues
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.labelText,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.cursor-position-label",
                                defaultMessage: "Position of cursor"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $f2806cae53c3f91e$var$footerStyles.rightSection,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.line-count",
                                defaultMessage: "{lineCount, plural, one {# line} other {# lines}}",
                                values: lineCountValues
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            xcss: $f2806cae53c3f91e$var$footerStyles.countSeparator,
                            "aria-hidden": true,
                            children: "|"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.word-count",
                                defaultMessage: "{wordCount, plural, one {# word} other {# words}}",
                                values: wordCountValues
                            })
                        })
                    ]
                })
            ]
        })
    });
};


const $44754940e72df3bb$var$TRAILING_SPACE_REGEX = /[ \t]$/u; // ---------------------------------------------------------------------------
// Annotation decoration support
//
// Annotation marks (inline comments) from the ADF document are surfaced as
// highlighted spans in the CodeMirror source view. These are purely visual —
// the markdown string itself is clean (no annotation syntax). The highlights
// shift correctly as the user edits because CM6's RangeSet maps them through
// document changes via the StateField update function.
// ---------------------------------------------------------------------------
// noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/**
 * Debounce window (ms) for recomputing the footer word count. Counting words
 * scans the whole document, so we don't run it on every keystroke — the cursor
 * line/column update live, but the word count refreshes only after the user
 * pauses typing for this long.
 */ const $44754940e72df3bb$var$WORD_COUNT_DEBOUNCE_MS = 400; /** Effect dispatched to replace the annotation decoration set. */ 
const $44754940e72df3bb$var$setAnnotationRangesEffect = (0, $b2ZzE.StateEffect).define();
const $44754940e72df3bb$var$lineNumbersCompartment = new (0, $b2ZzE.Compartment)();
const $44754940e72df3bb$var$getLineNumbersExtension = (showLineNumbers)=>showLineNumbers ? (0, $3e6dc.lineNumbers)() : [];
const $44754940e72df3bb$var$lineWrappingCompartment = new (0, $b2ZzE.Compartment)();
const $44754940e72df3bb$var$getLineWrappingExtension = (wrapCode)=>// When wrapping is on there's no horizontal overflow, so the default fixed
    // (sticky) gutter is fine. When wrapping is off long lines scroll
    // horizontally — `gutters({ fixed: false })` unsets the gutter's
    // `position: sticky` so the line-number gutter scrolls off to the left
    // along with the text instead of staying pinned to the viewport edge.
    wrapCode ? (0, $3e6dc.EditorView).lineWrapping : (0, $3e6dc.gutters)({
        fixed: false
    }); /**
     * Returns a CM6 decoration mark for the given annotation ID.
     * The `id` attribute is set so that `document.getElementById(annotationId)`
     * finds this visible CM6 element (rather than the hidden ProseMirror span)
     * when the inline comment popup calculates its anchor position.
     */ 
function $44754940e72df3bb$var$annotationMarkForId(annotationId) {
    return (0, $3e6dc.Decoration).mark({
        class: 'cm-annotation-highlight',
        attributes: {
            id: annotationId
        }
    });
} /**
   * Extract the current annotation character ranges from a CM6 DecorationSet,
   * matching each decoration back to its original annotation ID.
   *
   * CM6's `StateField` maps decorations through document changes automatically
   * (via `decorations.map(tr.changes)`), so after user edits the positions in
   * the DecorationSet reflect the shifted character offsets. We recover the
   * annotation ID by matching the shifted range against the original snapshot
   * list — first by exact position, then by any overlap (best-effort).
   */ 
function $44754940e72df3bb$var$extractCurrentAnnotationRanges(decorations, originalRanges) {
    const result = [];
    const cursor = decorations.iter();
    while(cursor.value !== null){
        const { from: from, to: to } = cursor; // Try to match to an original annotation by exact position first,
        // then fall back to overlap — the id is what matters for re-application.
        const matched = originalRanges.find((a)=>a.from === from && a.to === to) ?? originalRanges.find((a)=>a.from < to && a.to > from); // Only push if we found a matching annotation — an empty-string ID is
        // meaningless and would corrupt the ranges array passed downstream.
        if (matched) result.push({
            id: matched.id,
            from: from,
            to: to
        });
        cursor.next();
    }
    return result;
} /**
   * Keep the latest value in a stable ref for CodeMirror callbacks that are
   * intentionally created once per source-view mount.
   */ 
function $44754940e72df3bb$var$useReactiveRef(targetValue) {
    const ref = (0, $cozmU.useRef)(targetValue);
    (0, $cozmU.useEffect)(()=>{
        ref.current = targetValue;
    }, [
        targetValue
    ]);
    return ref;
} // noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/**
 * CM6 StateField that holds the current annotation DecorationSet.
 *
 * On `setAnnotationRangesEffect`: rebuilds the decoration set from the new
 * ranges. On any other transaction: maps the existing decorations through
 * the document changes so character positions stay correct after edits.
 */ const $44754940e72df3bb$var$annotationDecorationsField = (0, $b2ZzE.StateField).define({
    create () {
        return (0, $3e6dc.Decoration).none;
    },
    update (decorations, tr) {
        // Check for a setAnnotationRangesEffect in this transaction.
        for (const effect of tr.effects)if (effect.is($44754940e72df3bb$var$setAnnotationRangesEffect)) {
            const ranges = effect.value;
            if (ranges.length === 0) return (0, $3e6dc.Decoration).none;
             // Rebuild the decoration set from the new ranges.
            // Ranges must be sorted and non-overlapping for a single decoration
            // type — we sort by `from` and clamp to doc length.
            const docLen = tr.state.doc.length;
            const builder = new (0, $b2ZzE.RangeSetBuilder)();
            const sorted = [
                ...ranges
            ].sort((a, b)=>a.from - b.from);
            for (const { from: from, to: to, id: id } of sorted){
                const clampedFrom = Math.min(Math.max(from, 0), docLen);
                const clampedTo = Math.min(Math.max(to, 0), docLen);
                if (clampedFrom < clampedTo) builder.add(clampedFrom, clampedTo, $44754940e72df3bb$var$annotationMarkForId(id));
            }
            return builder.finish();
        }
         // No range update — map existing decorations through any document changes.
        return tr.docChanged ? decorations.map(tr.changes) : decorations;
    },
    provide (field) {
        return (0, $3e6dc.EditorView).decorations.from(field);
    }
});
const $44754940e72df3bb$var$styles = {
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0GTcwRIZbP _2xTnZxIZbP _20H5YkdnbC _39xV02N91d",
    layout: "_0jFU0VN91d _0NUa3rN91d _4ouGXIdnbC _39xV02N91d",
    editor: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _30huDKYbGa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _4kiQYABfNa _39xV02N91d _20H5YkdnbC _2zzEJX98eZ _0MLwP2YbGa _42yC4ZT6kp _47LZLrN91d _3Qh52pdnbC _1F54yFN91d"
}; /**
    * Stable public prop interface for `MarkdownSourceView`.
    *
    * Other agents depend on this contract — DO NOT change without coordination.
    */ 
const $44754940e72df3bb$export$eb7c1c6ff6845883 = ({ contentId: _contentId, initialAdfDoc: initialAdfDoc, seedMarkdown: seedMarkdown, schema: schema, revision: revision = 0, onMarkdownCommit: onMarkdownCommit, liveAdfDoc: liveAdfDoc, postWritebackAdfDoc: postWritebackAdfDoc, onSourceMarkdownChange: onSourceMarkdownChange, sourceChangeDebounceMs: sourceChangeDebounceMs = 2000, serializeFileMedia: serializeFileMedia, annotationRanges: annotationRanges, onAnnotationRangesChange: onAnnotationRangesChange, onAnnotationClick: onAnnotationClick, onRegisterCommandDispatch: onRegisterCommandDispatch, onSourceFormatStateChange: onSourceFormatStateChange, syntaxHighlightTheme: syntaxHighlightTheme = 'default', onSourcePositionStateChange: onSourcePositionStateChange, onShowLineNumbersChange: onShowLineNumbersChange, showLineNumbers: showLineNumbers = true, onWrapCodeChange: onWrapCodeChange, wrapCode: wrapCode = true })=>{
    const intl = (0, $kSwu1.useIntl)(); // MVP full-page layout: the parent `editor-content-container` owns vertical
    // scrolling, so the source view grows to content height instead of scrolling
    // CodeMirror internally (avoids duplicate scrollbars). Read once — the gate
    // value is stable for the lifetime of the mounted view.
    const [sourcePositionState, setSourcePositionState] = (0, $cozmU.useState)(null); // Stash the file-media serialiser in a ref so changing the function
    // reference does not rebuild CodeMirror or invalidate the live-doc
    // effect. The function is read at call time inside `adfToMarkdown`.
    const serializeFileMediaRef = $44754940e72df3bb$var$useReactiveRef(serializeFileMedia); // Read at mount inside the seed effect; ref so a prop change doesn't rebuild
    // CodeMirror — it applies on the next seed.
    const syntaxHighlightThemeRef = $44754940e72df3bb$var$useReactiveRef(syntaxHighlightTheme); // EDITOR-7602 — active ADS colour mode from the `<html>` theme (the resolved
    // `data-color-mode`, not raw `prefers-color-scheme`). Read at seed time like
    // `syntaxHighlightTheme`; the palette is token-driven so a live toggle
    // re-paints anyway — the mode only picks the fallback-hex per mode.
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const syntaxColorModeRef = $44754940e72df3bb$var$useReactiveRef(colorMode === 'dark' ? 'dark' : 'light'); // Stash the schema + commit callback in refs so the unmount cleanup can
    // keep its dep list narrow (we only want the seed/teardown to run on
    // revision change, not whenever the parent re-renders with a new
    // function ref).
    const schemaRef = $44754940e72df3bb$var$useReactiveRef(schema);
    const onCommitRef = $44754940e72df3bb$var$useReactiveRef(onMarkdownCommit); // EDITOR-6558 Tier 2 — keep the live source-change callback + debounce in
    // refs so the seed effect's CodeMirror extension list (which captures
    // these once at mount) always reads the latest values without rebuilding
    // the editor on every parent re-render.
    const onSourceMarkdownChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourceMarkdownChange);
    const sourceChangeDebounceMsRef = $44754940e72df3bb$var$useReactiveRef(sourceChangeDebounceMs); // Latest ADF doc the parent has handed us, kept in a ref so the seed
    // effect can read the most-recent value without re-running on every
    // `initialAdfDoc` reference change. The seed effect deliberately reads
    // it only when `revision` changes.
    const initialAdfDocRef = $44754940e72df3bb$var$useReactiveRef(initialAdfDoc); // Pre-computed markdown from the parent (sync-snapshot), mirrored to a ref and
    // updated during render so the seed effect reads the value for the current revision.
    const seedMarkdownPropRef = (0, $cozmU.useRef)(seedMarkdown);
    seedMarkdownPropRef.current = seedMarkdown; // Ref to the host element CodeMirror mounts into.
    const hostRef = (0, $cozmU.useRef)(null); // Ref to the live EditorView so the cleanup can read its doc.
    const viewRef = (0, $cozmU.useRef)(null); // The markdown the editor was *seeded* with for the current revision —
    // used to detect no-op commits and skip the writeback round-trip. Also
    // the baseline for the disjoint/overlap analysis in the live-refresh path.
    const seedMarkdownRef = (0, $cozmU.useRef)(''); // Most recently deferred `liveAdfDoc` update. Set when an incoming remote
    // change overlaps the user's unsynced typing. Discarded on next
    // `postWritebackAdfDoc` (its content is already in the post-rebase PM).
    const pendingLiveMarkdownRef = (0, $cozmU.useRef)(null);
    const ariaLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).sourceAriaLabel);
    const ariaLabelRef = $44754940e72df3bb$var$useReactiveRef(ariaLabel); // Runtime locale for locale-aware word counting in the footer. Stored in a
    // ref so the CM6 updateListener (captured once per seed) reads the latest
    // value without rebuilding the editor when the locale changes.
    const localeRef = $44754940e72df3bb$var$useReactiveRef(intl.locale); // Word count is debounced (see WORD_COUNT_DEBOUNCE_MS): the cursor/line
    // fields update on every change, but the word count — a full-document scan —
    // is recomputed only after the user pauses. `lastWordCountRef` holds the most
    // recently computed count so the immediate (cheap) updates can reuse it
    // instead of re-scanning; `wordCountTimerRef` is the pending debounce timer.
    const lastWordCountRef = (0, $cozmU.useRef)(0);
    const wordCountTimerRef = (0, $cozmU.useRef)(null); // EDITOR-6558 Tier 2 — flag set while we're applying a programmatic
    // `liveAdfDoc` change to CodeMirror, so the resulting `updateListener`
    // fire is recognised as an echo and not pushed back to the parent. The
    // flag is set immediately before `view.dispatch({ changes })` and
    // cleared on the next microtask (CodeMirror's update listeners run
    // synchronously inside `dispatch`). Using a ref so the closure captured
    // inside the extension can read it.
    const suppressSourceChangeRef = (0, $cozmU.useRef)(false); // Debounce timer for `onSourceMarkdownChange` — scoped to the view so
    // teardown cleans it up.
    const sourceChangeTimerRef = (0, $cozmU.useRef)(null); // The line number (1-based) where the last doc change occurred.
    // Used to detect when the cursor has moved to a different line so we can
    // short-circuit the debounce and flush the pending writeback early.
    const lastEditLineRef = (0, $cozmU.useRef)(null); // Stash onAnnotationRangesChange in a ref so the sourceChangeListener
    // (captured once at mount) always reads the latest callback without
    // rebuilding CodeMirror on every parent re-render.
    const onAnnotationRangesChangeRef = $44754940e72df3bb$var$useReactiveRef(onAnnotationRangesChange); // Stash onAnnotationClick in a ref so the CM6 domEventHandlers click
    // extension (captured once at mount) always reads the latest callback.
    const onAnnotationClickRef = $44754940e72df3bb$var$useReactiveRef(onAnnotationClick); // Stash onRegisterCommandDispatch in a ref so the effect below doesn't
    // re-run when the parent re-renders with a new function reference.
    const onRegisterCommandDispatchRef = $44754940e72df3bb$var$useReactiveRef(onRegisterCommandDispatch);
    const onSourceFormatStateChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourceFormatStateChange);
    const onSourcePositionStateChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourcePositionStateChange);
    const showLineNumbersRef = $44754940e72df3bb$var$useReactiveRef(showLineNumbers);
    const wrapCodeRef = $44754940e72df3bb$var$useReactiveRef(wrapCode);
    const handleSourcePositionStateChange = (0, $cozmU.useCallback)((state)=>{
        setSourcePositionState(state);
        onSourcePositionStateChangeRef.current?.(state);
    }, [
        onSourcePositionStateChangeRef
    ]); // Expose a stable dispatcher function via the onRegisterCommandDispatch
    // prop so MarkdownModeContentComponent can register it with the plugin
    // whenever api changes. The function reads viewRef at call time so it
    // always dispatches to the live CM6 EditorView.
    const dispatchCmd = (0, $cozmU.useCallback)((cmd)=>{
        const view = viewRef.current;
        if (!view) return false;
        return cmd(view);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- viewRef is a stable ref — intentionally not in deps.
    []); // Register/unregister the dispatcher via the onRegisterCommandDispatch prop.
    // This fires on mount (register) and unmount (null). Re-registration when
    // the plugin rebuilds is handled by MarkdownModeContentComponent which
    // passes an updated onRegisterCommandDispatch whenever api changes.
    (0, $cozmU.useEffect)(()=>{
        const onRegisterCommandDispatch = onRegisterCommandDispatchRef.current;
        onRegisterCommandDispatch?.(dispatchCmd);
        return ()=>{
            onRegisterCommandDispatch?.(null);
        };
    }, [
        dispatchCmd,
        onRegisterCommandDispatchRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        const view = viewRef.current;
        if (!view) return;
        view.dispatch({
            effects: $44754940e72df3bb$var$lineNumbersCompartment.reconfigure($44754940e72df3bb$var$getLineNumbersExtension(showLineNumbers))
        });
    }, [
        showLineNumbers
    ]);
    (0, $cozmU.useEffect)(()=>{
        const view = viewRef.current;
        if (!view) return;
        view.dispatch({
            effects: $44754940e72df3bb$var$lineWrappingCompartment.reconfigure($44754940e72df3bb$var$getLineWrappingExtension(wrapCode))
        });
    }, [
        wrapCode
    ]); // Annotation ranges — kept in a ref so the CM6 StateField (created once
    // at mount) can always read the latest value. Updated whenever the prop
    // changes (i.e. when the parent re-seeds on revision change or live update).
    const annotationRangesRef = (0, $cozmU.useRef)(annotationRanges ?? []);
    (0, $cozmU.useEffect)(()=>{
        annotationRangesRef.current = annotationRanges ?? []; // If the view is mounted, notify the StateField to recompute decorations.
        const view = viewRef.current;
        if (view) view.dispatch({
            effects: $44754940e72df3bb$var$setAnnotationRangesEffect.of(annotationRanges ?? [])
        });
    }, [
        annotationRanges
    ]); // Mount/seed CodeMirror on every `revision` change. Tear down + commit
    // on cleanup (revision change OR component unmount).
    (0, $cozmU.useEffect)(()=>{
        const host = hostRef.current;
        if (!host) return undefined;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const onCommit = onCommitRef.current;
        const onAnnotationRangesChange = onAnnotationRangesChangeRef.current;
        const onSourcePositionStateChange = onSourcePositionStateChangeRef.current; // Seed markdown for this revision. Prefer the parent's pre-computed value
        // (sync-snapshot, avoids a second conversion); otherwise convert here.
        let seedMarkdownValue;
        const precomputedSeed = seedMarkdownPropRef.current;
        if (precomputedSeed !== undefined) seedMarkdownValue = precomputedSeed;
        else try {
            const result = (0, $5nazv.adfToMarkdown)(initialAdfDocRef.current, schema, {
                serializeFileMedia: serializeFileMedia
            });
            seedMarkdownValue = result.markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert ADF doc to markdown; starting with empty buffer.', err);
            seedMarkdownValue = '';
        }
        seedMarkdownRef.current = seedMarkdownValue; // How long to wait before retrying a flush when the current line has
        // unbalanced syntax (e.g. user typed `*ital` and paused mid-word).
        // Long enough to give the user time to finish their syntax, but short
        // enough to guarantee the doc eventually syncs even if they leave it
        // unfinished (e.g. intentional bare `*` or just navigated away).
        const UNBALANCED_RETRY_MS = 5000; // Shared flush function — reads the current CM6 state and fires the
        // writeback callbacks. If the cursor's current line has unbalanced
        // markdown syntax (e.g. `*ital` mid-word) the flush is deferred by
        // UNBALANCED_RETRY_MS instead of firing immediately, giving the user
        // time to finish the syntax without corrupting the live PM doc.
        // Called both by the debounce timer and by the line-change short-circuit.
        const flushSourceChange = (editorView)=>{
            const markdownNow = editorView.state.doc.toString();
            const cursorPos = editorView.state.selection.main.head;
            const cursorLine = editorView.state.doc.lineAt(cursorPos); // A trailing space at the cursor is usually in-progress typing. Live markdown→ADF
            // writeback can normalize it away and then re-sync the source view without the
            // space, so wait until the user types the next non-space character. The final
            // commit still reads from CodeMirror, so the user's buffer remains authoritative.
            if (cursorPos === cursorLine.to && $44754940e72df3bb$var$TRAILING_SPACE_REGEX.test(cursorLine.text)) return;
             // If the current line has unbalanced syntax, reschedule rather than
            // firing. Writing e.g. `*ital` into the PM editor would round-trip
            // back as `\*ital`, clobbering the source view. We defer instead of
            // suppressing indefinitely — worst case the user leaves a bare `*`
            // and it commits after UNBALANCED_RETRY_MS.
            if ((0, $b5c8870ce01fabc3$export$cf49bba3d053a321)(markdownNow, cursorPos)) {
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    const newEditorView = viewRef.current;
                    if (newEditorView) flushSourceChange(newEditorView);
                }, UNBALANCED_RETRY_MS);
                return;
            } // Fire the annotation ranges change callback FIRST so that
            // currentAnnotationRangesRef is up-to-date before onSourceMarkdownChange
            // reads it to re-apply annotation marks. If onSourceMarkdownChange fired
            // first it would see stale/empty ranges on the first flush, stripping
            // all annotation marks from the live PM doc.
            const onRangesChange = onAnnotationRangesChangeRef.current;
            if (onRangesChange && annotationRangesRef.current.length > 0) {
                const currentRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(editorView.state.field($44754940e72df3bb$var$annotationDecorationsField), annotationRangesRef.current);
                onRangesChange(currentRanges);
            }
            const cb = onSourceMarkdownChangeRef.current;
            if (cb) cb(markdownNow);
        }; // Recompute the (expensive) word count and push the full position state.
        // Called on mount and from the debounce timer, never synchronously on a
        // keystroke.
        const flushWordCount = (editorView)=>{
            lastWordCountRef.current = (0, $b8e7170495150c53$export$a063438ffa4b0154)(editorView.state.doc, localeRef.current);
            handleSourcePositionStateChange({
                ...(0, $b8e7170495150c53$export$35f4bb6bae3e9d74)(editorView.state),
                wordCount: lastWordCountRef.current
            });
        };
        const sourceChangeListener = (0, $3e6dc.EditorView).updateListener.of((update)=>{
            if (update.docChanged || update.selectionSet) {
                // Update the cheap cursor/line fields immediately, reusing the last
                // computed word count so the footer stays responsive without
                // re-scanning the document on every change.
                handleSourcePositionStateChange({
                    ...(0, $b8e7170495150c53$export$35f4bb6bae3e9d74)(update.state),
                    wordCount: lastWordCountRef.current
                }); // Only document edits change the word count; debounce the recompute.
                // Selection-only changes reuse the cached count above.
                if (update.docChanged) {
                    if (wordCountTimerRef.current !== null) clearTimeout(wordCountTimerRef.current);
                    wordCountTimerRef.current = setTimeout(()=>{
                        wordCountTimerRef.current = null;
                        const editorView = viewRef.current;
                        if (editorView) flushWordCount(editorView);
                    }, $44754940e72df3bb$var$WORD_COUNT_DEBOUNCE_MS);
                }
            }
            if (suppressSourceChangeRef.current) return;
             // Push format state on every selection or doc change so the toolbar
            // can reflect isActive / isDisabled correctly while in source view.
            if (update.docChanged || update.selectionSet) onSourceFormatStateChangeRef.current?.({
                inline: (0, $b8e7170495150c53$export$5069c0cb22ba97e6)(update.state),
                block: (0, $b8e7170495150c53$export$96bc0c55bfc3ec38)(update.state),
                list: (0, $b8e7170495150c53$export$19f8516089a6ae9b)(update.state)
            });
            if (update.docChanged) {
                // Record which line the edit happened on so we can short-circuit
                // the debounce if the cursor moves away before it fires.
                const headPos = update.state.selection.main.head;
                lastEditLineRef.current = update.state.doc.lineAt(headPos).number;
                if (!onSourceMarkdownChangeRef.current) return;
                 // Reset the debounce timer — 2000ms while the user is actively typing.
                if (sourceChangeTimerRef.current !== null) clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    lastEditLineRef.current = null;
                    const editorView = viewRef.current;
                    if (!editorView) return;
                    flushSourceChange(editorView);
                }, sourceChangeDebounceMsRef.current);
                return;
            } // Doc didn't change — check if the cursor has moved to a different line.
            // If there's a pending debounce timer and the cursor is now on a
            // different line than where the edit happened, short-circuit: cancel
            // the long timer and flush after a short 100ms grace period (to avoid
            // flushing on every arrow-key repeat).
            if (sourceChangeTimerRef.current !== null && lastEditLineRef.current !== null && update.selectionSet) {
                const headPos = update.state.selection.main.head;
                const currentLine = update.state.doc.lineAt(headPos).number;
                if (currentLine !== lastEditLineRef.current) {
                    clearTimeout(sourceChangeTimerRef.current);
                    sourceChangeTimerRef.current = setTimeout(()=>{
                        sourceChangeTimerRef.current = null;
                        lastEditLineRef.current = null;
                        const editorView = viewRef.current;
                        if (!editorView) return;
                        flushSourceChange(editorView);
                    }, 100);
                }
            }
        }); // EDITOR-7602 — highlight fenced code by language (`codeLanguages`) and
        // layer the ADS-token theme above the CM6 default.
        const state = (0, $b2ZzE.EditorState).create({
            doc: seedMarkdownValue,
            extensions: [
                $44754940e72df3bb$var$lineNumbersCompartment.of($44754940e72df3bb$var$getLineNumbersExtension(showLineNumbersRef.current)),
                (0, $3e6dc.highlightActiveLine)(),
                (0, $3e6dc.drawSelection)(),
                (0, $3e6dc.dropCursor)(),
                (0, $7nRDp.history)(),
                (0, $4lK5a.indentOnInput)(),
                (0, $4lK5a.bracketMatching)(),
                (0, $9R6p6.markdown)({
                    base: (0, $9R6p6.markdownLanguage),
                    codeLanguages: (0, $725xj.languages)
                }),
                (0, $4lK5a.syntaxHighlighting)((0, $6480260b9bb6fc4e$export$eb40053f1fb44ebf)(syntaxHighlightThemeRef.current, syntaxColorModeRef.current)),
                // CM6 default — base/fallback layer for tags the theme doesn't cover.
                (0, $4lK5a.syntaxHighlighting)((0, $4lK5a.defaultHighlightStyle), {
                    fallback: true
                }),
                $44754940e72df3bb$var$lineWrappingCompartment.of($44754940e72df3bb$var$getLineWrappingExtension(wrapCodeRef.current)),
                // Formatting shortcuts — mirror the WYSIWYG toolbar shortcuts.
                (0, $3e6dc.keymap).of([
                    // Inline formatting
                    {
                        key: 'Mod-b',
                        run: (0, $b8e7170495150c53$export$b850a936f66192a3)
                    },
                    {
                        key: 'Mod-i',
                        run: (0, $b8e7170495150c53$export$227b5ef404be9031)
                    },
                    {
                        key: 'Mod-Shift-m',
                        run: (0, $b8e7170495150c53$export$e7d955a85cfe503c)
                    },
                    {
                        key: 'Mod-Shift-s',
                        run: (0, $b8e7170495150c53$export$a46d65f808b4881d)
                    },
                    // Headings (Mod-Alt-1 through Mod-Alt-6, matching WYSIWYG)
                    {
                        key: 'Mod-Alt-1',
                        run: (0, $b8e7170495150c53$export$4e0d444e5782abea)
                    },
                    {
                        key: 'Mod-Alt-2',
                        run: (0, $b8e7170495150c53$export$b8d734de6aecb0a3)
                    },
                    {
                        key: 'Mod-Alt-3',
                        run: (0, $b8e7170495150c53$export$df05910f74b29e0)
                    },
                    {
                        key: 'Mod-Alt-4',
                        run: (0, $b8e7170495150c53$export$ca48da5fbbd68542)
                    },
                    {
                        key: 'Mod-Alt-5',
                        run: (0, $b8e7170495150c53$export$1335885ed6c2d3ac)
                    },
                    {
                        key: 'Mod-Alt-6',
                        run: (0, $b8e7170495150c53$export$8381ca7ddcf8db0d)
                    },
                    // Blockquote
                    {
                        key: 'Mod-Shift-9',
                        run: (0, $b8e7170495150c53$export$2cd68375ac1e5429)
                    },
                    // Lists
                    {
                        key: 'Mod-Shift-8',
                        run: (0, $b8e7170495150c53$export$71c898cbdfd51c6e)
                    },
                    {
                        key: 'Mod-Shift-7',
                        run: (0, $b8e7170495150c53$export$744c9722bde8c6b3)
                    }
                ]),
                (0, $3e6dc.keymap).of([
                    ...(0, $7nRDp.defaultKeymap),
                    ...(0, $7nRDp.historyKeymap)
                ]),
                (0, $3e6dc.EditorView).contentAttributes.of({
                    'aria-label': ariaLabelRef.current
                }),
                (0, $3e6dc.EditorView).theme({
                    // The source view is bounded to the viewport and CodeMirror owns its
                    // own scrolling — `.cm-scroller` scrolls both axes natively, so its
                    // horizontal scrollbar sits at the bottom of the viewport, just above
                    // the in-flow footer. The parent `editor-content-container`'s vertical
                    // scroll track is neutralised in markdown mode (see FullPageContentArea)
                    // so there is no second scrollbar.
                    '&': {
                        flex: '1 1 auto',
                        height: '100%',
                        minHeight: 0,
                        width: '100%'
                    },
                    '.cm-scroller': {
                        height: '100%',
                        minHeight: 0,
                        // Keeps the caret clear of the bottom edge when typing at the end of
                        // the document (the scroller is the scroll container again).
                        scrollPaddingBlockEnd: "var(--ds-space-600, 48px)",
                        // Left inset for the editor content (gutter + text). Lives on the
                        // scroller — not `.cm-editor` — so the horizontal scrollbar still
                        // spans the full viewport width (the scrollbar sits on the
                        // scroller's border box, outside this padding).
                        paddingLeft: "var(--ds-space-400, 32px)",
                        // Top inset for the editor content. Lives on the scroller (insets the
                        // gutter + text together, keeping line numbers aligned) rather than on
                        // the `.ak-editor-content-area-region` wrapper — wrapper padding would
                        // push the scroller down and leave a gap above the vertical scrollbar.
                        // The scrollbar sits on the scroller's border box, outside this padding,
                        // so it still spans the full height.
                        paddingTop: "var(--ds-space-500, 40px)",
                        ...(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot') ? // Token-aligned typography for the source view (ADS typography tokens
                        // instead of raw monospace/14px/1.6 values).
                        {
                            font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
                        } : {
                            fontFamily: 'monospace',
                            fontSize: '14px',
                            lineHeight: '1.6'
                        }
                    },
                    // Right inset for the text column. Applied to `.cm-content` rather
                    // than the scroller because a scroll container's `padding-inline-end`
                    // is dropped from the scrollable region in some browsers, letting the
                    // last characters sit flush against the right edge when scrolled.
                    '.cm-content': {
                        paddingRight: "var(--ds-space-400, 32px)"
                    },
                    '.cm-gutter': {
                        minHeight: '100%'
                    },
                    '.cm-gutters': {
                        alignSelf: 'stretch',
                        minHeight: '100%',
                        borderRight: 0,
                        marginRight: "var(--ds-space-200, 16px)",
                        backgroundColor: 'transparent'
                    },
                    '.cm-gutters .cm-gutter.cm-lineNumbers .cm-gutterElement': {
                        padding: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-200, 16px)"}`
                    },
                    // Annotation (inline comment) highlight — subtle background tint
                    // matching the Confluence inline comment highlight colour.
                    // cursor:pointer signals the span is interactive (clickable).
                    '.cm-annotation-highlight': {
                        backgroundColor: 'rgba(255, 196, 0, 0.3)',
                        cursor: 'pointer'
                    },
                    // Token-driven editor chrome. CM6's baseTheme is light by default
                    // (we never mark the view dark), so its selection (#d7d4f0),
                    // active-line (#cceeff44) and caret colours wash out on a dark
                    // surface. Override with ADS tokens (which adapt to the mode);
                    // `!important` is needed because CM's focused-selection selector
                    // (`&light.cm-focused > .cm-scroller > .cm-selectionLayer
                    // .cm-selectionBackground`) is far more specific than ours.
                    '.cm-activeLine': {
                        backgroundColor: `${"var(--ds-background-neutral-subtle-hovered, #0515240F)"} !important`
                    },
                    '.cm-selectionLayer .cm-selectionBackground, & .cm-selectionBackground': {
                        background: `${"var(--ds-background-selected, #E9F2FE)"} !important`
                    },
                    '.cm-cursor, .cm-dropCursor': {
                        borderLeftColor: `${"var(--ds-text, #292A2E)"} !important`
                    }
                }),
                // Annotation decorations — renders inline comment highlights.
                // Only active when annotation ranges are provided. The StateField
                // maps ranges through document changes so highlights shift
                // correctly as the user edits.
                $44754940e72df3bb$var$annotationDecorationsField,
                // Click handler for annotation highlights. When the user clicks
                // inside a `.cm-annotation-highlight` span, we look up which
                // annotation range contains the clicked character position and
                // fire `onAnnotationClick` with its ID. The parent dispatches
                // the appropriate ProseMirror command to open the comment popup
                // or panel — mirroring the click behaviour in the WYSIWYG view.
                (0, $3e6dc.EditorView).domEventHandlers({
                    click (event, view) {
                        const cb = onAnnotationClickRef.current;
                        if (!cb) return false;
                        const ranges = annotationRangesRef.current;
                        if (!ranges.length) return false;
                         // Use CM6's posAtCoords to get the character offset at the
                        // click position, then find the annotation range that contains it.
                        const pos = view.posAtCoords({
                            x: event.clientX,
                            y: event.clientY
                        });
                        if (pos === null) return false;
                         // Read the current (possibly-shifted) decoration positions from
                        // the StateField so clicks work correctly after the user has
                        // edited text around the annotation highlights.
                        const decorationsField = view.state.field($44754940e72df3bb$var$annotationDecorationsField, false);
                        if (!decorationsField) // Fall back to the original snapshot ranges if the field
                        // isn't present (e.g. annotationRanges wasn't provided).
                        return false;
                        const currentRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(decorationsField, ranges);
                        const clickedRange = currentRanges.find((range)=>pos >= range.from && pos < range.to);
                        if (!clickedRange) return false;
                        cb(clickedRange.id);
                        return true;
                    }
                }),
                sourceChangeListener
            ]
        });
        const view = new (0, $3e6dc.EditorView)({
            state: state,
            parent: host
        });
        viewRef.current = view;
        onSourceFormatStateChangeRef.current?.({
            inline: (0, $b8e7170495150c53$export$5069c0cb22ba97e6)(view.state),
            block: (0, $b8e7170495150c53$export$96bc0c55bfc3ec38)(view.state),
            list: (0, $b8e7170495150c53$export$19f8516089a6ae9b)(view.state)
        }); // Seed the full position state (including word count) synchronously on
        // mount; subsequent word-count updates are debounced via flushWordCount.
        flushWordCount(view); // Seed the annotation decorations for this revision if ranges were provided.
        // We dispatch immediately after view creation so the initial highlights
        // are visible on mount without waiting for the next render cycle.
        if (annotationRangesRef.current.length > 0) view.dispatch({
            effects: $44754940e72df3bb$var$setAnnotationRangesEffect.of(annotationRangesRef.current)
        });
        return ()=>{
            // Tier 2: drop any pending source-change debounce — we're tearing
            // down the view, the parent will get either the final commit
            // (below) or nothing.
            if (sourceChangeTimerRef.current !== null) {
                clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = null;
            } // Drop any pending word-count debounce — the view is going away.
            if (wordCountTimerRef.current !== null) {
                clearTimeout(wordCountTimerRef.current);
                wordCountTimerRef.current = null;
            } // Read the final markdown AND annotation ranges BEFORE destroying the view.
            const finalMarkdown = view.state.doc.toString(); // Fire the final annotation ranges to the parent so handleMarkdownCommit
            // has the latest CM6-tracked positions (not the stale snapshot ranges).
            if (onAnnotationRangesChange && annotationRangesRef.current.length > 0) {
                const finalRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(view.state.field($44754940e72df3bb$var$annotationDecorationsField), annotationRangesRef.current);
                onAnnotationRangesChange(finalRanges);
            }
            view.destroy();
            viewRef.current = null;
            onSourcePositionStateChange?.(null);
            if (!onCommit) return;
             // No-op guard: if the user didn't change the buffer, don't fire
            // a writeback. The markdown round-trip is lossy in general, so
            // committing the unchanged buffer would still mutate the live
            // doc (and reset collab cursors / undo history).
            if (finalMarkdown === seedMarkdownRef.current) return;
            try {
                // Validate by attempting to parse — if it throws we discard the
                // change. We deliberately do NOT pass the parsed PMNode out;
                // the parent re-parses against its own editor schema (which
                // may differ at the margins from ours) when applying.
                (0, $5nazv.markdownToAdf)(finalMarkdown, schema);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('[MarkdownSourceView] Failed to parse markdown back to ADF on commit; discarding change.', err);
                return;
            }
            onCommit(finalMarkdown);
        }; // `revision` is the only dependency: a bump forces a destroy + re-seed.
    // Schema/commit/aria/initialAdfDoc are all read through refs above so
    // they don't reseed the editor (which would clobber the user's edits).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        revision
    ]);
    // EDITOR-6558 Tier 1 — react to live WYSIWYG → source updates.
    //
    // We diff the new markdown against the current CodeMirror buffer and
    // dispatch a minimal-replace `ChangeSet`, so the user's caret survives
    // updates that don't touch the position they're editing at.
    //
    // `seedMarkdownRef` is updated on every successful diff-apply so a later
    // no-op-guard commit on unmount/revision-change still works correctly
    // (the "seed" for that revision is logically the most-recent live doc,
    // not the doc we mounted with).
    (0, $cozmU.useEffect)(()=>{
        if (liveAdfDoc === undefined) return;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const view = viewRef.current;
        if (!view) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('live-tap');
        const currentBuffer = view.state.doc.toString();
        let nextMarkdown;
        try {
            const result = (0, $5nazv.adfToMarkdown)(liveAdfDoc, schema, {
                serializeFileMedia: serializeFileMedia
            });
            nextMarkdown = result.markdown;
        } catch (err) {
            // Live doc contains a node that the markdown serialiser can't
            // represent. Don't blow away the user's buffer — just skip.
            trace?.sync(()=>({
                    decision: 'parse-failed',
                    path: null,
                    note: "adf\u2192md serialize failed; live update skipped"
                })); // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert live ADF doc to markdown; skipping live update.', err);
            return;
        }
        if (nextMarkdown === currentBuffer) {
            // Echo from our own writeback (or no-op live update). Update the
            // seed reference so the no-op guard on the next commit reflects
            // the latest agreed-on text.
            seedMarkdownRef.current = nextMarkdown;
            trace?.sync(()=>({
                    decision: 'echo-filtered',
                    path: null
                }));
            return;
        } // EDITOR-6558 Option C — "source markdown is canonical".
        //
        // The user is typing in CodeMirror. Their buffer is THE truth. The
        // `liveAdfDoc` we just received may be semantically equal to what
        // the user typed but disagree on the markdown surface form (e.g.
        // `*ital` vs `\*ital` after the round-trip escape, or trailing
        // space → `&#x20;`). In those cases we must skip the diff-apply.
        //
        // Comparison strategy: re-serialise BOTH sides via `adfToMarkdown`
        // and compare the markdown strings. Reasoning:
        //  - JSON.stringify identity fails when plugins assign attrs like
        //    `localId` to the live doc that aren't in the parsed buffer.
        //  - `Node.eq` (with `schema.nodeFromJSON(liveAdfDoc)`) ALSO fails
        //    for the same reason — Node.eq is attr-strict.
        //  - Re-serialising both sides via the same pipeline drops
        //    non-semantic attrs (the markdown serialiser doesn't include
        //    `localId`), so byte-equal markdown ⇒ semantically equivalent
        //    docs. This is the same approach the integration test bed
        //    proved correct.
        try {
            const currentBufferAsAdf = (0, $5nazv.markdownToAdf)(currentBuffer, schema);
            const { markdown: bufferAsMarkdown } = (0, $5nazv.adfToMarkdown)(currentBufferAsAdf, schema, {
                serializeFileMedia: serializeFileMedia
            });
            if (bufferAsMarkdown === nextMarkdown) {
                // Don't bump seedMarkdownRef here — the user's buffer is the
                // authoritative seed for the no-op-commit guard. If they
                // switch back to wysiwyg without further edits, the commit
                // will correctly fire because their buffer differs from the
                // markdown we seeded with at mount.
                trace?.sync(()=>({
                        decision: 'skipped-equivalent',
                        path: null,
                        note: 'buffer already semantically equal to live doc'
                    }));
                return;
            }
        } catch (err) {
        // (e.g. unbalanced syntax). Fall through to the diff-apply
        // path below.
        }
        const changes = (0, $221c70a2c73ffadc$export$e291136b00c395d)(seedMarkdownRef.current, currentBuffer, nextMarkdown);
        if (!changes) {
            // Overlap with user's typing — defer until next postWritebackAdfDoc.
            pendingLiveMarkdownRef.current = nextMarkdown;
            trace?.sync(()=>({
                    decision: 'no-op',
                    path: null,
                    note: "deferred \u2014 live update overlaps the user\u2019s in-progress edit"
                }));
            return;
        }
        if (changes.length > 0) {
            // Suppress the user-edit listener for this programmatic dispatch —
            // CM6 update listeners run synchronously inside `view.dispatch`, so
            // it's safe to clear immediately after.
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: changes
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
            trace?.sync(()=>({
                    decision: 'replaced',
                    path: null,
                    note: 'source buffer updated from live doc'
                }));
        } else trace?.sync(()=>({
                decision: 'no-op',
                path: null
            }));
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        liveAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    // Re-seed CM6 from the post-rebase PM doc the orchestrator pushed after
    // its own-writeback. Any deferred overlapping liveAdfDoc is already in PM
    // and is discarded.
    (0, $cozmU.useEffect)(()=>{
        if (postWritebackAdfDoc === undefined) return;
        const view = viewRef.current;
        if (!view) return;
        const schema = schemaRef.current;
        let nextMarkdown;
        try {
            nextMarkdown = (0, $5nazv.adfToMarkdown)(postWritebackAdfDoc, schema, {
                serializeFileMedia: serializeFileMediaRef.current
            }).markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to serialise post-writeback ADF; skipping re-seed.', err);
            return;
        }
        const currentBuffer = view.state.doc.toString(); // Minimal-replace via diffHunks instead of a full-buffer overwrite, so the
        // cursor stays put when it's outside any rebased remote hunk. Only the
        // rebased-flush case (post-rebase PM differs from buffer) actually dispatches.
        const hunks = (0, $221c70a2c73ffadc$export$294aa3c46d6af4a5)(currentBuffer, nextMarkdown);
        if (hunks.length > 0) {
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: hunks
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
        }
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        postWritebackAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": "markdown-source-view",
        className: (0, $hekY6.default)([
            $44754940e72df3bb$var$styles.container,
            $44754940e72df3bb$var$styles.layout
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: hostRef,
                "data-testid": "markdown-source-view--codemirror",
                className: (0, $hekY6.default)([
                    $44754940e72df3bb$var$styles.editor
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f2806cae53c3f91e$export$d36ee9c3e47d8d66), {
                onShowLineNumbersChange: onShowLineNumbersChange,
                showLineNumbers: showLineNumbers,
                onWrapCodeChange: onWrapCodeChange,
                wrapCode: wrapCode,
                sourcePositionState: sourcePositionState
            })
        ]
    });
};


const $f351bab582830cfa$var$EMPTY_ADF_DOC = {
    type: 'doc',
    version: 1,
    content: []
};
/**
 * Mark types the reconciler diff ignores. Single source of truth shared by the
 * actual `applyDiffSteps` call and the trace payload, so the trace can never
 * report a stale ignore list if this value changes.
 */ const $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES = [
    'annotation'
];
/**
 * Builds the `diff-applied` sync payload. Shared by both writeback handlers
 * (source-change and commit) so the reconciler payload shape stays identical
 * across them. Invoke this inside a `trace?.sync(() => …)` thunk so the
 * `toJSON()` calls are skipped when recording is off.
 */ const $f351bab582830cfa$var$buildDiffAppliedSync = (tr, beforeDoc, afterDoc, interveningStepCount)=>({
        decision: 'diff-applied',
        path: 'applyDiffSteps',
        reconciler: {
            steps: tr.steps.map((s)=>s.toJSON()),
            stepCount: tr.steps.length,
            ignoredMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES,
            interveningStepCount: interveningStepCount,
            reseedReason: 'post-writeback',
            beforeAdf: beforeDoc.toJSON(),
            afterAdf: afterDoc.toJSON()
        }
    });
const $f351bab582830cfa$var$replaceWithConvertedDoc = (editorView, newAdfNode)=>{
    if (editorView.isDestroyed) return null;
    const { state: state } = editorView;
    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, newAdfNode.content).setMeta('addToHistory', false).setMeta('replaceDocument', true).setMeta((0, $68b04ed0ed4951fc$export$372e47604067462f), true);
    editorView.dispatch(tr);
    return tr;
};
const $f351bab582830cfa$export$f6ff746d302c10e = ({ api: api, editorView: editorView, config: config, currentView: currentView, showSourceLineNumbers: showSourceLineNumbers = true, wrapSourceCode: wrapSourceCode = true })=>{
    if (!config.isMarkdownMode) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f351bab582830cfa$var$MarkdownModeOrchestratorDiff, {
        api: api,
        markdownView: currentView,
        editorView: editorView,
        config: config,
        showSourceLineNumbers: showSourceLineNumbers,
        wrapSourceCode: wrapSourceCode
    });
};
const $f351bab582830cfa$var$MarkdownModeOrchestratorDiff = ({ api: api, markdownView: markdownView, editorView: editorView, config: config, showSourceLineNumbers: showSourceLineNumbers, wrapSourceCode: wrapSourceCode })=>{
    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    const [adfDoc, setAdfDoc] = (0, $cozmU.useState)($f351bab582830cfa$var$EMPTY_ADF_DOC);
    const [snapshotRevision, setSnapshotRevision] = (0, $cozmU.useState)(0);
    const [liveAdfDoc, setLiveAdfDoc] = (0, $cozmU.useState)(undefined);
    // Pre-computed markdown for the snapshot (platform_editor_md_source_sync_snapshot).
    const [seedMarkdown, setSeedMarkdown] = (0, $cozmU.useState)(undefined);
    // Pushed to MarkdownSourceView after every successful own-writeback so CM6
    // can re-seed (absorbs any remote content that was folded in via rebase).
    const [postWritebackAdfDoc, setPostWritebackAdfDoc] = (0, $cozmU.useState)(undefined);
    const liveDocDebounceRef = (0, $cozmU.useRef)(null);
    const dispatchTapInstalledRef = (0, $cozmU.useRef)(false);
    // Collab-safe diff baseline: steps are computed against `seedPmDocRef` and
    // rebased through `interveningMappingRef`. Both reset on snapshot and after
    // every successful writeback.
    const seedPmDocRef = (0, $cozmU.useRef)(null);
    const interveningMappingRef = (0, $cozmU.useRef)(new (0, $eOaGc.Mapping)());
    // Stable ref for serializeFileMedia so effects and callbacks can read the
    // latest value without taking it as a dep (unstable parent references would
    // otherwise re-fire the snapshot effect and wipe the refs above).
    const serializeFileMediaRef = (0, $cozmU.useRef)(config.serializeFileMedia);
    serializeFileMediaRef.current = config.serializeFileMedia;
    // Annotation ranges extracted at snapshot time — passed to the source view
    // purely so highlight decorations render and click-to-open works. The diff
    // writeback path does NOT re-apply annotation marks (see file header).
    const [annotationRanges, setAnnotationRanges] = (0, $cozmU.useState)([]);
    // ---------------------------------------------------------------
    // Snapshot — synchronously read the current doc from PM.
    // ---------------------------------------------------------------
    const snapshotAdf = (0, $cozmU.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return null;
        return editorView.state.doc.toJSON();
    }, [
        editorView
    ]);
    // Snapshot whenever the user transitions away from preview (the WYSIWYG editor).
    (0, $cozmU.useEffect)(()=>{
        if (markdownView === 'preview') return;
        const snap = snapshotAdf();
        if (snap && snap.type === 'doc') {
            setAdfDoc(snap);
            setSnapshotRevision((r)=>r + 1);
            setLiveAdfDoc(undefined);
            setPostWritebackAdfDoc(undefined);
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $eOaGc.Mapping)();
            // Convert the snapshot to markdown a SINGLE time here and reuse for
            // both the source-view seed and annotation ranges.
            try {
                const schema = editorView.state.schema;
                const pmDoc = editorView.state.doc;
                const { markdown: markdown, annotations: annotations } = (0, $5nazv.adfToMarkdown)(pmDoc, schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if ((0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(markdown);
                setAnnotationRanges(annotations);
            } catch  {
                if ((0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(undefined);
                setAnnotationRanges([]);
            }
        }
    }, [
        markdownView,
        snapshotAdf,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Dispatch tap — push debounced live updates to source/preview.
    // ---------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (markdownView === 'preview') return;
        if (!editorView || editorView.isDestroyed) return;
        if (dispatchTapInstalledRef.current) return;
        const original = editorView.props.dispatchTransaction;
        const tap = (tr)=>{
            // Always run the original dispatcher first.
            if (original) original.call(editorView, tr);
            else editorView.updateState(editorView.state.apply(tr));
            if (!tr.docChanged) return;
            if (tr.getMeta((0, $68b04ed0ed4951fc$export$372e47604067462f))) {
                (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('live-tap')?.sync(()=>({
                        decision: 'echo-filtered',
                        path: 'applyDiffSteps'
                    }));
                return; // our writeback — don't accumulate, don't push to source view
            }
            for (const map of tr.mapping.maps)interveningMappingRef.current.appendMap(map);
            // Debounce: coalesce rapid keystrokes.
            if (liveDocDebounceRef.current !== null) clearTimeout(liveDocDebounceRef.current);
            liveDocDebounceRef.current = setTimeout(()=>{
                liveDocDebounceRef.current = null;
                if (!editorView || editorView.isDestroyed) return;
                setLiveAdfDoc(editorView.state.doc.toJSON());
            }, 150);
        };
        editorView.setProps({
            dispatchTransaction: tap
        });
        dispatchTapInstalledRef.current = true;
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
            // Restore the original dispatcher so the tap closure (and the React
            // fiber it captures via setLiveAdfDoc) can be GC'd, and so a future
            // editorView change re-installs cleanly.
            if (!editorView.isDestroyed) editorView.setProps({
                dispatchTransaction: original
            });
            dispatchTapInstalledRef.current = false;
        };
    }, [
        markdownView,
        editorView
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
        };
    }, []);
    // ---------------------------------------------------------------
    // Writeback handlers
    // ---------------------------------------------------------------
    // Same stable-ref pattern for the dev-only step-observer callback.
    const onDiffStepsAppliedRef = (0, $cozmU.useRef)(config.onDiffStepsApplied);
    onDiffStepsAppliedRef.current = config.onDiffStepsApplied;
    const sourceWritebackErrorRef = (0, $cozmU.useRef)(config.onSourceWritebackError);
    sourceWritebackErrorRef.current = config.onSourceWritebackError;
    const reseedAfterRebaseFailure = (0, $cozmU.useCallback)((trace, err)=>{
        trace?.sync(()=>({
                decision: 'reseeded',
                path: 'applyDiffSteps',
                reconciler: {
                    reseedReason: 'rebase-failure',
                    reconcilerError: err instanceof Error ? err.message : String(err)
                }
            }));
        seedPmDocRef.current = editorView.state.doc;
        interveningMappingRef.current = new (0, $eOaGc.Mapping)();
    }, [
        editorView
    ]);
    /**
   * Called when the user clicks an annotation highlight in the CodeMirror
   * source view. Mirrors the click handler in the annotation plugin's
   * inline-comment.ts: checks the annotation is unresolved, then dispatches
   * setSelectedAnnotation (or setPendingSelectedAnnotation when the annotation
   * manager is enabled) on the live ProseMirror editor so that the comment
   * popup / comments panel opens, exactly as in the WYSIWYG view.
   */ const handleAnnotationClick = (0, $cozmU.useCallback)((annotationId)=>{
        if (!editorView || editorView.isDestroyed) return;
        // Read annotation plugin state via api.annotation.sharedState — avoids
        // importing internal annotation plugin utilities directly and works
        // correctly with the pre-built dist in the browser dev environment.
        const annotationPluginState = api?.annotation?.sharedState.currentState();
        if (!annotationPluginState) return;
        const { annotations: annotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = annotationPluginState;
        // Only react to unresolved annotations (matches WYSIWYG click handler).
        const isUnresolved = annotations && annotations[annotationId] === false;
        if (!isUnresolved) return;
        if (isAnnotationManagerEnabled) api?.annotation?.actions.setPendingSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
        else api?.annotation?.actions.setSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    /**
   * Forwarded to MarkdownSourceView as `onRegisterCommandDispatch`.
   * Called on mount with a stable dispatcher that routes CM6 commands to
   * the live CodeMirror EditorView, and with `null` on unmount.
   * Registers/unregisters the dispatcher on the markdownMode plugin action
   * so toolbar buttons can call `api.markdownMode.actions.dispatchSourceCommand`.
   * Only wired when `platform_editor_markdown_compatible_toolbar` is enabled.
   */ // Stable ref to the CM6 dispatcher — populated when MarkdownSourceView
    // mounts and cleared when it unmounts.
    const sourceDispatchRef = (0, $cozmU.useRef)(null);
    const handleRegisterCommandDispatch = (0, $cozmU.useCallback)((dispatcher)=>{
        sourceDispatchRef.current = dispatcher;
        api?.markdownMode?.actions.registerSourceCommandDispatch(dispatcher);
        if (dispatcher === null) api?.markdownMode?.actions.setSourceFormatState(null);
    }, [
        api
    ]);
    // Re-register the dispatcher whenever api changes (preset rebuild resets
    // the plugin closure, clearing sourceCommandDispatch to null).
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
        if (sourceDispatchRef.current) api?.markdownMode?.actions.registerSourceCommandDispatch(sourceDispatchRef.current);
    }, [
        api
    ]);
    const handleSourceFormatStateChange = (0, $cozmU.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourceFormatState(state);
    }, [
        api
    ]);
    const handleSourcePositionStateChange = (0, $cozmU.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourcePositionState(state);
    }, [
        api
    ]);
    const handleShowSourceLineNumbersChange = (0, $cozmU.useCallback)((showLineNumbers)=>{
        api?.markdownMode?.actions.setShowSourceLineNumbers(showLineNumbers);
    }, [
        api
    ]);
    const handleWrapCodeChange = (0, $cozmU.useCallback)((wrapCode)=>{
        api?.markdownMode?.actions.setWrapSourceCode(wrapCode);
    }, [
        api
    ]);
    /**
   * Called by MarkdownSourceView on every debounced source change (Tier 2).
   * Parses markdown back to ADF and applies the delta to the live PM doc via
   * surgical `Step`s computed by `@atlassian/content-reconciler`.
   */ const handleSourceMarkdownChange = (0, $cozmU.useCallback)((markdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('source-change');
        let adfNode;
        try {
            adfNode = (0, $5nazv.markdownToAdf)(markdown, editorView.state.schema);
        } catch (err) {
            // Bound interveningMapping growth while the user iterates on invalid
            // markdown; next valid input diffs against the post-remote baseline.
            trace?.sync(()=>({
                    decision: 'reseeded',
                    path: 'applyDiffSteps',
                    reconciler: {
                        reseedReason: 'parse-error'
                    }
                }));
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) sourceWritebackErrorRef.current?.({
                error: err,
                reason: 'parse-error',
                source: 'live'
            });
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $eOaGc.Mapping)();
            return;
        }
        // Early-out + re-seed: if live PM already serializes to the requested
        // markdown, the diff is a no-op and current PM is the right new seed.
        try {
            const { markdown: liveMarkdown } = (0, $5nazv.adfToMarkdown)(editorView.state.doc, editorView.state.schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            if (liveMarkdown === markdown) {
                trace?.sync(()=>({
                        decision: 'reseeded',
                        path: 'applyDiffSteps',
                        reconciler: {
                            reseedReason: 'round-trip-match',
                            interveningStepCount: interveningMappingRef.current.maps.length
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                return;
            }
        } catch (err) {
        // fall through to diff path
        }
        // Capture before dispatch so the dev callback sees the diff baseline.
        const oldDocForCallback = editorView.state.doc;
        const paddedAdfNode = (0, $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
        try {
            const interveningStepCount = interveningMappingRef.current.maps.length;
            const tr = (0, $68b04ed0ed4951fc$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES
            });
            if (tr) {
                trace?.sync(()=>$f351bab582830cfa$var$buildDiffAppliedSync(tr, oldDocForCallback, editorView.state.doc, interveningStepCount));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: markdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'live',
                    steps: tr.steps
                });
            } else trace?.sync(()=>({
                    decision: 'no-op',
                    path: 'applyDiffSteps',
                    reconciler: {
                        stepCount: 0,
                        interveningStepCount: interveningStepCount
                    }
                }));
        } catch (err) {
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) {
                // If surgical rebasing fails, keep the user's source edit saveable by
                // falling back to the legacy whole-document writeback for this flush.
                // This can happen after large paste/replace edits where the diff's
                // positional steps no longer map cleanly onto the live PM document.
                try {
                    $f351bab582830cfa$var$replaceWithConvertedDoc(editorView, paddedAdfNode);
                } catch (fallbackErr) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'replaceWith',
                            note: 'fallback-after-rebase-failure-failed',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: fallbackErr instanceof Error ? fallbackErr.message : String(fallbackErr)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: fallbackErr,
                        reason: 'rebase-fallback-error',
                        source: 'live'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
                trace?.sync(()=>({
                        decision: 'replaced',
                        path: 'replaceWith',
                        note: 'fallback-after-rebase-failure',
                        reconciler: {
                            reseedReason: 'rebase-failure',
                            reconcilerError: err instanceof Error ? err.message : String(err)
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                return;
            }
            // Gate off: keep the original recover-by-reseed behavior. The next
            // flush diffs against the live doc; CM6 keeps the user's source text
            // intact and just sees a wider userDiff next round.
            reseedAfterRebaseFailure(trace, err);
        }
    }, [
        editorView,
        reseedAfterRebaseFailure
    ]);
    /**
   * Called by MarkdownSourceView on unmount / revision change when the
   * user actually edited the buffer (Tier 0 — batch commit). Applies the
   * delta as surgical steps via the same path as handleSourceMarkdownChange.
   */ const handleMarkdownCommit = (0, $cozmU.useCallback)((finalMarkdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('commit');
        let fallbackAdfNode = null;
        try {
            // MarkdownSourceView's per-seed guard only catches open-then-close-
            // without-typing. Live WYSIWYG updates flow into the source buffer via
            // the dispatch tap, so finalMarkdown can differ from the seed yet still
            // round-trip to the current live doc.
            try {
                const { markdown: liveMarkdown } = (0, $5nazv.adfToMarkdown)(editorView.state.doc, editorView.state.schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if (liveMarkdown === finalMarkdown) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'applyDiffSteps',
                            reconciler: {
                                reseedReason: 'round-trip-match',
                                interveningStepCount: interveningMappingRef.current.maps.length
                            }
                        }));
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
            } catch (err) {
            // fall through to diff path
            }
            let adfNode;
            try {
                adfNode = (0, $5nazv.markdownToAdf)(finalMarkdown, editorView.state.schema);
            } catch (err) {
                // A parse error here is distinct from the positional rebase failure
                // the outer catch handles. Record it as 'parse-error' (mirroring
                // handleSourceMarkdownChange) so sync-level reseedReason filtering is
                // reliable on the commit path too — not just the source-change path.
                trace?.sync(()=>({
                        decision: 'reseeded',
                        path: 'applyDiffSteps',
                        reconciler: {
                            reseedReason: 'parse-error'
                        }
                    }));
                if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) sourceWritebackErrorRef.current?.({
                    error: err,
                    reason: 'parse-error',
                    source: 'commit'
                });
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                // eslint-disable-next-line no-console
                console.warn('[MarkdownModeContentComponentDiff] Failed to parse markdown source edits; discarding change.', err);
                return;
            }
            const oldDocForCallback = editorView.state.doc;
            const paddedAdfNode = (0, $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
            fallbackAdfNode = paddedAdfNode;
            const interveningStepCount = interveningMappingRef.current.maps.length;
            const tr = (0, $68b04ed0ed4951fc$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES
            });
            if (tr) {
                trace?.sync(()=>$f351bab582830cfa$var$buildDiffAppliedSync(tr, oldDocForCallback, editorView.state.doc, interveningStepCount));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: finalMarkdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'commit',
                    steps: tr.steps
                });
            } else trace?.sync(()=>({
                    decision: 'no-op',
                    path: 'applyDiffSteps',
                    reconciler: {
                        stepCount: 0,
                        interveningStepCount: interveningStepCount
                    }
                }));
        } catch (err) {
            // markdownToAdf now has its own parse-error catch above, so reaching
            // here means applyDiffSteps failed to rebase the delta onto the live
            // doc.
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) {
                // Gate on: preserve the commit by falling back to a whole-document
                // writeback, matching the non-reconciler markdown mode path.
                if (!fallbackAdfNode) {
                    // The rebase threw before a fallback document was prepared (e.g.
                    // padding failed), so there is nothing to write back. Reseed and
                    // surface the failure instead of discarding it silently, matching
                    // the other terminal branches in this catch.
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'applyDiffSteps',
                            note: 'rebase-failure-no-fallback-node',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: err instanceof Error ? err.message : String(err)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: err,
                        reason: 'writeback-error',
                        source: 'commit'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    // eslint-disable-next-line no-console
                    console.warn('[MarkdownModeContentComponentDiff] Reconciler writeback failed before a fallback document was prepared; discarding change.', err);
                    return;
                }
                try {
                    $f351bab582830cfa$var$replaceWithConvertedDoc(editorView, fallbackAdfNode);
                } catch (fallbackErr) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'replaceWith',
                            note: 'fallback-after-rebase-failure-failed',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: fallbackErr instanceof Error ? fallbackErr.message : String(fallbackErr)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: fallbackErr,
                        reason: 'rebase-fallback-error',
                        source: 'commit'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
                trace?.sync(()=>({
                        decision: 'replaced',
                        path: 'replaceWith',
                        note: 'fallback-after-rebase-failure',
                        reconciler: {
                            reseedReason: 'rebase-failure',
                            reconcilerError: err instanceof Error ? err.message : String(err)
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                // eslint-disable-next-line no-console
                console.warn('[MarkdownModeContentComponentDiff] Reconciler writeback failed; applied markdown source edits with full-document fallback.', err);
                return;
            }
            // Gate off: keep the original recover-by-reseed behavior. This can
            // discard the current commit, but preserves the pre-existing
            // reconciler behavior while the fallback is gated.
            reseedAfterRebaseFailure(trace, err);
            // eslint-disable-next-line no-console
            console.warn('[MarkdownModeContentComponentDiff] Failed to apply markdown source edits back to the editor; discarding change.', err);
        }
    }, [
        editorView,
        reseedAfterRebaseFailure
    ]);
    // Register a round-trip probe for the console `roundTrip()` helper, which
    // needs the live editor schema. The reconciler orchestrator is the sole
    // content-writeback path, so without this `roundTrip()` would wrongly
    // report "No editor registered". No-op when the tracer gate is off.
    (0, $cozmU.useEffect)(()=>{
        const tracer = (0, $5e1679443117df1d$export$de8e565f923f53f9).getInstance();
        if (!tracer || !editorView || editorView.isDestroyed) return;
        tracer.registerProbe((input)=>{
            if (editorView.isDestroyed) return {
                error: 'editor destroyed'
            };
            const schema = editorView.state.schema;
            if (typeof input === 'string') {
                const adf = (0, $5nazv.markdownToAdf)(input, schema);
                const { markdown: markdown } = (0, $5nazv.adfToMarkdown)(adf, schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                return {
                    adf: adf.toJSON(),
                    markdown: markdown,
                    match: markdown === input
                };
            }
            const node = schema.nodeFromJSON(input);
            const { markdown: markdown } = (0, $5nazv.adfToMarkdown)(node, schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            return {
                adf: (0, $5nazv.markdownToAdf)(markdown, schema).toJSON(),
                markdown: markdown
            };
        });
        return ()=>tracer.registerProbe(null);
    }, [
        editorView
    ]);
    // Hide the WYSIWYG ProseMirror DOM in syntax and split-view modes. The
    // platform's `FullPageContentArea` attempts this via
    // `hideEditorContentAreaProsemirrorStyle`, but that style is gated on the
    // `cc-markdown-mode` experiment AND on the plugin's PM state being in sync
    // — either can fail on first paint, leaving both the source CodeMirror
    // and the underlying ProseMirror visible (with floating toolbars leaking
    // through). Scoped to this plugin's `editorView.dom`; original `display`
    // is restored on cleanup. Blur on leaving preview dismisses
    // selection-anchored floating UI (code-block toolbar, table controls).
    (0, $cozmU.useEffect)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        if (markdownView === 'preview') return;
        const dom = editorView.dom;
        const originalDisplay = dom.style.display;
        dom.style.display = 'none';
        // Guard against blur throwing on a destroyed view.
        try {
            if (editorView.hasFocus()) dom.blur();
        } catch  {
        // no-op
        }
        return ()=>{
            if (!editorView.isDestroyed) dom.style.display = originalDisplay;
        };
    }, [
        markdownView,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------
    const isPreview = markdownView === 'preview';
    if (isPreview) return null;
    const PreviewComponent = config.previewComponent;
    // Resolve the gate once per render so paired props stay consistent and
    // we don't fire duplicate exposures.
    const compatibleToolbarEnabled = (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            markdownView === 'syntax' && (snapshotRevision > 0 || !(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $44754940e72df3bb$export$eb7c1c6ff6845883), {
                contentId: config.contentId,
                initialAdfDoc: adfDoc,
                seedMarkdown: seedMarkdown,
                schema: editorView.state.schema,
                revision: snapshotRevision,
                liveAdfDoc: liveAdfDoc,
                postWritebackAdfDoc: postWritebackAdfDoc,
                onSourceMarkdownChange: handleSourceMarkdownChange,
                onMarkdownCommit: handleMarkdownCommit,
                serializeFileMedia: config.serializeFileMedia,
                sourceChangeDebounceMs: config.sourceChangeDebounceMs,
                annotationRanges: annotationRanges,
                onAnnotationClick: handleAnnotationClick,
                onRegisterCommandDispatch: compatibleToolbarEnabled ? handleRegisterCommandDispatch : undefined,
                onSourceFormatStateChange: compatibleToolbarEnabled ? handleSourceFormatStateChange : undefined,
                onSourcePositionStateChange: handleSourcePositionStateChange,
                onShowLineNumbersChange: handleShowSourceLineNumbersChange,
                showLineNumbers: showSourceLineNumbers,
                onWrapCodeChange: handleWrapCodeChange,
                wrapCode: wrapSourceCode
            }),
            markdownView === 'split-view' && PreviewComponent && /*#__PURE__*/ (0, $8aG6j.jsx)(PreviewComponent, {
                adfDoc: liveAdfDoc ?? adfDoc
            }, `preview-${snapshotRevision}`)
        ]
    });
};


/* MarkdownModeViewToggle.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $ldqjS = parcelRequire("ldqjS");





var $6t3CY = parcelRequire("6t3CY");

var $cE5a1 = parcelRequire("cE5a1");

var $lslMH = parcelRequire("lslMH");


var $2HIrf = parcelRequire("2HIrf");


var $4R6R9 = parcelRequire("4R6R9");


var $6YkHb = parcelRequire("6YkHb");




const $9945c9978fff44c4$var$styles = {
    wrapper: "_10qCvKrzt2 _0xOCXhNvrM _41OGv76wH8 _41KQCPcM5X"
}; // ---------------------------------------------------------------------------
const $9945c9978fff44c4$export$dfbf3d9b6d36cb67 = ({ view: view, onViewChange: onViewChange })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)((nextView)=>{
        if (nextView === view) return;
        onViewChange(nextView);
    }, [
        view,
        onViewChange
    ]); // Stable per-view click handlers so the IconButtons receive a referentially
    // equal `onClick` prop across renders (avoids breaking memoisation in the
    // IconButton subtree). `handleClick` itself is already memoised on
    // (view, onViewChange).
    const handleSyntaxClick = (0, $cozmU.useCallback)(()=>handleClick('syntax'), [
        handleClick
    ]);
    const handlePreviewClick = (0, $cozmU.useCallback)(()=>handleClick('preview'), [
        handleClick
    ]);
    const handleSplitViewClick = (0, $cozmU.useCallback)(()=>handleClick('split-view'), [
        handleClick
    ]);
    const syntaxLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).source);
    const previewLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).wysiwyg); // Note: i18n message keys (`i18n.source`, `i18n.sourceAriaLabel`) are
    // intentionally left as-is to preserve translation memory for the
    // 'Syntax editor' / 'Markdown source' strings already in production.
    const splitViewLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).preview);
    const groupLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).groupLabel);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9945c9978fff44c4$var$styles.wrapper,
        role: "group",
        "aria-label": groupLabel,
        testId: "markdown-mode-view-toggle",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cE5a1.ToolbarSection), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: syntaxLabel,
                        keymap: view === 'preview' ? (0, $ldqjS.toggleMarkdownView) : undefined
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                            size: "small",
                            label: syntaxLabel
                        }),
                        label: syntaxLabel,
                        isSelected: view === 'syntax',
                        onClick: handleSyntaxClick,
                        testId: "markdown-mode-view-toggle--syntax",
                        ariaKeyshortcuts: view === 'preview' ? (0, $ldqjS.toggleMarkdownView).description : undefined
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: previewLabel,
                        keymap: view === 'syntax' ? (0, $ldqjS.toggleMarkdownView) : undefined
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HIrf))), {
                            size: "small",
                            label: previewLabel
                        }),
                        label: previewLabel,
                        isSelected: view === 'preview',
                        onClick: handlePreviewClick,
                        testId: "markdown-mode-view-toggle--preview",
                        ariaKeyshortcuts: view === 'syntax' ? (0, $ldqjS.toggleMarkdownView).description : undefined
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: splitViewLabel
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4R6R9))), {
                            size: "small",
                            label: splitViewLabel
                        }),
                        label: splitViewLabel,
                        isSelected: view === 'split-view',
                        onClick: handleSplitViewClick,
                        testId: "markdown-mode-view-toggle--split-view",
                        isDisabled: true
                    })
                })
            ]
        })
    });
};
const $9945c9978fff44c4$export$aa32935aa228c6fd = ({ api: api })=>{
    const { view: view, isMarkdownMode: isMarkdownMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            view: states.markdownModeState?.view ?? 'preview',
            isMarkdownMode: states.markdownModeState?.isMarkdownMode ?? false
        }));
    const handleViewChange = (0, $cozmU.useCallback)((nextView)=>{
        api?.markdownMode?.actions.setView(nextView);
    }, [
        api
    ]);
    if (!isMarkdownMode) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($9945c9978fff44c4$export$dfbf3d9b6d36cb67, {
        view: view,
        onViewChange: handleViewChange
    });
};


const $7021814cb7ec0e06$var$HEADING_SOURCE_VIEW_COMMANDS = {
    1: (0, $b8e7170495150c53$export$4e0d444e5782abea),
    2: (0, $b8e7170495150c53$export$b8d734de6aecb0a3),
    3: (0, $b8e7170495150c53$export$df05910f74b29e0),
    4: (0, $b8e7170495150c53$export$ca48da5fbbd68542),
    5: (0, $b8e7170495150c53$export$1335885ed6c2d3ac),
    6: (0, $b8e7170495150c53$export$8381ca7ddcf8db0d)
};
// so a floating selection toolbar has nothing to anchor to.
const $7021814cb7ec0e06$var$contextualFormattingOverrideForView = (view, isLivePage)=>{
    return view === 'preview' && isLivePage ? 'controlled' : 'always-pinned';
}; // Mirrors `selection-toolbar/PrimaryToolbarComponent`: prefers
// `userPreferences.toolbarDockingPosition` when the new plugin is enabled,
// otherwise falls back to `selectionToolbar.toolbarDocking`. In source /
// preview view the primary toolbar is forcibly pinned via the toolbar
// override (see `setView` below), so we treat the toolbar as docked-to-top
// regardless of the user's saved preference — otherwise the view-switcher
// renders in-content while the toolbar is actually pinned at the top.
const $7021814cb7ec0e06$var$useIsToolbarDockedToTop = (api)=>{
    const { dockingPositionFromPrefs: dockingPositionFromPrefs, isLivePage: isLivePage, view: view } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'userPreferences',
        'selectionToolbar',
        'markdownMode'
    ], (states)=>({
            dockingPositionFromPrefs: states.userPreferencesState?.preferences?.toolbarDockingPosition,
            isLivePage: states.markdownModeState?.isLivePage,
            view: states.markdownModeState?.view
        }));
    if (view && (view !== 'preview' || !isLivePage)) return true;
    return dockingPositionFromPrefs === 'top';
};
const $7021814cb7ec0e06$var$MarkdownModeContentComponentDiffWrapper = ({ editorView: editorView, config: config, api: api })=>{
    const hasReconciledPersistedViewRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Transient fallback: if the shared state hasn't hydrated yet, treat the
    // view as 'preview' so we don't briefly mount the syntax editor over the
    // PM editor. The authoritative initial view (which can be 'syntax') is
    // resolved upstream via `config.viewModePersistence.getInitialView` and
    // will populate `markdownModeState.view` once the plugin initialises.
    const currentView = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view ?? 'preview');
    const showSourceLineNumbers = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.showSourceLineNumbers ?? true);
    const wrapSourceCode = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.wrapSourceCode ?? true);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (hasReconciledPersistedViewRef.current) return;
        hasReconciledPersistedViewRef.current = true;
        const persistedView = config.viewModePersistence?.getInitialView?.();
        if (!persistedView || persistedView === currentView) return;
        api?.markdownMode?.actions.setView(persistedView);
    }, [
        api,
        config.viewModePersistence,
        currentView
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f351bab582830cfa$export$f6ff746d302c10e), {
                editorView: editorView,
                config: config,
                currentView: currentView,
                showSourceLineNumbers: showSourceLineNumbers,
                wrapSourceCode: wrapSourceCode,
                api: api
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$export$5a3a24cc1474d9cc, {
                api: api
            })
        ]
    });
};
const $7021814cb7ec0e06$var$styles = {
    trailingSection: "_1mT5xdWVPG _1OKFqY8HPE _2I62gz715P _1VJPcakruI _3iDTPbQ4SZ _0hPCNLDIqT",
    inContentToggleStickyRow: "_1mT5xdy1CL _2I62gz2ADO _1OKFqYNHnM _42Yu6BgtVO _1pp6NdYbGa",
    inContentToggleAnchor: "_0bjKvD8fU6 _4c065U1Y8M _2Y7lL41Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _1pp6NdIZbP"
};
const $7021814cb7ec0e06$var$InToolbarToggle = ({ api: api })=>{
    const isDockedToTop = $7021814cb7ec0e06$var$useIsToolbarDockedToTop(api);
    if (!isDockedToTop) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7021814cb7ec0e06$var$styles.trailingSection,
        testId: "markdown-mode-view-toggle-section",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9945c9978fff44c4$export$aa32935aa228c6fd), {
            api: api
        })
    });
};
const $7021814cb7ec0e06$export$5a3a24cc1474d9cc = ({ api: api })=>{
    const isDockedToTop = $7021814cb7ec0e06$var$useIsToolbarDockedToTop(api);
    if (isDockedToTop) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7021814cb7ec0e06$var$styles.inContentToggleStickyRow,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $7021814cb7ec0e06$var$styles.inContentToggleAnchor,
            testId: "markdown-mode-view-toggle-in-content",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9945c9978fff44c4$export$aa32935aa228c6fd), {
                api: api
            })
        })
    });
};
const $7021814cb7ec0e06$var$buildToolbarComponents = (config, api)=>{
    if (!config?.isMarkdownMode) return [];
    return [
        {
            type: (0, $3nacY.VIEW_MODE_TOGGLE_SECTION).type,
            key: (0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$var$InToolbarToggle, {
                    api: api
                })
        }
    ];
};
const $7021814cb7ec0e06$export$f3055fdbf3cad094 = ({ config: config, api: api })=>{
    let editorView;
    let sourceCommandDispatch = null;
    const dispatchSource = (cmd)=>{
        if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return false;
        if (!sourceCommandDispatch) return false;
        return sourceCommandDispatch(cmd);
    };
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    const dispatchSourceFormatState = (formatState)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            sourceBlockFormatState: formatState?.block ?? null,
            sourceInlineFormatState: formatState?.inline ?? null,
            sourceListFormatState: formatState?.list ?? null
        }));
    };
    const dispatchSourcePositionState = (positionState)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            sourcePositionState: positionState
        }));
    };
    const dispatchShowSourceLineNumbers = (showSourceLineNumbers)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            showSourceLineNumbers: showSourceLineNumbers
        }));
    };
    const dispatchWrapSourceCode = (wrapSourceCode)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            wrapSourceCode: wrapSourceCode
        }));
    }; // Resolve the initial view ONCE, at plugin construction time — not in
    // `init()`, which re-runs on `state.reconfigure` and would clobber any
    // in-flight user choice on every preset rebuild.
    //
    // When the initial view is browser-persisted, SSR cannot know the stored
    // value. Keep SSR and the first hydrating client render on the deterministic
    // default, then reconcile the persisted value from the content component's
    // mount effect.
    const initialView = 'syntax';
    api?.toolbar?.actions.registerComponents($7021814cb7ec0e06$var$buildToolbarComponents(config, api));
    return {
        name: 'markdownMode',
        getSharedState (editorState) {
            if (!editorState) return {
                view: initialView,
                isLivePage: config?.isLivePage ?? false,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                showSourceLineNumbers: true,
                wrapSourceCode: true,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null,
                sourcePositionState: null
            };
            return (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorState) ?? {
                view: initialView,
                isLivePage: config?.isLivePage ?? false,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                showSourceLineNumbers: true,
                wrapSourceCode: true,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null,
                sourcePositionState: null
            };
        },
        actions: {
            setView (view) {
                if (!editorView) return;
                const prevView = (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorView.state)?.view ?? initialView;
                if (prevView === view) return;
                const tr = editorView.state.tr;
                api?.toolbar?.commands.setContextualFormattingModeOverride($7021814cb7ec0e06$var$contextualFormattingOverrideForView(view, config?.isLivePage))({
                    tr: tr
                });
                tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    view: view
                });
                editorView.dispatch(tr);
                config?.viewModePersistence?.onViewChange?.(view, prevView);
            },
            dispatchSourceCommand: dispatchSource,
            insertSourceTable: (rowsCount, colsCount)=>dispatchSource((0, $b8e7170495150c53$export$feb50cc511a53ca1)(rowsCount, colsCount)),
            toggleSourceBlockquote: ()=>dispatchSource((0, $b8e7170495150c53$export$2cd68375ac1e5429)),
            toggleSourceBulletList: ()=>dispatchSource((0, $b8e7170495150c53$export$71c898cbdfd51c6e)),
            toggleSourceOrderedList: ()=>dispatchSource((0, $b8e7170495150c53$export$744c9722bde8c6b3)),
            toggleSourceTaskList: ()=>dispatchSource((0, $b8e7170495150c53$export$49b8416aa3f9522a)),
            toggleSourceHeading: (level)=>dispatchSource($7021814cb7ec0e06$var$HEADING_SOURCE_VIEW_COMMANDS[level]),
            toggleSourceBold: ()=>dispatchSource((0, $b8e7170495150c53$export$b850a936f66192a3)),
            toggleSourceItalic: ()=>dispatchSource((0, $b8e7170495150c53$export$227b5ef404be9031)),
            toggleSourceInlineCode: ()=>dispatchSource((0, $b8e7170495150c53$export$e7d955a85cfe503c)),
            toggleSourceStrike: ()=>dispatchSource((0, $b8e7170495150c53$export$a46d65f808b4881d)),
            registerSourceCommandDispatch (dispatcher) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
                sourceCommandDispatch = dispatcher;
            },
            setSourceBlockFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceBlockFormatState: formatState
                }));
            },
            setSourceFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
                dispatchSourceFormatState(formatState);
            },
            setSourceInlineFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceInlineFormatState: formatState
                }));
            },
            setSourceListFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceListFormatState: formatState
                }));
            },
            setSourcePositionState (positionState) {
                dispatchSourcePositionState(positionState);
            },
            setShowSourceLineNumbers (showSourceLineNumbers) {
                dispatchShowSourceLineNumbers(showSourceLineNumbers);
            },
            setWrapSourceCode (wrapSourceCode) {
                dispatchWrapSourceCode(wrapSourceCode);
            }
        },
        contentComponent ({ editorView: contentEditorView }) {
            if (!config?.isMarkdownMode || !contentEditorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$var$MarkdownModeContentComponentDiffWrapper, {
                editorView: contentEditorView,
                config: config,
                api: api
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'markdownModeState',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: (0, $9e7aa44e1133a0cd$export$160e35dbff8be862),
                            state: {
                                init: ()=>({
                                        view: initialView,
                                        isLivePage: config?.isLivePage ?? false,
                                        isMarkdownMode: config?.isMarkdownMode ?? false,
                                        showSourceLineNumbers: true,
                                        wrapSourceCode: true,
                                        sourceInlineFormatState: null,
                                        sourceBlockFormatState: null,
                                        sourceListFormatState: null,
                                        sourcePositionState: null
                                    }),
                                apply (tr, currentState) {
                                    const meta = tr.getMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862));
                                    if (meta) return {
                                        ...currentState,
                                        ...meta.view !== undefined ? {
                                            view: meta.view
                                        } : {},
                                        ...meta.showSourceLineNumbers !== undefined ? {
                                            showSourceLineNumbers: meta.showSourceLineNumbers
                                        } : {},
                                        ...meta.wrapSourceCode !== undefined ? {
                                            wrapSourceCode: meta.wrapSourceCode
                                        } : {},
                                        ...meta.sourceInlineFormatState !== undefined ? {
                                            sourceInlineFormatState: meta.sourceInlineFormatState
                                        } : {},
                                        ...meta.sourceBlockFormatState !== undefined ? {
                                            sourceBlockFormatState: meta.sourceBlockFormatState
                                        } : {},
                                        ...meta.sourceListFormatState !== undefined ? {
                                            sourceListFormatState: meta.sourceListFormatState
                                        } : {},
                                        ...meta.sourcePositionState !== undefined ? {
                                            sourcePositionState: meta.sourcePositionState
                                        } : {}
                                    };
                                    return currentState;
                                }
                            },
                            view (newEditorView) {
                                setEditorView(newEditorView);
                                let destroyed = false; // Seed the toolbar override on first mount so a page that
                                // opens straight into source/preview pins the toolbar without
                                // needing a user-triggered `setView`.
                                if (config?.isMarkdownMode) // Deferred to a microtask: dispatching synchronously inside
                                // `view()` is a PM re-entry hazard — the meta can be dropped
                                // before downstream plugins' `apply()` runs. By the next
                                // microtask the editor is fully constructed and dispatch is safe.
                                // The `destroyed` guard prevents dispatching on a torn-down
                                // view if `destroy()` runs before the microtask fires (e.g.
                                // React StrictMode double-mount).
                                Promise.resolve().then(()=>{
                                    if (destroyed) return;
                                    const tr = newEditorView.state.tr; // Read the latest markdown view from plugin state at microtask
                                    // time. During page transitions, relying on the static SSR
                                    // default (`initialView`) can briefly seed the wrong override.
                                    const viewForOverride = (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(newEditorView.state)?.view ?? initialView;
                                    api?.toolbar?.commands.setContextualFormattingModeOverride($7021814cb7ec0e06$var$contextualFormattingOverrideForView(viewForOverride, config?.isLivePage))({
                                        tr: tr
                                    });
                                    newEditorView.dispatch(tr);
                                });
                                 // Register a global keydown listener for the toggle shortcut.
                                // We use document-level rather than a PM keymap because in
                                // source view the PM editor is hidden/blurred and PM keymaps
                                // never fire.
                                const handler = (0, $6ac889fd0f465b1a$export$ed529ff4eb54147f)(api, ()=>editorView);
                                const doc = (0, $1hQ0e.getDocument)();
                                const unbind = doc ? (0, $cbY7C.bind)(doc, {
                                    type: 'keydown',
                                    listener: handler
                                }) : ()=>{};
                                return {
                                    destroy () {
                                        destroyed = true;
                                        unbind();
                                    }
                                };
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["markdownModePlugin"] = $7021814cb7ec0e06$export$f3055fdbf3cad094;

});

parcelRegister("9ta51", function(module, exports) {
const $da89658923f179a9$export$13f2d1f50f16890a = [
    // Hyperlinks → `[text](url)`
    'hyperlink',
    // Tables → GFM tables
    'table',
    // Headings → `#`/`##`/`###`/...
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    // Code blocks → ` ``` `
    'codeblock',
    // Block quote → `>`
    'blockquote',
    // Lists → `-`/`*`/`1.` and task lists → `- [x]`
    'unorderedList',
    'orderedList',
    'action',
    // Horizontal rule → `---`
    'rule',
    // Media — EDITOR-6636: `mediaSingle` + `media` now round-trip cleanly
    // through the markdown pipeline.
    //   - `type: "external"` → `![alt](https://…)` verbatim.
    //   - `type: "file"`     → `![alt](/wiki/download/attachments/{contentId}/{name})`
    //                          (Confluence tenant proxy URL, auth via session cookie).
    //
    // NOTE: Confluence uses `editor-plugin-media-insert` (the newer flow),
    // which registers the quick-insert item with id `'media-insert'` — NOT
    // `'media'` (which is the legacy media plugin's id used when mediaInsert
    // is absent). Both are allowlisted here for compatibility.
    'media-insert',
    'media'
];
const $da89658923f179a9$export$5775271e6e45828a = new Set($da89658923f179a9$export$13f2d1f50f16890a);
const $da89658923f179a9$export$a2dbfb573dc4efa5 = (item)=>{
    if (!item.id) return false;
    return $da89658923f179a9$export$5775271e6e45828a.has(item.id);
};
module.exports["isMarkdownCompatibleQuickInsertItem"] = $da89658923f179a9$export$a2dbfb573dc4efa5;

});

parcelRegister("aqPDM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4546d3e5054497daf7b66a2a9b41db25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $798463d0df385ce1$var$_react = $798463d0df385ce1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $798463d0df385ce1$var$_iconNew = $798463d0df385ce1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $798463d0df385ce1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolAction".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-action
 * Usage guidance:
 * Reserved for action diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $798463d0df385ce1$var$DiagramSymbolActionIcon = (props)=>/*#__PURE__*/ $798463d0df385ce1$var$_react.default.createElement($798463d0df385ce1$var$_iconNew.default, Object.assign({
        name: "DiagramSymbolActionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 12.5h13v-9h-13zm14.5.125c0 .76-.616 1.375-1.375 1.375H1.375C.615 14 0 13.384 0 12.625v-9.25C0 2.615.616 2 1.375 2h13.25C15.385 2 16 2.616 16 3.375z"/>`
    }, props));
$798463d0df385ce1$var$DiagramSymbolActionIcon.displayName = 'DiagramSymbolActionIcon';
var $798463d0df385ce1$var$_default = module.exports.default = $798463d0df385ce1$var$DiagramSymbolActionIcon;

});

parcelRegister("BQuz7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3b44251382593aa3e479ab021bf6b68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $071c2ca1beb98528$var$_react = $071c2ca1beb98528$var$_interopRequireDefault((parcelRequire("cozmU")));

var $071c2ca1beb98528$var$_iconNew = $071c2ca1beb98528$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $071c2ca1beb98528$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioAuto".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-auto
 * Usage guidance:
 * Known uses: Auto detect ratio in the image generation process
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $071c2ca1beb98528$var$ImageRatioAutoIcon = (props)=>/*#__PURE__*/ $071c2ca1beb98528$var$_react.default.createElement($071c2ca1beb98528$var$_iconNew.default, Object.assign({
        name: "ImageRatioAutoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 12.5H6V8H1.5zm6 .125c0 .76-.616 1.375-1.375 1.375h-4.75C.615 14 0 13.384 0 12.625v-4.75C0 7.115.616 6.5 1.375 6.5h4.75c.76 0 1.375.616 1.375 1.375z"/><path fill="currentcolor" d="M16 12.625c0 .76-.616 1.375-1.375 1.375H9v-1.5h5.5v-9h-13V5H0V3.375C0 2.615.616 2 1.375 2h13.25C15.385 2 16 2.616 16 3.375z"/>`
    }, props));
$071c2ca1beb98528$var$ImageRatioAutoIcon.displayName = 'ImageRatioAutoIcon';
var $071c2ca1beb98528$var$_default = module.exports.default = $071c2ca1beb98528$var$ImageRatioAutoIcon;

});

parcelRegister("9OqiZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53ba51ab01fb54f92a042e3f1ab85fb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $724d303f4e23bd1c$var$_react = $724d303f4e23bd1c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $724d303f4e23bd1c$var$_iconNew = $724d303f4e23bd1c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $724d303f4e23bd1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioNarrow".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-narrow
 * Usage guidance:
 * Known uses: Narrow image ratio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $724d303f4e23bd1c$var$ImageRatioNarrowIcon = (props)=>/*#__PURE__*/ $724d303f4e23bd1c$var$_react.default.createElement($724d303f4e23bd1c$var$_iconNew.default, Object.assign({
        name: "ImageRatioNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5 14.5h6v-13H5zm7.5.125c0 .76-.616 1.375-1.375 1.375h-6.25c-.76 0-1.375-.616-1.375-1.375V1.375C3.5.615 4.116 0 4.875 0h6.25c.76 0 1.375.616 1.375 1.375z"/>`
    }, props));
$724d303f4e23bd1c$var$ImageRatioNarrowIcon.displayName = 'ImageRatioNarrowIcon';
var $724d303f4e23bd1c$var$_default = module.exports.default = $724d303f4e23bd1c$var$ImageRatioNarrowIcon;

});

parcelRegister("hGZx0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e7335a32dfd35926c921516f5556e3d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce1616c4d5baf721$var$_react = $ce1616c4d5baf721$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ce1616c4d5baf721$var$_iconNew = $ce1616c4d5baf721$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ce1616c4d5baf721$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioPortrait".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-portrait
 * Usage guidance:
 * Known uses: Portrait image ratio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce1616c4d5baf721$var$ImageRatioPortraitIcon = (props)=>/*#__PURE__*/ $ce1616c4d5baf721$var$_react.default.createElement($ce1616c4d5baf721$var$_iconNew.default, Object.assign({
        name: "ImageRatioPortraitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M3.5 14.5h9v-13h-9zm10.5.125c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 16 2 15.384 2 14.625V1.375C2 .615 2.616 0 3.375 0h9.25C13.385 0 14 .616 14 1.375z"/>`
    }, props));
$ce1616c4d5baf721$var$ImageRatioPortraitIcon.displayName = 'ImageRatioPortraitIcon';
var $ce1616c4d5baf721$var$_default = module.exports.default = $ce1616c4d5baf721$var$ImageRatioPortraitIcon;

});

parcelRegister("4P0HA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::420bb8ab33e730f674ad3a512c5bab6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $382c7841319d0f48$var$_react = $382c7841319d0f48$var$_interopRequireDefault((parcelRequire("cozmU")));

var $382c7841319d0f48$var$_iconNew = $382c7841319d0f48$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $382c7841319d0f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/paint-brush
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $382c7841319d0f48$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $382c7841319d0f48$var$_react.default.createElement($382c7841319d0f48$var$_iconNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$382c7841319d0f48$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $382c7841319d0f48$var$_default = module.exports.default = $382c7841319d0f48$var$PaintBrushIcon;

});

parcelRegister("21wWN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df3465be38be39642f2888da784f90b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17953b6bbab7a07f$var$_react = $17953b6bbab7a07f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $17953b6bbab7a07f$var$_iconNew = $17953b6bbab7a07f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $17953b6bbab7a07f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShapeRectangle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/shape-rectangle
 * Usage guidance:
 * Rectangle shape tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17953b6bbab7a07f$var$ShapeRectangleIcon = (props)=>/*#__PURE__*/ $17953b6bbab7a07f$var$_react.default.createElement($17953b6bbab7a07f$var$_iconNew.default, Object.assign({
        name: "ShapeRectangleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.875c0-.76.616-1.375 1.375-1.375h10.25c.76 0 1.375.616 1.375 1.375v10.25c0 .76-.616 1.375-1.375 1.375H2.875c-.76 0-1.375-.616-1.375-1.375zM3 3v10h10V3z" clip-rule="evenodd"/>`
    }, props));
$17953b6bbab7a07f$var$ShapeRectangleIcon.displayName = 'ShapeRectangleIcon';
var $17953b6bbab7a07f$var$_default = module.exports.default = $17953b6bbab7a07f$var$ShapeRectangleIcon;

});

parcelRegister("28Zil", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcSlices = module.exports.applyPatch = module.exports.calcPatch = module.exports.lcs = module.exports.diff = module.exports.diff_core = void 0;
function $18fbe0039b7b1c20$var$diff_internal(state, c) {
    const { b: b, eq: eq, stack_base: stack_base } = state;
    let { i: i, N: N, j: j, M: M, Z: Z, stack_top: stack_top } = state;
    for(;;)switch(c){
        case 0:
            Z_block: while(N > 0 && M > 0){
                b.fill(0, 0, 2 * Z);
                const W = N - M;
                const L = N + M;
                const parity = L & 1;
                const offsetx = i + N - 1;
                const offsety = j + M - 1;
                const hmax = (L + parity) / 2;
                let z;
                h_loop: for(let h = 0; h <= hmax; h++){
                    const kmin = 2 * Math.max(0, h - M) - h;
                    const kmax = h - 2 * Math.max(0, h - N);
                    for(let k = kmin; k <= kmax; k += 2){
                        const gkm = b[k - 1 - Z * Math.floor((k - 1) / Z)];
                        const gkp = b[k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && gkm < gkp ? gkp : gkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(i + x, j + y))x++, y++;
                        b[k - Z * Math.floor(k / Z)] = x;
                        if (parity === 1 && (z = W - k) >= 1 - h && z < h && x + b[Z + z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 1 || x !== u) {
                                stack_base[stack_top++] = i + x;
                                stack_base[stack_top++] = N - x;
                                stack_base[stack_top++] = j + y;
                                stack_base[stack_top++] = M - y;
                                N = u;
                                M = v;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                    for(let k = kmin; k <= kmax; k += 2){
                        const pkm = b[Z + k - 1 - Z * Math.floor((k - 1) / Z)];
                        const pkp = b[Z + k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && pkm < pkp ? pkp : pkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(offsetx - x, offsety - y))x++, y++;
                        b[Z + k - Z * Math.floor(k / Z)] = x;
                        if (parity === 0 && (z = W - k) >= -h && z <= h && x + b[z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 0 || x !== u) {
                                stack_base[stack_top++] = i + N - u;
                                stack_base[stack_top++] = u;
                                stack_base[stack_top++] = j + M - v;
                                stack_base[stack_top++] = v;
                                N = N - x;
                                M = M - y;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                }
                if (N === M) continue;
                if (M > N) {
                    i += N;
                    j += N;
                    M -= N;
                    N = 0;
                } else {
                    i += M;
                    j += M;
                    N -= M;
                    M = 0;
                }
                break;
            }
            if (N + M !== 0) {
                if (state.pxe === i || state.pye === j) {
                    state.pxe = i + N;
                    state.pye = j + M;
                } else {
                    const sx = state.pxs;
                    state.oxs = state.pxs;
                    state.oxe = state.pxe;
                    state.oys = state.pys;
                    state.oye = state.pye;
                    state.pxs = i;
                    state.pxe = i + N;
                    state.pys = j;
                    state.pye = j + M;
                    if (sx >= 0) {
                        state.i = i;
                        state.N = N;
                        state.j = j;
                        state.M = M;
                        state.Z = Z;
                        state.stack_top = stack_top;
                        return 1;
                    }
                }
            }
        case 1:
            if (stack_top === 0) return 2;
            M = stack_base[--stack_top];
            j = stack_base[--stack_top];
            N = stack_base[--stack_top];
            i = stack_base[--stack_top];
            Z = 2 * (Math.min(N, M) + 1);
            c = 0;
    }
}
class $18fbe0039b7b1c20$var$DiffGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const { state: state, result: result } = this;
        if (this.c > 1) {
            result.done = true;
            result.value = undefined;
            return result;
        }
        const c = $18fbe0039b7b1c20$var$diff_internal(state, this.c);
        this.c = c;
        if (c === 1) {
            result.value = [
                state.oxs,
                state.oxe,
                state.oys,
                state.oye
            ];
            return result;
        }
        if (state.pxs >= 0) {
            result.value = [
                state.pxs,
                state.pxe,
                state.pys,
                state.pye
            ];
            return result;
        }
        result.done = true;
        result.value = undefined;
        return result;
    }
    constructor(state){
        this.state = state;
        this.c = 0;
        this.result = {
            value: null,
            done: false
        };
    }
}
function $18fbe0039b7b1c20$var$diff_core(i, N, j, M, eq) {
    const Z = (Math.min(N, M) + 1) * 2;
    const L = N + M;
    const b = new (L < 256 ? Uint8Array : L < 65536 ? Uint16Array : Uint32Array)(2 * Z);
    return new $18fbe0039b7b1c20$var$DiffGen({
        i: i,
        N: N,
        j: j,
        M: M,
        Z: Z,
        b: b,
        eq: eq,
        pxs: -1,
        pxe: -1,
        pys: -1,
        pye: -1,
        oxs: -1,
        oxe: -1,
        oys: -1,
        oye: -1,
        stack_top: 0,
        stack_base: []
    });
}
module.exports.diff_core = $18fbe0039b7b1c20$var$diff_core;
function $18fbe0039b7b1c20$var$diff(xs, ys, eq) {
    let [i, N, M] = [
        0,
        xs.length,
        ys.length
    ];
    if (typeof eq === 'function') {
        while(i < N && i < M && eq(i, i))i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(eq(--N, --M) && N > i && M > i);
    } else {
        while(i < N && i < M && xs[i] === ys[i])i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(xs[--N] === ys[--M] && N > i && M > i);
        eq = (i, j)=>xs[i] === ys[j];
    }
    return $18fbe0039b7b1c20$var$diff_core(i, N + 1 - i, i, M + 1 - i, eq);
}
module.exports.diff = $18fbe0039b7b1c20$var$diff;
class $18fbe0039b7b1c20$var$LCSGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const rec = this.diff.next();
        if (rec.done) {
            const { i: i, j: j, N: N } = this;
            if (i < N) {
                rec.done = false;
                rec.value = [
                    i,
                    j,
                    N - i
                ];
                this.i = N;
            }
            return rec;
        }
        const v = rec.value;
        const sx = v[0];
        const ex = v[1];
        const ey = v[3];
        const { i: i, j: j } = this;
        if (i !== sx) {
            v.length--;
            v[0] = i;
            v[1] = j;
            v[2] = sx - i;
        }
        this.i = ex;
        this.j = ey;
        return rec;
    }
    constructor(diff, N){
        this.diff = diff;
        this.N = N;
        this.i = 0;
        this.j = 0;
    }
}
function $18fbe0039b7b1c20$var$lcs(xs, ys, eq) {
    return new $18fbe0039b7b1c20$var$LCSGen($18fbe0039b7b1c20$var$diff(xs, ys, eq), xs.length);
}
module.exports.lcs = $18fbe0039b7b1c20$var$lcs;
function* $18fbe0039b7b1c20$var$calcPatch(xs, ys, eq) {
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const v of $18fbe0039b7b1c20$var$diff(xs, ys, eq)){
        v[2] = slice.call(ys, v[2], v[3]);
        yield v;
    }
}
module.exports.calcPatch = $18fbe0039b7b1c20$var$calcPatch;
function* $18fbe0039b7b1c20$var$applyPatch(xs, patch) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, ins] of patch){
        if (i < dels) yield slice.call(xs, i, dels);
        if (ins.length > 0) yield ins;
        i = dele;
    }
    if (i < xs.length) yield slice.call(xs, i);
}
module.exports.applyPatch = $18fbe0039b7b1c20$var$applyPatch;
function* $18fbe0039b7b1c20$var$calcSlices(xs, ys, eq) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, inss, inse] of $18fbe0039b7b1c20$var$diff(xs, ys, eq)){
        if (i < dels) yield [
            0,
            slice.call(xs, i, dels)
        ];
        if (dels < dele) yield [
            -1,
            slice.call(xs, dels, dele)
        ];
        if (inss < inse) yield [
            1,
            slice.call(ys, inss, inse)
        ];
        i = dele;
    }
    if (i < xs.length) yield [
        0,
        xs.slice(i)
    ];
}
module.exports.calcSlices = $18fbe0039b7b1c20$var$calcSlices;

});

parcelRegister("4R6R9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed1d6b5a60ed31105ef48bd3e2c936d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38916e32063841ec$var$_react = $38916e32063841ec$var$_interopRequireDefault((parcelRequire("cozmU")));

var $38916e32063841ec$var$_iconNew = $38916e32063841ec$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $38916e32063841ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ViewSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/view-split
 * Usage guidance:
 * Reserved for representing a 2 column split view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38916e32063841ec$var$ViewSplitIcon = (props)=>/*#__PURE__*/ $38916e32063841ec$var$_react.default.createElement($38916e32063841ec$var$_iconNew.default, Object.assign({
        name: "ViewSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H8.75v11H14a.5.5 0 0 0 .5-.5zm-13 10a.5.5 0 0 0 .5.5h5.25v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$38916e32063841ec$var$ViewSplitIcon.displayName = 'ViewSplitIcon';
var $38916e32063841ec$var$_default = module.exports.default = $38916e32063841ec$var$ViewSplitIcon;

});


//# sourceMappingURL=FullPageEditorComponent.0de083c2.js.map
